import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `Float` scalar type represents signed double-precision fractional.
   * In query it is displayed as a string.
   */
  CustomFloat: any;
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: any;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any;
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: any;
  /**
   *
   *     Errors messages and codes mapped to
   *     fields or non fields errors.
   *     Example:
   *     {
   *         field_name: [
   *             {
   *                 "message": "error message",
   *                 "code": "error_code"
   *             }
   *         ],
   *         other_field: [
   *             {
   *                 "message": "error message",
   *                 "code": "error_code"
   *             }
   *         ],
   *         nonFieldErrors: [
   *             {
   *                 "message": "error message",
   *                 "code": "error_code"
   *             }
   *         ]
   *     }
   *
   */
  ExpectedErrorType: any;
  /**
   * The `GenericScalar` scalar type represents a generic
   * GraphQL scalar value that could be:
   * String, Boolean, Int, Float, List or Object.
   */
  GenericScalar: any;
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: any;
  /**
   * The `Time` scalar type represents a Time value as
   * specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Time: any;
  /**
   * Create scalar that ignores normal serialization/deserialization, since
   * that will be handled by the multipart request spec
   */
  Upload: any;
};

/** An enumeration. */
export enum AccountsPayableCurrency {
  /** BYN */
  Byn = 'BYN',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN',
  /** RUB */
  Rub = 'RUB',
  /** USD */
  Usd = 'USD'
}

export type AccountsPayableInput = {
  accountsPayable?: InputMaybe<Scalars['Float']>;
  date: Scalars['Date'];
};

export type AccountsPayableType = {
  __typename?: 'AccountsPayableType';
  agreement?: Maybe<AgreementType>;
  amountByn?: Maybe<Scalars['CustomFloat']>;
  amountForeign?: Maybe<Scalars['CustomFloat']>;
  currency: AccountsPayableCurrency;
  date: Scalars['Date'];
  id: Scalars['ID'];
  repaid: Scalars['Boolean'];
  startedAgreement: AgreementType;
};

/** ERP: attach one downloadable file (multipart Upload) to a lesson. */
export type AddCareerLessonAttachment = {
  __typename?: 'AddCareerLessonAttachment';
  attachment?: Maybe<CareerLessonAttachmentType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lesson?: Maybe<CareerLessonType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AddNewRoleTeacher = {
  __typename?: 'AddNewRoleTeacher';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
  teacher?: Maybe<TeacherType>;
};

export type AddRoleStudentAndAgreement = {
  __typename?: 'AddRoleStudentAndAgreement';
  agreement?: Maybe<AgreementType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AddTeacherApplication = {
  __typename?: 'AddTeacherApplication';
  application?: Maybe<ApplicationType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AddTeacherExist = {
  __typename?: 'AddTeacherExist';
  application?: Maybe<ApplicationType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Roster-side connection over agreements — see docs/groups/groups_upgrade.md §B2.
 *
 * `total_count` is filled by the resolver before instantiating the
 * connection so the COUNT(*) is run once over the filtered queryset
 * (instead of `len(self.iterable)` re-counting the page slice).
 */
export type AgreementConnection = {
  __typename?: 'AgreementConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AgreementEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum AgreementCurrency {
  /** BYN */
  Byn = 'BYN',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN',
  /** RUB */
  Rub = 'RUB',
  /** USD */
  Usd = 'USD'
}

/** A Relay edge containing a `Agreement` and its cursor. */
export type AgreementEdge = {
  __typename?: 'AgreementEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AgreementType>;
};

export type AgreementInput = {
  agreementTitle: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['ID']>;
  currency: Scalars['String'];
  date?: InputMaybe<Scalars['Date']>;
  group_id: Scalars['ID'];
  partialAttendance?: InputMaybe<Scalars['Boolean']>;
  paymentByCompany?: InputMaybe<Scalars['Boolean']>;
  promocode?: InputMaybe<Scalars['String']>;
  resident?: InputMaybe<Scalars['Boolean']>;
  startAgreementBudget?: InputMaybe<Scalars['Float']>;
  terminated?: InputMaybe<Scalars['Boolean']>;
  terminatedDate?: InputMaybe<Scalars['Date']>;
  vat?: InputMaybe<Scalars['Boolean']>;
};

export type AgreementLessonsInput = {
  lastLessonId: Scalars['Int'];
  startLessonId: Scalars['Int'];
};

/**
 * Sort options for `GroupType.agreementsConnection`. Names match the
 * UI sort keys (`debt`, `percentPaid`, `name`, `status`) plus direction.
 */
export enum AgreementOrderByEnum {
  DebtAsc = 'DEBT_ASC',
  DebtDesc = 'DEBT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PercentPaidAsc = 'PERCENT_PAID_ASC',
  PercentPaidDesc = 'PERCENT_PAID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

export type AgreementType = {
  __typename?: 'AgreementType';
  accountsPayable: Array<AccountsPayableType>;
  /** One-line `street, city zip_code` composed from the individual fields. Convenience for compact UIs. */
  address?: Maybe<Scalars['String']>;
  agreementTitle: Scalars['String'];
  attendancesInfo?: Maybe<Scalars['Float']>;
  budgetAmount?: Maybe<Scalars['CustomFloat']>;
  chargeback?: Maybe<ChargebackType>;
  /** From PandaDoc. */
  city?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  company?: Maybe<CompanyType>;
  contributions: ContributionTypeConnection;
  contributionsCount?: Maybe<Scalars['Int']>;
  corrections?: Maybe<Array<Maybe<PaymentCorrectionType>>>;
  country?: Maybe<CountryType>;
  courseWorksAverage?: Maybe<Scalars['Float']>;
  currency: AgreementCurrency;
  date: Scalars['Date'];
  firstLesson?: Maybe<GroupLessonType>;
  freeOfCharge: Scalars['Boolean'];
  graduationProjectMark?: Maybe<Scalars['Float']>;
  group: MethodistGroupType;
  hwSummary?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  lastLesson?: Maybe<GroupLessonType>;
  /** Buyer's legal name (as it appears on the invoice). Sourced from the PandaDoc contract. */
  legalName?: Maybe<Scalars['String']>;
  paidAmount?: Maybe<Scalars['CustomFloat']>;
  paidContributionsCount?: Maybe<Scalars['Int']>;
  /** PandaDoc contract this agreement was provisioned from (1:1), if any. */
  pandadocDocument?: Maybe<PandaDocDocumentType>;
  partialAttendance: Scalars['Boolean'];
  paymentByCompany: Scalars['Boolean'];
  payments?: Maybe<Array<Maybe<PaymentType>>>;
  promocode?: Maybe<Scalars['String']>;
  resident: Scalars['Boolean'];
  startAccountsPayable?: Maybe<AccountsPayableType>;
  statePrefinanced: Scalars['Boolean'];
  /** From PandaDoc. */
  street?: Maybe<Scalars['String']>;
  student: StudentType;
  /** Buyer's NIP / VAT-ID / УНП. From PandaDoc. */
  taxId?: Maybe<Scalars['String']>;
  terminated: Scalars['Boolean'];
  terminatedDate?: Maybe<Scalars['Date']>;
  transferOut: Scalars['Boolean'];
  vat: Scalars['Boolean'];
  /** From PandaDoc. */
  zipCode?: Maybe<Scalars['String']>;
};


export type AgreementTypeContributionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderByDateFilter?: InputMaybe<Scalars['Boolean']>;
};

export type AllStoriesConnection = {
  __typename?: 'AllStoriesConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AllStoriesEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `AllStories` and its cursor. */
export type AllStoriesEdge = {
  __typename?: 'AllStoriesEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AllStoriesType>;
};

export type AllStoriesType = ArticlesType | NativeInfoType | SuccessStoriesType;

/**
 * Single-shot «+Студент в группу» from the group dashboard
 * (docs/groups/group_dashboard.md §G8, Variant B).
 *
 * The student already exists (search picker on the frontend); the
 * agreement carries the target `groupId` inside `agreement_input`.
 * Delegates to the existing `add_agreement_to_student` service so all
 * currency / contribution / attendance plumbing is shared with the rest
 * of the agreement-create flow — no duplicate validation paths.
 */
export type AppendStudentToGroupMutation = {
  __typename?: 'AppendStudentToGroupMutation';
  agreement?: Maybe<AgreementType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ApplicationConnection = {
  __typename?: 'ApplicationConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ApplicationEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum ApplicationCurrency {
  /** BYN */
  Byn = 'BYN',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN',
  /** RUB */
  Rub = 'RUB',
  /** USD */
  Usd = 'USD'
}

/** An enumeration. */
export enum ApplicationDeleteAvailable {
  DeleteAvailable = 'delete_available',
  DeleteNotAvailable = 'delete_not_available',
  DeleteWithTeacher = 'delete_with_teacher'
}

/** A Relay edge containing a `Application` and its cursor. */
export type ApplicationEdge = {
  __typename?: 'ApplicationEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ApplicationType>;
};

export type ApplicationFilterTypeConnection = {
  __typename?: 'ApplicationFilterTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ApplicationFilterTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ApplicationFilterType` and its cursor. */
export type ApplicationFilterTypeEdge = {
  __typename?: 'ApplicationFilterTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ApplicationType>;
};

export type ApplicationInputType = {
  comment?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  currency: Currencies;
  date: Scalars['Date'];
  group: Scalars['ID'];
  lessonsCount: Scalars['Int'];
  riaPrice?: InputMaybe<Scalars['Float']>;
  servicePrice: Scalars['Float'];
  teacherType: EmploymentTypes;
  title: Scalars['String'];
};

export type ApplicationType = Node & {
  __typename?: 'ApplicationType';
  appointedLessonsCount: Scalars['Int'];
  comment?: Maybe<Scalars['String']>;
  country?: Maybe<CountryType>;
  currency: ApplicationCurrency;
  date: Scalars['Date'];
  deleteAvailable?: Maybe<ApplicationDeleteAvailable>;
  employmentType?: Maybe<EmploymentType>;
  group: MethodistGroupType;
  id: Scalars['ID'];
  isCompleted?: Maybe<Scalars['Boolean']>;
  isTerminated: Scalars['Boolean'];
  lastLessonDate?: Maybe<Scalars['Date']>;
  lessons: GroupLessonTypeConnection;
  lessonsCount: Scalars['Int'];
  riaPrice?: Maybe<Scalars['Float']>;
  servicePrice?: Maybe<Scalars['Float']>;
  teacher: TeacherFilterType;
  title: Scalars['String'];
};


export type ApplicationTypeLessonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
};

export type ArchiveSurveyMutation = {
  __typename?: 'ArchiveSurveyMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  survey?: Maybe<SurveyType>;
};

export type ArticlesConnection = {
  __typename?: 'ArticlesConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ArticlesEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Articles` and its cursor. */
export type ArticlesEdge = {
  __typename?: 'ArticlesEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ArticlesType>;
};

export type ArticlesType = {
  __typename?: 'ArticlesType';
  adviceText?: Maybe<Scalars['String']>;
  adviceTitle?: Maybe<Scalars['String']>;
  articleImage?: Maybe<Scalars['String']>;
  articleShortText?: Maybe<Scalars['String']>;
  author: AuthorsType;
  banner?: Maybe<CourseBanner>;
  date: Scalars['Date'];
  id: Scalars['ID'];
  native?: Maybe<NativeInfoType>;
  nativeTitle?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  previewImage?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoSlug?: Maybe<Scalars['String']>;
  seoTitle: Scalars['String'];
  storyText?: Maybe<Scalars['String']>;
  storyTime?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type AssignSurveyToGroupMutation = {
  __typename?: 'AssignSurveyToGroupMutation';
  assignment?: Maybe<SurveyAssignmentType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AttendanceType = Node & {
  __typename?: 'AttendanceType';
  attendance?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lesson: GroupLessonType;
  student: StudentType;
};

export type AttendanceTypeConnection = {
  __typename?: 'AttendanceTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AttendanceTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AttendanceType` and its cursor. */
export type AttendanceTypeEdge = {
  __typename?: 'AttendanceTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AttendanceType>;
};

export type AuthorsType = {
  __typename?: 'AuthorsType';
  articlesSet: Array<ArticlesType>;
  authorImage: Scalars['String'];
  authorName: Scalars['String'];
  authorPosition: Scalars['String'];
  id: Scalars['ID'];
  successstoriesSet: Array<SuccessStoriesType>;
};

export type BaseTeacherInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
};

export type BlackFridayLeadInput = {
  course_id?: InputMaybe<Scalars['Int']>;
  email: Scalars['String'];
  formName: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  promocode?: InputMaybe<Scalars['String']>;
  referer?: InputMaybe<Scalars['String']>;
  roistatId: Scalars['String'];
  tittle: Scalars['String'];
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  utmTerm?: InputMaybe<Scalars['String']>;
};

/** Confirm an LMS access block for a debtor (manual operator action). */
export type BlockStudentLmsAccessMutation = {
  __typename?: 'BlockStudentLmsAccessMutation';
  accessBlock?: Maybe<StudentAccessBlockType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type BlogAllArticlesType = {
  __typename?: 'BlogAllArticlesType';
  id: Scalars['ID'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoTitle: Scalars['String'];
};

export type BlogGraduateStoryType = {
  __typename?: 'BlogGraduateStoryType';
  description: Scalars['String'];
  id: Scalars['ID'];
  image: Scalars['String'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoTitle: Scalars['String'];
  title: Scalars['String'];
};

export type BlogNativeType = {
  __typename?: 'BlogNativeType';
  description: Scalars['String'];
  id: Scalars['ID'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoTitle: Scalars['String'];
  title: Scalars['String'];
};

/**
 * Send ONE message to many students of a group INDIVIDUALLY — a private
 * Slack DM or a single email each (never a group blast). Runs as a paced
 * background task; returns the broadcast job id the client polls (`broadcast
 * Job`) for live progress and the per-recipient outcome.
 */
export type BroadcastGroupMessage = {
  __typename?: 'BroadcastGroupMessage';
  broadcastJobId?: Maybe<Scalars['ID']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  total?: Maybe<Scalars['Int']>;
};

/**
 * Live progress of a manager-initiated bulk broadcast: the running
 * sent/failed counts plus each recipient's outcome (who it didn't reach and
 * why).
 */
export type BroadcastJobType = {
  __typename?: 'BroadcastJobType';
  channel?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  errorMessage: Scalars['String'];
  failedCount: Scalars['Int'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  mailboxEmail: Scalars['String'];
  recipients: Array<BroadcastRecipientType>;
  sentCount: Scalars['Int'];
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  subject: Scalars['String'];
  total: Scalars['Int'];
};

/** One student targeted by a bulk broadcast + the delivery outcome. */
export type BroadcastRecipientType = {
  __typename?: 'BroadcastRecipientType';
  id: Scalars['ID'];
  reason: Scalars['String'];
  sentAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  studentName: Scalars['String'];
};

export type BulkPublishVacancies = {
  __typename?: 'BulkPublishVacancies';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  published?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CeoInfoType = {
  __typename?: 'CEOInfoType';
  course?: Maybe<CourseFilterType>;
  description: Scalars['String'];
  id: Scalars['ID'];
  image: Scalars['String'];
  keywords: Scalars['String'];
  title: Scalars['String'];
};

export type CalendarSettingsMutationOutput = {
  __typename?: 'CalendarSettingsMutationOutput';
  calendarSettings?: Maybe<PaymentCalendarSettingsType>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CancelVideoUpload = {
  __typename?: 'CancelVideoUpload';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** The LMS landing payload: am I a member, and how far along am I. */
export type CareerCenterType = {
  __typename?: 'CareerCenterType';
  directionTitle?: Maybe<Scalars['String']>;
  enrolledAt: Scalars['DateTime'];
  lessonsCompleted: Scalars['Int'];
  lessonsTotal: Scalars['Int'];
  memberId: Scalars['ID'];
  status: Scalars['String'];
};

/** Parent is the dict from `services.dashboard.funnel()`. */
export type CareerDashboardType = {
  __typename?: 'CareerDashboardType';
  applied: Scalars['Int'];
  members: Scalars['Int'];
  placed: Scalars['Int'];
  profileReady: Scalars['Int'];
  trained: Scalars['Int'];
  vacanciesPublished: Scalars['Int'];
};

export type CareerDirectionType = {
  __typename?: 'CareerDirectionType';
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  order: Scalars['Int'];
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type CareerLessonAttachmentType = {
  __typename?: 'CareerLessonAttachmentType';
  contentType: Scalars['String'];
  id: Scalars['ID'];
  originalName: Scalars['String'];
  sizeBytes: Scalars['Int'];
  url?: Maybe<Scalars['String']>;
};

export type CareerLessonInput = {
  artifactHint?: InputMaybe<Scalars['String']>;
  completionKind?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  durationMin?: InputMaybe<Scalars['Int']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  order: Scalars['Int'];
  summary?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

/**
 * ERP-only completion funnel for one lesson (spec 0020). Parent is the
 * dict `services.engagement.lesson_funnel` produces per lesson.
 */
export type CareerLessonStatsType = {
  __typename?: 'CareerLessonStatsType';
  completedCount: Scalars['Int'];
  membersTotal: Scalars['Int'];
  openedCount: Scalars['Int'];
};

/**
 * Parent is a CareerLesson annotated by the resolver with
 * `_is_unlocked` and `_is_completed` for the calling viewer.
 *
 * ERP staff read the same type with both flags forced True — they author
 * the content, so there is nothing to gate.
 *
 * The engagement fields (`is_opened`, `my_notes`, `is_bookmarked`, …) read a
 * per-viewer `_engagement` row that ONLY the LMS `_decorate` attaches — so on
 * the ERP side they default to empty/false and `my_notes` can never leak a
 * student's private note to staff. `stats` is the mirror image: attached only
 * by the ERP query, null on the LMS.
 */
export type CareerLessonType = {
  __typename?: 'CareerLessonType';
  artifactHint: Scalars['String'];
  attachments: Array<CareerLessonAttachmentType>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completionKind: Scalars['String'];
  content?: Maybe<Scalars['String']>;
  durationMin?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isBookmarked: Scalars['Boolean'];
  isCompleted: Scalars['Boolean'];
  isOpened: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  isUnlocked: Scalars['Boolean'];
  myNotes: Scalars['String'];
  openCount: Scalars['Int'];
  openedAt?: Maybe<Scalars['DateTime']>;
  order: Scalars['Int'];
  quizQuestions: Array<CareerQuizQuestionType>;
  stats?: Maybe<CareerLessonStatsType>;
  summary: Scalars['String'];
  title: Scalars['String'];
  videoUrl?: Maybe<Scalars['String']>;
};

export type CareerMemberInput = {
  directionId?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/**
 * One row of a member's learning map for the ERP per-member drawer
 * (spec 0020). Parent is a dict from `services.engagement.member_progress`.
 * Carries NO note text — staff see whether/when, never what.
 */
export type CareerMemberLessonProgressType = {
  __typename?: 'CareerMemberLessonProgressType';
  completedAt?: Maybe<Scalars['DateTime']>;
  isCompleted: Scalars['Boolean'];
  isOpened: Scalars['Boolean'];
  lessonId: Scalars['ID'];
  openCount: Scalars['Int'];
  openedAt?: Maybe<Scalars['DateTime']>;
  order: Scalars['Int'];
  title: Scalars['String'];
};

/** ERP row. Student/group refs are flat light fields on purpose. */
export type CareerMemberType = {
  __typename?: 'CareerMemberType';
  directionId?: Maybe<Scalars['ID']>;
  directionTitle?: Maybe<Scalars['String']>;
  enrolledAt: Scalars['DateTime'];
  groupId?: Maybe<Scalars['ID']>;
  groupName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lessonsCompleted: Scalars['Int'];
  lessonsTotal: Scalars['Int'];
  notes: Scalars['String'];
  profile?: Maybe<CareerProfileType>;
  status: Scalars['String'];
  studentEmail?: Maybe<Scalars['String']>;
  studentId: Scalars['ID'];
  studentName: Scalars['String'];
};

export type CareerProfileInput = {
  availableFrom?: InputMaybe<Scalars['Date']>;
  certificates?: InputMaybe<Array<ProfileCertificateInput>>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  customSkills?: InputMaybe<Array<Scalars['String']>>;
  desiredPosition?: InputMaybe<Scalars['String']>;
  desiredSalary?: InputMaybe<Scalars['String']>;
  education?: InputMaybe<Array<ProfileEducationInput>>;
  email?: InputMaybe<Scalars['String']>;
  experience?: InputMaybe<Array<ProfileExperienceInput>>;
  firstName?: InputMaybe<Scalars['String']>;
  githubUrl?: InputMaybe<Scalars['String']>;
  languages?: InputMaybe<Array<ProfileLanguageInput>>;
  lastName?: InputMaybe<Scalars['String']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  portfolioUrl?: InputMaybe<Scalars['String']>;
  projects?: InputMaybe<Array<ProfileProjectInput>>;
  relocationReady?: InputMaybe<Scalars['Boolean']>;
  seniority?: InputMaybe<Scalars['String']>;
  skills?: InputMaybe<Array<ProfileSkillInput>>;
  workMode?: InputMaybe<Scalars['String']>;
  workPermit?: InputMaybe<Scalars['String']>;
};

/**
 * The student's structured profile — canonical source of the CV.
 *
 * `is_searchable`/`contacts_visible` are the student's own opt-in flags,
 * returned only on their own profile.
 */
export type CareerProfileType = {
  __typename?: 'CareerProfileType';
  availableFrom?: Maybe<Scalars['Date']>;
  certificates: Array<CertificateType>;
  city: Scalars['String'];
  completeness: Scalars['Int'];
  contactsVisible: Scalars['Boolean'];
  country: Scalars['String'];
  customSkills: Array<Scalars['String']>;
  desiredPosition: Scalars['String'];
  desiredSalary: Scalars['String'];
  education: Array<EducationType>;
  email: Scalars['String'];
  experience: Array<WorkExperienceType>;
  firstName: Scalars['String'];
  githubUrl: Scalars['String'];
  id: Scalars['ID'];
  isSearchable: Scalars['Boolean'];
  languages: Array<LanguageSkillType>;
  lastName: Scalars['String'];
  linkedinUrl: Scalars['String'];
  locales: Array<CvLocaleType>;
  phone: Scalars['String'];
  photoUrl?: Maybe<Scalars['String']>;
  portfolioUrl: Scalars['String'];
  projects: Array<PortfolioProjectType>;
  relocationReady: Scalars['Boolean'];
  seniority: Scalars['String'];
  skills: Array<StudentSkillType>;
  workMode: Scalars['String'];
  workPermit: Scalars['String'];
};

export type CareerQuizAnswerInput = {
  questionId: Scalars['ID'];
  selectedIndexes: Array<Scalars['Int']>;
};

export type CareerQuizQuestionInput = {
  correctIndexes: Array<Scalars['Int']>;
  options: Array<Scalars['String']>;
  text: Scalars['String'];
};

/**
 * A self-check question (spec 0020). `correct_indexes` is revealed ONLY to
 * the ERP author — the `_reveal` flag is attached by `careerLessonsErp`; on
 * the LMS answer flow it is always empty, so the answer key can't be read off
 * the question list before submitting.
 */
export type CareerQuizQuestionType = {
  __typename?: 'CareerQuizQuestionType';
  correctIndexes: Array<Scalars['Int']>;
  id: Scalars['ID'];
  options: Array<Scalars['String']>;
  order: Scalars['Int'];
  text: Scalars['String'];
};

/**
 * One graded question after submit — parent is a dict from
 * `services.quiz.submit_quiz`. The key is returned here because the answer is
 * already given (post-submit feedback).
 */
export type CareerQuizResultType = {
  __typename?: 'CareerQuizResultType';
  correct: Scalars['Boolean'];
  correctIndexes: Array<Scalars['Int']>;
  questionId: Scalars['ID'];
};

export type CashBalanceMutationOutput = {
  __typename?: 'CashBalanceMutationOutput';
  cashBalance?: Maybe<CashBalanceSnapshotType>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CashBalanceSnapshotType = {
  __typename?: 'CashBalanceSnapshotType';
  amountPln?: Maybe<Scalars['Float']>;
  asOfDate: Scalars['Date'];
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  legalEntityId?: Maybe<Scalars['Int']>;
  pk?: Maybe<Scalars['Int']>;
};

export type CategoryConnection = {
  __typename?: 'CategoryConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CategoryEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Category` and its cursor. */
export type CategoryEdge = {
  __typename?: 'CategoryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CategoryType>;
};

export type CategoryType = {
  __typename?: 'CategoryType';
  categoryColumn?: Maybe<Scalars['String']>;
  courses: CourseFilterTypeConnection;
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type CategoryTypeCoursesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  category_Name?: InputMaybe<Scalars['String']>;
  educationForm?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderByPublishDateFilter?: InputMaybe<Scalars['Boolean']>;
  readyToPublish?: InputMaybe<Scalars['Boolean']>;
  startDateFilter?: InputMaybe<Scalars['Boolean']>;
};

export type CertificateType = {
  __typename?: 'CertificateType';
  fileUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  issuedAt?: Maybe<Scalars['Date']>;
  issuer: Scalars['String'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type ChangeAgreementGroupInput = {
  agreementId: Scalars['ID'];
  /** Clone the contribution schedule onto the new agreement. */
  copyContributions?: InputMaybe<Scalars['Boolean']>;
  /** Move payments dated >= effective_date to the new agreement. Linked Fakturownia invoices follow their Payment (1:1) — the bridge is not touched. */
  copyPayments?: InputMaybe<Scalars['Boolean']>;
  /** Date the move takes effect. Payments before this date stay on the old agreement; the old agreement is terminated with `terminated_date = effective_date`. */
  effectiveDate: Scalars['Date'];
  newGroupId: Scalars['ID'];
};

/**
 * Move a student from one group to another atomically.
 *
 * Created to back the "Перевести в другую группу" single-click action on
 * the new student card (`docs/fakturownia/student_card.md §6`). Replaces
 * the manual sequence of `editStudentWithAgreement` + chargeback +
 * new-agreement that finance currently has to chain by hand.
 */
export type ChangeAgreementGroupMutation = {
  __typename?: 'ChangeAgreementGroupMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  newAgreement?: Maybe<AgreementType>;
  oldAgreement?: Maybe<AgreementType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ChangeLessonDate = {
  __typename?: 'ChangeLessonDate';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ChannelGroupLinkType = {
  __typename?: 'ChannelGroupLinkType';
  archived: Scalars['Boolean'];
  channelName: Scalars['String'];
  id: Scalars['ID'];
  slackChannelId: Scalars['String'];
};

/** An enumeration. */
export enum ChargebackCurrency {
  /** BYN */
  Byn = 'BYN',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN',
  /** RUB */
  Rub = 'RUB',
  /** USD */
  Usd = 'USD'
}

export type ChargebackInput = {
  currency: Scalars['String'];
  date: Scalars['Date'];
  sum: Scalars['Float'];
};

export type ChargebackType = {
  __typename?: 'ChargebackType';
  agreement: AgreementType;
  amountByn?: Maybe<Scalars['CustomFloat']>;
  amountForeign?: Maybe<Scalars['CustomFloat']>;
  currency: ChargebackCurrency;
  date: Scalars['Date'];
  id: Scalars['ID'];
};

export type CheckStudentsDebtMutation = {
  __typename?: 'CheckStudentsDebtMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ClearCareerLessonVideo = {
  __typename?: 'ClearCareerLessonVideo';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lesson?: Maybe<CareerLessonType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ClearGroupLessonLinkOverride = {
  __typename?: 'ClearGroupLessonLinkOverride';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  group?: Maybe<GroupType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CompanyConnection = {
  __typename?: 'CompanyConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CompanyEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Company` and its cursor. */
export type CompanyEdge = {
  __typename?: 'CompanyEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CompanyType>;
};

export type CompanyImageType = {
  __typename?: 'CompanyImageType';
  id: Scalars['ID'];
  image: Scalars['String'];
  studentAndCompanies: StudentAndCompaniesType;
};

export type CompanyInput = {
  comment?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  registrationNumber: Scalars['String'];
  responsiblePerson: Scalars['String'];
};

export type CompanyType = Node & {
  __typename?: 'CompanyType';
  agreements: Array<AgreementType>;
  comment?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  phone: Scalars['String'];
  registrationNumber: Scalars['String'];
  responsiblePerson: Scalars['String'];
};

/** LMS: the student marks a lesson done, unlocking the next one. */
export type CompleteCareerLesson = {
  __typename?: 'CompleteCareerLesson';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lessonsCompleted?: Maybe<Scalars['Int']>;
  lessonsTotal?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ContactEmailType = {
  __typename?: 'ContactEmailType';
  contactsPage: ContactsPageType;
  contactspage?: Maybe<ContactsPageType>;
  email: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type ContactPhoneType = {
  __typename?: 'ContactPhoneType';
  contactsPage: ContactsPageType;
  id: Scalars['ID'];
  phone: Scalars['String'];
  title: Scalars['String'];
};

export type ContactsPageType = {
  __typename?: 'ContactsPageType';
  address: Scalars['String'];
  emails: Array<ContactEmailType>;
  id: Scalars['ID'];
  mainEmail?: Maybe<ContactEmailType>;
  paymentsLogo: Array<PaymentLogoType>;
  phones: Array<ContactPhoneType>;
  registrationData: Scalars['String'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoTitle: Scalars['String'];
};

export type ContributionConnection = {
  __typename?: 'ContributionConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContributionEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Contribution` and its cursor. */
export type ContributionEdge = {
  __typename?: 'ContributionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ContributionType>;
};

export type ContributionInput = {
  date: Scalars['Date'];
  sum: Scalars['Float'];
};

export type ContributionType = Node & {
  __typename?: 'ContributionType';
  agreement: AgreementType;
  agreementTitle?: Maybe<Scalars['String']>;
  amountByn?: Maybe<Scalars['CustomFloat']>;
  amountForeign?: Maybe<Scalars['CustomFloat']>;
  complete: Scalars['Boolean'];
  /** Money actually received against this installment (net invoice paid totals + manual payment, deduped). */
  coveredAmount?: Maybe<Scalars['Float']>;
  date: Scalars['Date'];
  /** max(0, amount − coveredAmount) in agreement currency. */
  debt?: Maybe<Scalars['Float']>;
  delay?: Maybe<Scalars['Int']>;
  group?: Maybe<GroupsType>;
  id: Scalars['ID'];
  /** Fakturownia documents charging this installment (advance+final chains give several). */
  invoices?: Maybe<Array<Maybe<FakturowniaInvoiceType>>>;
  /** True when fully covered exclusively by a manual «отметить оплаченным» payment (no invoice money). */
  paidManually?: Maybe<Scalars['Boolean']>;
  /** LMS Payment that closed this scheduled installment. Null while unpaid. */
  payment?: Maybe<PaymentType>;
  person?: Maybe<Person>;
  remainder?: Maybe<Scalars['CustomFloat']>;
  /** future | awaiting | invoiced | overdue | partial | paid | paid_manual — derived on read from the linked Fakturownia invoices + the manual payment edge. */
  status?: Maybe<Scalars['String']>;
};

export type ContributionTypeConnection = {
  __typename?: 'ContributionTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ContributionTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ContributionType` and its cursor. */
export type ContributionTypeEdge = {
  __typename?: 'ContributionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ContributionType>;
};

/**
 * Keyset (last_message_at, id) connection for the dashboard
 * communications browser. total_count is the FILTERED total (independent
 * of the cursor) — the section header's counter.
 */
export type ConversationConnection = {
  __typename?: 'ConversationConnection';
  edges?: Maybe<Array<ConversationEdge>>;
  pageInfo?: Maybe<MessagePageInfo>;
  totalCount: Scalars['Int'];
};

export type ConversationEdge = {
  __typename?: 'ConversationEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<ConversationType>;
};

export type ConversationType = {
  __typename?: 'ConversationType';
  /** Human title: stored title (channel name / mail subject / DM counterpart) → linked student's «Фамилия Имя» → the raw external id. */
  displayTitle?: Maybe<Scalars['String']>;
  externalId: Scalars['String'];
  group?: Maybe<MethodistGroupType>;
  /** At least one INBOUND message here is not yet ticked «обработано» — the amber dot. Never looks at read state or at `status`. */
  hasUnhandled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  kind?: Maybe<Scalars['String']>;
  lastInboundAt?: Maybe<Scalars['DateTime']>;
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  lastOutboundAt?: Maybe<Scalars['DateTime']>;
  mailboxEmail: Scalars['String'];
  /** Manual handling lifecycle: open / in_progress / done. */
  status?: Maybe<Scalars['String']>;
  student?: Maybe<StudentType>;
  teacher?: Maybe<TeacherFilterType>;
  teamId: Scalars['String'];
  title: Scalars['String'];
  /** How many INBOUND messages are not yet ticked «обработано». 0 = nothing left to triage. */
  unhandledCount?: Maybe<Scalars['Int']>;
  /** Messages in this conversation not yet marked read (team-wide). 0 = fully read. */
  unreadCount?: Maybe<Scalars['Int']>;
  /** The study group this conversation belongs to: the group FK for channels, else the group owning the conversation's Slack workspace (team_id). Null for Gmail / legacy rows. */
  workspaceGroup?: Maybe<MethodistGroupType>;
};

export type CountryConnection = {
  __typename?: 'CountryConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CountryEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Country` and its cursor. */
export type CountryEdge = {
  __typename?: 'CountryEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CountryType>;
};

export type CountryType = {
  __typename?: 'CountryType';
  agreements: Array<AgreementType>;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type CourseBanner = {
  __typename?: 'CourseBanner';
  articlesSet: Array<ArticlesType>;
  course?: Maybe<CourseFilterType>;
  description: Scalars['String'];
  id: Scalars['ID'];
  native: Array<NativeInfoType>;
  successstoriesSet: Array<SuccessStoriesType>;
  title: Scalars['String'];
};

export type CourseCatalogPageType = {
  __typename?: 'CourseCatalogPageType';
  description: Scalars['String'];
  id: Scalars['ID'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoTitle: Scalars['String'];
  title: Scalars['String'];
};

export type CourseContributionPriceType = {
  __typename?: 'CourseContributionPriceType';
  amount: Scalars['Float'];
  contribution: CourseContributionType;
  currency?: Maybe<CurrencyType>;
  currencyTicker: Scalars['String'];
  id: Scalars['ID'];
};

export type CourseContributionType = {
  __typename?: 'CourseContributionType';
  course: CourseFilterType;
  description: Scalars['String'];
  id: Scalars['ID'];
  prices: Array<CourseContributionPriceType>;
};

export type CourseFilterType = Node & {
  __typename?: 'CourseFilterType';
  category?: Maybe<CategoryType>;
  ceoInfo?: Maybe<CeoInfoType>;
  contributions: Array<CourseContributionType>;
  courseBanner?: Maybe<CourseBanner>;
  courseDiscount?: Maybe<Scalars['Int']>;
  courseIcon?: Maybe<Scalars['String']>;
  courseRequirementsInfo?: Maybe<CourseRequirementsIntoType>;
  currency?: Maybe<Scalars['String']>;
  curriculumVitae?: Maybe<StudentCvType>;
  deleteAvailable?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  duration: Scalars['String'];
  educationForm?: Maybe<Scalars['String']>;
  educationprogram?: Maybe<EducationProgramType>;
  futureKnowledge?: Maybe<FutureKnowledgeType>;
  futureProfession?: Maybe<FutureProfessionType>;
  graduateFeedbacks: Array<GraduateFeedbackType>;
  graduationVideo?: Maybe<GraduationVideoType>;
  groups: MethodistGroupTypeConnection;
  id: Scalars['ID'];
  marketingModules: Array<CourseMarketingModuleType>;
  modules: Array<CourseModuleType>;
  name: Scalars['String'];
  price: Scalars['CustomFloat'];
  prices: Array<CoursePriceType>;
  publishDate: Scalars['Date'];
  readyToPublish: Scalars['Boolean'];
  salary?: Maybe<SalaryInfoType>;
  slug: Scalars['String'];
  teacherWeb?: Maybe<TeacherWebType>;
  teachers?: Maybe<TeacherFilterTypeConnection>;
  title?: Maybe<Scalars['String']>;
  videoTrailer?: Maybe<VideoTrailerType>;
};


export type CourseFilterTypeGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  freePlacesGt?: InputMaybe<Scalars['Decimal']>;
  hideCompleted?: InputMaybe<Scalars['Date']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CourseFilterTypeTeachersArgs = {
  after?: InputMaybe<Scalars['String']>;
  availability?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  course?: InputMaybe<Scalars['Decimal']>;
  first?: InputMaybe<Scalars['Int']>;
  hasDescription?: InputMaybe<Scalars['Boolean']>;
  hasInterview?: InputMaybe<Scalars['Boolean']>;
  hasPhoto?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  minRating?: InputMaybe<Scalars['Decimal']>;
  offset?: InputMaybe<Scalars['Int']>;
  siteDisplay?: InputMaybe<Scalars['Boolean']>;
};

export type CourseFilterTypeConnection = {
  __typename?: 'CourseFilterTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CourseFilterTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `CourseFilterType` and its cursor. */
export type CourseFilterTypeEdge = {
  __typename?: 'CourseFilterTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CourseType>;
};

export type CourseLessonType = Node & {
  __typename?: 'CourseLessonType';
  courseProgram?: Maybe<EducationProgramType>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  lmsDescription: Scalars['String'];
  marketingModule?: Maybe<CourseMarketingModuleType>;
  module: CourseModuleType;
  name: Scalars['String'];
  number: Scalars['Int'];
  studentAttachments: StudentLessonAttachmentsTypeConnection;
  taskTypes: Array<Scalars['String']>;
  teacherAttachments: TeacherLessonAttachmentsTypeConnection;
};


export type CourseLessonTypeStudentAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CourseLessonTypeTeacherAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type CourseLessonTypeConnection = {
  __typename?: 'CourseLessonTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CourseLessonTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CourseLessonType` and its cursor. */
export type CourseLessonTypeEdge = {
  __typename?: 'CourseLessonTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CourseLessonType>;
};

export type CourseMarketingModuleType = {
  __typename?: 'CourseMarketingModuleType';
  course: CourseFilterType;
  description: Scalars['String'];
  id: Scalars['ID'];
  lessons: CourseLessonTypeConnection;
  name: Scalars['String'];
};


export type CourseMarketingModuleTypeLessonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type CourseModuleType = {
  __typename?: 'CourseModuleType';
  course: CourseFilterType;
  id: Scalars['ID'];
  lessons: CourseLessonTypeConnection;
  name: Scalars['String'];
  number: Scalars['Int'];
};


export type CourseModuleTypeLessonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type CoursePriceType = {
  __typename?: 'CoursePriceType';
  amount: Scalars['Float'];
  course: CourseFilterType;
  currency?: Maybe<CurrencyType>;
  currencyTicker: Scalars['String'];
  id: Scalars['ID'];
};

export type CourseRequirementsIntoType = {
  __typename?: 'CourseRequirementsIntoType';
  course?: Maybe<CourseFilterType>;
  courseRequirements: Array<RequirementsType>;
  description: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type CourseType = Node & {
  __typename?: 'CourseType';
  category?: Maybe<CategoryType>;
  ceoInfo?: Maybe<CeoInfoType>;
  contributions: Array<CourseContributionType>;
  courseBanner?: Maybe<CourseBanner>;
  courseDiscount?: Maybe<Scalars['Int']>;
  courseIcon?: Maybe<Scalars['String']>;
  courseRequirementsInfo?: Maybe<CourseRequirementsIntoType>;
  currency?: Maybe<Scalars['String']>;
  curriculumVitae?: Maybe<StudentCvType>;
  deleteAvailable?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  duration: Scalars['String'];
  educationForm?: Maybe<Scalars['String']>;
  educationprogram?: Maybe<EducationProgramType>;
  futureKnowledge?: Maybe<FutureKnowledgeType>;
  futureProfession?: Maybe<FutureProfessionType>;
  graduateFeedbacks: Array<GraduateFeedbackType>;
  graduationVideo?: Maybe<GraduationVideoType>;
  groups: MethodistGroupTypeConnection;
  id: Scalars['ID'];
  marketingModules: Array<CourseMarketingModuleType>;
  modules: Array<CourseModuleType>;
  name: Scalars['String'];
  price: Scalars['CustomFloat'];
  prices: Array<CoursePriceType>;
  publishDate: Scalars['Date'];
  readyToPublish: Scalars['Boolean'];
  salary?: Maybe<SalaryInfoType>;
  slug: Scalars['String'];
  teacherWeb?: Maybe<TeacherWebType>;
  teachers?: Maybe<TeacherFilterTypeConnection>;
  title?: Maybe<Scalars['String']>;
  videoTrailer?: Maybe<VideoTrailerType>;
};


export type CourseTypeGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  freePlacesGt?: InputMaybe<Scalars['Decimal']>;
  hideCompleted?: InputMaybe<Scalars['Date']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CourseTypeTeachersArgs = {
  after?: InputMaybe<Scalars['String']>;
  availability?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  course?: InputMaybe<Scalars['Decimal']>;
  first?: InputMaybe<Scalars['Int']>;
  hasDescription?: InputMaybe<Scalars['Boolean']>;
  hasInterview?: InputMaybe<Scalars['Boolean']>;
  hasPhoto?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  minRating?: InputMaybe<Scalars['Decimal']>;
  offset?: InputMaybe<Scalars['Int']>;
  siteDisplay?: InputMaybe<Scalars['Boolean']>;
};

export type CreateAgreementInput = {
  agreementTitle: Scalars['String'];
  companyComment?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  contributions?: InputMaybe<Array<InputMaybe<ContributionInput>>>;
  countryId?: InputMaybe<Scalars['ID']>;
  currency: Scalars['String'];
  date: Scalars['Date'];
  firstLesson?: InputMaybe<Scalars['ID']>;
  groupId: Scalars['ID'];
  lastLesson?: InputMaybe<Scalars['ID']>;
  partialAttendance?: InputMaybe<Scalars['Boolean']>;
  paymentByCompany?: InputMaybe<Scalars['Boolean']>;
  promocode?: InputMaybe<Scalars['String']>;
  resident?: InputMaybe<Scalars['Boolean']>;
  startAgreementBudget?: InputMaybe<Scalars['Float']>;
  studentId: Scalars['ID'];
  usedPayables?: InputMaybe<Array<Scalars['ID']>>;
  vat?: InputMaybe<Scalars['Boolean']>;
};

export type CreateAgreementInputBase = {
  agreementTitle: Scalars['String'];
  companyComment?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  contributions?: InputMaybe<Array<InputMaybe<ContributionInput>>>;
  countryId?: InputMaybe<Scalars['ID']>;
  currency: Scalars['String'];
  date: Scalars['Date'];
  firstLesson?: InputMaybe<Scalars['ID']>;
  groupId: Scalars['ID'];
  lastLesson?: InputMaybe<Scalars['ID']>;
  partialAttendance?: InputMaybe<Scalars['Boolean']>;
  paymentByCompany?: InputMaybe<Scalars['Boolean']>;
  promocode?: InputMaybe<Scalars['String']>;
  resident?: InputMaybe<Scalars['Boolean']>;
  startAgreementBudget?: InputMaybe<Scalars['Float']>;
  usedPayables?: InputMaybe<Array<Scalars['ID']>>;
  vat?: InputMaybe<Scalars['Boolean']>;
};

export type CreateAgreementMutation = {
  __typename?: 'CreateAgreementMutation';
  agreement?: Maybe<AgreementType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateBlackFridayLeadMutation = {
  __typename?: 'CreateBlackFridayLeadMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateCompanyMutation = {
  __typename?: 'CreateCompanyMutation';
  company?: Maybe<CompanyType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateCourseMutation = {
  __typename?: 'CreateCourseMutation';
  course?: Maybe<CourseType>;
};

export type CreateDeferredPaymentsMutation = {
  __typename?: 'CreateDeferredPaymentsMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  deferredPayments?: Maybe<Array<Maybe<DeferredPaymentType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateExpenseCategoryMutation = {
  __typename?: 'CreateExpenseCategoryMutation';
  category?: Maybe<ExpenseCategoryType>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateGroupMutation = {
  __typename?: 'CreateGroupMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  group?: Maybe<GroupType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateLeadMutation = {
  __typename?: 'CreateLeadMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateLessonWhiteboardMutation = {
  __typename?: 'CreateLessonWhiteboardMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  whiteboard?: Maybe<WhiteboardType>;
};

export type CreateManualLessonRecordingMutation = {
  __typename?: 'CreateManualLessonRecordingMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lessonRecording?: Maybe<LessonRecordingType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateMaterialInput = {
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  groupId: Scalars['ID'];
  kind: MaterialKindEnum;
  lessonId?: InputMaybe<Scalars['ID']>;
  title: Scalars['String'];
};

export type CreateMaterialMutation = {
  __typename?: 'CreateMaterialMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  material?: Maybe<MaterialType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateNewYearLeadMutation = {
  __typename?: 'CreateNewYearLeadMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreatePaymentCorrectionInput = {
  agreementId: Scalars['ID'];
  /** Positive magnitude. */
  amount: Scalars['Float'];
  currency: Scalars['String'];
  date: Scalars['Date'];
  /** Target one payment (reverse received money). Omit to correct the whole agreement / plan. */
  paymentId?: InputMaybe<Scalars['ID']>;
  reason: Scalars['String'];
};

export type CreatePaymentCorrectionMutation = {
  __typename?: 'CreatePaymentCorrectionMutation';
  correction?: Maybe<PaymentCorrectionType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreatePaymentInput = {
  agreementId: Scalars['ID'];
  /** Amount in the agreement's currency. amount_byn / amount_foreign are derived from this (CurrencyService). */
  amountAgreement: Scalars['Float'];
  /** If provided, atomically link the new payment to this Contribution (the scheduled installment). Both must belong to the same agreement; the contribution must be unlinked. */
  contributionId?: InputMaybe<Scalars['ID']>;
  /** Must equal the agreement's currency, otherwise CURRENCY_MISMATCH. */
  currency: Scalars['String'];
  date: Scalars['Date'];
};

/**
 * Create a free-standing Payment on an agreement (no Fakturownia link).
 *
 * Mirrors `createPaymentForFakturowniaInvoice` but starts from the
 * agreement instead of an invoice — finance often records a payment
 * before any invoice exists. Link to an invoice later via
 * `linkFakturowniaInvoiceToPayment`.
 */
export type CreatePaymentMutation = {
  __typename?: 'CreatePaymentMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  payment?: Maybe<PaymentType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreatePaymentsMutation = {
  __typename?: 'CreatePaymentsMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  payments?: Maybe<Array<Maybe<PaymentType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateStaffTaskInput = {
  agreementId?: InputMaybe<Scalars['ID']>;
  assigneeId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  groupId?: InputMaybe<Scalars['ID']>;
  priority?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  studentId?: InputMaybe<Scalars['ID']>;
  subject?: InputMaybe<TaskSubjectInput>;
  title: Scalars['String'];
};

export type CreateStaffTaskMutation = {
  __typename?: 'CreateStaffTaskMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  task?: Maybe<StaffTaskType>;
};

export type CreateStudentNoteInput = {
  body: Scalars['String'];
  groupId?: InputMaybe<Scalars['ID']>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  /** neutral | positive | negative */
  sentiment?: InputMaybe<Scalars['String']>;
  studentId?: InputMaybe<Scalars['ID']>;
};

export type CreateStudentNoteMutation = {
  __typename?: 'CreateStudentNoteMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  note?: Maybe<StudentNoteType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateSurveyMutation = {
  __typename?: 'CreateSurveyMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  survey?: Maybe<SurveyType>;
};

/**
 * Spin a staff task off a student's message («создать задачу из вопроса»).
 *
 * The task inherits the conversation's student/group; the assignee defaults
 * to the acting manager and must always be ERP staff. Side effects record
 * the reaction: the message is marked handled + linked to the task, and an
 * `open` conversation moves to `in_progress`. One task per message — a
 * retry / second manager gets `already_linked` instead of a duplicate.
 */
export type CreateTaskFromMessageMutation = {
  __typename?: 'CreateTaskFromMessageMutation';
  conversation?: Maybe<ConversationType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<MessageType>;
  success?: Maybe<Scalars['Boolean']>;
  task?: Maybe<StaffTaskType>;
};

/**
 * Create a STANDALONE teacher WITHOUT any application/group assignment —
 * add «свободных» преподавателей на будущее (собеседование/курсы/рейтинг
 * заполняются на карточке). Distinct from `createUniqueTeacher`, which
 * requires an application.
 */
export type CreateTeacher = {
  __typename?: 'CreateTeacher';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
  teacher?: Maybe<TeacherType>;
};

export type CreateUniqueTeacher = {
  __typename?: 'CreateUniqueTeacher';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
  teacher?: Maybe<TeacherType>;
};

/** An enumeration. */
export enum Currencies {
  Byn = 'BYN',
  Eur = 'EUR',
  Pln = 'PLN',
  Rub = 'RUB',
  Usd = 'USD'
}

export type CurrencyType = {
  __typename?: 'CurrencyType';
  coursecontributionpriceSet: Array<CourseContributionPriceType>;
  coursepriceSet: Array<CoursePriceType>;
  id: Scalars['ID'];
  ticker: Scalars['String'];
};

export type CustomErrorType = {
  __typename?: 'CustomErrorType';
  code?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

/** SDL: {token, success, errors, user, unarchiving, customErrors, refreshToken}. */
export type CustomObtainJsonWebToken = {
  __typename?: 'CustomObtainJSONWebToken';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  refreshToken?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  token?: Maybe<Scalars['String']>;
  unarchiving?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserNode>;
};

/** То же, что в `graphql_jwt`, но с нашей формой ответа (success/errors). */
export type CustomRefreshToken = {
  __typename?: 'CustomRefreshToken';
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  payload?: Maybe<Scalars['GenericScalar']>;
  refreshToken?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  token?: Maybe<Scalars['String']>;
};

/** SDL: {success, errors, customErrors}. */
export type CustomSendPasswordResetEmail = {
  __typename?: 'CustomSendPasswordResetEmail';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CustomUserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  roles: Scalars['String'];
};

export type CustomUserType = Node & {
  __typename?: 'CustomUserType';
  dateJoined: Scalars['DateTime'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  /** Określa czy użytkownika należy uważać za aktywnego. Odznacz zamiast usuwać konto. */
  isActive: Scalars['Boolean'];
  /** Określa czy użytkownik może zalogować się do panelu administracyjnego. */
  isStaff: Scalars['Boolean'];
  /** Oznacza, że ten użytkownik ma wszystkie uprawnienia bez ich jawnego przypisywania. */
  isSuperuser: Scalars['Boolean'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  roles: Array<Scalars['String']>;
  student?: Maybe<StudentType>;
  teacher?: Maybe<TeacherFilterType>;
  /** Wymagana. 150 lub mniej znaków. Jedynie litery, cyfry i @/./+/-/_. */
  username: Scalars['String'];
};

export type CvLocaleType = {
  __typename?: 'CvLocaleType';
  about: Scalars['String'];
  jobTitle: Scalars['String'];
  language: Scalars['String'];
};

export type DataProcessingPolicyAgreementType = Node & {
  __typename?: 'DataProcessingPolicyAgreementType';
  agreementDate: Scalars['Date'];
  content: Scalars['String'];
  displayPage: DataProcessingPolicyType;
  file: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
};

export type DataProcessingPolicyAgreementTypeConnection = {
  __typename?: 'DataProcessingPolicyAgreementTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DataProcessingPolicyAgreementTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `DataProcessingPolicyAgreementType` and its cursor. */
export type DataProcessingPolicyAgreementTypeEdge = {
  __typename?: 'DataProcessingPolicyAgreementTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DataProcessingPolicyAgreementType>;
};

export type DataProcessingPolicyType = {
  __typename?: 'DataProcessingPolicyType';
  actualPublicOfferAgreement?: Maybe<DataProcessingPolicyAgreementType>;
  id: Scalars['ID'];
  publicOfferAgreements: DataProcessingPolicyAgreementTypeConnection;
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoTitle: Scalars['String'];
  title: Scalars['String'];
};


export type DataProcessingPolicyTypePublicOfferAgreementsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type DayOfClassInput = {
  endTime?: InputMaybe<Scalars['Time']>;
  startTime?: InputMaybe<Scalars['Time']>;
  weekDay: Scalars['Int'];
};

export type DayOfClassType = {
  __typename?: 'DayOfClassType';
  endTime: Scalars['Time'];
  group: MethodistGroupType;
  id: Scalars['ID'];
  startTime: Scalars['Time'];
  weekDay: Scalars['Int'];
};

/**
 * One student with at least one overdue issued invoice (corrections /
 * transfer-aware). `currently_blocked` lets the ERP render the toggle state
 * without a second query.
 */
export type DebtorCandidateType = {
  __typename?: 'DebtorCandidateType';
  currentlyBlocked: Scalars['Boolean'];
  maxOverdueDays: Scalars['Int'];
  overdueAmount: Scalars['Float'];
  overdueInvoiceCount: Scalars['Int'];
  student: StudentType;
};

export type DeferredPaymentConnection = {
  __typename?: 'DeferredPaymentConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DeferredPaymentEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum DeferredPaymentCurrency {
  /** BYN */
  Byn = 'BYN',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN',
  /** RUB */
  Rub = 'RUB',
  /** USD */
  Usd = 'USD'
}

/** A Relay edge containing a `DeferredPayment` and its cursor. */
export type DeferredPaymentEdge = {
  __typename?: 'DeferredPaymentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<DeferredPaymentType>;
};

export type DeferredPaymentInput = {
  agreementTitle?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  date: Scalars['Date'];
  deferredPaymentId?: InputMaybe<Scalars['ID']>;
  studentFullname?: InputMaybe<Scalars['String']>;
  sum?: InputMaybe<Scalars['Float']>;
  userInput: Scalars['String'];
};

export type DeferredPaymentType = Node & {
  __typename?: 'DeferredPaymentType';
  agreementCurrency?: Maybe<Scalars['String']>;
  agreementId?: Maybe<Scalars['Int']>;
  agreementTitle?: Maybe<Scalars['String']>;
  currency?: Maybe<DeferredPaymentCurrency>;
  date: Scalars['Date'];
  id: Scalars['ID'];
  studentFullname?: Maybe<Scalars['String']>;
  sum?: Maybe<Scalars['CustomFloat']>;
  userInput: Scalars['String'];
};

export type DeleteCourseMutation = {
  __typename?: 'DeleteCourseMutation';
  course?: Maybe<CourseType>;
};

export type DeleteExpenseMutation = {
  __typename?: 'DeleteExpenseMutation';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteGroupMutation = {
  __typename?: 'DeleteGroupMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteMaterialMutation = {
  __typename?: 'DeleteMaterialMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeletePaymentCorrectionMutation = {
  __typename?: 'DeletePaymentCorrectionMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Delete a Payment. Refuses if a FakturowniaInvoice is still linked —
 * the operator must call `unlinkFakturowniaInvoice` first so the invoice
 * isn't left orphaned with `payment_id → DELETED`.
 */
export type DeletePaymentMutation = {
  __typename?: 'DeletePaymentMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeletePlannedPaymentOutput = {
  __typename?: 'DeletePlannedPaymentOutput';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteStaffTaskMutation = {
  __typename?: 'DeleteStaffTaskMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Detach a diploma. The S3 object is left in place deliberately — a
 * student may hold a live signed URL, and a leaked object beats a document
 * that vanished mid-download. The orphaned key goes to the audit log.
 */
export type DeleteStudentDiplomaMutation = {
  __typename?: 'DeleteStudentDiplomaMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteStudentNoteMutation = {
  __typename?: 'DeleteStudentNoteMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteSurveyAssignmentMutation = {
  __typename?: 'DeleteSurveyAssignmentMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteTeacherApplication = {
  __typename?: 'DeleteTeacherApplication';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteZoomRecordingMutation = {
  __typename?: 'DeleteZoomRecordingMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  zoomRecording?: Maybe<ZoomRecordingType>;
};

export type DemoType = {
  __typename?: 'DemoType';
  totalCount?: Maybe<Scalars['Int']>;
};

export type DiplomaCandidateType = {
  __typename?: 'DiplomaCandidateType';
  fullName?: Maybe<Scalars['String']>;
  student: DiplomaStudentType;
};

export type DiplomaDownloadUrlType = {
  __typename?: 'DiplomaDownloadUrlType';
  expiresAt: Scalars['DateTime'];
  url: Scalars['String'];
};

/** An enumeration. */
export enum DiplomaLanguageEnum {
  En = 'EN',
  Pl = 'PL'
}

export type DiplomaMatchPreviewType = {
  __typename?: 'DiplomaMatchPreviewType';
  rows: Array<DiplomaMatchRowType>;
  summary: DiplomaMatchSummaryType;
  unmatchedStudents: Array<UnmatchedStudentType>;
};

/**
 * One dry-run match result. `file_name` is the join key back to the
 * client's File objects — the commit sends explicit ids, never a match.
 */
export type DiplomaMatchRowType = {
  __typename?: 'DiplomaMatchRowType';
  candidates: Array<DiplomaCandidateType>;
  confidence?: Maybe<Scalars['Float']>;
  fileName: Scalars['String'];
  language?: Maybe<DiplomaLanguageEnum>;
  matchedBy?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  student?: Maybe<DiplomaStudentType>;
  /** Non-null ⇒ committing this row OVERWRITES an existing diploma. The commit refuses unless the operator confirmed that specific row. */
  wouldReplace?: Maybe<DiplomaType>;
};

export type DiplomaMatchSummaryType = {
  __typename?: 'DiplomaMatchSummaryType';
  ambiguous: Scalars['Int'];
  duplicates: Scalars['Int'];
  matched: Scalars['Int'];
  noMatch: Scalars['Int'];
  total: Scalars['Int'];
  willReplace: Scalars['Int'];
};

/** Minimal student identity for the ERP diplomas table. */
export type DiplomaStudentType = {
  __typename?: 'DiplomaStudentType';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
};

/** ERP view of one attached diploma. No file URL — see module docstring. */
export type DiplomaType = {
  __typename?: 'DiplomaType';
  contentType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  language: DiplomaLanguageEnum;
  originalName?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  sizeBytes?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  uploadedAt?: Maybe<Scalars['DateTime']>;
  uploadedByName?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

export type DuplicateSurveyMutation = {
  __typename?: 'DuplicateSurveyMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  survey?: Maybe<SurveyType>;
};

export type EducationProgramType = {
  __typename?: 'EducationProgramType';
  course: CourseFilterType;
  description: Scalars['String'];
  id: Scalars['ID'];
  lessons: CourseLessonTypeConnection;
  numberOfHours: Scalars['String'];
  title: Scalars['String'];
};


export type EducationProgramTypeLessonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type EducationType = {
  __typename?: 'EducationType';
  degree: Scalars['String'];
  endMonth?: Maybe<Scalars['Int']>;
  endYear?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  institution: Scalars['String'];
  specialization: Scalars['String'];
  startMonth?: Maybe<Scalars['Int']>;
  startYear?: Maybe<Scalars['Int']>;
};

export type EmploymentInputType = {
  individualEntrepreneur?: InputMaybe<IndividualEntrepreneurInput>;
  legalEntity?: InputMaybe<LegalEntityInput>;
  naturalPerson?: InputMaybe<NaturalPersonInput>;
  selfEmployed?: InputMaybe<SelfEmployedInput>;
};

export type EmploymentType = IndividualEntrepreneurType | LegalEntityType | NaturalPersonType | SelfEmployedType;

/** An enumeration. */
export enum EmploymentTypes {
  /** individual_entrepreneur */
  Ie = 'IE',
  /** legal_entity */
  Le = 'LE',
  /** natural_person */
  Np = 'NP',
  /** self_employed */
  Se = 'SE'
}

/** Add students and/or a whole graduating group to the centre. */
export type EnrollCareerMembers = {
  __typename?: 'EnrollCareerMembers';
  created?: Maybe<Scalars['Int']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  reactivated?: Maybe<Scalars['Int']>;
  skipped?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum ExchangeRateCurrency {
  /** BYN */
  Byn = 'BYN',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN',
  /** RUB */
  Rub = 'RUB',
  /** USD */
  Usd = 'USD'
}

export type ExchangeRateMutationOutput = {
  __typename?: 'ExchangeRateMutationOutput';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  exchangeRate?: Maybe<ExchangeRateType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ExchangeRateType = {
  __typename?: 'ExchangeRateType';
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currency: ExchangeRateCurrency;
  effectiveFrom: Scalars['Date'];
  id: Scalars['ID'];
  pk?: Maybe<Scalars['Int']>;
  rateToPln?: Maybe<Scalars['Float']>;
};

export type ExistEmploymentInputType = {
  individualEntrepreneur?: InputMaybe<ExistIndividualEntrepreneurInput>;
  legalEntity?: InputMaybe<ExistLegalEntityInput>;
  naturalPerson?: InputMaybe<ExistNaturalPersonInput>;
  selfEmployed?: InputMaybe<ExistSelfEmployedInput>;
};

export type ExistIndividualEntrepreneurInput = {
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  existId?: InputMaybe<Scalars['ID']>;
  inn: Scalars['String'];
  registrationAddress: Scalars['String'];
};

export type ExistLegalEntityInput = {
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  existId?: InputMaybe<Scalars['ID']>;
  inn: Scalars['String'];
  registrationAddress: Scalars['String'];
  tittle: Scalars['String'];
};

export type ExistNaturalPersonInput = {
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  existId?: InputMaybe<Scalars['ID']>;
  nationality: Scalars['ID'];
  passportNumber: Scalars['String'];
  registrationAddress: Scalars['String'];
};

export type ExistSelfEmployedInput = {
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  existId?: InputMaybe<Scalars['ID']>;
  inn: Scalars['String'];
  nationality: Scalars['ID'];
  passportNumber: Scalars['String'];
  registrationAddress: Scalars['String'];
};

/**
 * One row of an `expense_aggregates` response.
 *
 * `group` carries the bucket key — a category slug, an ISO month
 * (`YYYY-MM`) or a legal-entity id — depending on the query's
 * `group_by` parameter. `total` is the PLN sum of `amount_pln` (the FX
 * cache) in that bucket, so multi-currency rows aggregate correctly.
 */
export type ExpenseAggregateRow = {
  __typename?: 'ExpenseAggregateRow';
  count?: Maybe<Scalars['Int']>;
  group?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
};

export type ExpenseCategoryType = {
  __typename?: 'ExpenseCategoryType';
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  pk?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
};

/** An enumeration. */
export enum ExpenseCurrency {
  /** BYN */
  Byn = 'BYN',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN',
  /** RUB */
  Rub = 'RUB',
  /** USD */
  Usd = 'USD'
}

export type ExpenseInput = {
  amount: Scalars['Float'];
  categorySlug?: InputMaybe<Scalars['String']>;
  counterpartyName?: InputMaybe<Scalars['String']>;
  counterpartyTaxNo?: InputMaybe<Scalars['String']>;
  currency: Scalars['String'];
  date: Scalars['Date'];
  description?: InputMaybe<Scalars['String']>;
  documentUrl?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  paidAt?: InputMaybe<Scalars['Date']>;
  /** none | weekly | monthly (default none). */
  recurrence?: InputMaybe<Scalars['String']>;
  /** 1–31 for monthly recurrence. */
  recurrenceDay?: InputMaybe<Scalars['Int']>;
  recurrenceUntil?: InputMaybe<Scalars['Date']>;
  /** Link a received Fakturownia invoice — prefills and locks amount/currency/date/counterparty from it, sets source='fakturownia'. */
  relatedFakturowniaInvoiceId?: InputMaybe<Scalars['ID']>;
  relatedGroupId?: InputMaybe<Scalars['ID']>;
  relatedTeacherId?: InputMaybe<Scalars['ID']>;
  /** planned | confirmed | paid | cancelled (default planned). */
  status?: InputMaybe<Scalars['String']>;
};

export type ExpenseMutationOutput = {
  __typename?: 'ExpenseMutationOutput';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  expense?: Maybe<ExpenseType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum ExpenseRecurrence {
  /** Monthly */
  Monthly = 'MONTHLY',
  /** Brak */
  None = 'NONE',
  /** Weekly */
  Weekly = 'WEEKLY'
}

/** An enumeration. */
export enum ExpenseSource {
  /** Fakturownia */
  Fakturownia = 'FAKTUROWNIA',
  /** Manual */
  Manual = 'MANUAL'
}

/** An enumeration. */
export enum ExpenseStatus {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Confirmed */
  Confirmed = 'CONFIRMED',
  /** Paid */
  Paid = 'PAID',
  /** Planned */
  Planned = 'PLANNED'
}

export type ExpenseType = {
  __typename?: 'ExpenseType';
  amount?: Maybe<Scalars['Float']>;
  /** FX cache of `amount` converted to PLN at `date`. Null when no ExchangeRate exists for the currency. */
  amountPln?: Maybe<Scalars['Float']>;
  category?: Maybe<ExpenseCategoryType>;
  /** The linked Fakturownia corrective invoice's `correction_reason`, when this is a correction. */
  correctionReason?: Maybe<Scalars['String']>;
  /** Supplier / recipient name (free-text) */
  counterpartyName: Scalars['String'];
  /** NIP / УНП / VAT — optional */
  counterpartyTaxNo: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currency: ExpenseCurrency;
  /** Document/issue date */
  date: Scalars['Date'];
  description: Scalars['String'];
  documentUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** True when this expense mirrors a Fakturownia corrective invoice (kind='correction'). The amount is signed (usually negative) so the original and its correction net out; a metadata-only correction carries amount 0. */
  isCorrection?: Maybe<Scalars['Boolean']>;
  notes: Scalars['String'];
  /** When the money actually left our account (may differ from `date`). */
  paidAt?: Maybe<Scalars['Date']>;
  pk?: Maybe<Scalars['Int']>;
  /** none = one-off; weekly steps +7 days from `date`; monthly repeats on `recurrence_day`. */
  recurrence: ExpenseRecurrence;
  /** 1–31 for monthly recurrence; clamped to the last day of short months. Ignored for weekly (uses `date.day`). */
  recurrenceDay?: Maybe<Scalars['Int']>;
  /** Inclusive end; empty means open-ended (until changed). */
  recurrenceUntil?: Maybe<Scalars['Date']>;
  /** Set for rows mirrored from a Fakturownia cost document. Acts as the idempotency key for the bridge. */
  relatedFakturowniaInvoice?: Maybe<FakturowniaInvoiceType>;
  /** Optional — when the spend belongs to a specific group (teacher payout per group, group materials, etc.) */
  relatedGroup?: Maybe<MethodistGroupType>;
  relatedTeacher?: Maybe<TeacherFilterType>;
  source: ExpenseSource;
  /** Lifecycle status, for parity with the payment calendar. */
  status: ExpenseStatus;
  updatedAt: Scalars['DateTime'];
};

/**
 * Preflight verdict — «can we issue for this installment, and if not why».
 *
 * Backed by the SAME `services.billability.check_billability` the mutation
 * and the group job call, so the greyed-out button and the server's answer
 * can never disagree.
 */
export type FakturowniaBillabilityType = {
  __typename?: 'FakturowniaBillabilityType';
  agreementId?: Maybe<Scalars['Int']>;
  amount?: Maybe<Scalars['Float']>;
  billable: Scalars['Boolean'];
  buyerAddress?: Maybe<Scalars['String']>;
  buyerEmail?: Maybe<Scalars['String']>;
  buyerName?: Maybe<Scalars['String']>;
  buyerTaxNo?: Maybe<Scalars['String']>;
  contributionId?: Maybe<Scalars['Int']>;
  courseName?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  /** Which buyer fields are blank, for MISSING_BUYER_*. */
  missingFields?: Maybe<Array<Scalars['String']>>;
  paymentTo?: Maybe<Scalars['Date']>;
  /** Rendered line-item preview — exactly what will be printed on the document. */
  positionName?: Maybe<Scalars['String']>;
  /** Machine code, empty when billable. */
  reason?: Maybe<Scalars['String']>;
  studentName?: Maybe<Scalars['String']>;
  /** The VAT rate that WILL be sent, from settings — e.g. '23' or 'zw'. Lets the UI show the real rate instead of a hardcoded chip. */
  taxRate?: Maybe<Scalars['String']>;
};

export type FakturowniaBillingJobEnqueueOutput = {
  __typename?: 'FakturowniaBillingJobEnqueueOutput';
  billableCount?: Maybe<Scalars['Int']>;
  errorCode?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  job?: Maybe<FakturowniaBillingJobType>;
  skippedCount?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
  total?: Maybe<Scalars['Int']>;
};

export type FakturowniaBillingJobRowType = {
  __typename?: 'FakturowniaBillingJobRowType';
  agreement: AgreementType;
  amount?: Maybe<Scalars['Float']>;
  contribution?: Maybe<ContributionType>;
  currency: Scalars['String'];
  id: Scalars['ID'];
  invoice?: Maybe<FakturowniaInvoiceType>;
  invoiceNumber?: Maybe<Scalars['String']>;
  issuedAt?: Maybe<Scalars['DateTime']>;
  job: FakturowniaBillingJobType;
  pk?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studentName?: Maybe<Scalars['String']>;
  viewUrl?: Maybe<Scalars['String']>;
};

export type FakturowniaBillingJobType = {
  __typename?: 'FakturowniaBillingJobType';
  celeryTaskId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<CustomUserType>;
  errorMessage: Scalars['String'];
  failedCount: Scalars['Int'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  group: MethodistGroupType;
  id: Scalars['ID'];
  issuedCount: Scalars['Int'];
  paymentTo?: Maybe<Scalars['Date']>;
  pk?: Maybe<Scalars['Int']>;
  rows?: Maybe<Array<FakturowniaBillingJobRowType>>;
  skippedCount: Scalars['Int'];
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
};

export type FakturowniaGroupBillingPreviewType = {
  __typename?: 'FakturowniaGroupBillingPreviewType';
  billableCount: Scalars['Int'];
  rows: Array<FakturowniaBillabilityType>;
  skippedCount: Scalars['Int'];
  total: Scalars['Int'];
};

/**
 * One bucket of `fakturownia_invoice_aggregates`.
 *
 * Phase 4 contract: every monetary value here is in **PLN (zł)**. The
 * project is PL-only and all invoice amounts come from Fakturownia in
 * złoty; we no longer compute or surface a separate BYN-converted total.
 * `total_outstanding` excludes paid invoices (status='paid' → 0).
 */
export type FakturowniaInvoiceAggregateRow = {
  __typename?: 'FakturowniaInvoiceAggregateRow';
  count?: Maybe<Scalars['Int']>;
  /** Bucket key — format depends on group_by */
  group?: Maybe<Scalars['String']>;
  totalGross?: Maybe<Scalars['Float']>;
  totalOutstanding?: Maybe<Scalars['Float']>;
  totalPaid?: Maybe<Scalars['Float']>;
};

/** An enumeration. */
export enum FakturowniaInvoiceDirection {
  /** Issued (we billed) */
  Issued = 'ISSUED',
  /** Received (we were billed) */
  Received = 'RECEIVED'
}

/** An enumeration. */
export enum FakturowniaInvoiceGroupMatchSource {
  /** Auto */
  Auto = 'AUTO',
  /** Manual */
  Manual = 'MANUAL',
  /** Brak */
  None = 'NONE'
}

/** An enumeration. */
export enum FakturowniaInvoiceMatchStatus {
  /** Auto matched */
  Auto = 'AUTO',
  /** Manually matched */
  Manual = 'MANUAL',
  /** Not applicable */
  NotApplicable = 'NOT_APPLICABLE',
  /** Unmatched */
  Unmatched = 'UNMATCHED'
}

export type FakturowniaInvoiceType = {
  __typename?: 'FakturowniaInvoiceType';
  /** Fakturownia's `accounting_kind` — purchases / media / salary / fuel / fixed_assets / expenses / ... */
  accountingKind: Scalars['String'];
  /** Reverse relation — advance invoices under this estimate (children with kind='advance'). */
  advances?: Maybe<Array<Maybe<FakturowniaInvoiceType>>>;
  /** Convenience shortcut for `payment.agreement` — the договор this invoice is part of. Null when payment is null. Use this for grouping invoices on a student's card without resolving Payment first. */
  agreement?: Maybe<AgreementType>;
  /** On issued invoices = the student / customer. On received invoices buyer/seller swap visually but stay stable in JSON — here `buyer_*` carries the supplier. */
  buyerEmail: Scalars['String'];
  buyerName: Scalars['String'];
  buyerTaxNo: Scalars['String'];
  /** The installment this document charges (N:1). Set by the sync auto-matcher or the linkInvoiceToContribution mutation. */
  contribution?: Maybe<ContributionType>;
  /** none | auto | manual — manual pins the link, the auto-matcher never re-points it. */
  contributionMatchSource?: Maybe<Scalars['String']>;
  correctionReason: Scalars['String'];
  /** Reverse relation — correction invoices amending this one (children with kind='correction'). */
  corrections?: Maybe<Array<Maybe<FakturowniaInvoiceType>>>;
  createdAt: Scalars['DateTime'];
  currency: Scalars['String'];
  direction: FakturowniaInvoiceDirection;
  fakturowniaId: Scalars['Int'];
  /** Mirror of Fakturownia's /payments.json rows for this invoice. Fakturownia can split a single invoice across several receipt records (deposit + balance, etc.); they all show up here. */
  fakturowniaPayments?: Maybe<Array<Maybe<FakturowniaPaymentType>>>;
  fakturowniaUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** Reverse relation — the closing 'final' invoice under this estimate, if it has been issued (first child with kind='final'). */
  finalInvoice?: Maybe<FakturowniaInvoiceType>;
  /** Which chain links this invoice to a group. CANONICAL = payment.agreement.group; LEGACY_LINKED_GROUP = only the deprecated linked_group FK. Frontend uses this to badge rows still backed by the legacy mirror during the Phase-13 rollout (see §G7). */
  groupFilterSource?: Maybe<GroupFilterSourceEnum>;
  groupMatchSource: FakturowniaInvoiceGroupMatchSource;
  id: Scalars['ID'];
  /** kind=='advance' — partial-payment tax invoice that's part of an estimate chain. */
  isAdvance?: Maybe<Scalars['Boolean']>;
  /** Shortcut for kind=='correction'. Frontend uses this to tag the row as «correction to FV/N» visually. */
  isCorrection?: Maybe<Scalars['Boolean']>;
  /** kind in (estimate, client_order) — the chain root / order document. Informational, not summed in aggregates. */
  isEstimate?: Maybe<Scalars['Boolean']>;
  /** kind=='final' — closing tax invoice that pairs with advance(s) under the same estimate. */
  isFinal?: Maybe<Scalars['Boolean']>;
  /** True for estimate / client_order / proforma — informational documents excluded from revenue sums. */
  isQuotation?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['Date']>;
  /** vat / proforma / correction / bill / receipt / advance / final / ... */
  kind: Scalars['String'];
  linkedAt?: Maybe<Scalars['DateTime']>;
  /** DEPRECATED: use invoice.payment.agreement.group. */
  linkedGroup?: Maybe<MethodistGroupType>;
  /** DEPRECATED: use invoice.payment.agreement.student. */
  linkedStudent?: Maybe<StudentType>;
  matchStatus: FakturowniaInvoiceMatchStatus;
  /** price_gross after netting child correction invoices. */
  netGross?: Maybe<Scalars['Float']>;
  /** paid after netting refunds on child corrections. */
  netPaid?: Maybe<Scalars['Float']>;
  number: Scalars['String'];
  outstanding?: Maybe<Scalars['Float']>;
  paid?: Maybe<Scalars['Float']>;
  /** Points to the Fakturownia document this one references. Set for kind=correction (→ amended doc) and for kind=advance/final (→ parent estimate). */
  parentInvoice?: Maybe<FakturowniaInvoiceType>;
  /** 1:1 link to the LMS students.Payment that this invoice settles. Null when the invoice hasn't been reconciled yet — operators close that gap via the createPaymentForFakturowniaInvoice / linkFakturowniaInvoiceToPayment mutations. */
  payment?: Maybe<PaymentType>;
  paymentTo?: Maybe<Scalars['Date']>;
  /** Online-payment URL, when the document has one. Often null — only ~16% of issued invoices carry it. */
  paymentUrl?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  priceGross?: Maybe<Scalars['Float']>;
  priceNet?: Maybe<Scalars['Float']>;
  /** Why the auto-provisioner refused to create the hidden Payment for this paid invoice (CURRENCY_MISMATCH / NO_PAYMENT_DATE). Empty when not blocked — surfaces as «требует внимания» in the ERP. */
  provisionBlockedReason?: Maybe<Scalars['String']>;
  rawPayload?: Maybe<Scalars['JSONString']>;
  sellDate?: Maybe<Scalars['Date']>;
  sellerName: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  /** Public preview URL of the document in Fakturownia. */
  viewUrl?: Maybe<Scalars['String']>;
};

export type FakturowniaMutationOutput = {
  __typename?: 'FakturowniaMutationOutput';
  /** True when a document DEFINITELY exists in Fakturownia despite success=false. Not the whole at-risk set — errorCode=FAKTUROWNIA_AMBIGUOUS also means a document may exist. Check both before deciding not to warn. */
  documentCreated?: Maybe<Scalars['Boolean']>;
  /** Machine code for the failure, e.g. AGREEMENT_STATE_PREFINANCED, MISSING_BUYER_ADDRESS, ISSUE_IN_FLIGHT. Null on success. */
  errorCode?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  invoice?: Maybe<FakturowniaInvoiceType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Mirror of one row in Fakturownia's `/payments.json`. N:1 to invoice. */
export type FakturowniaPaymentType = {
  __typename?: 'FakturowniaPaymentType';
  createdAt: Scalars['DateTime'];
  currency: Scalars['String'];
  fakturowniaId: Scalars['Int'];
  fakturowniaUpdatedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  /** N:1 to FakturowniaInvoice — Fakturownia may split one invoice across several payment records. */
  invoice: FakturowniaInvoiceType;
  /** Fakturownia payment kind — cash / transfer / card / ... */
  kind: Scalars['String'];
  paidDate?: Maybe<Scalars['Date']>;
  pk?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Float']>;
  rawPayload?: Maybe<Scalars['JSONString']>;
  updatedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum FakturowniaSyncRunStatus {
  /** Failed */
  Failed = 'FAILED',
  /** Running */
  Running = 'RUNNING',
  /** Success */
  Success = 'SUCCESS'
}

export type FakturowniaSyncRunType = {
  __typename?: 'FakturowniaSyncRunType';
  celeryTaskId: Scalars['String'];
  durationSeconds?: Maybe<Scalars['Float']>;
  errorMessage: Scalars['String'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  pk?: Maybe<Scalars['Int']>;
  startedAt: Scalars['DateTime'];
  stats?: Maybe<Scalars['JSONString']>;
  status: FakturowniaSyncRunStatus;
  taskName: Scalars['String'];
};

/**
 * Compact "is the mirror up-to-date?" snapshot for dashboard widgets.
 *
 * A single object the frontend can poll on a tick: when did the last
 * successful sync finish, how many invoices it touched, and whether a
 * new run is currently in flight (so the spinner stays on).
 */
export type FakturowniaSyncStatus = {
  __typename?: 'FakturowniaSyncStatus';
  /** True while a run is in progress. */
  isRunning?: Maybe<Scalars['Boolean']>;
  /** The most recent run, regardless of outcome. */
  lastRun?: Maybe<FakturowniaSyncRunType>;
  /** The most recent run that finished with status='success'. Use this for 'last synced at HH:MM' captions; `last_run` may carry a fresher 'failed' that hasn't been retried yet. */
  lastSuccess?: Maybe<FakturowniaSyncRunType>;
  /** Invoice-issuing attempts whose outcome is UNKNOWN — a document may exist in Fakturownia that we have no record of. Each one also blocks its installment from being billed again. Non-zero needs attention: an invisible orphan blocks that взнос forever. */
  orphanSuspectedCount?: Maybe<Scalars['Int']>;
};

export type FinishLmsLessonMutation = {
  __typename?: 'FinishLmsLessonMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Flag/unflag one message (team-wide global state). */
export type FlagMessageMutation = {
  __typename?: 'FlagMessageMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<MessageType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type FutureKnowledgeType = {
  __typename?: 'FutureKnowledgeType';
  course?: Maybe<CourseFilterType>;
  descriptions: Array<KnowledgeDescriptionType>;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type FutureProfessionType = {
  __typename?: 'FutureProfessionType';
  course?: Maybe<CourseFilterType>;
  description: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

/** A shared mailbox available to send FROM (compose a new email). */
export type GmailMailboxType = {
  __typename?: 'GmailMailboxType';
  displayName: Scalars['String'];
  email: Scalars['String'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
};

/**
 * Teacher grades a student's homework — with or without a submission
 * (non-submitters get `not_done`). Writes through to
 * journals.StudentsMark.hw_mark; the comment lives on the submission.
 */
export type GradeHomeworkMutation = {
  __typename?: 'GradeHomeworkMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  row?: Maybe<HomeworkRosterRowType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type GraduateFeedbackConnection = {
  __typename?: 'GraduateFeedbackConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GraduateFeedbackEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `GraduateFeedback` and its cursor. */
export type GraduateFeedbackEdge = {
  __typename?: 'GraduateFeedbackEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<GraduateFeedbackType>;
};

export type GraduateFeedbackType = {
  __typename?: 'GraduateFeedbackType';
  course: CourseFilterTypeConnection;
  date: Scalars['Date'];
  feedback: Scalars['String'];
  graduateName: Scalars['String'];
  graduatePhoto?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  resourceIcon: Scalars['String'];
};


export type GraduateFeedbackTypeCourseArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  category_Name?: InputMaybe<Scalars['String']>;
  educationForm?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderByPublishDateFilter?: InputMaybe<Scalars['Boolean']>;
  readyToPublish?: InputMaybe<Scalars['Boolean']>;
  startDateFilter?: InputMaybe<Scalars['Boolean']>;
};

export type GraduationVideoType = {
  __typename?: 'GraduationVideoType';
  course?: Maybe<CourseFilterType>;
  description: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
  url: Scalars['String'];
};

/** Per-student attendance row inside `groupAttendanceSummary`. */
export type GroupAttendanceStudentRow = {
  __typename?: 'GroupAttendanceStudentRow';
  /** attended / expected_lessons × 100. 0 when expected_lessons is 0. */
  attendanceRate: Scalars['Float'];
  /** StudentAttendance rows with attendance=True for the expected lessons. */
  attended: Scalars['Int'];
  /** True when attendance_rate < threshold OR the student has no expected lessons yet — the UI treats both as «needs attention». */
  belowThreshold: Scalars['Boolean'];
  /** Passed lessons the student was expected to attend (clipped by agreement.terminated_date when set). */
  expectedLessons: Scalars['Int'];
  fullName: Scalars['String'];
  /** expected_lessons − attended (skipped + not marked). */
  missed: Scalars['Int'];
  studentId: Scalars['ID'];
};

/**
 * Group-level attendance rollup for the dashboard KpiStrip + ScheduleTab.
 *
 * Replaces the per-lesson fan-out the frontend used to do
 * (`journal(groupId)` + `attendances` per lesson) with a single resolver
 * pass. Threshold value comes from `settings.GROUP_ATTENDANCE_THRESHOLD`
 * so it can be tuned without a release.
 */
export type GroupAttendanceSummary = {
  __typename?: 'GroupAttendanceSummary';
  /** Mean attendance_rate over students who had at least one expected lesson. Students with 0 expected lessons are skipped from the average but still flagged below. */
  averageAttendance: Scalars['Float'];
  groupId: Scalars['ID'];
  /** GroupLesson.finished=True — the denominator for expected_lessons before per-student clipping. */
  passedLessons: Scalars['Int'];
  students: Array<GroupAttendanceStudentRow>;
  studentsBelowThresholdCount: Scalars['Int'];
  /** The 0..100 cutoff used to compute below_threshold per student. */
  threshold: Scalars['Float'];
  totalLessons: Scalars['Int'];
};

/**
 * A group's Slack channel for the whole-group inbox: the configured
 * channel (`ChannelGroupLink`, discovered via `conversations.list`) merged
 * with its `Conversation` mirror when one exists — so channels that haven't
 * received a message yet still appear (fixes the «нет каналов» blank list).
 */
export type GroupChannelRow = {
  __typename?: 'GroupChannelRow';
  channelName: Scalars['String'];
  conversationId?: Maybe<Scalars['ID']>;
  hasUnhandled: Scalars['Boolean'];
  lastMessageAt?: Maybe<Scalars['DateTime']>;
  slackChannelId: Scalars['String'];
  teamId: Scalars['String'];
  unreadCount: Scalars['Int'];
};

/**
 * The communicator middle-column badge aggregate for one group —
 * computed server-side in two set-based queries (spec 0008). Replaces the
 * frontend's ~10-page conversationsBrowser drain.
 */
export type GroupCommsIndex = {
  __typename?: 'GroupCommsIndex';
  channelsUnhandled: Scalars['Boolean'];
  channelsUnread: Scalars['Int'];
  groupId: Scalars['ID'];
  mailUnhandled: Scalars['Boolean'];
  mailUnreadTotal: Scalars['Int'];
  slackUnhandled: Scalars['Boolean'];
  slackUnreadTotal: Scalars['Int'];
  students: Array<StudentCommsBadgeRow>;
};

export type GroupConnection = {
  __typename?: 'GroupConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GroupEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/**
 * One roster row: the student plus whichever languages are attached.
 *
 * Shaped per-student rather than per-file so the ERP table renders directly
 * (student | PL | EN | actions) without a client-side group-by.
 */
export type GroupDiplomaRowType = {
  __typename?: 'GroupDiplomaRowType';
  agreementTitle?: Maybe<Scalars['String']>;
  en?: Maybe<DiplomaType>;
  pl?: Maybe<DiplomaType>;
  student: DiplomaStudentType;
};

/** A Relay edge containing a `Group` and its cursor. */
export type GroupEdge = {
  __typename?: 'GroupEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<GroupType>;
};

/**
 * Which path linked this invoice to the group it was filtered by.
 *
 * Used by `fakturowniaInvoices(group_id)` during the Phase-13 rollout
 * (docs/groups/group_dashboard.md §G7) so the frontend can show a
 * "legacy" badge on rows that only matched because the canonical
 * `payment → agreement → group` chain hadn't reached them yet.
 * Distinct from the existing `group_match_source` field, which records
 * how the legacy `linked_group` FK itself was assigned.
 */
export enum GroupFilterSourceEnum {
  Canonical = 'CANONICAL',
  LegacyLinkedGroup = 'LEGACY_LINKED_GROUP'
}

export type GroupInput = {
  course_id: Scalars['Int'];
  currency: Scalars['String'];
  daysOfClass: Array<DayOfClassInput>;
  name: Scalars['String'];
  price: Scalars['Float'];
  startDate: Scalars['Date'];
};

export type GroupLessonConnection = {
  __typename?: 'GroupLessonConnection';
  comment?: Maybe<Scalars['String']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GroupLessonEdge>>;
  groupName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `GroupLesson` and its cursor. */
export type GroupLessonEdge = {
  __typename?: 'GroupLessonEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<GroupLessonType>;
};

export type GroupLessonForLmsType = Node & {
  __typename?: 'GroupLessonForLMSType';
  additional?: Maybe<Scalars['Boolean']>;
  comment?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  endTime: Scalars['Time'];
  finished: Scalars['Boolean'];
  hasJoinLink?: Maybe<Scalars['Boolean']>;
  hasStudentAttachment?: Maybe<Scalars['Boolean']>;
  hasStudentMarks?: Maybe<Scalars['Boolean']>;
  hasTeacherAttachment?: Maybe<Scalars['Boolean']>;
  homeworkAssignmentId?: Maybe<Scalars['ID']>;
  homeworkAvailable?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  lessonNumber?: Maybe<Scalars['Int']>;
  linkOverrideActive?: Maybe<Scalars['Boolean']>;
  lmsDescription?: Maybe<Scalars['String']>;
  marks: StudentsMarkTypeConnection;
  /** Optional — for group-wide handouts leave NULL; for per-lesson homework point at the specific GroupLesson. */
  materials: Array<MaterialType>;
  module: GroupModuleType;
  name: Scalars['String'];
  needToFinish?: Maybe<Scalars['Boolean']>;
  number: Scalars['Int'];
  startTime: Scalars['Time'];
  students: StudentTypeConnection;
  taskTypes: Array<Scalars['String']>;
  teacher?: Maybe<TeacherType>;
  teacherApplication?: Maybe<ApplicationType>;
  video?: Maybe<Scalars['String']>;
  whiteboardId?: Maybe<Scalars['ID']>;
  zoomProcessingLogs: ZoomProcessingLogTypeConnection;
  zoomRecordingMeta?: Maybe<LessonRecordingType>;
};


export type GroupLessonForLmsTypeMarksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  lessonId?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  taskType?: InputMaybe<Scalars['String']>;
};


export type GroupLessonForLmsTypeStudentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type GroupLessonForLmsTypeZoomProcessingLogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type GroupLessonType = Node & {
  __typename?: 'GroupLessonType';
  additional?: Maybe<Scalars['Boolean']>;
  attendances: AttendanceTypeConnection;
  comment?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  endTime: Scalars['Time'];
  finished: Scalars['Boolean'];
  hasStudentMarks?: Maybe<Scalars['Boolean']>;
  homeworkStats?: Maybe<LessonHomeworkStatsType>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  lessonNumber?: Maybe<Scalars['Int']>;
  lmsDescription?: Maybe<Scalars['String']>;
  marks: StudentsMarkTypeConnection;
  /** Optional — for group-wide handouts leave NULL; for per-lesson homework point at the specific GroupLesson. */
  materials: Array<MaterialType>;
  module: GroupModuleType;
  name: Scalars['String'];
  needToFinish?: Maybe<Scalars['Boolean']>;
  number: Scalars['Int'];
  startTime: Scalars['Time'];
  students: StudentTypeConnection;
  studentsAttachments: StudentLessonAttachmentTypeConnection;
  taskTypes: Array<Scalars['String']>;
  teacher?: Maybe<TeacherType>;
  teacherApplication?: Maybe<ApplicationType>;
  teachersAttachments: TeacherLessonAttachmentTypeConnection;
  video?: Maybe<Scalars['String']>;
  whiteboardId?: Maybe<Scalars['ID']>;
  zoomProcessingLogs: ZoomProcessingLogTypeConnection;
  zoomRecordingMeta?: Maybe<LessonRecordingType>;
};


export type GroupLessonTypeAttendancesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type GroupLessonTypeMarksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  lessonId?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  taskType?: InputMaybe<Scalars['String']>;
};


export type GroupLessonTypeStudentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type GroupLessonTypeStudentsAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type GroupLessonTypeTeachersAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type GroupLessonTypeZoomProcessingLogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type GroupLessonTypeConnection = {
  __typename?: 'GroupLessonTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GroupLessonTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `GroupLessonType` and its cursor. */
export type GroupLessonTypeEdge = {
  __typename?: 'GroupLessonTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<GroupLessonType>;
};

/**
 * Временная ссылка на день (spec 0013). Плоский ObjectType поверх модели
 * (НЕ DjangoObjectType — чтобы ничего не авто-протекло в другие типы);
 * отдаётся только role-gated резолвером на GroupType.
 */
export type GroupLinkOverrideType = {
  __typename?: 'GroupLinkOverrideType';
  createdAt?: Maybe<Scalars['DateTime']>;
  date: Scalars['Date'];
  id: Scalars['ID'];
  joinUrl: Scalars['String'];
  setByName?: Maybe<Scalars['String']>;
  setVia?: Maybe<Scalars['String']>;
};

/**
 * One row of the ERP recipient picker: a student plus, when relevant, the
 * most recent unpaid invoice we would reference in the email.
 */
export type GroupMailCandidateType = {
  __typename?: 'GroupMailCandidateType';
  agreementTitle?: Maybe<Scalars['String']>;
  daysOverdue: Scalars['Int'];
  email?: Maybe<Scalars['String']>;
  invoiceCurrency?: Maybe<Scalars['String']>;
  invoiceDueDate?: Maybe<Scalars['Date']>;
  invoiceId?: Maybe<Scalars['ID']>;
  invoiceIssueDate?: Maybe<Scalars['Date']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  invoiceOutstanding?: Maybe<Scalars['Float']>;
  invoiceUrl?: Maybe<Scalars['String']>;
  isOverdue: Scalars['Boolean'];
  lastMailedAt?: Maybe<Scalars['DateTime']>;
  studentId: Scalars['ID'];
  studentName: Scalars['String'];
};

export type GroupModuleType = {
  __typename?: 'GroupModuleType';
  group: MethodistGroupType;
  id: Scalars['ID'];
  lessons: GroupLessonTypeConnection;
  name: Scalars['String'];
};


export type GroupModuleTypeLessonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
};

/**
 * One group's at-a-glance signals for the account-manager command-center
 * dashboard (spec 0003 redesign): enrolment, contribution-based debt (NOT
 * Fakturownia), unanswered Slack/email, and open/overdue tasks. `debtTotal`
 * is the largest single-currency debt (with its `debtCurrency`); the group
 * card shows the full per-currency money model.
 */
export type GroupOverviewRow = {
  __typename?: 'GroupOverviewRow';
  course: Scalars['String'];
  debtCurrency: Scalars['String'];
  debtTotal: Scalars['Float'];
  debtorsCount: Scalars['Int'];
  groupId: Scalars['ID'];
  name: Scalars['String'];
  openTasksCount: Scalars['Int'];
  overdueTasksCount: Scalars['Int'];
  startDate?: Maybe<Scalars['Date']>;
  studentsCount: Scalars['Int'];
  /** Число студентов группы, у которых есть хотя бы одно НЕОБРАБОТАННОЕ входящее сообщение (Message.is_handled=False, direction=inbound) — оранжевая точка. Считает уникальных студентов, а не сообщения: студент, написавший и в Slack, и на почту, — один. Канал группы (без студента) добавляет +1 за себя. Прочитанность и статус диалога не учитываются. */
  unhandledStudentsCount: Scalars['Int'];
  /** Число НЕПРОЧИТАННЫХ сообщений (Message.is_read=False) по диалогам группы: её каналы плюс личные диалоги её АКТИВНЫХ студентов (Slack DM / Gmail) — та же популяция и способ атрибуции, что и unhandledStudentsCount. Каждое непрочитанное сообщение считается один раз (per-conversation unreadCount). Обычно совпадает с суммой бейджей внутри группы, но может немного отличаться: средняя колонка коммуникатора дополнительно показывает отчисленных студентов с непрочитанным и внероестерных собеседников из DM, которых этот счётчик по активным студентам не учитывает. */
  unreadMessagesCount: Scalars['Int'];
  /** Число студентов группы, у которых есть хотя бы одно непрочитанное сообщение (Message.is_read=False). Считает уникальных студентов, а не сообщения/диалоги; каналы (без студента) в счётчик не входят. */
  unreadStudentsCount: Scalars['Int'];
};

/**
 * Group-level marks rollup — §G4. `average_mark` is a weighted mean
 * across students who have at least one mark; null when the journal is
 * empty.
 */
export type GroupPerformanceSummary = {
  __typename?: 'GroupPerformanceSummary';
  averageMark?: Maybe<Scalars['Float']>;
  bottom: Array<StudentPerfRow>;
  groupId: Scalars['ID'];
  studentsWithoutMarks: Scalars['Int'];
  top: Array<StudentPerfRow>;
};

/**
 * Per-currency revenue rollup for the group dashboard KpiStrip
 * (docs/groups/group_dashboard.md §G5). Lets the frontend drop the
 * heavy `agreements[].payments[]` payload on big groups.
 */
export type GroupRevenueAggregates = {
  __typename?: 'GroupRevenueAggregates';
  groupId: Scalars['ID'];
  rows: Array<GroupRevenueRow>;
};

/**
 * One currency bucket of `groupRevenueAggregates` (§G5).
 *
 * Mirrors the client-side aggregation in `KpiStrip.tsx`: Number-coerce
 * decimals, clamp debt at 0.
 */
export type GroupRevenueRow = {
  __typename?: 'GroupRevenueRow';
  agreementsActive: Scalars['Int'];
  budget: Scalars['Float'];
  currency: Scalars['String'];
  debt: Scalars['Float'];
  paid: Scalars['Float'];
  studentsWithDebt: Scalars['Int'];
};

export type GroupType = Node & {
  __typename?: 'GroupType';
  activeLinkOverride?: Maybe<GroupLinkOverrideType>;
  agreements: Array<AgreementType>;
  agreementsConnection?: Maybe<AgreementConnection>;
  classesDays: Array<DayOfClassType>;
  comment?: Maybe<Scalars['String']>;
  contributionsSum?: Maybe<Scalars['CustomFloat']>;
  conversations: Array<ConversationType>;
  course: CourseFilterType;
  currency?: Maybe<Scalars['String']>;
  datetimeNextLesson?: Maybe<Scalars['DateTime']>;
  daysOfClass: Array<Scalars['Int']>;
  deleteAvailable?: Maybe<Scalars['Boolean']>;
  /** Optional — when the spend belongs to a specific group (teacher payout per group, group materials, etc.) */
  expenses: Array<ExpenseType>;
  /** DEPRECATED: use invoice.payment.agreement.group. */
  fakturowniaInvoices: Array<FakturowniaInvoiceType>;
  freeLessonsCount?: Maybe<Scalars['Int']>;
  freePlaces?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isFree: Scalars['Boolean'];
  lessonJoinUrl?: Maybe<Scalars['String']>;
  lessons?: Maybe<Array<GroupLessonType>>;
  lessonsCount?: Maybe<Scalars['Int']>;
  materials: Array<MaterialType>;
  maxStudentsCount: Scalars['Int'];
  modules: Array<GroupModuleType>;
  name: Scalars['String'];
  notes: Array<StudentNoteType>;
  passedLessonsCount?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['CustomFloat']>;
  publishedLms: Scalars['Boolean'];
  publishedLmsForMethodist: Scalars['Boolean'];
  publishedLmsForTeacher: Scalars['Boolean'];
  slackChannels: Array<ChannelGroupLinkType>;
  slackWorkspace?: Maybe<SlackWorkspaceLinkType>;
  startDate: Scalars['Date'];
  statusFinished?: Maybe<Scalars['Boolean']>;
  studentsCount?: Maybe<Scalars['Int']>;
  tasks: Array<StaffTaskType>;
  teacherLeads: ApplicationFilterTypeConnection;
  teachers?: Maybe<Array<Maybe<TeacherType>>>;
  zoomAccount?: Maybe<ZoomAccountType>;
  zoomSchedules: GroupZoomScheduleTypeConnection;
};


export type GroupTypeAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  hasDebt?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AgreementOrderByEnum>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<RosterStatusEnum>;
};


export type GroupTypeTeacherLeadsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  byGroupId?: InputMaybe<Scalars['Decimal']>;
  first?: InputMaybe<Scalars['Int']>;
  isTerminated?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type GroupTypeZoomSchedulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type GroupZoomScheduleConnection = {
  __typename?: 'GroupZoomScheduleConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GroupZoomScheduleEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `GroupZoomSchedule` and its cursor. */
export type GroupZoomScheduleEdge = {
  __typename?: 'GroupZoomScheduleEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<GroupZoomScheduleType>;
};

export type GroupZoomScheduleSlotInput = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  runTime: Scalars['Time'];
  weekDay: Scalars['Int'];
};

export type GroupZoomScheduleType = Node & {
  __typename?: 'GroupZoomScheduleType';
  createdAt: Scalars['DateTime'];
  group: MethodistGroupType;
  /** The ID of the object */
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  runTime: Scalars['Time'];
  updatedAt: Scalars['DateTime'];
  weekDay: GroupZoomScheduleWeekDay;
  weekDayDisplay?: Maybe<Scalars['String']>;
};

export type GroupZoomScheduleTypeConnection = {
  __typename?: 'GroupZoomScheduleTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GroupZoomScheduleTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `GroupZoomScheduleType` and its cursor. */
export type GroupZoomScheduleTypeEdge = {
  __typename?: 'GroupZoomScheduleTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<GroupZoomScheduleType>;
};

/** An enumeration. */
export enum GroupZoomScheduleWeekDay {
  /** Monday */
  A_0 = 'A_0',
  /** Tuesday */
  A_1 = 'A_1',
  /** Wednesday */
  A_2 = 'A_2',
  /** Thursday */
  A_3 = 'A_3',
  /** Friday */
  A_4 = 'A_4',
  /** Saturday */
  A_5 = 'A_5',
  /** Sunday */
  A_6 = 'A_6'
}

export type GroupsType = {
  __typename?: 'GroupsType';
  agreements: Array<AgreementType>;
  classesDays: Array<DayOfClassType>;
  comment?: Maybe<Scalars['String']>;
  conversations: Array<ConversationType>;
  course: CourseFilterType;
  /** Optional — when the spend belongs to a specific group (teacher payout per group, group materials, etc.) */
  expenses: Array<ExpenseType>;
  /** DEPRECATED: use invoice.payment.agreement.group. */
  fakturowniaInvoices: Array<FakturowniaInvoiceType>;
  id: Scalars['ID'];
  isFree: Scalars['Boolean'];
  materials: Array<MaterialType>;
  maxStudentsCount: Scalars['Int'];
  modules: Array<GroupModuleType>;
  name: Scalars['String'];
  notes: Array<StudentNoteType>;
  publishedLms: Scalars['Boolean'];
  publishedLmsForMethodist: Scalars['Boolean'];
  publishedLmsForTeacher: Scalars['Boolean'];
  slackChannels: Array<ChannelGroupLinkType>;
  slackWorkspace?: Maybe<SlackWorkspaceLinkType>;
  startDate: Scalars['Date'];
  tasks: Array<StaffTaskType>;
  teacherLeads: ApplicationFilterTypeConnection;
  zoomAccount?: Maybe<ZoomAccountType>;
  zoomSchedules: GroupZoomScheduleTypeConnection;
};


export type GroupsTypeTeacherLeadsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  byGroupId?: InputMaybe<Scalars['Decimal']>;
  first?: InputMaybe<Scalars['Int']>;
  isTerminated?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type GroupsTypeZoomSchedulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/**
 * Parent is a HomeworkAiReview. Staff-facing ONLY — never reachable
 * from the student types below.
 */
export type HomeworkAiReviewType = {
  __typename?: 'HomeworkAiReviewType';
  aiJustification?: Maybe<Scalars['String']>;
  aiModel?: Maybe<Scalars['String']>;
  aiScore?: Maybe<Scalars['Int']>;
  aiSummary?: Maybe<Scalars['String']>;
  analyzedAt?: Maybe<Scalars['DateTime']>;
  assignmentSource?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  filesUsedCount?: Maybe<Scalars['Int']>;
  promptVersion?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  suspicionNotes?: Maybe<Scalars['String']>;
  suspiciousContent: Scalars['Boolean'];
  truncatedBasis?: Maybe<Scalars['Boolean']>;
};

/**
 * Parent is {'lesson': GroupLesson, 'assignment': Material|None,
 * 'has_teacher_assignment': bool, 'submission': ..., 'hw_mark': ...,
 * 'can_submit': bool} from services.roster.my_lesson_homework.
 *
 * The assignment is optional (rev.3): when the teacher created nothing,
 * `has_teacher_assignment` is False, `title`/`text` are null, and the LMS
 * shows a "see the lesson materials" note over an open submit form.
 */
export type HomeworkAssignmentForStudentType = {
  __typename?: 'HomeworkAssignmentForStudentType';
  canSubmit: Scalars['Boolean'];
  dueDate?: Maybe<Scalars['Date']>;
  hasTeacherAssignment: Scalars['Boolean'];
  id: Scalars['ID'];
  lessonId: Scalars['ID'];
  mySubmission?: Maybe<MyHomeworkSubmissionType>;
  text?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** Parent is a materials.Material (kind=HOMEWORK). Staff-facing. */
export type HomeworkAssignmentType = {
  __typename?: 'HomeworkAssignmentType';
  dueDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  lessonId: Scalars['ID'];
  text: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/**
 * Parent is {'student': Student, 'submission': HomeworkSubmission|None,
 * 'hw_mark': str|None} from services.roster.
 */
export type HomeworkRosterRowType = {
  __typename?: 'HomeworkRosterRowType';
  hwMark?: Maybe<Scalars['String']>;
  studentId: Scalars['ID'];
  studentName: Scalars['String'];
  submission?: Maybe<HomeworkSubmissionType>;
};

/**
 * Parent is a HomeworkSubmission (ai_review/graded_by select_related
 * by the services). Staff-facing.
 */
export type HomeworkSubmissionType = {
  __typename?: 'HomeworkSubmissionType';
  aiReview?: Maybe<HomeworkAiReviewType>;
  attempt: Scalars['Int'];
  fileName?: Maybe<Scalars['String']>;
  fileSizeBytes?: Maybe<Scalars['Int']>;
  githubUrl?: Maybe<Scalars['String']>;
  gradedAt?: Maybe<Scalars['DateTime']>;
  gradedByName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  status: Scalars['String'];
  submittedAt: Scalars['DateTime'];
  teacherComment?: Maybe<Scalars['String']>;
};

export type IndividualEntrepreneurInput = {
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  inn: Scalars['String'];
  registrationAddress: Scalars['String'];
};

export type IndividualEntrepreneurType = Node & {
  __typename?: 'IndividualEntrepreneurType';
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  id: Scalars['ID'];
  inn: Scalars['String'];
  registrationAddress: Scalars['String'];
};

export type KnowledgeDescriptionType = {
  __typename?: 'KnowledgeDescriptionType';
  description: Scalars['String'];
  futureKnowledge: FutureKnowledgeType;
  id: Scalars['ID'];
};

export type LmsAuthenticationInput = {
  email: Scalars['String'];
  scope: Scalars['String'];
};

export type LanguageSkillType = {
  __typename?: 'LanguageSkillType';
  id: Scalars['ID'];
  language: Scalars['String'];
  level: Scalars['String'];
};

export type LeadInput = {
  course_id?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  formName: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  promocode?: InputMaybe<Scalars['String']>;
  referer?: InputMaybe<Scalars['String']>;
  roistatId: Scalars['String'];
  tittle: Scalars['String'];
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  utmTerm?: InputMaybe<Scalars['String']>;
};

export type LegalEntityInput = {
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  inn: Scalars['String'];
  registrationAddress: Scalars['String'];
  tittle: Scalars['String'];
};

export type LegalEntityPublicOfferAgreementType = Node & {
  __typename?: 'LegalEntityPublicOfferAgreementType';
  agreementDate: Scalars['Date'];
  content: Scalars['String'];
  displayPage: LegalEntityPublicOfferPageType;
  file: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
};

export type LegalEntityPublicOfferAgreementTypeConnection = {
  __typename?: 'LegalEntityPublicOfferAgreementTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LegalEntityPublicOfferAgreementTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LegalEntityPublicOfferAgreementType` and its cursor. */
export type LegalEntityPublicOfferAgreementTypeEdge = {
  __typename?: 'LegalEntityPublicOfferAgreementTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<LegalEntityPublicOfferAgreementType>;
};

export type LegalEntityPublicOfferPageType = {
  __typename?: 'LegalEntityPublicOfferPageType';
  actualPublicOfferAgreement?: Maybe<LegalEntityPublicOfferAgreementType>;
  id: Scalars['ID'];
  publicOfferAgreements: LegalEntityPublicOfferAgreementTypeConnection;
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoTitle: Scalars['String'];
  title: Scalars['String'];
};


export type LegalEntityPublicOfferPageTypePublicOfferAgreementsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type LegalEntityType = Node & {
  __typename?: 'LegalEntityType';
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  id: Scalars['ID'];
  inn: Scalars['String'];
  registrationAddress: Scalars['String'];
  tittle: Scalars['String'];
};

export type LessonAttachmentsForLmsType = {
  __typename?: 'LessonAttachmentsForLMSType';
  file: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type LessonAttachmentsType = {
  __typename?: 'LessonAttachmentsType';
  file?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
};

export type LessonAttendancesType = Node & {
  __typename?: 'LessonAttendancesType';
  attendance?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lesson: GroupLessonType;
  student: StudentType;
};

/**
 * Parent is the stats dict from services.eligibility
 * (homework_stats_for_lessons) — dict keys match the snake_case field
 * names, so graphene's default resolver handles them.
 */
export type LessonHomeworkStatsType = {
  __typename?: 'LessonHomeworkStatsType';
  aiDoneCount: Scalars['Int'];
  gradedCount: Scalars['Int'];
  hasAssignment: Scalars['Boolean'];
  lessonId: Scalars['ID'];
  submittedCount: Scalars['Int'];
  suspiciousCount: Scalars['Int'];
  totalStudents: Scalars['Int'];
};

export type LessonInput = {
  additional?: InputMaybe<Scalars['Boolean']>;
  lmsDescription?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  studentsAttachments?: InputMaybe<Array<Scalars['Int']>>;
  taskTypes?: InputMaybe<Array<Scalars['String']>>;
  teachersAttachments?: InputMaybe<Array<Scalars['Int']>>;
};

/** ERP «Кто заходил» по занятию (spec 0013). */
export type LessonJoinClickType = {
  __typename?: 'LessonJoinClickType';
  clickedAt: Scalars['DateTime'];
  id: Scalars['ID'];
  role?: Maybe<Scalars['String']>;
  userName: Scalars['String'];
};

export type LessonMarkInput = {
  hwMark?: InputMaybe<StudentHwTypeEnum>;
  mark?: InputMaybe<Scalars['Int']>;
  student_id: Scalars['Int'];
};

export type LessonRecordingConnection = {
  __typename?: 'LessonRecordingConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LessonRecordingEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `LessonRecording` and its cursor. */
export type LessonRecordingEdge = {
  __typename?: 'LessonRecordingEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<LessonRecordingType>;
};

/** An enumeration. */
export enum LessonRecordingMatchedBy {
  /** Auto */
  Auto = 'AUTO',
  /** Manual */
  Manual = 'MANUAL'
}

/** An enumeration. */
export enum LessonRecordingStatus {
  /** AI completed */
  AiCompleted = 'AI_COMPLETED',
  /** AI processing */
  AiProcessing = 'AI_PROCESSING',
  /** Downloading */
  Downloading = 'DOWNLOADING',
  /** Failed */
  Failed = 'FAILED',
  /** Matched */
  Matched = 'MATCHED',
  /** Published */
  Published = 'PUBLISHED',
  /** Skipped */
  Skipped = 'SKIPPED',
  /** Uploaded */
  Uploaded = 'UPLOADED'
}

export type LessonRecordingType = Node & {
  __typename?: 'LessonRecordingType';
  aiModel: Scalars['String'];
  aiSummary: Scalars['String'];
  aiTimecodes: Scalars['JSONString'];
  ambiguous: Scalars['Boolean'];
  audioS3Key: Scalars['String'];
  chatS3Key: Scalars['String'];
  createdAt: Scalars['DateTime'];
  errorMessage: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  lastAttemptAt?: Maybe<Scalars['DateTime']>;
  lesson?: Maybe<GroupLessonForLmsType>;
  matchedBy: LessonRecordingMatchedBy;
  matchedByUser?: Maybe<CustomUserType>;
  processingLogs?: Maybe<Array<Maybe<ZoomProcessingLogType>>>;
  retryCount: Scalars['Int'];
  status: LessonRecordingStatus;
  transcriptS3Key: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  zoomRecording?: Maybe<ZoomRecordingType>;
};

/** An enumeration. */
export enum LessonTaskTypeEnum {
  /** coursework */
  Coursework = 'coursework',
  /** graduation_project */
  GraduationProject = 'graduation_project',
  /** homework */
  Homework = 'homework'
}

/** Map a Slack channel id to a Group. */
export type LinkChannelGroupMutation = {
  __typename?: 'LinkChannelGroupMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type LinkContributionInput = {
  contributionId: Scalars['ID'];
  paymentId: Scalars['ID'];
};

/**
 * Attach an existing Payment to an existing Contribution (1:1).
 *
 * Used by the frontend "Перепривязать" / "Привязать существующий платёж"
 * action on the schedule row. The happy path also flips
 * `contribution.complete=True` and recomputes `remainder` via
 * `Contribution.save()` (§9.5).
 */
export type LinkContributionToPaymentMutation = {
  __typename?: 'LinkContributionToPaymentMutation';
  contribution?: Maybe<ContributionType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  payment?: Maybe<PaymentType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type LinkLessonWhiteboardMutation = {
  __typename?: 'LinkLessonWhiteboardMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  whiteboard?: Maybe<WhiteboardType>;
};

/**
 * Attach a PandaDoc document to an existing agreement (manual link from
 * the student card). Does not create a Student/Agreement and does not touch
 * `provisioned_at`.
 */
export type LinkPandadocDocumentMutation = {
  __typename?: 'LinkPandadocDocumentMutation';
  document?: Maybe<PandaDocDocumentType>;
  errors?: Maybe<Scalars['JSONString']>;
};

/**
 * Attach a `trainer` PandaDoc document to a Teacher (from the teacher
 * card). The teacher analog of LinkPandadocDocumentMutation.
 */
export type LinkPandadocTeacherMutation = {
  __typename?: 'LinkPandadocTeacherMutation';
  document?: Maybe<PandaDocDocumentType>;
  errors?: Maybe<Scalars['JSONString']>;
};

/**
 * Map a Slack user id to a Student (for DM mirroring). The manual
 * fallback for auto-matching by email — a student may sit in Slack under an
 * email we don't know.
 */
export type LinkSlackUserMutation = {
  __typename?: 'LinkSlackUserMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Read-only public subset of `students.StudentAccessBlock` for the LMS.
 *
 * Only the fields the LMS banner needs — never the operator/audit fields.
 * Resolves to None unless the student is actually blocked, so `me
 * { lmsAccessBlock }` is null for everyone with access.
 *
 * `reason` holds the operator's internal note and MUST NOT reach the
 * student, so it always resolves to null (see resolve_lms_access_block).
 * The field is kept on the type only so the LMS `UserFields` fragment that
 * still selects `reason` stays valid.
 */
export type LmsAccessBlockType = {
  __typename?: 'LmsAccessBlockType';
  isBlocked: Scalars['Boolean'];
  overdueAmount?: Maybe<Scalars['Float']>;
  reason?: Maybe<Scalars['String']>;
};

export type LmsAttendanceType = {
  attendance: Scalars['Boolean'];
  id: Scalars['Int'];
};

export type LmsClearTodayLessonLink = {
  __typename?: 'LmsClearTodayLessonLink';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type LmsJoinLesson = {
  __typename?: 'LmsJoinLesson';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  redirectUrl?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Подсказка журнала преподавателя: первый клик студента (spec 0013).
 * Резолвится из dict-ов сервиса first_clicks_per_student.
 */
export type LmsLessonJoinClickType = {
  __typename?: 'LmsLessonJoinClickType';
  clickedAt: Scalars['DateTime'];
  studentId: Scalars['Int'];
  studentName: Scalars['String'];
};

/** An enumeration. */
export enum LmsRoles {
  /** Methodist */
  Methodist = 'METHODIST',
  /** Student */
  Student = 'STUDENT',
  /** Teacher */
  Teacher = 'TEACHER'
}

export type LmsSetTodayLessonLink = {
  __typename?: 'LmsSetTodayLessonLink';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** A mailing run: live send progress plus aggregate delivery telemetry. */
export type MailJobType = {
  __typename?: 'MailJobType';
  bouncedCount: Scalars['Int'];
  clickedCount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  createdByName?: Maybe<Scalars['String']>;
  deliveredCount: Scalars['Int'];
  errorMessage: Scalars['String'];
  failedCount: Scalars['Int'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  fromEmail: Scalars['String'];
  id: Scalars['ID'];
  openedCount: Scalars['Int'];
  recipients: Array<MailRecipientType>;
  sentCount: Scalars['Int'];
  startedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  /** Blank ⇒ the template's own subject is used. */
  subjectOverride: Scalars['String'];
  templateId: Scalars['String'];
  templateName: Scalars['String'];
  total: Scalars['Int'];
};

export type MailRecipientInput = {
  /** Invoice to reference in the email. Omit for templates that don't mention one (e.g. 'course starts soon'). */
  invoiceId?: InputMaybe<Scalars['ID']>;
  studentId: Scalars['ID'];
};

/** Per-recipient outcome: whether we sent it, and what SendGrid reported. */
export type MailRecipientType = {
  __typename?: 'MailRecipientType';
  bounceReason: Scalars['String'];
  bouncedAt?: Maybe<Scalars['DateTime']>;
  clickCount: Scalars['Int'];
  deliveredAt?: Maybe<Scalars['DateTime']>;
  dropReason: Scalars['String'];
  droppedAt?: Maybe<Scalars['DateTime']>;
  /** Snapshot of the address used — the account email may change later. */
  email: Scalars['String'];
  firstClickedAt?: Maybe<Scalars['DateTime']>;
  firstOpenedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  invoiceCurrency?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  invoiceOutstanding?: Maybe<Scalars['Float']>;
  lastClickUrl: Scalars['String'];
  openCount: Scalars['Int'];
  reason: Scalars['String'];
  sentAt?: Maybe<Scalars['DateTime']>;
  spamAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  studentId: Scalars['ID'];
  studentName: Scalars['String'];
  unsubscribedAt?: Maybe<Scalars['DateTime']>;
};

export type MainPageInfoType = {
  __typename?: 'MainPageInfoType';
  description: Scalars['String'];
  id: Scalars['ID'];
  image: Scalars['String'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoTitle: Scalars['String'];
  title: Scalars['String'];
};

export type MainTeacherWebType = Node & {
  __typename?: 'MainTeacherWebType';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mainTeachers: TeacherFilterTypeConnection;
  title?: Maybe<Scalars['String']>;
};


export type MainTeacherWebTypeMainTeachersArgs = {
  after?: InputMaybe<Scalars['String']>;
  availability?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  course?: InputMaybe<Scalars['Decimal']>;
  first?: InputMaybe<Scalars['Int']>;
  hasDescription?: InputMaybe<Scalars['Boolean']>;
  hasInterview?: InputMaybe<Scalars['Boolean']>;
  hasPhoto?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  minRating?: InputMaybe<Scalars['Decimal']>;
  offset?: InputMaybe<Scalars['Int']>;
  siteDisplay?: InputMaybe<Scalars['Boolean']>;
};

export type MainTeacherWebTypeConnection = {
  __typename?: 'MainTeacherWebTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MainTeacherWebTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MainTeacherWebType` and its cursor. */
export type MainTeacherWebTypeEdge = {
  __typename?: 'MainTeacherWebTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<MainTeacherWebType>;
};

/** LMS: record that the student opened a lesson — viewed, NOT completed. */
export type MarkCareerLessonOpened = {
  __typename?: 'MarkCareerLessonOpened';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  openCount?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Record an off-invoice payment against an installment.
 *
 * Creates the hidden `Payment(source='manual_paid')` and links it through
 * the manual 1:1 edge (`contribution.payment`). Amount defaults to the
 * installment's remainder. The row then reads «оплачен вручную».
 */
export type MarkContributionPaidManuallyMutation = {
  __typename?: 'MarkContributionPaidManuallyMutation';
  contribution?: Maybe<ContributionType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Bulk-set the read flag on every message of a conversation. `read=false`
 * marks the whole thread unread (to revisit it later).
 */
export type MarkConversationReadMutation = {
  __typename?: 'MarkConversationReadMutation';
  conversation?: Maybe<ConversationType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  updated?: Maybe<Scalars['Int']>;
};

export type MarkLessonMissingRecordingMutation = {
  __typename?: 'MarkLessonMissingRecordingMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lessonRecording?: Maybe<LessonRecordingType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Mark one message read/unread (team-wide global state). */
export type MarkMessageReadMutation = {
  __typename?: 'MarkMessageReadMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<MessageType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** LMS: a member saves a vacancy or marks that they applied. */
export type MarkVacancyInteraction = {
  __typename?: 'MarkVacancyInteraction';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  vacancy?: Maybe<VacancyType>;
};

/**
 * Dry-run: propose a (student, language) for each file NAME.
 *
 * A mutation rather than a query only because clients treat it as an action;
 * it performs no writes.
 */
export type MatchDiplomaFilesMutation = {
  __typename?: 'MatchDiplomaFilesMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  preview?: Maybe<DiplomaMatchPreviewType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type MaterialAttachmentType = {
  __typename?: 'MaterialAttachmentType';
  contentType: Scalars['String'];
  id: Scalars['ID'];
  material: MaterialType;
  originalName: Scalars['String'];
  pk?: Maybe<Scalars['Int']>;
  sizeBytes: Scalars['Int'];
  uploadedAt: Scalars['DateTime'];
  /** Signed S3 URL with the project's default TTL. The frontend treats this as opaque; the link expires after `LESSON_RECORDING_VIDEO_EXPIRE` (settings). */
  url?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum MaterialKindEnum {
  Homework = 'HOMEWORK',
  Other = 'OTHER',
  Reading = 'READING',
  Video = 'VIDEO'
}

export type MaterialType = {
  __typename?: 'MaterialType';
  attachments: Array<MaterialAttachmentType>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<CustomUserType>;
  description: Scalars['String'];
  /** HOMEWORK only; ignored for other kinds. */
  dueDate?: Maybe<Scalars['Date']>;
  group: MethodistGroupType;
  id: Scalars['ID'];
  kind: MaterialKindEnum;
  /** Optional — for group-wide handouts leave NULL; for per-lesson homework point at the specific GroupLesson. */
  lesson?: Maybe<GroupLessonType>;
  pk?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/**
 * Keyset (sent_at, id) connection — correct under head inserts, unlike an
 * offset cursor that would skip/dup as new messages arrive.
 */
export type MessageConnection = {
  __typename?: 'MessageConnection';
  edges?: Maybe<Array<MessageEdge>>;
  pageInfo?: Maybe<MessagePageInfo>;
};

export type MessageEdge = {
  __typename?: 'MessageEdge';
  cursor?: Maybe<Scalars['String']>;
  node?: Maybe<MessageType>;
};

export type MessagePageInfo = {
  __typename?: 'MessagePageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
};

export type MessageType = {
  __typename?: 'MessageType';
  /** Human name of the author: stored author_name (Gmail / reply mirrors) → workspace member name from SlackUserLink (linked student «Фамилия Имя», otherwise Slack display name) → the raw external id. */
  authorDisplay?: Maybe<Scalars['String']>;
  authorExternalId: Scalars['String'];
  authorName: Scalars['String'];
  body: Scalars['String'];
  channelName?: Maybe<Scalars['String']>;
  conversationId?: Maybe<Scalars['ID']>;
  direction?: Maybe<Scalars['String']>;
  externalId: Scalars['String'];
  id: Scalars['ID'];
  isFlagged: Scalars['Boolean'];
  isHandled: Scalars['Boolean'];
  isRead: Scalars['Boolean'];
  kind?: Maybe<Scalars['String']>;
  linkedTask?: Maybe<StaffTaskType>;
  sentAt: Scalars['DateTime'];
};

export type MetaContribution = {
  __typename?: 'MetaContribution';
  /** Deprecated from 1.3.0 version. */
  contributionsCount?: Maybe<Scalars['Int']>;
  contributionsNums: Array<Maybe<Scalars['Int']>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type MetaCourses = {
  __typename?: 'MetaCourses';
  totalCount?: Maybe<Scalars['Int']>;
};

export type MetaDeferredPayment = Node & {
  __typename?: 'MetaDeferredPayment';
  deferredPaymentsDate?: Maybe<Scalars['Date']>;
  /** The ID of the object */
  id: Scalars['ID'];
  totalCount?: Maybe<Scalars['Int']>;
};

export type MetaDeferredPaymentConnection = {
  __typename?: 'MetaDeferredPaymentConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MetaDeferredPaymentEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MetaDeferredPayment` and its cursor. */
export type MetaDeferredPaymentEdge = {
  __typename?: 'MetaDeferredPaymentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<MetaDeferredPayment>;
};

export type MetaGroups = {
  __typename?: 'MetaGroups';
  totalCount?: Maybe<Scalars['Int']>;
};

export type MetaStudents = {
  __typename?: 'MetaStudents';
  agreementsCount?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type MetaTeacherApplications = {
  __typename?: 'MetaTeacherApplications';
  totalCount?: Maybe<Scalars['Int']>;
};

export type MetaTeachers = {
  __typename?: 'MetaTeachers';
  /** Returns applications count */
  applicationsCount?: Maybe<Scalars['Int']>;
  /** Returns teachers count */
  totalCount?: Maybe<Scalars['Int']>;
};

export type MetaUsersSettings = {
  __typename?: 'MetaUsersSettings';
  totalCount?: Maybe<Scalars['Int']>;
};

export type MethodistGroupType = Node & {
  __typename?: 'MethodistGroupType';
  activeLinkOverride?: Maybe<GroupLinkOverrideType>;
  agreements: Array<AgreementType>;
  agreementsConnection?: Maybe<AgreementConnection>;
  classesDays: Array<DayOfClassType>;
  comment?: Maybe<Scalars['String']>;
  contributionsSum?: Maybe<Scalars['CustomFloat']>;
  conversations: Array<ConversationType>;
  course: CourseFilterType;
  currency?: Maybe<Scalars['String']>;
  datetimeNextLesson?: Maybe<Scalars['DateTime']>;
  daysOfClass: Array<Scalars['Int']>;
  deleteAvailable?: Maybe<Scalars['Boolean']>;
  /** Optional — when the spend belongs to a specific group (teacher payout per group, group materials, etc.) */
  expenses: Array<ExpenseType>;
  /** DEPRECATED: use invoice.payment.agreement.group. */
  fakturowniaInvoices: Array<FakturowniaInvoiceType>;
  freeLessonsCount?: Maybe<Scalars['Int']>;
  freePlaces?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isFree: Scalars['Boolean'];
  lessonJoinUrl?: Maybe<Scalars['String']>;
  lessons?: Maybe<Array<GroupLessonType>>;
  lessonsCount?: Maybe<Scalars['Int']>;
  materials: Array<MaterialType>;
  maxStudentsCount: Scalars['Int'];
  modules: Array<GroupModuleType>;
  name: Scalars['String'];
  notes: Array<StudentNoteType>;
  passedLessonsCount?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['CustomFloat']>;
  publishedLms: Scalars['Boolean'];
  publishedLmsForMethodist: Scalars['Boolean'];
  publishedLmsForTeacher: Scalars['Boolean'];
  slackChannels: Array<ChannelGroupLinkType>;
  slackWorkspace?: Maybe<SlackWorkspaceLinkType>;
  startDate: Scalars['Date'];
  statusFinished?: Maybe<Scalars['Boolean']>;
  studentsCount?: Maybe<Scalars['Int']>;
  tasks: Array<StaffTaskType>;
  teacherLeads: ApplicationFilterTypeConnection;
  teachers?: Maybe<Array<Maybe<TeacherType>>>;
  zoomAccount?: Maybe<ZoomAccountType>;
  zoomSchedules: GroupZoomScheduleTypeConnection;
};


export type MethodistGroupTypeAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  hasDebt?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AgreementOrderByEnum>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<RosterStatusEnum>;
};


export type MethodistGroupTypeTeacherLeadsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  byGroupId?: InputMaybe<Scalars['Decimal']>;
  first?: InputMaybe<Scalars['Int']>;
  isTerminated?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MethodistGroupTypeZoomSchedulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type MethodistGroupTypeConnection = {
  __typename?: 'MethodistGroupTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MethodistGroupTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MethodistGroupType` and its cursor. */
export type MethodistGroupTypeEdge = {
  __typename?: 'MethodistGroupTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<MethodistGroupType>;
};

export type MethodistLessonType = Node & {
  __typename?: 'MethodistLessonType';
  additional?: Maybe<Scalars['Boolean']>;
  attendances: AttendanceTypeConnection;
  comment?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  endTime: Scalars['Time'];
  finished: Scalars['Boolean'];
  firstLessonAgreements: Array<AgreementType>;
  hasJoinLink?: Maybe<Scalars['Boolean']>;
  hasStudentAttachment?: Maybe<Scalars['Boolean']>;
  hasStudentMarks?: Maybe<Scalars['Boolean']>;
  hasTeacherAttachment?: Maybe<Scalars['Boolean']>;
  homeworkAssignmentId?: Maybe<Scalars['ID']>;
  homeworkAvailable?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  lastLessonAgreements: Array<AgreementType>;
  lessonNumber?: Maybe<Scalars['Int']>;
  linkOverrideActive?: Maybe<Scalars['Boolean']>;
  lmsDescription?: Maybe<Scalars['String']>;
  marks: StudentsMarkTypeConnection;
  /** Optional — for group-wide handouts leave NULL; for per-lesson homework point at the specific GroupLesson. */
  materials: Array<MaterialType>;
  module: GroupModuleType;
  name: Scalars['String'];
  needToFinish?: Maybe<Scalars['Boolean']>;
  number: Scalars['Int'];
  startTime: Scalars['Time'];
  students: StudentTypeConnection;
  studentsAttachments: StudentLessonAttachmentTypeConnection;
  taskTypes: Array<Scalars['String']>;
  teacher?: Maybe<TeacherType>;
  teacherApplication?: Maybe<ApplicationType>;
  teachersAttachments: TeacherLessonAttachmentTypeConnection;
  video?: Maybe<Scalars['String']>;
  whiteboardId?: Maybe<Scalars['ID']>;
  zoomProcessingLogs: ZoomProcessingLogTypeConnection;
  zoomRecordingMeta?: Maybe<LessonRecordingType>;
};


export type MethodistLessonTypeAttendancesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MethodistLessonTypeMarksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  lessonId?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  taskType?: InputMaybe<Scalars['String']>;
};


export type MethodistLessonTypeStudentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MethodistLessonTypeStudentsAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MethodistLessonTypeTeachersAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type MethodistLessonTypeZoomProcessingLogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ModuleInput = {
  lessons: Array<InputMaybe<LessonInput>>;
  name: Scalars['String'];
};

export type MonthBudget = {
  __typename?: 'MonthBudget';
  BYN?: Maybe<Scalars['CustomFloat']>;
  EUR?: Maybe<Scalars['CustomFloat']>;
  PLN?: Maybe<Scalars['CustomFloat']>;
  RUB?: Maybe<Scalars['CustomFloat']>;
  USD?: Maybe<Scalars['CustomFloat']>;
  month?: Maybe<Scalars['Int']>;
};

export type MoveStaffTaskInput = {
  afterId?: InputMaybe<Scalars['ID']>;
  beforeId?: InputMaybe<Scalars['ID']>;
  clearDueDate?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  targetDueDate?: InputMaybe<Scalars['Date']>;
  targetStatus?: InputMaybe<Scalars['String']>;
};

/**
 * Drag-and-drop a task on the command-center board: optionally change its
 * column (status or due date) and reposition it between two neighbours — all
 * atomically.
 */
export type MoveStaffTaskMutation = {
  __typename?: 'MoveStaffTaskMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  task?: Maybe<StaffTaskType>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** ERP: attach one downloadable file (multipart Upload) to a lesson. */
  addCareerLessonAttachment?: Maybe<AddCareerLessonAttachment>;
  addTeacherApplication?: Maybe<AddTeacherApplication>;
  addTeacherExist?: Maybe<AddTeacherExist>;
  addTeacherRole?: Maybe<AddNewRoleTeacher>;
  appendRolesUserSettings?: Maybe<UserSettingsRolesAddMutation>;
  appendStudentRoleAndAgreement?: Maybe<AddRoleStudentAndAgreement>;
  /**
   * Single-shot «+Студент в группу» from the group dashboard
   * (docs/groups/group_dashboard.md §G8, Variant B).
   *
   * The student already exists (search picker on the frontend); the
   * agreement carries the target `groupId` inside `agreement_input`.
   * Delegates to the existing `add_agreement_to_student` service so all
   * currency / contribution / attendance plumbing is shared with the rest
   * of the agreement-create flow — no duplicate validation paths.
   */
  appendStudentToGroup?: Maybe<AppendStudentToGroupMutation>;
  archiveSurvey?: Maybe<ArchiveSurveyMutation>;
  assignSurveyToGroup?: Maybe<AssignSurveyToGroupMutation>;
  /** Confirm an LMS access block for a debtor (manual operator action). */
  blockStudentLmsAccess?: Maybe<BlockStudentLmsAccessMutation>;
  /**
   * Send ONE message to many students of a group INDIVIDUALLY — a private
   * Slack DM or a single email each (never a group blast). Runs as a paced
   * background task; returns the broadcast job id the client polls (`broadcast
   * Job`) for live progress and the per-recipient outcome.
   */
  broadcastGroupMessage?: Maybe<BroadcastGroupMessage>;
  bulkPublishVacancies?: Maybe<BulkPublishVacancies>;
  cancelVideoUpload?: Maybe<CancelVideoUpload>;
  /**
   * Move a student from one group to another atomically.
   *
   * Created to back the "Перевести в другую группу" single-click action on
   * the new student card (`docs/fakturownia/student_card.md §6`). Replaces
   * the manual sequence of `editStudentWithAgreement` + chargeback +
   * new-agreement that finance currently has to chain by hand.
   */
  changeAgreementGroup?: Maybe<ChangeAgreementGroupMutation>;
  changeLessonDates?: Maybe<ChangeLessonDate>;
  checkStudentDebt?: Maybe<CheckStudentsDebtMutation>;
  clearCareerLessonVideo?: Maybe<ClearCareerLessonVideo>;
  clearGroupLessonLinkOverride?: Maybe<ClearGroupLessonLinkOverride>;
  /** LMS: the student marks a lesson done, unlocking the next one. */
  completeCareerLesson?: Maybe<CompleteCareerLesson>;
  createAgreement?: Maybe<CreateAgreementMutation>;
  createBlackFridayLead?: Maybe<CreateBlackFridayLeadMutation>;
  createCompany?: Maybe<CreateCompanyMutation>;
  createCourse?: Maybe<CreateCourseMutation>;
  /** @deprecated Legacy deferred-Payment entry (ТЗ 0004); the flow is retired. */
  createDeferredPayments?: Maybe<CreateDeferredPaymentsMutation>;
  createExpense?: Maybe<ExpenseMutationOutput>;
  createExpenseCategory?: Maybe<CreateExpenseCategoryMutation>;
  createGroup?: Maybe<CreateGroupMutation>;
  createLead?: Maybe<CreateLeadMutation>;
  createLessonWhiteboard?: Maybe<CreateLessonWhiteboardMutation>;
  createManualLessonRecording?: Maybe<CreateManualLessonRecordingMutation>;
  createMaterial?: Maybe<CreateMaterialMutation>;
  createNewYearLead?: Maybe<CreateNewYearLeadMutation>;
  /**
   * Create a free-standing Payment on an agreement (no Fakturownia link).
   *
   * Mirrors `createPaymentForFakturowniaInvoice` but starts from the
   * agreement instead of an invoice — finance often records a payment
   * before any invoice exists. Link to an invoice later via
   * `linkFakturowniaInvoiceToPayment`.
   * @deprecated Legacy: Payment is a hidden system record (ТЗ 0004). Use linkInvoiceToContribution / markContributionPaidManually.
   */
  createPayment?: Maybe<CreatePaymentMutation>;
  createPaymentCorrection?: Maybe<CreatePaymentCorrectionMutation>;
  /**
   * Create a `students.Payment` on `agreement_id` from the invoice's
   * amount/currency/date and link it 1:1 to the invoice.
   *
   * The amount is taken from `invoice.paid` (the Fakturownia "paid" total).
   * Currency must match between agreement and invoice — we don't auto-FX
   * here because finance wants explicit conversions.
   * @deprecated Legacy: Payment is a hidden system record (ТЗ 0004). Use linkInvoiceToContribution / markContributionPaidManually.
   */
  createPaymentForFakturowniaInvoice?: Maybe<FakturowniaMutationOutput>;
  /** @deprecated Legacy bulk Payment entry (ТЗ 0004). Use linkInvoiceToContribution / markContributionPaidManually. */
  createPayments?: Maybe<CreatePaymentsMutation>;
  createPlannedPayment?: Maybe<PlannedPaymentMutationOutput>;
  createStaffTask?: Maybe<CreateStaffTaskMutation>;
  createStudentNote?: Maybe<CreateStudentNoteMutation>;
  createStudentWithAgreement?: Maybe<StudentWithAgreementCreateMutation>;
  createSurvey?: Maybe<CreateSurveyMutation>;
  /**
   * Spin a staff task off a student's message («создать задачу из вопроса»).
   *
   * The task inherits the conversation's student/group; the assignee defaults
   * to the acting manager and must always be ERP staff. Side effects record
   * the reaction: the message is marked handled + linked to the task, and an
   * `open` conversation moves to `in_progress`. One task per message — a
   * retry / second manager gets `already_linked` instead of a duplicate.
   */
  createTaskFromMessage?: Maybe<CreateTaskFromMessageMutation>;
  /**
   * Create a STANDALONE teacher WITHOUT any application/group assignment —
   * add «свободных» преподавателей на будущее (собеседование/курсы/рейтинг
   * заполняются на карточке). Distinct from `createUniqueTeacher`, which
   * requires an application.
   */
  createTeacher?: Maybe<CreateTeacher>;
  createUniqueTeacher?: Maybe<CreateUniqueTeacher>;
  /**
   * SDL: {success, errors, customErrors}.
   *
   * ТЗ 0021, стадия 4 — вместо `graphql_auth.mutations.Register`. Полей
   * token/refreshToken тут нет и быть не должно: пакет доливал их только при
   * `ALLOW_LOGIN_NOT_VERIFIED=True`, а в проекте настройка False.
   */
  createUser?: Maybe<RegisterMutation>;
  /** SDL: {token, success, errors, user, unarchiving, customErrors, refreshToken}. */
  customLogin?: Maybe<CustomObtainJsonWebToken>;
  deleteCourse?: Maybe<DeleteCourseMutation>;
  deleteExpense?: Maybe<DeleteExpenseMutation>;
  deleteGroup?: Maybe<DeleteGroupMutation>;
  deleteMaterial?: Maybe<DeleteMaterialMutation>;
  /**
   * Delete a Payment. Refuses if a FakturowniaInvoice is still linked —
   * the operator must call `unlinkFakturowniaInvoice` first so the invoice
   * isn't left orphaned with `payment_id → DELETED`.
   * @deprecated Legacy: kept only to drain orphan Payments (ТЗ 0004).
   */
  deletePayment?: Maybe<DeletePaymentMutation>;
  deletePaymentCorrection?: Maybe<DeletePaymentCorrectionMutation>;
  deletePlannedPayment?: Maybe<DeletePlannedPaymentOutput>;
  deleteStaffTask?: Maybe<DeleteStaffTaskMutation>;
  /**
   * Detach a diploma. The S3 object is left in place deliberately — a
   * student may hold a live signed URL, and a leaked object beats a document
   * that vanished mid-download. The orphaned key goes to the audit log.
   */
  deleteStudentDiploma?: Maybe<DeleteStudentDiplomaMutation>;
  deleteStudentNote?: Maybe<DeleteStudentNoteMutation>;
  deleteSurveyAssignment?: Maybe<DeleteSurveyAssignmentMutation>;
  deleteTeacherApplication?: Maybe<DeleteTeacherApplication>;
  deleteUserSettings?: Maybe<UserSettingsDeleteMutation>;
  deleteZoomRecording?: Maybe<DeleteZoomRecordingMutation>;
  /** SDL: {token, success, errors, user, unarchiving, customErrors, refreshToken}. */
  demoCustomLogin?: Maybe<CustomObtainJsonWebToken>;
  duplicateSurvey?: Maybe<DuplicateSurveyMutation>;
  /** Add students and/or a whole graduating group to the centre. */
  enrollCareerMembers?: Maybe<EnrollCareerMembers>;
  finishLmsLesson?: Maybe<FinishLmsLessonMutation>;
  /** Flag/unflag one message (team-wide global state). */
  flagMessage?: Maybe<FlagMessageMutation>;
  /**
   * Teacher grades a student's homework — with or without a submission
   * (non-submitters get `not_done`). Writes through to
   * journals.StudentsMark.hw_mark; the comment lives on the submission.
   */
  gradeHomework?: Maybe<GradeHomeworkMutation>;
  /**
   * Create a REAL invoice in Fakturownia for one installment.
   *
   * The unit of work is the **agreement**, not the student: a student may
   * hold several agreements, and this also makes the group job's per-row unit
   * identical to this mutation's, so both share one service.
   *
   * Everything hard lives in `services.issuing` — five layers of duplicate
   * protection around a vendor that has no idempotency key and whose
   * documents cannot be deleted from here. This class is only the GraphQL
   * skin: gate, resolve ids, translate the outcome.
   */
  issueInvoiceForContribution?: Maybe<FakturowniaMutationOutput>;
  /**
   * Enqueue a background run that issues invoices for a whole group.
   *
   * Returns immediately with the job; the frontend polls
   * `fakturowniaBillingJob(id)`. It has to be a job, not a synchronous loop:
   * every non-BYN row costs an invoice POST plus up to two live FX lookups
   * from `Contribution.save()`, so a 200-row group runs for 7-13 minutes.
   */
  issueInvoicesForGroup?: Maybe<FakturowniaBillingJobEnqueueOutput>;
  /** Map a Slack channel id to a Group. */
  linkChannelGroup?: Maybe<LinkChannelGroupMutation>;
  /**
   * Attach an existing Payment to an existing Contribution (1:1).
   *
   * Used by the frontend "Перепривязать" / "Привязать существующий платёж"
   * action on the schedule row. The happy path also flips
   * `contribution.complete=True` and recomputes `remainder` via
   * `Contribution.save()` (§9.5).
   * @deprecated Legacy: kept only to drain orphan Payments (ТЗ 0004). Use linkInvoiceToContribution.
   */
  linkContributionToPayment?: Maybe<LinkContributionToPaymentMutation>;
  /**
   * Attach an existing `students.Payment` to a Fakturownia invoice 1:1.
   *
   * Use when an operator has identified the LMS payment that corresponds to
   * this invoice (e.g. they already imported it from a bank statement).
   * The Payment is OneToOne — if it's already linked to a different
   * invoice the call fails with `Payment already linked`.
   * @deprecated Legacy payment-first link (ТЗ 0004). Use linkInvoiceToContribution; the hidden Payment is provisioned automatically.
   */
  linkFakturowniaInvoiceToPayment?: Maybe<FakturowniaMutationOutput>;
  /**
   * ТЗ 0004 — pin an issued invoice to the installment it charges.
   *
   * The PRIMARY business link of the unified «взнос» model. Manual link sets
   * `contribution_match_source='manual'` so the sync auto-matcher never
   * re-points it. If the invoice is already fully paid, the hidden Payment is
   * provisioned immediately (no waiting for the next sync).
   */
  linkInvoiceToContribution?: Maybe<FakturowniaMutationOutput>;
  linkLessonWhiteboard?: Maybe<LinkLessonWhiteboardMutation>;
  /**
   * Attach a PandaDoc document to an existing agreement (manual link from
   * the student card). Does not create a Student/Agreement and does not touch
   * `provisioned_at`.
   */
  linkPandadocDocument?: Maybe<LinkPandadocDocumentMutation>;
  /**
   * Attach a `trainer` PandaDoc document to a Teacher (from the teacher
   * card). The teacher analog of LinkPandadocDocumentMutation.
   */
  linkPandadocTeacher?: Maybe<LinkPandadocTeacherMutation>;
  /**
   * Map a Slack user id to a Student (for DM mirroring). The manual
   * fallback for auto-matching by email — a student may sit in Slack under an
   * email we don't know.
   */
  linkSlackUser?: Maybe<LinkSlackUserMutation>;
  lmsClearTodayLessonLink?: Maybe<LmsClearTodayLessonLink>;
  lmsJoinLesson?: Maybe<LmsJoinLesson>;
  lmsSetTodayLessonLink?: Maybe<LmsSetTodayLessonLink>;
  lmsStudentSignUp?: Maybe<StudentSignUpLmsMutation>;
  /** LMS: record that the student opened a lesson — viewed, NOT completed. */
  markCareerLessonOpened?: Maybe<MarkCareerLessonOpened>;
  /**
   * Record an off-invoice payment against an installment.
   *
   * Creates the hidden `Payment(source='manual_paid')` and links it through
   * the manual 1:1 edge (`contribution.payment`). Amount defaults to the
   * installment's remainder. The row then reads «оплачен вручную».
   */
  markContributionPaidManually?: Maybe<MarkContributionPaidManuallyMutation>;
  /**
   * Bulk-set the read flag on every message of a conversation. `read=false`
   * marks the whole thread unread (to revisit it later).
   */
  markConversationRead?: Maybe<MarkConversationReadMutation>;
  markLessonMissingRecording?: Maybe<MarkLessonMissingRecordingMutation>;
  /** Mark one message read/unread (team-wide global state). */
  markMessageRead?: Maybe<MarkMessageReadMutation>;
  /** LMS: a member saves a vacancy or marks that they applied. */
  markVacancyInteraction?: Maybe<MarkVacancyInteraction>;
  /**
   * Dry-run: propose a (student, language) for each file NAME.
   *
   * A mutation rather than a query only because clients treat it as an action;
   * it performs no writes.
   */
  matchDiplomaFiles?: Maybe<MatchDiplomaFilesMutation>;
  /**
   * DEPRECATED. Pin invoice to a Student/Group without touching Payment.
   *
   * Kept so the old frontend keeps working during the migration. New code
   * should call `linkFakturowniaInvoiceToPayment` or
   * `createPaymentForFakturowniaInvoice` instead.
   * @deprecated Legacy (ТЗ 0004). Use linkInvoiceToContribution instead.
   */
  matchFakturowniaInvoice?: Maybe<FakturowniaMutationOutput>;
  /**
   * Drag-and-drop a task on the command-center board: optionally change its
   * column (status or due date) and reposition it between two neighbours — all
   * atomically.
   */
  moveStaffTask?: Maybe<MoveStaffTaskMutation>;
  /** Сброс пароля по токену из письма. SDL: {success, errors}. */
  passwordReset?: Maybe<PasswordReset>;
  /** Установка первого пароля по токену из письма. SDL: {success, errors}. */
  passwordSet?: Maybe<PasswordSet>;
  /** Create students + agreements + first contribution from PandaDoc docs. */
  provisionStudents?: Maybe<ProvisionStudentsMutation>;
  publishGroup?: Maybe<PublishGroupToLms>;
  recordPlacement?: Maybe<RecordPlacement>;
  /** One-call refresh: accounts + all recordings + account usage. */
  refreshAllZoomData?: Maybe<RefreshAllZoomDataMutation>;
  /** То же, что в `graphql_jwt`, но с нашей формой ответа (success/errors). */
  refreshToken?: Maybe<CustomRefreshToken>;
  remindDebtors?: Maybe<RemindDebtorsMutation>;
  removeCareerLessonAttachment?: Maybe<RemoveCareerLessonAttachment>;
  renameWhiteboard?: Maybe<RenameWhiteboardMutation>;
  /**
   * Re-extract signer contact data (email/phone/name) on already-synced
   * documents and re-pull the details of rows a local re-parse can't fix.
   *
   * The repair button for «у студента нет договоров» / «новая папка не
   * появилась»: it applies the current parser to the whole cached inventory
   * instead of waiting for each document to change in PandaDoc.
   *
   * Admin-only (unlike the plain sync): a run can queue the entire inventory
   * for a `/details` re-fetch, which costs hours of the PandaDoc rate-limit
   * budget.
   */
  reparsePandadocRecipients?: Maybe<ReparsePandadocRecipientsMutation>;
  reprocessAi?: Maybe<ReprocessAiMutation>;
  /**
   * Force the auto-matcher to run again on a specific invoice — useful
   * when buyer_email changed, the student was just created, or a new
   * Payment row was just imported and we want to recheck the link.
   */
  rerunFakturowniaMatcher?: Maybe<FakturowniaMutationOutput>;
  /**
   * Teacher re-queues the AI analysis of a submission («Перепроверить»).
   * Answers AI_DISABLED while the HOMEWORK_AI_ENABLED flag is off.
   */
  rerunHomeworkAiReview?: Maybe<RerunHomeworkAiReviewMutation>;
  retryLessonRecording?: Maybe<RetryLessonRecordingMutation>;
  /**
   * Undo a manual «оплачен вручную» mark: deletes ONLY the
   * `source='manual_paid'` payment behind it. Auto-provisioned and legacy
   * operator payments are never deleted here.
   */
  revertManualContributionPayment?: Maybe<RevertManualContributionPaymentMutation>;
  /** SDL: {revoked: Int, success, errors}. */
  revokeToken?: Maybe<RevokeToken>;
  runAutoMatching?: Maybe<RunAutoMatchingMutation>;
  /** LMS: the student's PRIVATE note on a lesson (never shown to staff). */
  saveCareerLessonNotes?: Maybe<SaveCareerLessonNotes>;
  saveCareerProfile?: Maybe<SaveCareerProfile>;
  /** Upsert the per-language prose overlay (title + about) for the CV. */
  saveCvText?: Maybe<SaveCvText>;
  /** Full-list save of the school-wide component library (spec 0010 rev.2). */
  saveWhiteboardLibrary?: Maybe<SaveWhiteboardLibraryMutation>;
  saveWhiteboardScene?: Maybe<SaveWhiteboardSceneMutation>;
  /** Reply into a Gmail thread; mirrors the sent message locally. */
  sendGmailReply?: Maybe<SendGmailReplyMutation>;
  /**
   * Send a dynamic-template email to selected students of a group.
   *
   * Each recipient gets their OWN message with their own name, amount and pay
   * link — never a shared blast. Returns the job id to poll (`mailJob`) for live
   * progress and per-recipient delivery status.
   */
  sendGroupTemplateEmail?: Maybe<SendGroupTemplateEmail>;
  sendLmsAuthEmail?: Maybe<SendAuthenticationCode>;
  sendMorningReport?: Maybe<SendMorningReportMutation>;
  /**
   * Compose and send a BRAND-NEW email from a chosen shared mailbox (not a
   * reply). Mirrors it locally as a new gmail-thread conversation.
   */
  sendNewEmail?: Maybe<SendNewEmailMutation>;
  /** SDL: {success, errors, customErrors}. */
  sendPasswordResetEmail?: Maybe<CustomSendPasswordResetEmail>;
  /**
   * Post a message into one of a group's Slack channels — including the
   * FIRST one, before any Conversation mirror exists. Lets a manager start a
   * channel thread instead of only replying into an existing dialog.
   */
  sendSlackChannelMessage?: Maybe<SendSlackChannelMessage>;
  /** Reply into a Slack conversation; mirrors the sent message locally. */
  sendSlackMessage?: Maybe<SendSlackMessageMutation>;
  /**
   * Manually flag/unflag a contract as «бесплатный договор».
   *
   * Excludes the contract from ALL debt/overdue detection (student-card totals,
   * LMS-block candidates, debtors list, payment calendar) while leaving it
   * active — so the student keeps LMS access to the group. Like `transfer_out`
   * it also relaxes the FULL-zeroing correction guard, so the paid invoice can
   * be corrected to zero without pretending the contract was transferred.
   * Restricted to Admin/FinanceManager and audited — it silences a real debt, so
   * a rank-and-file operator must not be able to set it.
   */
  setAgreementFreeOfCharge?: Maybe<SetAgreementFreeOfChargeMutation>;
  /**
   * Manually flag/unflag a contract as «финансирование государством».
   *
   * The student is pre-financed by the state: intermediate documents
   * (proforma/advance/VAT) are not a debt — only an unpaid overdue FINAL
   * invoice is — and the plan/contributions owe nothing until then. Debt gates
   * honor this across totals, LMS block, debtors list and calendar. Restricted
   * to Admin/FinanceManager and audited.
   */
  setAgreementStatePrefinanced?: Maybe<SetAgreementStatePrefinancedMutation>;
  /**
   * Manually flag/unflag an agreement as «переведён из этой группы».
   *
   * The flag relaxes the FULL-zeroing limit on corrections (partials work
   * without it) and the carry-out money guards (still capped at `paid_amount`).
   * Restricted to Admin/FinanceManager and audited — it must not be settable by
   * a rank-and-file operator, and never via a self-declared termination reason.
   */
  setAgreementTransferOut?: Maybe<SetAgreementTransferOutMutation>;
  /** LMS: toggle a lesson bookmark for the calling student. */
  setCareerLessonBookmark?: Maybe<SetCareerLessonBookmark>;
  /** ERP: replace a lesson's self-check quiz (delete-and-recreate). */
  setCareerLessonQuiz?: Maybe<SetCareerLessonQuiz>;
  setCashBalance?: Maybe<CashBalanceMutationOutput>;
  /** Set a conversation's handling status (open / in_progress / done). */
  setConversationStatus?: Maybe<SetConversationStatusMutation>;
  setExchangeRate?: Maybe<ExchangeRateMutationOutput>;
  /**
   * One-click status change (planned / confirmed / paid / cancelled).
   *
   * Lighter than `updateExpense`: the register, the calendar and the
   * teacher-payout list flip a status inline without rebuilding the whole
   * input. `apply_status_transition` derives `paid_at` from the target status
   * (paid → stamp today unless already set / supplied; non-paid → clear).
   * Allowed on `source='fakturownia'` rows too — status is a manual field,
   * not part of the money lock the bridge owns.
   */
  setExpenseStatus?: Maybe<ExpenseMutationOutput>;
  /**
   * DEPRECATED. Change just the legacy `linked_group` column.
   * Use `linkFakturowniaInvoiceToPayment` to set the canonical chain.
   * @deprecated The group is now reached as invoice.contribution.agreement.group (ТЗ 0004).
   */
  setFakturowniaInvoiceGroup?: Maybe<FakturowniaMutationOutput>;
  setGroupLessonLink?: Maybe<SetGroupLessonLink>;
  setGroupLessonLinkOverride?: Maybe<SetGroupLessonLinkOverride>;
  setGroupZoomAccount?: Maybe<SetGroupZoomAccountMutation>;
  /** Set a group's Zoom account and fully replace its processing slots. */
  setGroupZoomSchedule?: Maybe<SetGroupZoomScheduleMutation>;
  /** Mark one message handled/unhandled — обработано (team-wide global). */
  setMessageHandled?: Maybe<SetMessageHandledMutation>;
  /**
   * Save the ACTING manager's personal Slack user token (xoxp) for a
   * group's workspace — DM replies to students then go out as the manager
   * himself, and his person-to-person DMs become pullable by sync. The token
   * is validated via auth.test and must belong to the group's workspace.
   * Write-only: no query ever returns it.
   */
  setMySlackUserToken?: Maybe<SetMySlackUserTokenMutation>;
  setPaymentCalendarSettings?: Maybe<CalendarSettingsMutationOutput>;
  /** The student's own opt-in to partner search (Ф3) + contact visibility. */
  setProfileSearchable?: Maybe<SetProfileSearchable>;
  /**
   * Bind (or update) the Slack workspace for a group. Only the bot token is
   * really needed (no OAuth flow): a blank team id is resolved via auth.test.
   * `team_id` stays as an advanced override; `signing_secret` matters only for
   * the optional realtime webhook.
   */
  setSlackWorkspace?: Maybe<SetSlackWorkspaceMutation>;
  setStudentsMarks?: Maybe<SetStudentsMarksMutation>;
  /**
   * Update the control-panel profile fields — rating, internal note,
   * interview-recording link, and the courses-can-teach list. Only the fields
   * actually passed are changed; `rating=0` clears the rating.
   */
  setTeacherProfile?: Maybe<SetTeacherProfile>;
  setVacancyStatus?: Maybe<SetVacancyStatus>;
  /**
   * Open a Slack DM with a student and post the first message, before any
   * Conversation exists — so a manager can write first. Sent AS the manager
   * (his xoxp user token; a bot can't hold a 1:1 DM).
   */
  startSlackDm?: Maybe<StartSlackDm>;
  /**
   * Return a signed Slack authorize URL so the ACTING manager can grant his
   * personal xoxp user token for a group's workspace in one click — no
   * api.slack.com, no copy-paste. The browser then navigates to Slack; on
   * "Allow" Slack redirects to `slack_oauth_callback`, which stores the token.
   *
   * Identity + group are captured HERE (under the JWT this mutation runs behind)
   * and sealed into a short-lived signed `state` (django.core.signing), because
   * the callback is a plain browser redirect that carries no JWT.
   */
  startSlackUserOauth?: Maybe<StartSlackUserOauthMutation>;
  /**
   * LMS: score the student's answers and record an attempt (self-check —
   * never gates the lesson).
   */
  submitCareerQuiz?: Maybe<SubmitCareerQuiz>;
  /**
   * Student submits (or replaces) their homework: a GitHub link AND/OR a
   * ZIP archive (at least one, both allowed together). Re-submitting after
   * grading resets the grade. No teacher assignment is required (rev.3).
   */
  submitHomework?: Maybe<SubmitHomeworkMutation>;
  submitSurveyResponse?: Maybe<SubmitSurveyResponseMutation>;
  /** Sync accounts + every cloud recording in Zoom for a date range. */
  syncAllZoomRecordings?: Maybe<SyncAllZoomRecordingsMutation>;
  /**
   * On-demand «обновить сообщения»: enqueue a Slack backfill PLUS a Gmail
   * backfill of the latest mail (metadata-first, so it's cheap). Without
   * group_id it syncs every ENABLED workspace of an ACTIVE group (one that
   * still has future lessons) plus legacy channel links; with group_id it
   * syncs that group's workspace regardless of activity — the group-card
   * button keeps working for finished groups. Async via Celery — the button
   * returns immediately; new messages appear once the worker finishes.
   */
  syncCommunicationsNow?: Maybe<SyncCommunicationsNowMutation>;
  /**
   * On-demand 'refresh mail' button: enqueue a Gmail backfill of the latest
   * ~100 messages per mailbox. Runs async via Celery so the request returns
   * immediately; the new mail appears once the worker finishes.
   */
  syncGmailNow?: Maybe<SyncGmailNowMutation>;
  /**
   * Create (if needed) and refill the group's SendGrid contact list.
   *
   * Idempotent — contacts are upserted by email, so re-running re-syncs rather
   * than duplicating. SendGrid processes the upload asynchronously, so the
   * contact count updates a few seconds later.
   */
  syncGroupSendgridList?: Maybe<SyncGroupSendgridList>;
  syncZoomAccounts?: Maybe<SyncZoomAccountsMutation>;
  syncZoomRecordings?: Maybe<SyncZoomRecordingsMutation>;
  /** Refresh the Zoom account usage summary (storage quota + counts). */
  syncZoomUsage?: Maybe<SyncZoomUsageMutation>;
  /**
   * Safe one-click agreement termination — see docs/groups/groups_upgrade.md §B3.
   *
   * Replaces the chained `updateStudentWithAgreement` workaround that
   * re-sent the student's PII just to flip `terminated=True`. This mutation
   * touches only the agreement and writes an audit log entry; contributions
   * and deferred payments are deliberately left alone.
   */
  terminateAgreement?: Maybe<TerminateAgreementMutation>;
  /**
   * Group-scoped Fakturownia sync — docs/groups/group_dashboard.md §G10.
   *
   * Same Celery task as `triggerFakturowniaSync`, but the dedup lock is
   * scoped per `(group_id, period)` so a busy operator can fire syncs
   * for several groups without the global trigger getting in the way.
   * The payer-email UNION (agreement.buyer_email + student.email) is
   * recorded in the audit log and the returned `message`; narrowing the
   * actual Fakturownia API call by that list is intentionally deferred —
   * the mirror only ever grows, and the new canonical `groupId` filter
   * (§G7) will surface the new rows on the group's FinancesTab as soon
   * as the sync completes.
   */
  triggerFakturowniaGroupSync?: Maybe<TriggerFakturowniaGroupSyncMutation>;
  /**
   * Fire-and-forget: enqueue a Fakturownia sync via Celery.
   *
   * The frontend pattern is: call this mutation → poll
   * `fakturownia_sync_status` until `is_running` flips back to false →
   * read `last_run.stats` to render "synced N invoices". The returned
   * `last_run` is the state *before* the new task starts so the UI can
   * show "synced 14:23 (… enqueueing new run …)" instantly.
   */
  triggerFakturowniaSync?: Maybe<TriggerFakturowniaSyncMutation>;
  /**
   * Enqueue a full PandaDoc re-sync (list + details, with student folder
   * backfill). Powers the dashboard 'refresh everything' button — the Celery
   * task self-chains until the whole details backlog is drained.
   */
  triggerPandadocSync?: Maybe<TriggerPandadocSyncMutation>;
  /**
   * Manual Zoom sync scoped to one group — docs/groups/group_dashboard.md
   * §G9. Re-runs `sync_recordings` for the window and the matcher against
   * the group's lessons. 60-sec dedup lock per group so a frantic operator
   * doesn't queue ten copies.
   */
  triggerZoomGroupProcess?: Maybe<TriggerZoomGroupProcessMutation>;
  /** Manually restore a student's LMS access. */
  unblockStudentLmsAccess?: Maybe<UnblockStudentLmsAccessMutation>;
  /**
   * Detach the Payment from a Contribution. The Payment stays alive as
   * an orphan (visible in the "вне графика" block); the Contribution
   * flips back to `complete=False, remainder=amount_foreign`.
   * @deprecated Legacy: use unlinkInvoiceFromContribution (ТЗ 0004).
   */
  unlinkContribution?: Maybe<UnlinkContributionMutation>;
  /**
   * Drop both `payment` and the legacy `linked_*` columns, returning the
   * invoice to `unmatched`. The Payment row itself is left intact — finance
   * may still want it for the agreement's ledger; only the bridge is removed.
   * @deprecated Legacy payment-first unlink (ТЗ 0004). Use unlinkInvoiceFromContribution.
   */
  unlinkFakturowniaInvoice?: Maybe<FakturowniaMutationOutput>;
  /**
   * Drop the invoice → contribution link and re-derive the installment's
   * coverage. The invoice's Payment (if provisioned) stays attached to the
   * invoice — real received money is never destroyed here.
   */
  unlinkInvoiceFromContribution?: Maybe<FakturowniaMutationOutput>;
  unlinkLessonRecording?: Maybe<UnlinkLessonRecordingMutation>;
  unlinkLessonWhiteboard?: Maybe<UnlinkLessonWhiteboardMutation>;
  /** Detach a manually-linked PandaDoc document from its agreement. */
  unlinkPandadocDocument?: Maybe<UnlinkPandadocDocumentMutation>;
  /** Detach a PandaDoc document from its teacher. */
  unlinkPandadocTeacher?: Maybe<UnlinkPandadocTeacherMutation>;
  updateAttendance?: Maybe<UpdateAttendanceMutation>;
  updateCareerMember?: Maybe<UpdateCareerMember>;
  updateCompany?: Maybe<UpdateCompanyMutation>;
  updateCourse?: Maybe<UpdateCourseMutation>;
  updateExpense?: Maybe<ExpenseMutationOutput>;
  updateGroup?: Maybe<UpdateGroupMutation>;
  updateJournal?: Maybe<UpdateJournalsMutation>;
  updateMaterial?: Maybe<UpdateMaterialMutation>;
  /**
   * Patch a Payment's amount and/or date.
   *
   * Re-derives `amount_byn` / `amount_foreign` via `PaymentBase.save()` —
   * that's how the existing forms-based path keeps the chargeback / debt
   * tables consistent.
   * @deprecated Legacy: Payments are system-provisioned (ТЗ 0004) and not edited by operators.
   */
  updatePayment?: Maybe<UpdatePaymentMutation>;
  updatePaymentCorrection?: Maybe<UpdatePaymentCorrectionMutation>;
  updatePlannedPayment?: Maybe<PlannedPaymentMutationOutput>;
  updateStaffTask?: Maybe<UpdateStaffTaskMutation>;
  updateStudentNote?: Maybe<UpdateStudentNoteMutation>;
  updateStudentWithAgreement?: Maybe<StudentWithAgreementUpdateMutation>;
  updateSurvey?: Maybe<UpdateSurveyMutation>;
  updateSurveyAssignment?: Maybe<UpdateSurveyAssignmentMutation>;
  /** Move a task between statuses; stamps/clears `completed_at` on done. */
  updateTaskStatus?: Maybe<UpdateTaskStatusMutation>;
  updateTeacherApplication?: Maybe<UpdateTeacherApplication>;
  updateTeacherWithType?: Maybe<UpdateTeacherWithTypeMutation>;
  updateUserSettings?: Maybe<UserSettingsUpdateMutation>;
  /**
   * ERP: upload a lesson video (multipart, server-side write to the private
   * bucket — the same path as attachments, diplomas and the Django-admin file
   * widget, so no bucket CORS is required).
   */
  uploadCareerLessonVideo?: Maybe<UploadCareerLessonVideo>;
  uploadLessonVideo?: Maybe<UploadLessonVideo>;
  /** Attach or replace one student's diploma in one language. */
  uploadStudentDiploma?: Maybe<UploadStudentDiplomaMutation>;
  /**
   * Pastes an image onto a board (spec 0010 rev.3): the bytes go to the
   * private bucket, the scene keeps only the fileId reference.
   */
  uploadWhiteboardFile?: Maybe<UploadWhiteboardFileMutation>;
  upsertCareerLesson?: Maybe<UpsertCareerLesson>;
  /**
   * Teacher creates or edits the lesson's homework assignment (backed by
   * materials.Material kind=HOMEWORK; ≤1 per lesson via this path).
   */
  upsertHomeworkAssignment?: Maybe<UpsertHomeworkAssignmentMutation>;
  upsertVacancy?: Maybe<UpsertVacancy>;
  /** SDL: {payload: GenericScalar, success, errors}. */
  verifyToken?: Maybe<VerifyToken>;
  /**
   * Zero an UNPAID contribution's amount on a transfer-out agreement.
   *
   * `Contribution.save()` re-derives `remainder = amount_foreign` for any
   * unpaid row, so "set remainder=0" is impossible — the legitimate way to
   * drop a contribution to zero is to set its AMOUNT to 0. This is strictly
   * gated:
   *
   * * the agreement must be `terminated` AND `transfer_out` — i.e. wound down
   *   via `ChangeAgreementGroup`, which clones the schedule onto the NEW group,
   *   so the obligation is re-attributed there, not erased; and
   * * the contribution must NOT have a linked Payment — real received money is
   *   never destroyed here. To move already-received cash out of the old group,
   *   use a Chargeback / AccountsPayable carry-out (capped at `paid_amount`),
   *   not this mutation.
   *
   * Every call is audited. The old terminated contract is already excluded from
   * debtors / finance / the calendar by the `terminated_date` cutoff; zeroing
   * additionally makes the old agreement read literally zero, which is what the
   * "обнулить старую группу" workflow asks for.
   */
  zeroOutContribution?: Maybe<ZeroOutContributionMutation>;
};


export type MutationAddCareerLessonAttachmentArgs = {
  file: Scalars['Upload'];
  lessonId: Scalars['ID'];
};


export type MutationAddTeacherApplicationArgs = {
  application: ApplicationInputType;
  teacherId: Scalars['ID'];
};


export type MutationAddTeacherExistArgs = {
  application: ApplicationInputType;
  employmentTypes: ExistEmploymentInputType;
  teacherId: Scalars['ID'];
};


export type MutationAddTeacherRoleArgs = {
  application: ApplicationInputType;
  employmentTypes: EmploymentInputType;
  siteDisplay?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['ID'];
};


export type MutationAppendRolesUserSettingsArgs = {
  roles: Scalars['String'];
  userId: Scalars['ID'];
};


export type MutationAppendStudentRoleAndAgreementArgs = {
  agreementInput: CreateAgreementInputBase;
  userId: Scalars['ID'];
};


export type MutationAppendStudentToGroupArgs = {
  agreementInput: CreateAgreementInputBase;
  studentId: Scalars['ID'];
};


export type MutationArchiveSurveyArgs = {
  id: Scalars['ID'];
  isArchived: Scalars['Boolean'];
};


export type MutationAssignSurveyToGroupArgs = {
  groupId: Scalars['ID'];
  surveyId: Scalars['ID'];
  triggerLessonId: Scalars['ID'];
};


export type MutationBlockStudentLmsAccessArgs = {
  reason?: InputMaybe<Scalars['String']>;
  studentId: Scalars['ID'];
};


export type MutationBroadcastGroupMessageArgs = {
  channel: Scalars['String'];
  groupId: Scalars['ID'];
  mailboxEmail?: InputMaybe<Scalars['String']>;
  studentIds: Array<Scalars['ID']>;
  subject?: InputMaybe<Scalars['String']>;
  text: Scalars['String'];
};


export type MutationBulkPublishVacanciesArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationCancelVideoUploadArgs = {
  lessonId: Scalars['Int'];
};


export type MutationChangeAgreementGroupArgs = {
  input: ChangeAgreementGroupInput;
};


export type MutationChangeLessonDatesArgs = {
  groupId: Scalars['Int'];
  newDate: Scalars['Date'];
  oldDate: Scalars['Date'];
};


export type MutationCheckStudentDebtArgs = {
  agreementsInput: Array<InputMaybe<Scalars['String']>>;
};


export type MutationClearCareerLessonVideoArgs = {
  lessonId: Scalars['ID'];
};


export type MutationClearGroupLessonLinkOverrideArgs = {
  date: Scalars['Date'];
  groupId: Scalars['Int'];
};


export type MutationCompleteCareerLessonArgs = {
  artifactUrl?: InputMaybe<Scalars['String']>;
  lessonId: Scalars['ID'];
};


export type MutationCreateAgreementArgs = {
  agreementInput: CreateAgreementInput;
};


export type MutationCreateBlackFridayLeadArgs = {
  bfLeadInput: BlackFridayLeadInput;
};


export type MutationCreateCompanyArgs = {
  companyInput: CompanyInput;
};


export type MutationCreateCourseArgs = {
  name?: InputMaybe<Scalars['String']>;
};


export type MutationCreateDeferredPaymentsArgs = {
  deferredPaymentsInput?: InputMaybe<Array<InputMaybe<DeferredPaymentInput>>>;
};


export type MutationCreateExpenseArgs = {
  input: ExpenseInput;
};


export type MutationCreateExpenseCategoryArgs = {
  name: Scalars['String'];
  slug: Scalars['String'];
};


export type MutationCreateGroupArgs = {
  groupInput: GroupInput;
  moduleInput: Array<InputMaybe<ModuleInput>>;
};


export type MutationCreateLeadArgs = {
  leadInput: LeadInput;
};


export type MutationCreateLessonWhiteboardArgs = {
  lessonId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};


export type MutationCreateManualLessonRecordingArgs = {
  lessonId: Scalars['ID'];
  zoomRecordingId: Scalars['ID'];
};


export type MutationCreateMaterialArgs = {
  input: CreateMaterialInput;
};


export type MutationCreateNewYearLeadArgs = {
  nyLeadInput: NewYearLeadInput;
};


export type MutationCreatePaymentArgs = {
  input: CreatePaymentInput;
};


export type MutationCreatePaymentCorrectionArgs = {
  input: CreatePaymentCorrectionInput;
};


export type MutationCreatePaymentForFakturowniaInvoiceArgs = {
  agreementId: Scalars['ID'];
  invoiceId: Scalars['ID'];
  paymentDate?: InputMaybe<Scalars['Date']>;
};


export type MutationCreatePaymentsArgs = {
  paymentsInput?: InputMaybe<Array<InputMaybe<PaymentInput>>>;
};


export type MutationCreatePlannedPaymentArgs = {
  input: PlannedPaymentInput;
};


export type MutationCreateStaffTaskArgs = {
  input: CreateStaffTaskInput;
};


export type MutationCreateStudentNoteArgs = {
  input: CreateStudentNoteInput;
};


export type MutationCreateStudentWithAgreementArgs = {
  agreementInput: CreateAgreementInputBase;
  studentInput: StudentInput;
};


export type MutationCreateSurveyArgs = {
  input: SurveyInput;
};


export type MutationCreateTaskFromMessageArgs = {
  assigneeId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  groupId?: InputMaybe<Scalars['ID']>;
  messageId: Scalars['ID'];
  priority?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};


export type MutationCreateTeacherArgs = {
  teacher: NewTeacherInput;
};


export type MutationCreateUniqueTeacherArgs = {
  application: ApplicationInputType;
  employmentTypes: EmploymentInputType;
  teacher: NewTeacherInput;
};


export type MutationCreateUserArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  roles: Scalars['String'];
};


export type MutationCustomLoginArgs = {
  authenticationCode?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  scope: Scalars['String'];
};


export type MutationDeleteCourseArgs = {
  courseId?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteExpenseArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteGroupArgs = {
  groupId: Scalars['Int'];
};


export type MutationDeleteMaterialArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePaymentArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePaymentCorrectionArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePlannedPaymentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteStaffTaskArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteStudentDiplomaArgs = {
  diplomaId: Scalars['ID'];
};


export type MutationDeleteStudentNoteArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSurveyAssignmentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTeacherApplicationArgs = {
  applicationId: Scalars['ID'];
};


export type MutationDeleteUserSettingsArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteZoomRecordingArgs = {
  confirm: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationDemoCustomLoginArgs = {
  authenticationCode?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  scope: Scalars['String'];
};


export type MutationDuplicateSurveyArgs = {
  id: Scalars['ID'];
};


export type MutationEnrollCareerMembersArgs = {
  directionId?: InputMaybe<Scalars['ID']>;
  groupId?: InputMaybe<Scalars['ID']>;
  studentIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationFinishLmsLessonArgs = {
  attendances: Array<LmsAttendanceType>;
  comment: Scalars['String'];
  groupLessonId: Scalars['Int'];
};


export type MutationFlagMessageArgs = {
  flagged?: InputMaybe<Scalars['Boolean']>;
  messageId: Scalars['ID'];
};


export type MutationGradeHomeworkArgs = {
  attempt?: InputMaybe<Scalars['Int']>;
  comment?: InputMaybe<Scalars['String']>;
  hwMark: Scalars['String'];
  lessonId: Scalars['ID'];
  studentId: Scalars['ID'];
};


export type MutationIssueInvoiceForContributionArgs = {
  agreementId: Scalars['ID'];
  allowReissue?: InputMaybe<Scalars['Boolean']>;
  contributionId?: InputMaybe<Scalars['ID']>;
  paymentTo?: InputMaybe<Scalars['Date']>;
};


export type MutationIssueInvoicesForGroupArgs = {
  agreementIds?: InputMaybe<Array<Scalars['ID']>>;
  expectedBillableCount?: InputMaybe<Scalars['Int']>;
  groupId: Scalars['ID'];
  paymentTo?: InputMaybe<Scalars['Date']>;
};


export type MutationLinkChannelGroupArgs = {
  channelName?: InputMaybe<Scalars['String']>;
  groupId: Scalars['ID'];
  slackChannelId: Scalars['String'];
};


export type MutationLinkContributionToPaymentArgs = {
  input: LinkContributionInput;
};


export type MutationLinkFakturowniaInvoiceToPaymentArgs = {
  invoiceId: Scalars['ID'];
  paymentId: Scalars['ID'];
};


export type MutationLinkInvoiceToContributionArgs = {
  contributionId: Scalars['ID'];
  invoiceId: Scalars['ID'];
};


export type MutationLinkLessonWhiteboardArgs = {
  lessonId: Scalars['ID'];
  whiteboardId: Scalars['ID'];
};


export type MutationLinkPandadocDocumentArgs = {
  agreementId: Scalars['ID'];
  pandadocId: Scalars['String'];
};


export type MutationLinkPandadocTeacherArgs = {
  pandadocId: Scalars['String'];
  teacherId: Scalars['ID'];
};


export type MutationLinkSlackUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['ID']>;
  slackUserId: Scalars['String'];
  studentId: Scalars['ID'];
};


export type MutationLmsClearTodayLessonLinkArgs = {
  groupId: Scalars['Int'];
};


export type MutationLmsJoinLessonArgs = {
  groupLessonId: Scalars['Int'];
};


export type MutationLmsSetTodayLessonLinkArgs = {
  groupId: Scalars['Int'];
  joinUrl: Scalars['String'];
};


export type MutationLmsStudentSignUpArgs = {
  studentInput: StudentSignUpInput;
};


export type MutationMarkCareerLessonOpenedArgs = {
  lessonId: Scalars['ID'];
};


export type MutationMarkContributionPaidManuallyArgs = {
  amount?: InputMaybe<Scalars['Float']>;
  contributionId: Scalars['ID'];
  date: Scalars['Date'];
};


export type MutationMarkConversationReadArgs = {
  conversationId: Scalars['ID'];
  read?: InputMaybe<Scalars['Boolean']>;
};


export type MutationMarkLessonMissingRecordingArgs = {
  lessonId: Scalars['ID'];
};


export type MutationMarkMessageReadArgs = {
  messageId: Scalars['ID'];
  read?: InputMaybe<Scalars['Boolean']>;
};


export type MutationMarkVacancyInteractionArgs = {
  kind: Scalars['String'];
  vacancyId: Scalars['ID'];
};


export type MutationMatchDiplomaFilesArgs = {
  fileNames: Array<Scalars['String']>;
  groupId: Scalars['ID'];
};


export type MutationMatchFakturowniaInvoiceArgs = {
  groupId?: InputMaybe<Scalars['ID']>;
  invoiceId: Scalars['ID'];
  studentId: Scalars['ID'];
};


export type MutationMoveStaffTaskArgs = {
  input: MoveStaffTaskInput;
};


export type MutationPasswordResetArgs = {
  newPassword1: Scalars['String'];
  newPassword2: Scalars['String'];
  token: Scalars['String'];
};


export type MutationPasswordSetArgs = {
  newPassword1: Scalars['String'];
  newPassword2: Scalars['String'];
  token: Scalars['String'];
};


export type MutationProvisionStudentsArgs = {
  contributionAmount: Scalars['Float'];
  currency: Scalars['String'];
  documents: Array<ProvisionDocOverrideInput>;
  groupId: Scalars['ID'];
};


export type MutationPublishGroupArgs = {
  groupId: Scalars['ID'];
  publishedForTeachers?: InputMaybe<Scalars['Boolean']>;
  publishedLms: Scalars['Boolean'];
  publishedLmsForMethodist?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRecordPlacementArgs = {
  input: PlacementInput;
  memberId: Scalars['ID'];
};


export type MutationRefreshAllZoomDataArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
};


export type MutationRefreshTokenArgs = {
  activeRole?: InputMaybe<LmsRoles>;
  refreshToken: Scalars['String'];
  scope?: InputMaybe<Scalars['String']>;
};


export type MutationRemindDebtorsArgs = {
  agreementTitles: Array<Scalars['String']>;
};


export type MutationRemoveCareerLessonAttachmentArgs = {
  attachmentId: Scalars['ID'];
};


export type MutationRenameWhiteboardArgs = {
  name: Scalars['String'];
  whiteboardId: Scalars['ID'];
};


export type MutationReparsePandadocRecipientsArgs = {
  markRefetch?: InputMaybe<Scalars['Boolean']>;
};


export type MutationReprocessAiArgs = {
  id: Scalars['ID'];
};


export type MutationRerunFakturowniaMatcherArgs = {
  invoiceId: Scalars['ID'];
};


export type MutationRerunHomeworkAiReviewArgs = {
  submissionId: Scalars['ID'];
};


export type MutationRetryLessonRecordingArgs = {
  id: Scalars['ID'];
};


export type MutationRevertManualContributionPaymentArgs = {
  contributionId: Scalars['ID'];
};


export type MutationRevokeTokenArgs = {
  refreshToken: Scalars['String'];
};


export type MutationRunAutoMatchingArgs = {
  date: Scalars['Date'];
};


export type MutationSaveCareerLessonNotesArgs = {
  lessonId: Scalars['ID'];
  notes: Scalars['String'];
};


export type MutationSaveCareerProfileArgs = {
  clearPhoto?: InputMaybe<Scalars['Boolean']>;
  input: CareerProfileInput;
  photo?: InputMaybe<Scalars['Upload']>;
};


export type MutationSaveCvTextArgs = {
  about?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  language: Scalars['String'];
};


export type MutationSaveWhiteboardLibraryArgs = {
  expectedVersion: Scalars['Int'];
  itemsJson: Scalars['String'];
};


export type MutationSaveWhiteboardSceneArgs = {
  expectedVersion: Scalars['Int'];
  sceneJson: Scalars['String'];
  whiteboardId: Scalars['ID'];
};


export type MutationSendGmailReplyArgs = {
  conversationId: Scalars['ID'];
  text: Scalars['String'];
};


export type MutationSendGroupTemplateEmailArgs = {
  groupId: Scalars['ID'];
  recipients: Array<MailRecipientInput>;
  subjectOverride?: InputMaybe<Scalars['String']>;
  templateId: Scalars['String'];
  templateName?: InputMaybe<Scalars['String']>;
};


export type MutationSendLmsAuthEmailArgs = {
  authenticationInput: LmsAuthenticationInput;
};


export type MutationSendMorningReportArgs = {
  date?: InputMaybe<Scalars['Date']>;
};


export type MutationSendNewEmailArgs = {
  mailboxEmail: Scalars['String'];
  studentId?: InputMaybe<Scalars['ID']>;
  subject?: InputMaybe<Scalars['String']>;
  teacherId?: InputMaybe<Scalars['ID']>;
  text: Scalars['String'];
  toEmail: Scalars['String'];
};


export type MutationSendPasswordResetEmailArgs = {
  email: Scalars['String'];
};


export type MutationSendSlackChannelMessageArgs = {
  groupId: Scalars['ID'];
  slackChannelId: Scalars['String'];
  text: Scalars['String'];
};


export type MutationSendSlackMessageArgs = {
  conversationId: Scalars['ID'];
  text: Scalars['String'];
};


export type MutationSetAgreementFreeOfChargeArgs = {
  agreementId: Scalars['ID'];
  freeOfCharge: Scalars['Boolean'];
};


export type MutationSetAgreementStatePrefinancedArgs = {
  agreementId: Scalars['ID'];
  statePrefinanced: Scalars['Boolean'];
};


export type MutationSetAgreementTransferOutArgs = {
  agreementId: Scalars['ID'];
  transferOut: Scalars['Boolean'];
};


export type MutationSetCareerLessonBookmarkArgs = {
  isBookmarked: Scalars['Boolean'];
  lessonId: Scalars['ID'];
};


export type MutationSetCareerLessonQuizArgs = {
  lessonId: Scalars['ID'];
  questions: Array<CareerQuizQuestionInput>;
};


export type MutationSetCashBalanceArgs = {
  amountPln: Scalars['Float'];
  asOfDate: Scalars['Date'];
  comment?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['ID']>;
};


export type MutationSetConversationStatusArgs = {
  conversationId: Scalars['ID'];
  status: Scalars['String'];
};


export type MutationSetExchangeRateArgs = {
  comment?: InputMaybe<Scalars['String']>;
  currency: Scalars['String'];
  effectiveFrom: Scalars['Date'];
  rateToPln: Scalars['Float'];
};


export type MutationSetExpenseStatusArgs = {
  id: Scalars['ID'];
  paidAt?: InputMaybe<Scalars['Date']>;
  status: Scalars['String'];
};


export type MutationSetFakturowniaInvoiceGroupArgs = {
  groupId?: InputMaybe<Scalars['ID']>;
  invoiceId: Scalars['ID'];
};


export type MutationSetGroupLessonLinkArgs = {
  groupId: Scalars['Int'];
  joinUrl: Scalars['String'];
};


export type MutationSetGroupLessonLinkOverrideArgs = {
  date?: InputMaybe<Scalars['Date']>;
  groupId: Scalars['Int'];
  joinUrl: Scalars['String'];
};


export type MutationSetGroupZoomAccountArgs = {
  groupId: Scalars['ID'];
  zoomAccountId?: InputMaybe<Scalars['ID']>;
};


export type MutationSetGroupZoomScheduleArgs = {
  groupId: Scalars['ID'];
  slots: Array<GroupZoomScheduleSlotInput>;
  zoomAccountId?: InputMaybe<Scalars['ID']>;
};


export type MutationSetMessageHandledArgs = {
  handled?: InputMaybe<Scalars['Boolean']>;
  messageId: Scalars['ID'];
};


export type MutationSetMySlackUserTokenArgs = {
  groupId: Scalars['ID'];
  userToken: Scalars['String'];
};


export type MutationSetPaymentCalendarSettingsArgs = {
  incomeOffsetDays?: InputMaybe<Scalars['Int']>;
  legalEntityId?: InputMaybe<Scalars['ID']>;
  teacherPayoutDay?: InputMaybe<Scalars['Int']>;
};


export type MutationSetProfileSearchableArgs = {
  contactsVisible?: InputMaybe<Scalars['Boolean']>;
  isSearchable: Scalars['Boolean'];
};


export type MutationSetSlackWorkspaceArgs = {
  botToken?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  groupId: Scalars['ID'];
  oauthClientId?: InputMaybe<Scalars['String']>;
  oauthClientSecret?: InputMaybe<Scalars['String']>;
  signingSecret?: InputMaybe<Scalars['String']>;
  teamId?: InputMaybe<Scalars['String']>;
  workspaceName?: InputMaybe<Scalars['String']>;
};


export type MutationSetStudentsMarksArgs = {
  date: Scalars['Date'];
  lessonId: Scalars['Int'];
  studentsMarks: Array<InputMaybe<LessonMarkInput>>;
  taskType: LessonTaskTypeEnum;
};


export type MutationSetTeacherProfileArgs = {
  coursesCanTeachIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  internalNote?: InputMaybe<Scalars['String']>;
  interviewRecording?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Scalars['Int']>;
  teacherId: Scalars['ID'];
};


export type MutationSetVacancyStatusArgs = {
  id: Scalars['ID'];
  status: Scalars['String'];
};


export type MutationStartSlackDmArgs = {
  groupId: Scalars['ID'];
  studentId: Scalars['ID'];
  text: Scalars['String'];
};


export type MutationStartSlackUserOauthArgs = {
  groupId: Scalars['ID'];
};


export type MutationSubmitCareerQuizArgs = {
  answers: Array<CareerQuizAnswerInput>;
  lessonId: Scalars['ID'];
};


export type MutationSubmitHomeworkArgs = {
  file?: InputMaybe<Scalars['Upload']>;
  githubUrl?: InputMaybe<Scalars['String']>;
  lessonId: Scalars['ID'];
};


export type MutationSubmitSurveyResponseArgs = {
  answers: Array<SurveyAnswerInput>;
  assignmentId: Scalars['ID'];
};


export type MutationSyncAllZoomRecordingsArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
};


export type MutationSyncCommunicationsNowArgs = {
  groupId?: InputMaybe<Scalars['ID']>;
};


export type MutationSyncGroupSendgridListArgs = {
  groupId: Scalars['ID'];
};


export type MutationSyncZoomRecordingsArgs = {
  date: Scalars['Date'];
};


export type MutationTerminateAgreementArgs = {
  agreementId: Scalars['ID'];
  comment?: InputMaybe<Scalars['String']>;
  terminatedDate?: InputMaybe<Scalars['Date']>;
  terminatedReason?: InputMaybe<TerminatedReasonEnum>;
};


export type MutationTriggerFakturowniaGroupSyncArgs = {
  groupId: Scalars['ID'];
  period?: InputMaybe<Scalars['String']>;
};


export type MutationTriggerFakturowniaSyncArgs = {
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  period?: InputMaybe<Scalars['String']>;
};


export type MutationTriggerZoomGroupProcessArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  groupId: Scalars['ID'];
};


export type MutationUnblockStudentLmsAccessArgs = {
  reason?: InputMaybe<Scalars['String']>;
  studentId: Scalars['ID'];
};


export type MutationUnlinkContributionArgs = {
  contributionId: Scalars['ID'];
};


export type MutationUnlinkFakturowniaInvoiceArgs = {
  invoiceId: Scalars['ID'];
};


export type MutationUnlinkInvoiceFromContributionArgs = {
  invoiceId: Scalars['ID'];
};


export type MutationUnlinkLessonRecordingArgs = {
  id: Scalars['ID'];
};


export type MutationUnlinkLessonWhiteboardArgs = {
  lessonId: Scalars['ID'];
};


export type MutationUnlinkPandadocDocumentArgs = {
  pandadocId: Scalars['String'];
};


export type MutationUnlinkPandadocTeacherArgs = {
  pandadocId: Scalars['String'];
};


export type MutationUpdateAttendanceArgs = {
  attendance: Scalars['Boolean'];
  attendanceId: Scalars['Int'];
};


export type MutationUpdateCareerMemberArgs = {
  id: Scalars['ID'];
  input: CareerMemberInput;
};


export type MutationUpdateCompanyArgs = {
  companyId: Scalars['ID'];
  companyInput: UpdateCompanyInput;
};


export type MutationUpdateCourseArgs = {
  courseId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateExpenseArgs = {
  input: UpdateExpenseInput;
};


export type MutationUpdateGroupArgs = {
  groupId: Scalars['Int'];
  groupInput: UpdateGroupInput;
};


export type MutationUpdateJournalArgs = {
  comment: Scalars['String'];
  daysOfClass: Array<DayOfClassInput>;
  groupId: Scalars['Int'];
  modules: Array<InputMaybe<UpdateModuleInput>>;
};


export type MutationUpdateMaterialArgs = {
  id: Scalars['ID'];
  input: UpdateMaterialInput;
};


export type MutationUpdatePaymentArgs = {
  input: UpdatePaymentInput;
};


export type MutationUpdatePaymentCorrectionArgs = {
  input: UpdatePaymentCorrectionInput;
};


export type MutationUpdatePlannedPaymentArgs = {
  input: UpdatePlannedPaymentInput;
};


export type MutationUpdateStaffTaskArgs = {
  input: UpdateStaffTaskInput;
};


export type MutationUpdateStudentNoteArgs = {
  input: UpdateStudentNoteInput;
};


export type MutationUpdateStudentWithAgreementArgs = {
  agreementId?: InputMaybe<Scalars['ID']>;
  updateStudentInput: UpdateStudentInput;
};


export type MutationUpdateSurveyArgs = {
  id: Scalars['ID'];
  input: SurveyInput;
};


export type MutationUpdateSurveyAssignmentArgs = {
  id: Scalars['ID'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  triggerLessonId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateTaskStatusArgs = {
  id: Scalars['ID'];
  status: Scalars['String'];
};


export type MutationUpdateTeacherApplicationArgs = {
  application: UpdateApplicationInputType;
};


export type MutationUpdateTeacherWithTypeArgs = {
  employmentInput: ExistEmploymentInputType;
  teacherId?: InputMaybe<Scalars['ID']>;
  teacherInput: TeacherWithTypeInput;
};


export type MutationUpdateUserSettingsArgs = {
  userId?: InputMaybe<Scalars['ID']>;
  userSettingsInput: CustomUserInput;
};


export type MutationUploadCareerLessonVideoArgs = {
  lessonId: Scalars['ID'];
  video: Scalars['Upload'];
};


export type MutationUploadLessonVideoArgs = {
  lessonId: Scalars['Int'];
  videoUrl: Scalars['String'];
};


export type MutationUploadStudentDiplomaArgs = {
  file: Scalars['Upload'];
  groupId: Scalars['ID'];
  language: DiplomaLanguageEnum;
  replaceExisting?: InputMaybe<Scalars['Boolean']>;
  studentId: Scalars['ID'];
};


export type MutationUploadWhiteboardFileArgs = {
  file: Scalars['Upload'];
  fileId: Scalars['String'];
  mimeType?: InputMaybe<Scalars['String']>;
  whiteboardId: Scalars['ID'];
};


export type MutationUpsertCareerLessonArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input: CareerLessonInput;
};


export type MutationUpsertHomeworkAssignmentArgs = {
  dueDate?: InputMaybe<Scalars['Date']>;
  lessonId: Scalars['ID'];
  text: Scalars['String'];
  title: Scalars['String'];
};


export type MutationUpsertVacancyArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input: VacancyInput;
};


export type MutationVerifyTokenArgs = {
  token: Scalars['String'];
};


export type MutationZeroOutContributionArgs = {
  contributionId: Scalars['ID'];
};

/**
 * LMS student-self view. Reachable ONLY from `myDiplomas`.
 *
 * Carries `group_name`/`course_name` because a student who studied in two
 * groups would otherwise see two indistinguishable «Diploma (PL)» rows.
 */
export type MyDiplomaType = {
  __typename?: 'MyDiplomaType';
  courseName?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  issuedAt?: Maybe<Scalars['DateTime']>;
  language: DiplomaLanguageEnum;
  originalName?: Maybe<Scalars['String']>;
  sizeBytes?: Maybe<Scalars['Int']>;
};

/** Parent is {'submission': HomeworkSubmission, 'hw_mark': str|None}. */
export type MyHomeworkSubmissionType = {
  __typename?: 'MyHomeworkSubmissionType';
  attempt: Scalars['Int'];
  fileName?: Maybe<Scalars['String']>;
  githubUrl?: Maybe<Scalars['String']>;
  hwMark?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  status: Scalars['String'];
  submittedAt: Scalars['DateTime'];
  teacherComment?: Maybe<Scalars['String']>;
};

/**
 * One row of the signed-in student's OWN attendance record (spec 0013
 * follow-up). Parent is a `journals.StudentAttendance`.
 *
 * Deliberately a hand-built ObjectType rather than a DjangoObjectType on
 * StudentAttendance: that model hangs off Student/GroupLesson, and exposing
 * it as a Django type would let the LMS schema walk back to other students'
 * rows. Everything here is the requester's own by construction.
 */
export type MyLessonAttendanceType = {
  __typename?: 'MyLessonAttendanceType';
  attendance?: Maybe<Scalars['Boolean']>;
  date?: Maybe<Scalars['Date']>;
  lessonId: Scalars['ID'];
  lessonName: Scalars['String'];
  lessonNumber: Scalars['Int'];
};

export type NativeInfoConnection = {
  __typename?: 'NativeInfoConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NativeInfoEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `NativeInfo` and its cursor. */
export type NativeInfoEdge = {
  __typename?: 'NativeInfoEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<NativeInfoType>;
};

export type NativeInfoType = {
  __typename?: 'NativeInfoType';
  articlesSet: Array<ArticlesType>;
  date: Scalars['Date'];
  description: Scalars['String'];
  id: Scalars['ID'];
  image: Scalars['String'];
  interviewLink: Scalars['String'];
  interviewText: Scalars['String'];
  nativeBanner?: Maybe<CourseBanner>;
  published: Scalars['Boolean'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoSlug?: Maybe<Scalars['String']>;
  seoTitle: Scalars['String'];
  successstoriesSet: Array<SuccessStoriesType>;
  title: Scalars['String'];
};

export type NaturalPersonInput = {
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  nationality: Scalars['ID'];
  passportNumber: Scalars['String'];
  registrationAddress: Scalars['String'];
};

export type NaturalPersonType = Node & {
  __typename?: 'NaturalPersonType';
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  id: Scalars['ID'];
  nationality: CountryType;
  passportNumber: Scalars['String'];
  registrationAddress: Scalars['String'];
};

export type NewTeacherInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  siteDisplay?: InputMaybe<Scalars['Boolean']>;
};

export type NewYearLeadInput = {
  age: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  course_id?: InputMaybe<Scalars['Int']>;
  email: Scalars['String'];
  formName: Scalars['String'];
  message: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  promocode?: InputMaybe<Scalars['String']>;
  referer?: InputMaybe<Scalars['String']>;
  roistatId: Scalars['String'];
  tittle: Scalars['String'];
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  utmTerm?: InputMaybe<Scalars['String']>;
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID'];
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Everything the standalone dashboard renders, computed server-side. */
export type PandaDocAnalyticsType = {
  __typename?: 'PandaDocAnalyticsType';
  conversionByCourse?: Maybe<Array<Maybe<PandaDocCourseConversion>>>;
  conversionKpi?: Maybe<PandaDocConversionKpi>;
  conversionSeries?: Maybe<PandaDocConversionSeriesGroup>;
  course?: Maybe<Scalars['String']>;
  granularity?: Maybe<Scalars['String']>;
  ttsByCourse?: Maybe<Array<Maybe<PandaDocCourseTts>>>;
  ttsHistogram?: Maybe<PandaDocHistogram>;
  ttsKpi?: Maybe<PandaDocTtsKpi>;
  ttsMedianSeries?: Maybe<PandaDocTtsMedianSeries>;
  volumeKpi?: Maybe<PandaDocVolumeKpi>;
  volumeSeries?: Maybe<PandaDocVolumeSeries>;
  window?: Maybe<PandaDocWindow>;
};

export type PandaDocConversionKpi = {
  __typename?: 'PandaDocConversionKpi';
  active?: Maybe<Scalars['Int']>;
  activePct?: Maybe<Scalars['Int']>;
  lost?: Maybe<Scalars['Int']>;
  lostPct?: Maybe<Scalars['Int']>;
  ratePct?: Maybe<Scalars['Int']>;
  sent?: Maybe<Scalars['Int']>;
  signed?: Maybe<Scalars['Int']>;
  signedPct?: Maybe<Scalars['Int']>;
};

/** Sent→signed conversion stacked per bucket. */
export type PandaDocConversionSeries = {
  __typename?: 'PandaDocConversionSeries';
  active?: Maybe<Array<Maybe<Scalars['Int']>>>;
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  lost?: Maybe<Array<Maybe<Scalars['Int']>>>;
  signed?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type PandaDocConversionSeriesGroup = {
  __typename?: 'PandaDocConversionSeriesGroup';
  dofin?: Maybe<PandaDocConversionSeries>;
  students?: Maybe<PandaDocConversionSeries>;
};

/** Volume series: a count per timeline bucket. */
export type PandaDocCountSeries = {
  __typename?: 'PandaDocCountSeries';
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  values?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type PandaDocCourseConversion = {
  __typename?: 'PandaDocCourseConversion';
  active?: Maybe<Scalars['Int']>;
  course?: Maybe<Scalars['String']>;
  lost?: Maybe<Scalars['Int']>;
  signed?: Maybe<Scalars['Int']>;
};

export type PandaDocCourseTts = {
  __typename?: 'PandaDocCourseTTS';
  avgDays?: Maybe<Scalars['Float']>;
  course?: Maybe<Scalars['String']>;
  sample?: Maybe<Scalars['Int']>;
};

export type PandaDocDocumentConnection = {
  __typename?: 'PandaDocDocumentConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PandaDocDocumentEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** An enumeration. */
export enum PandaDocDocumentDocType {
  /** Co-financing */
  Dofin = 'DOFIN',
  /** Other */
  Other = 'OTHER',
  /** Student agreement */
  Student = 'STUDENT',
  /** Trainer agreement */
  Trainer = 'TRAINER'
}

/** A Relay edge containing a `PandaDocDocument` and its cursor. */
export type PandaDocDocumentEdge = {
  __typename?: 'PandaDocDocumentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PandaDocDocumentType>;
};

/** An enumeration. */
export enum PandaDocDocumentOutcome {
  /** In progress */
  Active = 'ACTIVE',
  /** Not signed */
  Lost = 'LOST',
  /** Signed */
  Signed = 'SIGNED'
}

export type PandaDocDocumentType = Node & {
  __typename?: 'PandaDocDocumentType';
  /** LMS Agreement (договор) that was created from this signed document. Null until the document is provisioned via the `provisionStudents` mutation. */
  agreement?: Maybe<AgreementType>;
  contractUrl: Scalars['String'];
  course: Scalars['String'];
  dateCompleted?: Maybe<Scalars['DateTime']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateModified?: Maybe<Scalars['DateTime']>;
  dateSent?: Maybe<Scalars['DateTime']>;
  detailsFetched: Scalars['Boolean'];
  docType: PandaDocDocumentDocType;
  folderName: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  /** provisioned | linked | candidate — link state of the document relative to an LMS agreement (student) or a Teacher. */
  matchType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  outcome: PandaDocDocumentOutcome;
  pandadocId: Scalars['String'];
  pk?: Maybe<Scalars['Int']>;
  /** Timestamp the document was turned into a Student + Agreement. Null while the document is still pending or has been signed but not yet provisioned. */
  provisionedAt?: Maybe<Scalars['DateTime']>;
  recipientEmail: Scalars['String'];
  recipientPhone: Scalars['String'];
  status: Scalars['String'];
  syncedAt: Scalars['DateTime'];
  /** Teacher this trainer document is linked to (teacher card). Null for student / unlinked documents. */
  teacher?: Maybe<TeacherType>;
  ttsHours?: Maybe<Scalars['Float']>;
};

export type PandaDocHistogram = {
  __typename?: 'PandaDocHistogram';
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  values?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

/** Sync-health snapshot, sourced from `PandaDocSyncState` (req 3). */
export type PandaDocSyncStatusType = {
  __typename?: 'PandaDocSyncStatusType';
  detailsPending?: Maybe<Scalars['Int']>;
  documentsCount?: Maybe<Scalars['Int']>;
  lastDetailsSyncAt?: Maybe<Scalars['DateTime']>;
  lastDocumentsPulled?: Maybe<Scalars['Int']>;
  lastError?: Maybe<Scalars['String']>;
  lastListSyncAt?: Maybe<Scalars['DateTime']>;
  lastRunStatus?: Maybe<Scalars['String']>;
  newestDocDate?: Maybe<Scalars['DateTime']>;
  syncRunning?: Maybe<Scalars['Boolean']>;
};

export type PandaDocTtsKpi = {
  __typename?: 'PandaDocTTSKpi';
  meanHours?: Maybe<Scalars['Float']>;
  medianHours?: Maybe<Scalars['Float']>;
  pct3d?: Maybe<Scalars['Int']>;
  pct24h?: Maybe<Scalars['Int']>;
  sample?: Maybe<Scalars['Int']>;
};

export type PandaDocTtsMedianSeries = {
  __typename?: 'PandaDocTTSMedianSeries';
  dofin?: Maybe<PandaDocTtsSeries>;
  students?: Maybe<PandaDocTtsSeries>;
  trainers?: Maybe<PandaDocTtsSeries>;
};

/** Median time-to-sign (days) per bucket; null where the bucket is empty. */
export type PandaDocTtsSeries = {
  __typename?: 'PandaDocTTSSeries';
  labels?: Maybe<Array<Maybe<Scalars['String']>>>;
  values?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export type PandaDocVolumeKpi = {
  __typename?: 'PandaDocVolumeKpi';
  dofin?: Maybe<Scalars['Int']>;
  last30?: Maybe<Scalars['Int']>;
  students?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  trainers?: Maybe<Scalars['Int']>;
};

export type PandaDocVolumeSeries = {
  __typename?: 'PandaDocVolumeSeries';
  dofin?: Maybe<PandaDocCountSeries>;
  students?: Maybe<PandaDocCountSeries>;
  trainers?: Maybe<PandaDocCountSeries>;
};

export type PandaDocWindow = {
  __typename?: 'PandaDocWindow';
  docsLoaded?: Maybe<Scalars['Int']>;
  maxDate?: Maybe<Scalars['Date']>;
  minDate?: Maybe<Scalars['Date']>;
  signedCount?: Maybe<Scalars['Int']>;
  totalInDb?: Maybe<Scalars['Int']>;
};

/** Сброс пароля по токену из письма. SDL: {success, errors}. */
export type PasswordReset = {
  __typename?: 'PasswordReset';
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Установка первого пароля по токену из письма. SDL: {success, errors}. */
export type PasswordSet = {
  __typename?: 'PasswordSet';
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type PaymentCalendarDayType = {
  __typename?: 'PaymentCalendarDayType';
  date?: Maybe<Scalars['Date']>;
  endBalancePln?: Maybe<Scalars['Float']>;
  expenseRows?: Maybe<Array<Maybe<PaymentCalendarRowType>>>;
  expenseTotalPln?: Maybe<Scalars['Float']>;
  hasRateMissing?: Maybe<Scalars['Boolean']>;
  incomeRows?: Maybe<Array<Maybe<PaymentCalendarRowType>>>;
  incomeTotalPln?: Maybe<Scalars['Float']>;
  openingBalancePln?: Maybe<Scalars['Float']>;
  receivedRows?: Maybe<Array<Maybe<PaymentCalendarRowType>>>;
  receivedTotalPln?: Maybe<Scalars['Float']>;
  tone?: Maybe<Scalars['String']>;
};

export type PaymentCalendarRowType = {
  __typename?: 'PaymentCalendarRowType';
  amount?: Maybe<Scalars['Float']>;
  amountPln?: Maybe<Scalars['Float']>;
  balanceAfterPln?: Maybe<Scalars['Float']>;
  comment?: Maybe<Scalars['String']>;
  contributionId?: Maybe<Scalars['Int']>;
  counterpartyName?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['Date']>;
  direction?: Maybe<Scalars['String']>;
  editable?: Maybe<Scalars['Boolean']>;
  expenseId?: Maybe<Scalars['Int']>;
  incomeState?: Maybe<Scalars['String']>;
  /** Fakturownia UI view_url from the mirrored payload; empty when the document has none. */
  invoiceExternalUrl?: Maybe<Scalars['String']>;
  /** Internal FakturowniaInvoice pk — ERP invoice detail page. */
  invoiceId?: Maybe<Scalars['Int']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  plannedPaymentId?: Maybe<Scalars['Int']>;
  rateMissing?: Maybe<Scalars['Boolean']>;
  relatedGroupId?: Maybe<Scalars['Int']>;
  relatedTeacherId?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  sourceRef?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  toneAfter?: Maybe<Scalars['String']>;
};

export type PaymentCalendarSettingsType = {
  __typename?: 'PaymentCalendarSettingsType';
  id: Scalars['ID'];
  /** Money is expected this many days after invoice/installment date. */
  incomeOffsetDays: Scalars['Int'];
  legalEntityId?: Maybe<Scalars['Int']>;
  /** Day of month M+1 on which month M's lessons are paid. */
  teacherPayoutDay: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type PaymentCalendarType = {
  __typename?: 'PaymentCalendarType';
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  days?: Maybe<Array<Maybe<PaymentCalendarDayType>>>;
  hasRateMissing?: Maybe<Scalars['Boolean']>;
  hasShortfall?: Maybe<Scalars['Boolean']>;
  minBalancePln?: Maybe<Scalars['Float']>;
  openingBalancePln?: Maybe<Scalars['Float']>;
  totalAwaitedPln?: Maybe<Scalars['Float']>;
  totalExpensePln?: Maybe<Scalars['Float']>;
  totalIncomePln?: Maybe<Scalars['Float']>;
  totalOverduePln?: Maybe<Scalars['Float']>;
  totalReceivedPln?: Maybe<Scalars['Float']>;
  totalToPayPln?: Maybe<Scalars['Float']>;
};

/** An enumeration. */
export enum PaymentCorrectionCurrency {
  /** BYN */
  Byn = 'BYN',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN',
  /** RUB */
  Rub = 'RUB',
  /** USD */
  Usd = 'USD'
}

/**
 * A correction line (корректировка) — amount is the positive magnitude;
 * `payment` is the target payment (null → whole-agreement / plan correction).
 */
export type PaymentCorrectionType = {
  __typename?: 'PaymentCorrectionType';
  agreement: AgreementType;
  amountByn?: Maybe<Scalars['CustomFloat']>;
  amountForeign?: Maybe<Scalars['CustomFloat']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<CustomUserType>;
  currency: PaymentCorrectionCurrency;
  date: Scalars['Date'];
  id: Scalars['ID'];
  /** Целевой платёж (разворот полученного); null — ко всему договору/плану. */
  payment?: Maybe<PaymentType>;
  reason?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

/** An enumeration. */
export enum PaymentCurrency {
  /** BYN */
  Byn = 'BYN',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN',
  /** RUB */
  Rub = 'RUB',
  /** USD */
  Usd = 'USD'
}

export type PaymentInput = {
  agreement_id: Scalars['ID'];
  currency: Scalars['String'];
  date: Scalars['Date'];
  deferredPaymentId?: InputMaybe<Scalars['ID']>;
  sum: Scalars['Float'];
};

export type PaymentLogoType = {
  __typename?: 'PaymentLogoType';
  contactsPage: ContactsPageType;
  id: Scalars['ID'];
  logo: Scalars['String'];
};

export type PaymentRulesPageType = {
  __typename?: 'PaymentRulesPageType';
  id: Scalars['ID'];
  rules: Scalars['String'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoTitle: Scalars['String'];
  title: Scalars['String'];
};

/** An enumeration. */
export enum PaymentSource {
  /** Авто из оплаченной фактуры */
  InvoiceAuto = 'INVOICE_AUTO',
  /** Ручная отметка «оплачен» */
  ManualPaid = 'MANUAL_PAID',
  /** Создан оператором (legacy) */
  Operator = 'OPERATOR'
}

export type PaymentType = {
  __typename?: 'PaymentType';
  agreement: AgreementType;
  amountAgreement: Scalars['Float'];
  amountByn?: Maybe<Scalars['CustomFloat']>;
  amountForeign?: Maybe<Scalars['CustomFloat']>;
  /** Scheduled contribution this payment satisfies. Null for orphan payments (returns, advances, top-ups, payments on agreements without a schedule). */
  contribution?: Maybe<ContributionType>;
  /** Если указан — корректа к одному платежу (разворот полученных денег, отток). Если пусто — ко всему договору/плану (списание неоплаченного). */
  corrections: Array<PaymentCorrectionType>;
  currency: PaymentCurrency;
  date: Scalars['Date'];
  /** Linked Fakturownia invoice (1:1), if any. */
  fakturowniaInvoice?: Maybe<FakturowniaInvoiceType>;
  id: Scalars['ID'];
  source: PaymentSource;
};

export type PaymentsVerificationType = {
  __typename?: 'PaymentsVerificationType';
  agreementTitle?: Maybe<Scalars['String']>;
  agreement_id?: Maybe<Scalars['ID']>;
  currency?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  studentId?: Maybe<Scalars['ID']>;
};

/**
 * Parent is a SurveyAssignment from the pending service (survey +
 * group + trigger lesson select_related, questions prefetched) — the full
 * payload the fill page needs, no second query.
 */
export type PendingSurveyType = {
  __typename?: 'PendingSurveyType';
  assignmentId: Scalars['ID'];
  description: Scalars['String'];
  groupName: Scalars['String'];
  lessonName: Scalars['String'];
  lessonNumber: Scalars['Int'];
  questions: Array<SurveyQuestionForStudentType>;
  /** Who the teacher_rating / teacher_comment questions are about — the trigger lesson's teacher. Null when the lesson has none; the client then omits the attribution line rather than asking to rate an unnamed person. */
  teacherName?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type Person = {
  __typename?: 'Person';
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type PlacementInput = {
  companyName: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  salary?: InputMaybe<Scalars['Int']>;
  salaryCurrency?: InputMaybe<Scalars['String']>;
  startedAt?: InputMaybe<Scalars['Date']>;
  vacancyId?: InputMaybe<Scalars['ID']>;
};

export type PlacementRecordType = {
  __typename?: 'PlacementRecordType';
  companyName: Scalars['String'];
  confirmedAt: Scalars['DateTime'];
  id: Scalars['ID'];
  memberId: Scalars['ID'];
  position: Scalars['String'];
  startedAt?: Maybe<Scalars['Date']>;
  studentName: Scalars['String'];
};

/** An enumeration. */
export enum PlannedPaymentCurrency {
  /** BYN */
  Byn = 'BYN',
  /** EUR */
  Eur = 'EUR',
  /** PLN */
  Pln = 'PLN',
  /** RUB */
  Rub = 'RUB',
  /** USD */
  Usd = 'USD'
}

/** An enumeration. */
export enum PlannedPaymentDirection {
  /** Expense */
  Expense = 'EXPENSE',
  /** Income */
  Income = 'INCOME'
}

export type PlannedPaymentInput = {
  amount: Scalars['Float'];
  categorySlug?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  date: Scalars['Date'];
  direction: Scalars['String'];
  kind?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['ID']>;
  periodDate?: InputMaybe<Scalars['Date']>;
  periodMonth?: InputMaybe<Scalars['Int']>;
  periodYear?: InputMaybe<Scalars['Int']>;
  recurrence?: InputMaybe<Scalars['String']>;
  recurrenceDay?: InputMaybe<Scalars['Int']>;
  recurrenceUntil?: InputMaybe<Scalars['Date']>;
  relatedApplicationId?: InputMaybe<Scalars['ID']>;
  relatedContributionId?: InputMaybe<Scalars['ID']>;
  relatedExpenseId?: InputMaybe<Scalars['ID']>;
  relatedFakturowniaInvoiceId?: InputMaybe<Scalars['ID']>;
  relatedGroupId?: InputMaybe<Scalars['ID']>;
  relatedTeacherId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** An enumeration. */
export enum PlannedPaymentKind {
  /** Expense occurrence override */
  ExpenseOccurrenceOverride = 'EXPENSE_OCCURRENCE_OVERRIDE',
  /** Income override */
  IncomeOverride = 'INCOME_OVERRIDE',
  /** Manual one-off */
  Manual = 'MANUAL',
  /** Recurring template */
  Recurring = 'RECURRING',
  /** Teacher payout override */
  TeacherPayoutOverride = 'TEACHER_PAYOUT_OVERRIDE'
}

export type PlannedPaymentMutationOutput = {
  __typename?: 'PlannedPaymentMutationOutput';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  plannedPayment?: Maybe<PlannedPaymentType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** An enumeration. */
export enum PlannedPaymentRecurrence {
  /** Monthly */
  Monthly = 'MONTHLY',
  /** Brak */
  None = 'NONE'
}

/** An enumeration. */
export enum PlannedPaymentStatus {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Confirmed */
  Confirmed = 'CONFIRMED',
  /** Paid */
  Paid = 'PAID',
  /** Planned */
  Planned = 'PLANNED'
}

export type PlannedPaymentType = {
  __typename?: 'PlannedPaymentType';
  amount?: Maybe<Scalars['Float']>;
  amountPln?: Maybe<Scalars['Float']>;
  categorySlug?: Maybe<Scalars['String']>;
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  currency: PlannedPaymentCurrency;
  /** Predicted payment date (user-editable). For recurring templates this is the first occurrence. */
  date: Scalars['Date'];
  direction: PlannedPaymentDirection;
  id: Scalars['ID'];
  kind: PlannedPaymentKind;
  legalEntityId?: Maybe<Scalars['Int']>;
  periodMonth?: Maybe<Scalars['Int']>;
  periodYear?: Maybe<Scalars['Int']>;
  pk?: Maybe<Scalars['Int']>;
  recurrence: PlannedPaymentRecurrence;
  /** 1–31; clamped to the last day of short months. */
  recurrenceDay?: Maybe<Scalars['Int']>;
  /** Inclusive end; empty means open-ended (until changed). */
  recurrenceUntil?: Maybe<Scalars['Date']>;
  relatedApplicationId?: Maybe<Scalars['Int']>;
  relatedContributionId?: Maybe<Scalars['Int']>;
  relatedFakturowniaInvoiceId?: Maybe<Scalars['Int']>;
  relatedGroupId?: Maybe<Scalars['Int']>;
  relatedTeacherId?: Maybe<Scalars['Int']>;
  status: PlannedPaymentStatus;
  /** Short label shown in the day cell / row. */
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PortfolioProjectType = {
  __typename?: 'PortfolioProjectType';
  demoUrl: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  repoUrl: Scalars['String'];
  role: Scalars['String'];
  technologyIds: Array<Scalars['ID']>;
  technologyNames: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type PrivateIndividualPublicOfferAgreementType = Node & {
  __typename?: 'PrivateIndividualPublicOfferAgreementType';
  agreementDate: Scalars['Date'];
  content: Scalars['String'];
  displayPage: PrivateIndividualPublicOfferPageType;
  file: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
};

export type PrivateIndividualPublicOfferAgreementTypeConnection = {
  __typename?: 'PrivateIndividualPublicOfferAgreementTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PrivateIndividualPublicOfferAgreementTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PrivateIndividualPublicOfferAgreementType` and its cursor. */
export type PrivateIndividualPublicOfferAgreementTypeEdge = {
  __typename?: 'PrivateIndividualPublicOfferAgreementTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PrivateIndividualPublicOfferAgreementType>;
};

export type PrivateIndividualPublicOfferPageType = {
  __typename?: 'PrivateIndividualPublicOfferPageType';
  actualPublicOfferAgreement?: Maybe<PrivateIndividualPublicOfferAgreementType>;
  id: Scalars['ID'];
  publicOfferAgreements: PrivateIndividualPublicOfferAgreementTypeConnection;
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoTitle: Scalars['String'];
  title: Scalars['String'];
};


export type PrivateIndividualPublicOfferPageTypePublicOfferAgreementsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ProfessionalSkillType = {
  __typename?: 'ProfessionalSkillType';
  description: Scalars['String'];
  id: Scalars['ID'];
  studentCv: StudentCvType;
};

export type ProfileCertificateInput = {
  id?: InputMaybe<Scalars['ID']>;
  issuedAt?: InputMaybe<Scalars['Date']>;
  issuer?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
};

export type ProfileEducationInput = {
  degree?: InputMaybe<Scalars['String']>;
  endMonth?: InputMaybe<Scalars['Int']>;
  endYear?: InputMaybe<Scalars['Int']>;
  institution?: InputMaybe<Scalars['String']>;
  specialization?: InputMaybe<Scalars['String']>;
  startMonth?: InputMaybe<Scalars['Int']>;
  startYear?: InputMaybe<Scalars['Int']>;
};

export type ProfileExperienceInput = {
  company?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  endMonth?: InputMaybe<Scalars['Int']>;
  endYear?: InputMaybe<Scalars['Int']>;
  isCurrent?: InputMaybe<Scalars['Boolean']>;
  position?: InputMaybe<Scalars['String']>;
  startMonth?: InputMaybe<Scalars['Int']>;
  startYear?: InputMaybe<Scalars['Int']>;
};

export type ProfileLanguageInput = {
  language: Scalars['String'];
  level?: InputMaybe<Scalars['String']>;
};

export type ProfileProjectInput = {
  demoUrl?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  repoUrl?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  technologyIds?: InputMaybe<Array<Scalars['ID']>>;
  title: Scalars['String'];
};

export type ProfileSkillInput = {
  level?: InputMaybe<Scalars['Int']>;
  skillId: Scalars['ID'];
  years?: InputMaybe<Scalars['Float']>;
};

/**
 * One selected PandaDoc document, with optional manager corrections.
 *
 * A document is provisioned only if it appears in this list — deselected
 * documents are simply omitted. Any non-null field overrides the value
 * parsed from PandaDoc (used mainly to supply a missing phone).
 */
export type ProvisionDocOverrideInput = {
  email?: InputMaybe<Scalars['String']>;
  existingUserId?: InputMaybe<Scalars['ID']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  pandadocId: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

/** Per-document outcome of a provisioning run. */
export type ProvisionResultItem = {
  __typename?: 'ProvisionResultItem';
  agreementId?: Maybe<Scalars['ID']>;
  error?: Maybe<Scalars['JSONString']>;
  pandadocId?: Maybe<Scalars['String']>;
  skipped?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Create students + agreements + first contribution from PandaDoc docs. */
export type ProvisionStudentsMutation = {
  __typename?: 'ProvisionStudentsMutation';
  errors?: Maybe<Scalars['JSONString']>;
  results?: Maybe<Array<Maybe<ProvisionResultItem>>>;
};

/** A PandaDoc folder == a study group; groups its signed contracts. */
export type ProvisioningFolder = {
  __typename?: 'ProvisioningFolder';
  detectedCourseId?: Maybe<Scalars['ID']>;
  detectedCourseName?: Maybe<Scalars['String']>;
  existingGroupId?: Maybe<Scalars['ID']>;
  existingGroupName?: Maybe<Scalars['String']>;
  folderName?: Maybe<Scalars['String']>;
  folderUuid?: Maybe<Scalars['String']>;
  studentDocs?: Maybe<Array<Maybe<ProvisioningStudentDoc>>>;
};

/** A signed student contract, ready to be turned into a Student. */
export type ProvisioningStudentDoc = {
  __typename?: 'ProvisioningStudentDoc';
  alreadyProvisioned?: Maybe<Scalars['Boolean']>;
  contractUrl?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  existingUserId?: Maybe<Scalars['ID']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  outcome?: Maybe<Scalars['String']>;
  pandadocId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phoneMissing?: Maybe<Scalars['Boolean']>;
  pk?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  studentExists?: Maybe<Scalars['Boolean']>;
  userExists?: Maybe<Scalars['Boolean']>;
};

export type PublishGroupToLms = {
  __typename?: 'PublishGroupToLMS';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  group?: Maybe<GroupType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Query = {
  __typename?: 'Query';
  agreement?: Maybe<AgreementType>;
  /** Tasks tied to one agreement (договор). */
  agreementTasks: Array<StaffTaskType>;
  allArticles?: Maybe<ArticlesConnection>;
  allCompanies?: Maybe<CompanyConnection>;
  allContributions?: Maybe<ContributionConnection>;
  allCountries?: Maybe<CountryConnection>;
  allCourseCategories?: Maybe<CategoryConnection>;
  allCourses?: Maybe<CourseFilterTypeConnection>;
  allDeferredPayments?: Maybe<DeferredPaymentConnection>;
  allGroupZoomSchedules?: Maybe<GroupZoomScheduleConnection>;
  allGroups?: Maybe<GroupConnection>;
  allGroupsForLms?: Maybe<UnionGroupConnection>;
  allLessonRecordings?: Maybe<LessonRecordingConnection>;
  allNatives?: Maybe<NativeInfoConnection>;
  allStories?: Maybe<AllStoriesConnection>;
  allStudents?: Maybe<StudentConnection>;
  allStudentsAchievement?: Maybe<StudentsAchievementConnection>;
  allSuccessStories?: Maybe<SuccessStoriesConnection>;
  allTeachers?: Maybe<TeacherFilterTypeConnection>;
  allTeachersApplications?: Maybe<ApplicationFilterTypeConnection>;
  allUsersSettings?: Maybe<UsersSettingsConnection>;
  allZoomAccounts?: Maybe<ZoomAccountConnection>;
  allZoomLessons?: Maybe<ZoomLessonConnection>;
  allZoomProcessingLog?: Maybe<ZoomProcessingLogConnection>;
  allZoomRecordings?: Maybe<ZoomRecordingConnection>;
  article?: Maybe<ArticlesType>;
  articleBySlug?: Maybe<ArticlesType>;
  blogAllArticles?: Maybe<BlogAllArticlesType>;
  blogGraduateStory?: Maybe<BlogGraduateStoryType>;
  blogNative?: Maybe<BlogNativeType>;
  /** Live progress of a bulk broadcast the acting manager launched: running sent/failed counts + each recipient's outcome. Null if it isn't the manager's own job. */
  broadcastJob?: Maybe<BroadcastJobType>;
  /** The ERP funnel: members → trained → profile → applied → placed. */
  careerDashboard: CareerDashboardType;
  careerDirections: Array<CareerDirectionType>;
  /** One published career lesson. Locked lessons resolve without a body — same filter as the listing, so a guessed id leaks nothing. */
  careerLesson?: Maybe<CareerLessonType>;
  /** Published career lessons with per-viewer lock state. A locked lesson carries no content/video/attachments. */
  careerLessons: Array<CareerLessonType>;
  /** All career lessons including unpublished ones. Staff author this content, so no lock gate applies. Each row carries a `stats` completion funnel (spec 0020). */
  careerLessonsErp: Array<CareerLessonType>;
  careerMemberDetail?: Maybe<CareerMemberType>;
  /** One member's learning map — opened/completed per lesson (spec 0020). Carries no private note text. */
  careerMemberProgress: Array<CareerMemberLessonProgressType>;
  /** Career-centre participants for the ERP table. */
  careerMembers: Array<CareerMemberType>;
  /** Skill dictionary for the profile editor's autocomplete. */
  careerSkills: Array<SkillType>;
  /** Published vacancies for a career-centre member; empty for non-members. `savedOnly` narrows the feed to what this member saved. */
  careerVacancies: Array<VacancyType>;
  /** Vacancies for the ERP board (all statuses). */
  careerVacanciesErp: Array<VacancyType>;
  /** One published vacancy; same filter as the feed, so a guessed id can't reach a draft. */
  careerVacancy?: Maybe<VacancyType>;
  careerVacancyErp?: Maybe<VacancyType>;
  cashBalances?: Maybe<Array<Maybe<CashBalanceSnapshotType>>>;
  /** The Slack channel currently linked to a group (or null). */
  channelGroupLink?: Maybe<ChannelGroupLinkType>;
  company?: Maybe<CompanyType>;
  contactsPage?: Maybe<ContactsPageType>;
  /** @deprecated Unbounded (loads the whole thread). Use conversationThread — the keyset-paginated replacement (spec 0008). */
  conversationMessages: Array<MessageType>;
  /** Newest-first keyset page of ONE conversation's messages (spec 0008) — the paginated replacement for the deprecated conversationMessages: the panel opens on the newest 30 and pages back to older ones via `after`. */
  conversationThread: MessageConnection;
  /** Dashboard communications browser: keyset-paginated conversations (newest activity first) filterable by group, student, date range (last activity day, both ends inclusive) and text (dialog title + student name; message bodies are deliberately NOT searched — unindexed). unhandledOnly=true (default) keeps only dialogs with an inbound message not yet ticked «обработано» — the amber-dot queue. */
  conversationsBrowser: ConversationConnection;
  course?: Maybe<CourseType>;
  courseBySlug?: Maybe<CourseType>;
  courseCatalogPage?: Maybe<CourseCatalogPageType>;
  coursesGraduateFeedback?: Maybe<GraduateFeedbackConnection>;
  dataProcessingPolicyPage?: Maybe<DataProcessingPolicyType>;
  /** Students with an issued invoice overdue by more than settings.DEBTOR_OVERDUE_DAYS, excluding terminated / transferred-out / fully-corrected agreements. Optionally scoped to one group. */
  debtorCandidates: Array<DebtorCandidateType>;
  demoGroupsCount?: Maybe<DemoType>;
  /** Short-lived presigned GET for one diploma. ERP staff only; the student's own path is `myDiplomaDownloadUrl`. */
  diplomaDownloadUrl?: Maybe<DiplomaDownloadUrlType>;
  exchangeRates?: Maybe<Array<Maybe<ExchangeRateType>>>;
  expense?: Maybe<ExpenseType>;
  expenseAggregates?: Maybe<Array<Maybe<ExpenseAggregateRow>>>;
  expenseCategories?: Maybe<Array<Maybe<ExpenseCategoryType>>>;
  expenses?: Maybe<Array<Maybe<ExpenseType>>>;
  /** Progress of a group billing run. Scoped by role, NOT by creator (unlike broadcastJob): the rows carry invoice data every FAKTUROWNIA_ACCESS_ROLES holder can already read via fakturowniaInvoices, and finance genuinely needs to see a colleague's run. */
  fakturowniaBillingJob?: Maybe<FakturowniaBillingJobType>;
  /** Preflight for «Выставить фактуру» — same check the mutation runs, so the UI can grey out the button and say why, and preview exactly what will be sent. */
  fakturowniaContributionBillability: FakturowniaBillabilityType;
  /** Per-agreement preflight for the whole group — the bulk-issue picker. Non-billable rows are RETURNED, not filtered out: «пропущено» has to be visible or the operator believes the whole group was billed. */
  fakturowniaGroupBillingPreview: FakturowniaGroupBillingPreviewType;
  fakturowniaInvoice?: Maybe<FakturowniaInvoiceType>;
  /** Aggregated sums for KPI / charts. PLN by contract — no FX conversion. Quotation-kinds are excluded by default so estimate+advance+final chains aren't double-counted. */
  fakturowniaInvoiceAggregates?: Maybe<Array<Maybe<FakturowniaInvoiceAggregateRow>>>;
  fakturowniaInvoices?: Maybe<Array<Maybe<FakturowniaInvoiceType>>>;
  fakturowniaSyncRuns?: Maybe<Array<Maybe<FakturowniaSyncRunType>>>;
  /** One-shot 'is the mirror fresh?' snapshot for dashboard widgets. Combines the most recent run with the most recent successful run so the UI can show both 'last synced HH:MM' and 'sync failed'. */
  fakturowniaSyncStatus?: Maybe<FakturowniaSyncStatus>;
  fakturowniaUnmatchedCount?: Maybe<Scalars['Int']>;
  financeBudget?: Maybe<Array<Maybe<MonthBudget>>>;
  financeMonthBudget?: Maybe<WeeksBudgetInfo>;
  financePlan?: Maybe<Array<Maybe<MonthBudget>>>;
  financeYears?: Maybe<Array<Maybe<Scalars['Int']>>>;
  /** Shared mailboxes available to send FROM when composing a new email (enabled only). */
  gmailMailboxes: Array<GmailMailboxType>;
  group?: Maybe<GroupType>;
  /** Group dashboard — passed/expected lessons rollup plus per-student attendance rate, with a settings-driven threshold flag for the «attention» badge. Replaces the per-lesson fan-out the frontend used to do. See docs/groups/group_dashboard.md §G3. */
  groupAttendanceSummary?: Maybe<GroupAttendanceSummary>;
  /** The communicator middle-column badge aggregate for one group: per-student unread/unhandled splits + the whole-group Slack/mail totals, computed server-side in two set-based queries (spec 0008). Replaces the frontend's multi-page conversationsBrowser drain. */
  groupCommsIndex: GroupCommsIndex;
  groupConversations: Array<ConversationType>;
  /** Diploma roster of the group — one row per student with an ACTIVE agreement, carrying their PL/EN diplomas. Students on a terminated agreement are excluded. */
  groupDiplomas: Array<GroupDiplomaRowType>;
  groupForLms?: Maybe<UnionGroupType>;
  groupHomeworkOverviewForErp: Array<LessonHomeworkStatsType>;
  groupLessonAttachment?: Maybe<LessonAttachmentsType>;
  groupLessonAttachmentForLms?: Maybe<Array<Maybe<LessonAttachmentsForLmsType>>>;
  groupLessonAttendanceForLms?: Maybe<Array<Maybe<LessonAttendancesType>>>;
  /** Recipient picker rows for a group: one per student, with their latest unpaid invoice when there is one. */
  groupMailCandidates: Array<GroupMailCandidateType>;
  /** Newest-first keyset feed of all of a group's Slack messages (every channel + its students' DMs), with search / unread / flagged / unhandled / per-channel filters. */
  groupMessages: MessageConnection;
  groupNotes: Array<StudentNoteType>;
  /** Per-group marks rollup: weighted average + top/bottom 3 by avg mark. Terminated agreements are excluded. See docs/groups/group_dashboard.md §G4. */
  groupPerformanceSummary?: Maybe<GroupPerformanceSummary>;
  /** Per-currency revenue rollup over the group's active agreements (budget / paid / debt / agreementsActive / studentsWithDebt). Mirrors KpiStrip.tsx so the frontend can drop the heavy `agreements[].payments[]` payload for big groups. See §G5. */
  groupRevenueAggregates?: Maybe<GroupRevenueAggregates>;
  /** Every Slack channel configured for a group (ChannelGroupLink, discovered via conversations.list), merged with its Conversation mirror — so channels with no ingested messages yet still appear in the inbox. */
  groupSlackChannels: Array<GroupChannelRow>;
  groupSurveyAssignments: Array<SurveyAssignmentType>;
  groupTasks: Array<StaffTaskType>;
  groupWhiteboards: Array<WhiteboardMetaType>;
  /** Account-manager command-center rollup: one row per enrolled group with students count, contribution-based debt (NOT Fakturownia), debtors count, unanswered Slack/email and open/overdue task counts. */
  groupsOverview: Array<GroupOverviewRow>;
  /** Whether the AI review pipeline is switched on (HOMEWORK_AI_ENABLED). The teacher UI hides the AI card and the re-run control when this is false — without it the control is always rendered and always fails with AI_DISABLED. */
  homeworkAiEnabled: Scalars['Boolean'];
  /** One row per eligible student: submission + journal hw_mark. LMS scope: the lesson's teacher or a methodist (read-only). */
  homeworkRoster: Array<HomeworkRosterRowType>;
  /** Short-lived presigned GET for a submission's ZIP. Students get their own file only; teachers — their lessons'; methodists — read-only access. */
  homeworkSubmissionDownloadUrl?: Maybe<Scalars['String']>;
  homeworkSubmissionDownloadUrlForErp?: Maybe<Scalars['String']>;
  journal?: Maybe<GroupLessonConnection>;
  legalEntityPublicOfferPage?: Maybe<LegalEntityPublicOfferPageType>;
  lessonForLms?: Maybe<UnionLessonType>;
  /** The lesson's homework assignment (staff view). LMS scope: the lesson's teacher or a methodist. */
  lessonHomework?: Maybe<HomeworkAssignmentType>;
  lessonHomeworkSubmissionsForErp: Array<HomeworkRosterRowType>;
  /** ERP «Кто заходил»: клики «Присоединиться к занятию» по занятию (spec 0013). */
  lessonJoinClicks?: Maybe<Array<Maybe<LessonJoinClickType>>>;
  lessonWhiteboard?: Maybe<WhiteboardType>;
  lessonWhiteboardForErp?: Maybe<WhiteboardType>;
  lmsJournal?: Maybe<GroupLessonType>;
  /** Подсказки журнала преподавателя: первый клик каждого студента по занятию (spec 0013). */
  lmsLessonJoinClicks?: Maybe<Array<Maybe<LmsLessonJoinClickType>>>;
  /** One mailing run — poll this for live send progress and per-recipient delivery status. */
  mailJob?: Maybe<MailJobType>;
  /** Mailing history for a group, newest first. */
  mailJobs: Array<MailJobType>;
  mainPageInfo?: Maybe<MainPageInfoType>;
  mainTeachersWeb?: Maybe<MainTeacherWebType>;
  /** Group-scoped study materials list. STUDENT scope callers see only materials in groups where they have an active agreement. */
  materials: Array<Maybe<MaterialType>>;
  me?: Maybe<UserNode>;
  metaContributions?: Maybe<MetaContribution>;
  metaCourses?: Maybe<MetaCourses>;
  metaDeferredPayments?: Maybe<MetaDeferredPaymentConnection>;
  metaGroups?: Maybe<MetaGroups>;
  metaStudents?: Maybe<MetaStudents>;
  metaTeachers?: Maybe<MetaTeachers>;
  metaTeachersApplications?: Maybe<MetaTeacherApplications>;
  metaUsersSettings?: Maybe<MetaUsersSettings>;
  /** The signed-in student's OWN attendance for one group, lesson by lesson. The teacher has always recorded this (and even sees Zoom join-time chips), but none of it reached the student — they could not answer «сколько я пропустил». Self-scoped: there is no student argument, the row set is derived from the token. */
  myAttendance: Array<MyLessonAttendanceType>;
  /** The logged-in student's career-centre membership and training progress; null if not enrolled. LMS scope + Student role only. */
  myCareerCenter?: Maybe<CareerCenterType>;
  /** The logged-in student's own structured career profile (created on first read). Any Student, self only. */
  myCareerProfile?: Maybe<CareerProfileType>;
  /** Short-lived presigned GET for one of the student's OWN diplomas. Minted per click, never listed. */
  myDiplomaDownloadUrl?: Maybe<DiplomaDownloadUrlType>;
  /** The logged-in student's own diplomas, newest first. LMS scope + Student role only; takes no arguments. */
  myDiplomas: Array<MyDiplomaType>;
  /** The logged-in student's own issued Fakturownia invoices (paid + unpaid), in due-date order. LMS scope + Student role only. */
  myInvoices?: Maybe<Array<Maybe<StudentInvoiceType>>>;
  /** The lesson's homework assignment with the logged-in student's own submission and (once graded) mark + teacher comment. Null when the lesson has no assignment yet. LMS scope + Student role only. */
  myLessonHomework?: Maybe<HomeworkAssignmentForStudentType>;
  /** Whether the ACTING manager has saved his personal Slack user token (xoxp) for this group's workspace. The token itself is never returned. */
  mySlackUserToken: SlackUserTokenStatusType;
  /** The logged-in student's pending (unanswered, open) surveys, questions included. LMS scope + Student role only. */
  mySurveys: Array<PendingSurveyType>;
  /** Tasks assigned to the current user. */
  myTasks: Array<StaffTaskType>;
  native?: Maybe<NativeInfoType>;
  nativeBySlug?: Maybe<NativeInfoType>;
  pandadocAnalytics?: Maybe<PandaDocAnalyticsType>;
  pandadocDocuments?: Maybe<PandaDocDocumentConnection>;
  pandadocProvisioningFolders?: Maybe<Array<Maybe<ProvisioningFolder>>>;
  pandadocSyncStatus?: Maybe<PandaDocSyncStatusType>;
  paymentCalendar?: Maybe<PaymentCalendarType>;
  paymentCalendarSettings?: Maybe<PaymentCalendarSettingsType>;
  paymentRulesPage?: Maybe<PaymentRulesPageType>;
  paymentsVerification?: Maybe<Array<Maybe<PaymentsVerificationType>>>;
  plannedPayments?: Maybe<Array<Maybe<PlannedPaymentType>>>;
  privateIndividualPublicOfferPage?: Maybe<PrivateIndividualPublicOfferPageType>;
  /** Received Fakturownia cost documents eligible to back an Expense (excludes quotations; by default also excludes invoices already linked to an Expense). */
  receivedInvoicesForExpense?: Maybe<Array<Maybe<ReceivedInvoiceForExpenseType>>>;
  /** Most recently created LessonRecordings (newest first) for the ERP «recently matched» list. `mine` limits to matches made by the current user; `limit` caps the result set (default 20). */
  recentlyMatchedLessonRecordings?: Maybe<Array<Maybe<LessonRecordingType>>>;
  /** Who a reply to this conversation will be sent as, for the acting manager: him personally (his Slack token), the workspace bot, or the shared mailbox. */
  replyIdentity: ReplyIdentityType;
  robotTxt?: Maybe<RobotTxtType>;
  /** The SendGrid contact list mirroring this group's students, or null if it has not been created yet. */
  sendgridGroupList?: Maybe<SendgridGroupListType>;
  /** Dynamic templates available in SendGrid, for the mailing template picker. Read live from the API. */
  sendgridTemplates: Array<SendgridTemplateType>;
  /** The exact backend URL to register as each Slack app's OAuth «Redirect URL» (server setting SLACK_OAUTH_REDIRECT_URI). Empty → the one-click «Подключить мой Slack» flow isn't configured server-side. */
  slackOauthRedirectUri?: Maybe<Scalars['String']>;
  /** The Slack user currently linked to a student (or null). */
  slackUserLink?: Maybe<SlackUserLinkType>;
  /** The Slack workspace bound to a group (or null). */
  slackWorkspaceLink?: Maybe<SlackWorkspaceLinkType>;
  /** Human members of the group's Slack workspace (mirrored by sync). By default only those not yet matched to a student — the manual-matching worklist. */
  slackWorkspaceMembers: Array<SlackUserLinkType>;
  /** Flexible task feed for the command center: filter by group / student / agreement / teacher / assignee=me, by a due-date range (due_from..due_to) and a title/description search; ordered open-first then by due date. */
  staffTasks: Array<StaffTaskType>;
  /** Active ERP staff (management roles) — the only valid task assignees. */
  staffUsers: Array<StaffUserType>;
  student?: Maybe<StudentType>;
  /** The stored LMS-access block for a student (null if the student was never blocked). */
  studentAccessBlock?: Maybe<StudentAccessBlockType>;
  studentConversations: Array<ConversationType>;
  studentHomeworkForErp: Array<StudentHomeworkRowType>;
  studentMarks?: Maybe<StudentsMarkConnection>;
  /** Aggregated communicator hover-card (spec 0009). `finance` and per-group financing flags are null for viewers without payment roles; the whole result is null when the student does not exist. */
  studentMiniCard?: Maybe<StudentMiniCard>;
  studentNotes: Array<StudentNoteType>;
  studentTasks: Array<StaffTaskType>;
  studentsCompaniesInfo?: Maybe<StudentAndCompaniesType>;
  studentsForJournal?: Maybe<StudentConnection>;
  studentsMarks?: Maybe<StudentConnection>;
  studentsReviews?: Maybe<StudentsReviewsType>;
  successStoriesBlock?: Maybe<SuccessStoriesBlockType>;
  successStory?: Maybe<SuccessStoriesType>;
  successStoryBySlug?: Maybe<SuccessStoriesType>;
  survey?: Maybe<SurveyType>;
  surveyAssignmentResults?: Maybe<SurveyAssignmentResultsType>;
  surveyResponseDetail?: Maybe<SurveyResponseDetailType>;
  /** Survey templates. `courseId` narrows to that course's surveys PLUS universal ones (what the attach popup needs); archived rows are hidden unless `includeArchived`. */
  surveys: Array<SurveyType>;
  teacher?: Maybe<TeacherType>;
  teacherApplication?: Maybe<ApplicationType>;
  /** A teacher's email threads (Gmail) — the teacher analog of studentConversations. Kept separate from the student communicator (not in the dashboard queue). */
  teacherConversations: Array<ConversationType>;
  teachersPageInfo?: Maybe<TeachersPageInfoType>;
  /** Dialogs holding an INBOUND message no manager has ticked «обработано» yet — the amber-dot work queue. Read state and dialog status play no part. */
  unhandledConversations: Array<ConversationType>;
  user?: Maybe<UserNode>;
  users?: Maybe<UserNodeConnection>;
  verifyStudent?: Maybe<VerifiedStudent>;
  verifyTeacher?: Maybe<VerifiedTeacher>;
  whiteboardLibrary?: Maybe<WhiteboardLibraryType>;
  zoomAccountUsage?: Maybe<ZoomAccountUsageType>;
  zoomAuditLog?: Maybe<ZoomAuditLogConnection>;
  zoomDashboard?: Maybe<ZoomDashboardType>;
  zoomLesson?: Maybe<GroupLessonForLmsType>;
};


export type QueryAgreementArgs = {
  agreementId: Scalars['ID'];
};


export type QueryAgreementTasksArgs = {
  agreementId: Scalars['ID'];
  includeClosed?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAllArticlesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAllCompaniesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryAllContributionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  contributionNum?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryAllCountriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAllCourseCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAllCoursesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  category_Name?: InputMaybe<Scalars['String']>;
  educationForm?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderByPublishDateFilter?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
  readyToPublish?: InputMaybe<Scalars['Boolean']>;
  startDateFilter?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAllDeferredPaymentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryAllGroupZoomSchedulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  groupId?: InputMaybe<Scalars['ID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  weekDay?: InputMaybe<Scalars['Int']>;
};


export type QueryAllGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  hasZoomAccount?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  zoomAccountId?: InputMaybe<Scalars['ID']>;
};


export type QueryAllGroupsForLmsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  courseId?: InputMaybe<Scalars['ID']>;
  finished?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  last?: InputMaybe<Scalars['Int']>;
  lessonDate?: InputMaybe<Scalars['Date']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryAllLessonRecordingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  ambiguousOnly?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  courseId?: InputMaybe<Scalars['ID']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  groupId?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryAllNativesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  excludedNatives?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAllStoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  excludeArticles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludeStories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludedNatives?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  first?: InputMaybe<Scalars['Int']>;
  includeNatives?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAllStudentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryAllStudentsAchievementArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryAllSuccessStoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAllTeachersArgs = {
  after?: InputMaybe<Scalars['String']>;
  availability?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  course?: InputMaybe<Scalars['Decimal']>;
  first?: InputMaybe<Scalars['Int']>;
  hasDescription?: InputMaybe<Scalars['Boolean']>;
  hasInterview?: InputMaybe<Scalars['Boolean']>;
  hasPhoto?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  minRating?: InputMaybe<Scalars['Decimal']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  siteDisplay?: InputMaybe<Scalars['Boolean']>;
};


export type QueryAllTeachersApplicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  byGroupId?: InputMaybe<Scalars['Decimal']>;
  first?: InputMaybe<Scalars['Int']>;
  groupsFilter?: InputMaybe<Scalars['Boolean']>;
  isTerminated?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryAllUsersSettingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryAllZoomAccountsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAllZoomLessonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  courseId?: InputMaybe<Scalars['ID']>;
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  first?: InputMaybe<Scalars['Int']>;
  groupId?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryAllZoomProcessingLogArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  lessonId?: InputMaybe<Scalars['ID']>;
  lessonRecordingId?: InputMaybe<Scalars['ID']>;
  level?: InputMaybe<Scalars['String']>;
  step?: InputMaybe<Scalars['String']>;
};


export type QueryAllZoomRecordingsArgs = {
  accountId?: InputMaybe<Scalars['ID']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  groupId?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  orphanOnly?: InputMaybe<Scalars['Boolean']>;
  showDeleted?: InputMaybe<Scalars['Boolean']>;
  tooShort?: InputMaybe<Scalars['Boolean']>;
};


export type QueryArticleArgs = {
  articleId?: InputMaybe<Scalars['ID']>;
};


export type QueryArticleBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryBroadcastJobArgs = {
  id: Scalars['ID'];
};


export type QueryCareerDirectionsArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCareerLessonArgs = {
  id: Scalars['ID'];
};


export type QueryCareerMemberDetailArgs = {
  id: Scalars['ID'];
};


export type QueryCareerMemberProgressArgs = {
  memberId: Scalars['ID'];
};


export type QueryCareerMembersArgs = {
  directionId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryCareerSkillsArgs = {
  category?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryCareerVacanciesArgs = {
  directionId?: InputMaybe<Scalars['ID']>;
  savedOnly?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  seniority?: InputMaybe<Scalars['String']>;
  skillId?: InputMaybe<Scalars['ID']>;
  workMode?: InputMaybe<Scalars['String']>;
};


export type QueryCareerVacanciesErpArgs = {
  directionId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type QueryCareerVacancyArgs = {
  id: Scalars['ID'];
};


export type QueryCareerVacancyErpArgs = {
  id: Scalars['ID'];
};


export type QueryCashBalancesArgs = {
  legalEntityId?: InputMaybe<Scalars['ID']>;
};


export type QueryChannelGroupLinkArgs = {
  groupId: Scalars['ID'];
};


export type QueryCompanyArgs = {
  id: Scalars['ID'];
};


export type QueryConversationMessagesArgs = {
  conversationId: Scalars['ID'];
};


export type QueryConversationThreadArgs = {
  after?: InputMaybe<Scalars['String']>;
  conversationId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryConversationsBrowserArgs = {
  after?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  groupId?: InputMaybe<Scalars['ID']>;
  kinds?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  studentId?: InputMaybe<Scalars['ID']>;
  unhandledOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCourseArgs = {
  courseId?: InputMaybe<Scalars['ID']>;
};


export type QueryCourseBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryCoursesGraduateFeedbackArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryDebtorCandidatesArgs = {
  groupId?: InputMaybe<Scalars['ID']>;
};


export type QueryDiplomaDownloadUrlArgs = {
  diplomaId: Scalars['ID'];
};


export type QueryExchangeRatesArgs = {
  currency?: InputMaybe<Scalars['String']>;
};


export type QueryExpenseArgs = {
  id: Scalars['ID'];
};


export type QueryExpenseAggregatesArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  groupBy?: InputMaybe<Scalars['String']>;
  teacherId?: InputMaybe<Scalars['ID']>;
};


export type QueryExpensesArgs = {
  categorySlug?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  groupId?: InputMaybe<Scalars['ID']>;
  legalEntityId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  recurrence?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  studentId?: InputMaybe<Scalars['ID']>;
  teacherId?: InputMaybe<Scalars['ID']>;
};


export type QueryFakturowniaBillingJobArgs = {
  id: Scalars['ID'];
};


export type QueryFakturowniaContributionBillabilityArgs = {
  agreementId: Scalars['ID'];
  contributionId?: InputMaybe<Scalars['ID']>;
};


export type QueryFakturowniaGroupBillingPreviewArgs = {
  groupId: Scalars['ID'];
};


export type QueryFakturowniaInvoiceArgs = {
  id: Scalars['ID'];
};


export type QueryFakturowniaInvoiceAggregatesArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  direction?: InputMaybe<Scalars['String']>;
  groupBy: Scalars['String'];
  groupId?: InputMaybe<Scalars['ID']>;
  includeQuotations?: InputMaybe<Scalars['Boolean']>;
  studentId?: InputMaybe<Scalars['ID']>;
};


export type QueryFakturowniaInvoicesArgs = {
  agreementId?: InputMaybe<Scalars['ID']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  direction?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['ID']>;
  kind?: InputMaybe<Scalars['String']>;
  matchStatus?: InputMaybe<Scalars['String']>;
  needsLinkOnly?: InputMaybe<Scalars['Boolean']>;
  overdueOnly?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  parentId?: InputMaybe<Scalars['ID']>;
  paymentId?: InputMaybe<Scalars['ID']>;
  perPage?: InputMaybe<Scalars['Int']>;
  provisionBlockedOnly?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  studentId?: InputMaybe<Scalars['ID']>;
  unpaidOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFakturowniaSyncRunsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryFinanceBudgetArgs = {
  year: Scalars['Int'];
};


export type QueryFinanceMonthBudgetArgs = {
  month: Scalars['Int'];
  year: Scalars['Int'];
};


export type QueryFinancePlanArgs = {
  year: Scalars['Int'];
};


export type QueryGroupArgs = {
  groupId?: InputMaybe<Scalars['ID']>;
};


export type QueryGroupAttendanceSummaryArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupCommsIndexArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupConversationsArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupDiplomasArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupForLmsArgs = {
  groupId?: InputMaybe<Scalars['ID']>;
};


export type QueryGroupHomeworkOverviewForErpArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupLessonAttachmentArgs = {
  attachmentId?: InputMaybe<Scalars['ID']>;
  attachmentRole?: InputMaybe<Scalars['String']>;
};


export type QueryGroupLessonAttachmentForLmsArgs = {
  attachmentRole?: InputMaybe<Scalars['String']>;
  groupLessonId?: InputMaybe<Scalars['ID']>;
};


export type QueryGroupLessonAttendanceForLmsArgs = {
  groupLessonId?: InputMaybe<Scalars['ID']>;
};


export type QueryGroupMailCandidatesArgs = {
  groupId: Scalars['ID'];
  mode?: InputMaybe<Scalars['String']>;
};


export type QueryGroupMessagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  channelId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  flaggedOnly?: InputMaybe<Scalars['Boolean']>;
  groupId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  unhandledOnly?: InputMaybe<Scalars['Boolean']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGroupNotesArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupPerformanceSummaryArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupRevenueAggregatesArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupSlackChannelsArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupSurveyAssignmentsArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupTasksArgs = {
  groupId: Scalars['ID'];
  includeClosed?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGroupWhiteboardsArgs = {
  groupId: Scalars['ID'];
};


export type QueryGroupsOverviewArgs = {
  onlyIssues?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryHomeworkRosterArgs = {
  lessonId: Scalars['ID'];
};


export type QueryHomeworkSubmissionDownloadUrlArgs = {
  submissionId: Scalars['ID'];
};


export type QueryHomeworkSubmissionDownloadUrlForErpArgs = {
  submissionId: Scalars['ID'];
};


export type QueryJournalArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  groupId: Scalars['ID'];
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryLessonForLmsArgs = {
  groupLessonId?: InputMaybe<Scalars['ID']>;
};


export type QueryLessonHomeworkArgs = {
  lessonId: Scalars['ID'];
};


export type QueryLessonHomeworkSubmissionsForErpArgs = {
  lessonId: Scalars['ID'];
};


export type QueryLessonJoinClicksArgs = {
  lessonId: Scalars['Int'];
};


export type QueryLessonWhiteboardArgs = {
  lessonId: Scalars['ID'];
};


export type QueryLessonWhiteboardForErpArgs = {
  lessonId: Scalars['ID'];
};


export type QueryLmsJournalArgs = {
  groupLessonId: Scalars['ID'];
};


export type QueryLmsLessonJoinClicksArgs = {
  groupLessonId: Scalars['Int'];
};


export type QueryMailJobArgs = {
  id: Scalars['ID'];
};


export type QueryMailJobsArgs = {
  groupId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryMaterialsArgs = {
  groupId: Scalars['ID'];
  kind?: InputMaybe<MaterialKindEnum>;
  lessonId?: InputMaybe<Scalars['ID']>;
};


export type QueryMetaContributionsArgs = {
  contributionNum?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryMetaCoursesArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryMetaDeferredPaymentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryMetaGroupsArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryMetaStudentsArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryMetaTeachersArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryMetaTeachersApplicationsArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryMetaUsersSettingsArgs = {
  query?: InputMaybe<Scalars['String']>;
};


export type QueryMyAttendanceArgs = {
  groupId: Scalars['ID'];
};


export type QueryMyDiplomaDownloadUrlArgs = {
  diplomaId: Scalars['ID'];
};


export type QueryMyLessonHomeworkArgs = {
  lessonId: Scalars['ID'];
};


export type QueryMySlackUserTokenArgs = {
  groupId: Scalars['ID'];
};


export type QueryMyTasksArgs = {
  includeClosed?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNativeArgs = {
  nativeId?: InputMaybe<Scalars['ID']>;
};


export type QueryNativeBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryPandadocAnalyticsArgs = {
  course?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  docType?: InputMaybe<Scalars['String']>;
  granularity?: InputMaybe<Scalars['String']>;
};


export type QueryPandadocDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  agreementId?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['String']>;
  course?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  docType?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  groupId?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  outcome?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  studentId?: InputMaybe<Scalars['ID']>;
  studentMatches?: InputMaybe<Scalars['Boolean']>;
  teacherId?: InputMaybe<Scalars['ID']>;
  teacherMatches?: InputMaybe<Scalars['Boolean']>;
  unlinked?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPandadocProvisioningFoldersArgs = {
  course?: InputMaybe<Scalars['String']>;
};


export type QueryPaymentCalendarArgs = {
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  legalEntityId?: InputMaybe<Scalars['ID']>;
};


export type QueryPaymentCalendarSettingsArgs = {
  legalEntityId?: InputMaybe<Scalars['ID']>;
};


export type QueryPaymentsVerificationArgs = {
  query: Array<InputMaybe<Scalars['String']>>;
};


export type QueryPlannedPaymentsArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  direction?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['ID']>;
};


export type QueryReceivedInvoicesForExpenseArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  unlinkedOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryRecentlyMatchedLessonRecordingsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  mine?: InputMaybe<Scalars['Boolean']>;
};


export type QueryReplyIdentityArgs = {
  conversationId: Scalars['ID'];
};


export type QuerySendgridGroupListArgs = {
  groupId: Scalars['ID'];
};


export type QuerySlackUserLinkArgs = {
  studentId: Scalars['ID'];
};


export type QuerySlackWorkspaceLinkArgs = {
  groupId: Scalars['ID'];
};


export type QuerySlackWorkspaceMembersArgs = {
  groupId: Scalars['ID'];
  unmatchedOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryStaffTasksArgs = {
  agreementId?: InputMaybe<Scalars['ID']>;
  assigneeMe?: InputMaybe<Scalars['Boolean']>;
  closedWithinDays?: InputMaybe<Scalars['Int']>;
  dueFrom?: InputMaybe<Scalars['Date']>;
  dueTo?: InputMaybe<Scalars['Date']>;
  groupId?: InputMaybe<Scalars['ID']>;
  includeClosed?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  studentId?: InputMaybe<Scalars['ID']>;
  teacherId?: InputMaybe<Scalars['ID']>;
};


export type QueryStudentArgs = {
  id: Scalars['ID'];
};


export type QueryStudentAccessBlockArgs = {
  studentId: Scalars['ID'];
};


export type QueryStudentConversationsArgs = {
  studentId: Scalars['ID'];
};


export type QueryStudentHomeworkForErpArgs = {
  studentId: Scalars['ID'];
};


export type QueryStudentMarksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  lessonsId: Scalars['ID'];
};


export type QueryStudentMiniCardArgs = {
  studentId: Scalars['ID'];
};


export type QueryStudentNotesArgs = {
  studentId: Scalars['ID'];
};


export type QueryStudentTasksArgs = {
  includeClosed?: InputMaybe<Scalars['Boolean']>;
  studentId: Scalars['ID'];
};


export type QueryStudentsForJournalArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  groupId: Scalars['Int'];
  last?: InputMaybe<Scalars['Int']>;
  lessonsId: Array<InputMaybe<Scalars['Int']>>;
};


export type QueryStudentsMarksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  lessonsId: Scalars['ID'];
};


export type QuerySuccessStoryArgs = {
  storyId?: InputMaybe<Scalars['ID']>;
};


export type QuerySuccessStoryBySlugArgs = {
  slug: Scalars['String'];
};


export type QuerySurveyArgs = {
  id: Scalars['ID'];
};


export type QuerySurveyAssignmentResultsArgs = {
  assignmentId: Scalars['ID'];
};


export type QuerySurveyResponseDetailArgs = {
  responseId: Scalars['ID'];
};


export type QuerySurveysArgs = {
  courseId?: InputMaybe<Scalars['ID']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryTeacherArgs = {
  teacherId?: InputMaybe<Scalars['ID']>;
};


export type QueryTeacherApplicationArgs = {
  applicationId: Scalars['ID'];
};


export type QueryTeacherConversationsArgs = {
  teacherId: Scalars['ID'];
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  email_Icontains?: InputMaybe<Scalars['String']>;
  email_Istartswith?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  firstName?: InputMaybe<Scalars['String']>;
  firstName_Icontains?: InputMaybe<Scalars['String']>;
  firstName_Istartswith?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastName_Icontains?: InputMaybe<Scalars['String']>;
  lastName_Istartswith?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  phone?: InputMaybe<Scalars['String']>;
  phone_Icontains?: InputMaybe<Scalars['String']>;
  phone_Istartswith?: InputMaybe<Scalars['String']>;
};


export type QueryVerifyStudentArgs = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
};


export type QueryVerifyTeacherArgs = {
  teacherInput: BaseTeacherInput;
};


export type QueryZoomAuditLogArgs = {
  action?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  targetKind?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryZoomDashboardArgs = {
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
};


export type QueryZoomLessonArgs = {
  groupLessonId: Scalars['ID'];
};

/**
 * A received Fakturownia invoice as a candidate for linking to an
 * Expense (the picker in the expense form). A trimmed projection of
 * `FakturowniaInvoice` — only the fields the picker needs to display and to
 * prefill the expense on selection.
 */
export type ReceivedInvoiceForExpenseType = {
  __typename?: 'ReceivedInvoiceForExpenseType';
  accountingKind?: Maybe<Scalars['String']>;
  buyerName?: Maybe<Scalars['String']>;
  buyerTaxNo?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  issueDate?: Maybe<Scalars['Date']>;
  kind?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  paymentTo?: Maybe<Scalars['Date']>;
  pk?: Maybe<Scalars['Int']>;
  priceGross?: Maybe<Scalars['Float']>;
  /** Invoice status (issued/sent/paid/partial/rejected) — lets the form auto-set the expense to 'paid' when a paid invoice is linked. */
  status?: Maybe<Scalars['String']>;
};

export type RecordPlacement = {
  __typename?: 'RecordPlacement';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  placement?: Maybe<PlacementRecordType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** One-call refresh: accounts + all recordings + account usage. */
export type RefreshAllZoomDataMutation = {
  __typename?: 'RefreshAllZoomDataMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * SDL: {success, errors, customErrors}.
 *
 * ТЗ 0021, стадия 4 — вместо `graphql_auth.mutations.Register`. Полей
 * token/refreshToken тут нет и быть не должно: пакет доливал их только при
 * `ALLOW_LOGIN_NOT_VERIFIED=True`, а в проекте настройка False.
 */
export type RegisterMutation = {
  __typename?: 'RegisterMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type RemindDebtorsMutation = {
  __typename?: 'RemindDebtorsMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type RemoveCareerLessonAttachment = {
  __typename?: 'RemoveCareerLessonAttachment';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  ok?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type RenameWhiteboardMutation = {
  __typename?: 'RenameWhiteboardMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  whiteboard?: Maybe<WhiteboardType>;
};

/**
 * Re-extract signer contact data (email/phone/name) on already-synced
 * documents and re-pull the details of rows a local re-parse can't fix.
 *
 * The repair button for «у студента нет договоров» / «новая папка не
 * появилась»: it applies the current parser to the whole cached inventory
 * instead of waiting for each document to change in PandaDoc.
 *
 * Admin-only (unlike the plain sync): a run can queue the entire inventory
 * for a `/details` re-fetch, which costs hours of the PandaDoc rate-limit
 * budget.
 */
export type ReparsePandadocRecipientsMutation = {
  __typename?: 'ReparsePandadocRecipientsMutation';
  enqueued?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  syncStatus?: Maybe<PandaDocSyncStatusType>;
};

/**
 * Who a reply to this conversation will be sent as, for the ACTING
 * manager — mirrors services/reply._token_for WITHOUT network healing
 * (read path).
 */
export type ReplyIdentityType = {
  __typename?: 'ReplyIdentityType';
  /** Human name; '' → the frontend renders its localized fallback (e.g. «Slack-бот»). */
  name: Scalars['String'];
  /** 'manager' | 'bot' | 'mailbox' */
  via: Scalars['String'];
};

export type ReprocessAiMutation = {
  __typename?: 'ReprocessAiMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lessonRecording?: Maybe<LessonRecordingType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type RequirementsType = {
  __typename?: 'RequirementsType';
  courseRequirements: CourseRequirementsIntoType;
  description: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

/**
 * Teacher re-queues the AI analysis of a submission («Перепроверить»).
 * Answers AI_DISABLED while the HOMEWORK_AI_ENABLED flag is off.
 */
export type RerunHomeworkAiReviewMutation = {
  __typename?: 'RerunHomeworkAiReviewMutation';
  aiReviewStatus?: Maybe<Scalars['String']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * TZ-2 — ответственный менеджер студента.
 *
 * Per-student связь сейчас не существует ни в БД, ни в CRM-интеграции
 * (`CRMUser` — singleton, общий на всю систему). Резолвер на `StudentType`
 * возвращает `None` до отдельного продуктового решения. Тип нужен,
 * чтобы фронт мог писать запрос без падения на компиляции схемы.
 * См. docs/student_card/update_card.md TZ-2.
 */
export type ResponsibleManagerType = {
  __typename?: 'ResponsibleManagerType';
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type RetryLessonRecordingMutation = {
  __typename?: 'RetryLessonRecordingMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lessonRecording?: Maybe<LessonRecordingType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Undo a manual «оплачен вручную» mark: deletes ONLY the
 * `source='manual_paid'` payment behind it. Auto-provisioned and legacy
 * operator payments are never deleted here.
 */
export type RevertManualContributionPaymentMutation = {
  __typename?: 'RevertManualContributionPaymentMutation';
  contribution?: Maybe<ContributionType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** SDL: {revoked: Int, success, errors}. */
export type RevokeToken = {
  __typename?: 'RevokeToken';
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  revoked?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type RobotTxtType = {
  __typename?: 'RobotTxtType';
  id: Scalars['ID'];
  robotContent: Scalars['String'];
};

/** Roster status filter — see docs/groups/groups_upgrade.md §B2. */
export enum RosterStatusEnum {
  Active = 'ACTIVE',
  All = 'ALL',
  Terminated = 'TERMINATED'
}

export type RunAutoMatchingMutation = {
  __typename?: 'RunAutoMatchingMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SalaryInfoType = {
  __typename?: 'SalaryInfoType';
  companyCount: Scalars['String'];
  course?: Maybe<CourseFilterType>;
  dataSource: Scalars['String'];
  id: Scalars['ID'];
  marketDemand: Scalars['String'];
  marketInfo: Scalars['String'];
  maxSeniorValue: Scalars['Int'];
  minJuniorValue: Scalars['Int'];
  minMiddleValue: Scalars['Int'];
  minSeniorValue: Scalars['Int'];
  title: Scalars['String'];
};

/** LMS: the student's PRIVATE note on a lesson (never shown to staff). */
export type SaveCareerLessonNotes = {
  __typename?: 'SaveCareerLessonNotes';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  notes?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SaveCareerProfile = {
  __typename?: 'SaveCareerProfile';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  profile?: Maybe<CareerProfileType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Upsert the per-language prose overlay (title + about) for the CV. */
export type SaveCvText = {
  __typename?: 'SaveCvText';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  profile?: Maybe<CareerProfileType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Full-list save of the school-wide component library (spec 0010 rev.2). */
export type SaveWhiteboardLibraryMutation = {
  __typename?: 'SaveWhiteboardLibraryMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  library?: Maybe<WhiteboardLibraryType>;
  success?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['Int']>;
};

export type SaveWhiteboardSceneMutation = {
  __typename?: 'SaveWhiteboardSceneMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  sceneVersion?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
  whiteboard?: Maybe<WhiteboardType>;
};

export type SelfEmployedInput = {
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  inn: Scalars['String'];
  nationality: Scalars['ID'];
  passportNumber: Scalars['String'];
  registrationAddress: Scalars['String'];
};

export type SelfEmployedType = Node & {
  __typename?: 'SelfEmployedType';
  accountNumber: Scalars['String'];
  bankTitle: Scalars['String'];
  bic: Scalars['String'];
  id: Scalars['ID'];
  inn: Scalars['String'];
  nationality: CountryType;
  passportNumber: Scalars['String'];
  registrationAddress: Scalars['String'];
};

export type SendAuthenticationCode = {
  __typename?: 'SendAuthenticationCode';
  createdAt?: Maybe<Scalars['DateTime']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Reply into a Gmail thread; mirrors the sent message locally. */
export type SendGmailReplyMutation = {
  __typename?: 'SendGmailReplyMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<MessageType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Send a dynamic-template email to selected students of a group.
 *
 * Each recipient gets their OWN message with their own name, amount and pay
 * link — never a shared blast. Returns the job id to poll (`mailJob`) for live
 * progress and per-recipient delivery status.
 */
export type SendGroupTemplateEmail = {
  __typename?: 'SendGroupTemplateEmail';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  mailJobId?: Maybe<Scalars['ID']>;
  success?: Maybe<Scalars['Boolean']>;
  total?: Maybe<Scalars['Int']>;
};

export type SendMorningReportMutation = {
  __typename?: 'SendMorningReportMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Compose and send a BRAND-NEW email from a chosen shared mailbox (not a
 * reply). Mirrors it locally as a new gmail-thread conversation.
 */
export type SendNewEmailMutation = {
  __typename?: 'SendNewEmailMutation';
  conversationId?: Maybe<Scalars['ID']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<MessageType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Post a message into one of a group's Slack channels — including the
 * FIRST one, before any Conversation mirror exists. Lets a manager start a
 * channel thread instead of only replying into an existing dialog.
 */
export type SendSlackChannelMessage = {
  __typename?: 'SendSlackChannelMessage';
  conversationId?: Maybe<Scalars['ID']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<MessageType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Reply into a Slack conversation; mirrors the sent message locally. */
export type SendSlackMessageMutation = {
  __typename?: 'SendSlackMessageMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<MessageType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** The SendGrid Marketing list mirroring a group's students. */
export type SendgridGroupListType = {
  __typename?: 'SendgridGroupListType';
  /** Contacts confirmed by the last finished import — not necessarily the current roster size. */
  contactCount: Scalars['Int'];
  errorMessage: Scalars['String'];
  id: Scalars['ID'];
  lastSyncStatus?: Maybe<Scalars['String']>;
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  sendgridListId: Scalars['String'];
};

/** A dynamic template read live from the SendGrid API (not stored here). */
export type SendgridTemplateType = {
  __typename?: 'SendgridTemplateType';
  id: Scalars['String'];
  name: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  versionId?: Maybe<Scalars['String']>;
};

/**
 * Manually flag/unflag a contract as «бесплатный договор».
 *
 * Excludes the contract from ALL debt/overdue detection (student-card totals,
 * LMS-block candidates, debtors list, payment calendar) while leaving it
 * active — so the student keeps LMS access to the group. Like `transfer_out`
 * it also relaxes the FULL-zeroing correction guard, so the paid invoice can
 * be corrected to zero without pretending the contract was transferred.
 * Restricted to Admin/FinanceManager and audited — it silences a real debt, so
 * a rank-and-file operator must not be able to set it.
 */
export type SetAgreementFreeOfChargeMutation = {
  __typename?: 'SetAgreementFreeOfChargeMutation';
  agreement?: Maybe<AgreementType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Manually flag/unflag a contract as «финансирование государством».
 *
 * The student is pre-financed by the state: intermediate documents
 * (proforma/advance/VAT) are not a debt — only an unpaid overdue FINAL
 * invoice is — and the plan/contributions owe nothing until then. Debt gates
 * honor this across totals, LMS block, debtors list and calendar. Restricted
 * to Admin/FinanceManager and audited.
 */
export type SetAgreementStatePrefinancedMutation = {
  __typename?: 'SetAgreementStatePrefinancedMutation';
  agreement?: Maybe<AgreementType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Manually flag/unflag an agreement as «переведён из этой группы».
 *
 * The flag relaxes the FULL-zeroing limit on corrections (partials work
 * without it) and the carry-out money guards (still capped at `paid_amount`).
 * Restricted to Admin/FinanceManager and audited — it must not be settable by
 * a rank-and-file operator, and never via a self-declared termination reason.
 */
export type SetAgreementTransferOutMutation = {
  __typename?: 'SetAgreementTransferOutMutation';
  agreement?: Maybe<AgreementType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** LMS: toggle a lesson bookmark for the calling student. */
export type SetCareerLessonBookmark = {
  __typename?: 'SetCareerLessonBookmark';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  isBookmarked?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** ERP: replace a lesson's self-check quiz (delete-and-recreate). */
export type SetCareerLessonQuiz = {
  __typename?: 'SetCareerLessonQuiz';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lesson?: Maybe<CareerLessonType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SetCompanyInput = {
  companyComment?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
};

/** Set a conversation's handling status (open / in_progress / done). */
export type SetConversationStatusMutation = {
  __typename?: 'SetConversationStatusMutation';
  conversation?: Maybe<ConversationType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SetGroupLessonLink = {
  __typename?: 'SetGroupLessonLink';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  group?: Maybe<GroupType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SetGroupLessonLinkOverride = {
  __typename?: 'SetGroupLessonLinkOverride';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  group?: Maybe<GroupType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SetGroupZoomAccountMutation = {
  __typename?: 'SetGroupZoomAccountMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Set a group's Zoom account and fully replace its processing slots. */
export type SetGroupZoomScheduleMutation = {
  __typename?: 'SetGroupZoomScheduleMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  schedules?: Maybe<Array<Maybe<GroupZoomScheduleType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Mark one message handled/unhandled — обработано (team-wide global). */
export type SetMessageHandledMutation = {
  __typename?: 'SetMessageHandledMutation';
  conversation?: Maybe<ConversationType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<MessageType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Save the ACTING manager's personal Slack user token (xoxp) for a
 * group's workspace — DM replies to students then go out as the manager
 * himself, and his person-to-person DMs become pullable by sync. The token
 * is validated via auth.test and must belong to the group's workspace.
 * Write-only: no query ever returns it.
 */
export type SetMySlackUserTokenMutation = {
  __typename?: 'SetMySlackUserTokenMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** The student's own opt-in to partner search (Ф3) + contact visibility. */
export type SetProfileSearchable = {
  __typename?: 'SetProfileSearchable';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  profile?: Maybe<CareerProfileType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Bind (or update) the Slack workspace for a group. Only the bot token is
 * really needed (no OAuth flow): a blank team id is resolved via auth.test.
 * `team_id` stays as an advanced override; `signing_secret` matters only for
 * the optional realtime webhook.
 */
export type SetSlackWorkspaceMutation = {
  __typename?: 'SetSlackWorkspaceMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SetStudentsMarksMutation = {
  __typename?: 'SetStudentsMarksMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  studentsMarks?: Maybe<StudentsMarkConnection>;
  success?: Maybe<Scalars['Boolean']>;
};


export type SetStudentsMarksMutationStudentsMarksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/**
 * Update the control-panel profile fields — rating, internal note,
 * interview-recording link, and the courses-can-teach list. Only the fields
 * actually passed are changed; `rating=0` clears the rating.
 */
export type SetTeacherProfile = {
  __typename?: 'SetTeacherProfile';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  teacher?: Maybe<TeacherType>;
};

export type SetVacancyStatus = {
  __typename?: 'SetVacancyStatus';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  vacancy?: Maybe<VacancyType>;
};

/** A dictionary skill — used by the profile editor's autocomplete. */
export type SkillType = {
  __typename?: 'SkillType';
  category: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
};

export type SlackUserLinkType = {
  __typename?: 'SlackUserLinkType';
  displayName: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['ID'];
  slackUserId: Scalars['String'];
  student?: Maybe<StudentType>;
  teamId: Scalars['String'];
};

/**
 * Whether the ACTING manager has an xoxp token for a workspace. The token
 * itself is write-only (never leaves the server).
 */
export type SlackUserTokenStatusType = {
  __typename?: 'SlackUserTokenStatusType';
  hasToken: Scalars['Boolean'];
  slackUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SlackWorkspaceLinkType = {
  __typename?: 'SlackWorkspaceLinkType';
  channelCount?: Maybe<Scalars['Int']>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  oauthConfigured?: Maybe<Scalars['Boolean']>;
  teamId: Scalars['String'];
  workspaceName: Scalars['String'];
};

export type StaffTaskType = {
  __typename?: 'StaffTaskType';
  agreement?: Maybe<AgreementType>;
  assignee?: Maybe<CustomUserType>;
  assigneeName?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  createdByName?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  dueDate?: Maybe<Scalars['Date']>;
  fromMessage?: Maybe<Scalars['Boolean']>;
  group?: Maybe<MethodistGroupType>;
  id: Scalars['ID'];
  position: Scalars['Int'];
  priority?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  student?: Maybe<StudentType>;
  teacher?: Maybe<TeacherFilterType>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/**
 * Lightweight ERP-staff row for assignee dropdowns (plain ObjectType so
 * it doesn't fight users' relay UserNode over the model registry).
 */
export type StaffUserType = {
  __typename?: 'StaffUserType';
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  roles: Array<Scalars['String']>;
};

/**
 * Open a Slack DM with a student and post the first message, before any
 * Conversation exists — so a manager can write first. Sent AS the manager
 * (his xoxp user token; a bot can't hold a 1:1 DM).
 */
export type StartSlackDm = {
  __typename?: 'StartSlackDm';
  conversationId?: Maybe<Scalars['ID']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<MessageType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Return a signed Slack authorize URL so the ACTING manager can grant his
 * personal xoxp user token for a group's workspace in one click — no
 * api.slack.com, no copy-paste. The browser then navigates to Slack; on
 * "Allow" Slack redirects to `slack_oauth_callback`, which stores the token.
 *
 * Identity + group are captured HERE (under the JWT this mutation runs behind)
 * and sealed into a short-lived signed `state` (django.core.signing), because
 * the callback is a plain browser redirect that carries no JWT.
 */
export type StartSlackUserOauthMutation = {
  __typename?: 'StartSlackUserOauthMutation';
  authorizeUrl?: Maybe<Scalars['String']>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type StudentAccessBlockType = {
  __typename?: 'StudentAccessBlockType';
  blockedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  isBlocked: Scalars['Boolean'];
  manualOverride: Scalars['Boolean'];
  maxOverdueDays: Scalars['Int'];
  overdueAmount?: Maybe<Scalars['Float']>;
  overdueInvoiceCount: Scalars['Int'];
  reason: Scalars['String'];
  unblockedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type StudentAndCompaniesType = {
  __typename?: 'StudentAndCompaniesType';
  companiesDescription: Scalars['String'];
  companyImages: Array<CompanyImageType>;
  id: Scalars['ID'];
  studentsCount: Scalars['Int'];
  studentsDescription: Scalars['String'];
};

export type StudentCvType = {
  __typename?: 'StudentCVType';
  certificateImage: Scalars['String'];
  course?: Maybe<CourseFilterType>;
  id: Scalars['ID'];
  professionalSkills: Array<ProfessionalSkillType>;
  salary: Scalars['String'];
  studentImage: Scalars['String'];
  title: Scalars['String'];
  workingPosition: Scalars['String'];
};

/**
 * Per-student communicator badges: one row per roster student (zeroed
 * when they have no conversations) plus `in_roster=False` rows for
 * workspace-DM counterparts outside the roster.
 */
export type StudentCommsBadgeRow = {
  __typename?: 'StudentCommsBadgeRow';
  email: Scalars['String'];
  firstName: Scalars['String'];
  inRoster: Scalars['Boolean'];
  lastName: Scalars['String'];
  studentId: Scalars['ID'];
  /** True when EVERY agreement of the student in this group is terminated (the frontend hides such a row unless it still has unread messages). */
  terminated: Scalars['Boolean'];
  /** The student still has at least one INBOUND message no manager has ticked «обработано» — the amber dot. Independent of read state and of dialog status. */
  unhandled: Scalars['Boolean'];
  unhandledMail: Scalars['Boolean'];
  unhandledSlack: Scalars['Boolean'];
  unread: Scalars['Int'];
  unreadMail: Scalars['Int'];
  unreadSlack: Scalars['Int'];
};

export type StudentConnection = {
  __typename?: 'StudentConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `Student` and its cursor. */
export type StudentEdge = {
  __typename?: 'StudentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StudentType>;
};

export type StudentGroupType = Node & {
  __typename?: 'StudentGroupType';
  activeLinkOverride?: Maybe<GroupLinkOverrideType>;
  agreements: Array<AgreementType>;
  agreementsConnection?: Maybe<AgreementConnection>;
  classesDays: Array<DayOfClassType>;
  comment?: Maybe<Scalars['String']>;
  contributionsSum?: Maybe<Scalars['CustomFloat']>;
  conversations: Array<ConversationType>;
  course: CourseFilterType;
  currency?: Maybe<Scalars['String']>;
  datetimeNextLesson?: Maybe<Scalars['DateTime']>;
  daysOfClass: Array<Scalars['Int']>;
  deleteAvailable?: Maybe<Scalars['Boolean']>;
  /** Optional — when the spend belongs to a specific group (teacher payout per group, group materials, etc.) */
  expenses: Array<ExpenseType>;
  /** DEPRECATED: use invoice.payment.agreement.group. */
  fakturowniaInvoices: Array<FakturowniaInvoiceType>;
  freeLessonsCount?: Maybe<Scalars['Int']>;
  freePlaces?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isFree: Scalars['Boolean'];
  lessonJoinUrl?: Maybe<Scalars['String']>;
  lessons?: Maybe<Array<GroupLessonType>>;
  lessonsCount?: Maybe<Scalars['Int']>;
  materials: Array<MaterialType>;
  maxStudentsCount: Scalars['Int'];
  modules: Array<GroupModuleType>;
  name: Scalars['String'];
  notes: Array<StudentNoteType>;
  passedLessonsCount?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['CustomFloat']>;
  publishedLms: Scalars['Boolean'];
  publishedLmsForMethodist: Scalars['Boolean'];
  publishedLmsForTeacher: Scalars['Boolean'];
  slackChannels: Array<ChannelGroupLinkType>;
  slackWorkspace?: Maybe<SlackWorkspaceLinkType>;
  startDate: Scalars['Date'];
  statusFinished?: Maybe<Scalars['Boolean']>;
  studentsCount?: Maybe<Scalars['Int']>;
  tasks: Array<StaffTaskType>;
  teacherLeads: ApplicationFilterTypeConnection;
  teachers?: Maybe<Array<Maybe<TeacherType>>>;
  zoomAccount?: Maybe<ZoomAccountType>;
  zoomSchedules: GroupZoomScheduleTypeConnection;
};


export type StudentGroupTypeAgreementsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  hasDebt?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AgreementOrderByEnum>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<RosterStatusEnum>;
};


export type StudentGroupTypeTeacherLeadsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  byGroupId?: InputMaybe<Scalars['Decimal']>;
  first?: InputMaybe<Scalars['Int']>;
  isTerminated?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type StudentGroupTypeZoomSchedulesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** Parent is a history dict from services.roster (ERP student card). */
export type StudentHomeworkRowType = {
  __typename?: 'StudentHomeworkRowType';
  assignmentTitle: Scalars['String'];
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  hwMark?: Maybe<Scalars['String']>;
  lessonId: Scalars['ID'];
  lessonName: Scalars['String'];
  submission?: Maybe<HomeworkSubmissionType>;
};

/** An enumeration. */
export enum StudentHwTypeEnum {
  ContainsErrors = 'CONTAINS_ERRORS',
  Done = 'DONE',
  NotDone = 'NOT_DONE'
}

export type StudentInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
};

/**
 * PUBLIC student-facing subset of FakturowniaInvoice for `myInvoices`.
 *
 * Hand-built (NOT a DjangoObjectType) so nothing can leak — only the
 * whitelisted fields below exist. Fed FakturowniaInvoice instances by
 * `student_invoices_qs`; scalar fields auto-resolve off the model, the rest
 * are cast/computed here. `is_overdue`/`days_overdue` use the standard
 * overdue definition (payment_to < today AND status != 'paid') PLUS a
 * student-facing `outstanding > 0` guard so a fully-covered invoice never
 * reads as overdue with a zero balance.
 * `view_url`/`payment_url` are read from the stored Fakturownia JSON so the
 * student can open (and, where enabled, pay) the invoice on Fakturownia's
 * hosted page — no extra sync/migration needed.
 */
export type StudentInvoiceType = {
  __typename?: 'StudentInvoiceType';
  currency?: Maybe<Scalars['String']>;
  daysOverdue?: Maybe<Scalars['Int']>;
  fakturowniaId?: Maybe<Scalars['String']>;
  isOverdue?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['Date']>;
  number?: Maybe<Scalars['String']>;
  outstanding?: Maybe<Scalars['Float']>;
  paid?: Maybe<Scalars['Float']>;
  paymentTo?: Maybe<Scalars['Date']>;
  paymentUrl?: Maybe<Scalars['String']>;
  priceGross?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  viewUrl?: Maybe<Scalars['String']>;
};

export type StudentLessonAttachmentType = Node & {
  __typename?: 'StudentLessonAttachmentType';
  file: Scalars['String'];
  id: Scalars['ID'];
  lesson?: Maybe<GroupLessonType>;
  title: Scalars['String'];
};

export type StudentLessonAttachmentTypeConnection = {
  __typename?: 'StudentLessonAttachmentTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentLessonAttachmentTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `StudentLessonAttachmentType` and its cursor. */
export type StudentLessonAttachmentTypeEdge = {
  __typename?: 'StudentLessonAttachmentTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StudentLessonAttachmentType>;
};

export type StudentLessonAttachmentsType = Node & {
  __typename?: 'StudentLessonAttachmentsType';
  courseLesson?: Maybe<CourseLessonType>;
  file: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type StudentLessonAttachmentsTypeConnection = {
  __typename?: 'StudentLessonAttachmentsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentLessonAttachmentsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `StudentLessonAttachmentsType` and its cursor. */
export type StudentLessonAttachmentsTypeEdge = {
  __typename?: 'StudentLessonAttachmentsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StudentLessonAttachmentsType>;
};

export type StudentLessonConnection = {
  __typename?: 'StudentLessonConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentLessonEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `StudentLesson` and its cursor. */
export type StudentLessonEdge = {
  __typename?: 'StudentLessonEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StudentLessonNodeType>;
};

/**
 * TZ-1 — one row of the student's lessons feed.
 *
 * `attended` and `mark` come from per-student records (StudentAttendance /
 * StudentsMark) attached as queryset annotations by
 * `students.services.academic.annotate_student_lessons`. Built as a
 * graphene.ObjectType (not DjangoObjectType) because these fields are
 * student-scoped, not lesson-intrinsic.
 */
export type StudentLessonNodeType = Node & {
  __typename?: 'StudentLessonNodeType';
  attended?: Maybe<Scalars['Boolean']>;
  date?: Maybe<Scalars['Date']>;
  /** The ID of the object */
  id: Scalars['ID'];
  lessonNumber?: Maybe<Scalars['Int']>;
  mark?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
};

export type StudentLessonType = Node & {
  __typename?: 'StudentLessonType';
  additional?: Maybe<Scalars['Boolean']>;
  attendances: AttendanceTypeConnection;
  comment?: Maybe<Scalars['String']>;
  date: Scalars['Date'];
  endTime: Scalars['Time'];
  finished: Scalars['Boolean'];
  firstLessonAgreements: Array<AgreementType>;
  hasJoinLink?: Maybe<Scalars['Boolean']>;
  hasStudentAttachment?: Maybe<Scalars['Boolean']>;
  hasStudentMarks?: Maybe<Scalars['Boolean']>;
  hasTeacherAttachment?: Maybe<Scalars['Boolean']>;
  homeworkAssignmentId?: Maybe<Scalars['ID']>;
  homeworkAvailable?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  lastLessonAgreements: Array<AgreementType>;
  lessonNumber?: Maybe<Scalars['Int']>;
  linkOverrideActive?: Maybe<Scalars['Boolean']>;
  lmsDescription?: Maybe<Scalars['String']>;
  marks: StudentsMarkTypeConnection;
  /** Optional — for group-wide handouts leave NULL; for per-lesson homework point at the specific GroupLesson. */
  materials: Array<MaterialType>;
  module: GroupModuleType;
  name: Scalars['String'];
  needToFinish?: Maybe<Scalars['Boolean']>;
  number: Scalars['Int'];
  startTime: Scalars['Time'];
  students: StudentTypeConnection;
  studentsAttachments: StudentLessonAttachmentTypeConnection;
  taskTypes: Array<Scalars['String']>;
  teacher?: Maybe<TeacherType>;
  teacherApplication?: Maybe<ApplicationType>;
  teachersAttachments: TeacherLessonAttachmentTypeConnection;
  video?: Maybe<Scalars['String']>;
  whiteboardId?: Maybe<Scalars['ID']>;
  zoomProcessingLogs: ZoomProcessingLogTypeConnection;
  zoomRecordingMeta?: Maybe<LessonRecordingType>;
};


export type StudentLessonTypeAttendancesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type StudentLessonTypeMarksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  lessonId?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  taskType?: InputMaybe<Scalars['String']>;
};


export type StudentLessonTypeStudentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type StudentLessonTypeStudentsAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type StudentLessonTypeTeachersAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type StudentLessonTypeZoomProcessingLogsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type StudentMiniCard = {
  __typename?: 'StudentMiniCard';
  email: Scalars['String'];
  finance?: Maybe<StudentMiniCardFinance>;
  firstName: Scalars['String'];
  groups: Array<StudentMiniCardGroupRow>;
  isLmsBlocked: Scalars['Boolean'];
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  notesCount: Scalars['Int'];
  openTasksCount: Scalars['Int'];
  phone?: Maybe<Scalars['String']>;
  recentNotes: Array<StudentNoteType>;
  recentTasks: Array<StaffTaskType>;
  studentId: Scalars['ID'];
};

export type StudentMiniCardFinance = {
  __typename?: 'StudentMiniCardFinance';
  blockReason?: Maybe<Scalars['String']>;
  isBlocked: Scalars['Boolean'];
  isDebtor: Scalars['Boolean'];
  maxOverdueDays: Scalars['Int'];
  overdueAmount: Scalars['Float'];
  overdueInvoiceCount: Scalars['Int'];
  overdueSince?: Maybe<Scalars['Date']>;
  totals: StudentTotals;
};

/**
 * One agreement = one group membership row. A retake student can have
 * two rows with the same group — disambiguated by `agreement_title`.
 */
export type StudentMiniCardGroupRow = {
  __typename?: 'StudentMiniCardGroupRow';
  agreementId: Scalars['ID'];
  agreementTitle: Scalars['String'];
  courseName?: Maybe<Scalars['String']>;
  freeOfCharge?: Maybe<Scalars['Boolean']>;
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  paymentByCompany?: Maybe<Scalars['Boolean']>;
  statePrefinanced?: Maybe<Scalars['Boolean']>;
  status: Scalars['String'];
  terminatedDate?: Maybe<Scalars['Date']>;
};

export type StudentNoteType = {
  __typename?: 'StudentNoteType';
  authorName?: Maybe<Scalars['String']>;
  body: Scalars['String'];
  createdAt: Scalars['DateTime'];
  group?: Maybe<MethodistGroupType>;
  id: Scalars['ID'];
  pinned: Scalars['Boolean'];
  sentiment?: Maybe<Scalars['String']>;
  student?: Maybe<StudentType>;
  updatedAt: Scalars['DateTime'];
};

/** One row of `groupPerformanceSummary.top`/`bottom`/`students`. */
export type StudentPerfRow = {
  __typename?: 'StudentPerfRow';
  averageMark: Scalars['Float'];
  fullName: Scalars['String'];
  marksCount: Scalars['Int'];
  studentId: Scalars['ID'];
};

export type StudentSignUpInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  phone: Scalars['String'];
  recaptchaToken: Scalars['String'];
};

export type StudentSignUpLmsMutation = {
  __typename?: 'StudentSignUpLMSMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  student?: Maybe<StudentType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type StudentSkillType = {
  __typename?: 'StudentSkillType';
  category: Scalars['String'];
  level: Scalars['Int'];
  name: Scalars['String'];
  skillId: Scalars['ID'];
  years?: Maybe<Scalars['Float']>;
};

export type StudentTimelineConnection = {
  __typename?: 'StudentTimelineConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentTimelineEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `StudentTimeline` and its cursor. */
export type StudentTimelineEdge = {
  __typename?: 'StudentTimelineEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StudentTimelineEventType>;
};

export type StudentTimelineEventType = Node & {
  __typename?: 'StudentTimelineEventType';
  date: Scalars['Date'];
  /** The ID of the object */
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['GenericScalar']>;
  type: TimelineEventTypeEnum;
};

/**
 * Wrapper so the field can grow extra aggregates later without a
 * breaking schema change (e.g. `top_level_currency`, `as_of`).
 */
export type StudentTotals = {
  __typename?: 'StudentTotals';
  byCurrency: Array<StudentTotalsRow>;
};

/**
 * One row per currency, over the active debt-bearing agreements.
 * `total_debt` is Σ «взнос» debt (spec-0004 coverage, derived on read from
 * the linked invoices) and `total_paid = budget - debt`; `outstanding_invoices`
 * is the Fakturownia outstanding on `issued` invoices reached dual-chain.
 */
export type StudentTotalsRow = {
  __typename?: 'StudentTotalsRow';
  agreementsActive: Scalars['Int'];
  agreementsTerminated: Scalars['Int'];
  currency: Scalars['String'];
  outstandingInvoices: Scalars['Float'];
  totalBudget: Scalars['Float'];
  totalDebt: Scalars['Float'];
  totalPaid: Scalars['Float'];
};

export type StudentType = Node & {
  __typename?: 'StudentType';
  accountsPayables?: Maybe<Array<Maybe<AccountsPayableType>>>;
  acquisitionSource?: Maybe<Scalars['String']>;
  agreementIsActive?: Maybe<Scalars['Boolean']>;
  agreementTitle?: Maybe<AgreementType>;
  agreements: Array<AgreementType>;
  attendancePercent?: Maybe<Scalars['Float']>;
  attendances: AttendanceTypeConnection;
  averageMark?: Maybe<Scalars['Float']>;
  conversations: Array<ConversationType>;
  crmLink?: Maybe<Scalars['String']>;
  /** DEPRECATED: use invoice.payment.agreement.student. */
  fakturowniaInvoices: Array<FakturowniaInvoiceType>;
  groupsCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  /** True while the student's LMS access is blocked (debtor block). Bare boolean by design — block details are ERP-only. */
  isLmsBlocked?: Maybe<Scalars['Boolean']>;
  lesson: GroupLessonTypeConnection;
  lessons?: Maybe<StudentLessonConnection>;
  marks: StudentsMarkTypeConnection;
  notes: Array<StudentNoteType>;
  registrationDate?: Maybe<Scalars['Date']>;
  responsibleManager?: Maybe<ResponsibleManagerType>;
  slackLinks: Array<SlackUserLinkType>;
  tasks: Array<StaffTaskType>;
  timeline?: Maybe<StudentTimelineConnection>;
  /** Σ budget / paid / debt / outstanding-invoices, grouped by currency. See docs/fakturownia/student_card.md §7. */
  totals?: Maybe<StudentTotals>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<CustomUserType>;
};


export type StudentTypeAttendancesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type StudentTypeLessonArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
};


export type StudentTypeLessonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type StudentTypeMarksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  lessonId?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  taskType?: InputMaybe<Scalars['String']>;
};


export type StudentTypeTimelineArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type StudentTypeConnection = {
  __typename?: 'StudentTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `StudentType` and its cursor. */
export type StudentTypeEdge = {
  __typename?: 'StudentTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StudentType>;
};

export type StudentWithAgreementCreateMutation = {
  __typename?: 'StudentWithAgreementCreateMutation';
  agreement?: Maybe<AgreementType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type StudentWithAgreementUpdateMutation = {
  __typename?: 'StudentWithAgreementUpdateMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  student?: Maybe<StudentType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type StudentsAchievementConnection = {
  __typename?: 'StudentsAchievementConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentsAchievementEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `StudentsAchievement` and its cursor. */
export type StudentsAchievementEdge = {
  __typename?: 'StudentsAchievementEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<AgreementType>;
};

export type StudentsMarkConnection = {
  __typename?: 'StudentsMarkConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentsMarkEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `StudentsMark` and its cursor. */
export type StudentsMarkEdge = {
  __typename?: 'StudentsMarkEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StudentsMarkType>;
};

/** An enumeration. */
export enum StudentsMarkHwMark {
  /** Содержит ошибки */
  ContainsErrors = 'CONTAINS_ERRORS',
  /** Выполнено */
  Done = 'DONE',
  /** Не выполнено */
  NotDone = 'NOT_DONE'
}

/** An enumeration. */
export enum StudentsMarkTaskType {
  /** Курсовая работа */
  Coursework = 'COURSEWORK',
  /** Дипломный проект */
  GraduationProject = 'GRADUATION_PROJECT',
  /** Домашнее задание */
  Homework = 'HOMEWORK'
}

export type StudentsMarkType = Node & {
  __typename?: 'StudentsMarkType';
  date: Scalars['Date'];
  hwMark?: Maybe<StudentsMarkHwMark>;
  id: Scalars['ID'];
  lesson: GroupLessonType;
  /** Od 1 do 10 */
  mark?: Maybe<Scalars['Int']>;
  student: StudentType;
  taskType?: Maybe<StudentsMarkTaskType>;
};

export type StudentsMarkTypeConnection = {
  __typename?: 'StudentsMarkTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StudentsMarkTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `StudentsMarkType` and its cursor. */
export type StudentsMarkTypeEdge = {
  __typename?: 'StudentsMarkTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<StudentsMarkType>;
};

export type StudentsReviewsType = {
  __typename?: 'StudentsReviewsType';
  description: Scalars['String'];
  id: Scalars['ID'];
  markCountText: Scalars['String'];
  markText: Scalars['String'];
  marks: Scalars['Float'];
  marksCount: Scalars['Int'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoTitle: Scalars['String'];
  title: Scalars['String'];
};

/**
 * LMS: score the student's answers and record an attempt (self-check —
 * never gates the lesson).
 */
export type SubmitCareerQuiz = {
  __typename?: 'SubmitCareerQuiz';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  maxScore?: Maybe<Scalars['Int']>;
  results?: Maybe<Array<CareerQuizResultType>>;
  score?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Student submits (or replaces) their homework: a GitHub link AND/OR a
 * ZIP archive (at least one, both allowed together). Re-submitting after
 * grading resets the grade. No teacher assignment is required (rev.3).
 */
export type SubmitHomeworkMutation = {
  __typename?: 'SubmitHomeworkMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  submission?: Maybe<MyHomeworkSubmissionType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SubmitSurveyResponseMutation = {
  __typename?: 'SubmitSurveyResponseMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SuccessStoriesBlockType = {
  __typename?: 'SuccessStoriesBlockType';
  id: Scalars['ID'];
  stories: Array<SuccessStoriesType>;
  title: Scalars['String'];
};

export type SuccessStoriesConnection = {
  __typename?: 'SuccessStoriesConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SuccessStoriesEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `SuccessStories` and its cursor. */
export type SuccessStoriesEdge = {
  __typename?: 'SuccessStoriesEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SuccessStoriesType>;
};

export type SuccessStoriesType = {
  __typename?: 'SuccessStoriesType';
  adviceText?: Maybe<Scalars['String']>;
  adviceTitle?: Maybe<Scalars['String']>;
  author: AuthorsType;
  banner?: Maybe<CourseBanner>;
  date: Scalars['Date'];
  id: Scalars['ID'];
  interview?: Maybe<Scalars['String']>;
  interviewText?: Maybe<Scalars['String']>;
  native?: Maybe<NativeInfoType>;
  nativeTitle?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
  previewImage?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoSlug?: Maybe<Scalars['String']>;
  seoTitle: Scalars['String'];
  storyBlock: Array<SuccessStoriesBlockType>;
  storyImage?: Maybe<Scalars['String']>;
  storyShortText?: Maybe<Scalars['String']>;
  storyText?: Maybe<Scalars['String']>;
  storyTime?: Maybe<Scalars['String']>;
  studentImage?: Maybe<Scalars['String']>;
  studentName?: Maybe<Scalars['String']>;
  thesis: Array<ThesesType>;
  title: Scalars['String'];
};

export type SurveyAnswerInput = {
  questionId: Scalars['ID'];
  value: Scalars['JSONString'];
};

/** Parent is a SurveyAnswer. */
export type SurveyAnswerViewType = {
  __typename?: 'SurveyAnswerViewType';
  questionId: Scalars['ID'];
  value: Scalars['JSONString'];
};

/** Parent is the dict built by services.results.assignment_results. */
export type SurveyAssignmentResultsType = {
  __typename?: 'SurveyAssignmentResultsType';
  assignment: SurveyAssignmentType;
  questionResults: Array<SurveyQuestionResultType>;
  respondents: Array<SurveyRespondentStatusType>;
};

/**
 * Parent is a SurveyAssignment (survey/group/trigger_lesson+module
 * select_related by the queries).
 */
export type SurveyAssignmentType = {
  __typename?: 'SurveyAssignmentType';
  createdAt: Scalars['DateTime'];
  eligibleCount: Scalars['Int'];
  groupId: Scalars['ID'];
  groupName: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  lessonDate?: Maybe<Scalars['Date']>;
  lessonId: Scalars['ID'];
  lessonName: Scalars['String'];
  lessonNumber: Scalars['Int'];
  respondedCount: Scalars['Int'];
  surveyId: Scalars['ID'];
  surveyTitle: Scalars['String'];
};

/** Parent is {'key', 'label', 'count'}. */
export type SurveyDistributionBucketType = {
  __typename?: 'SurveyDistributionBucketType';
  count: Scalars['Int'];
  key: Scalars['String'];
  label: Scalars['String'];
};

export type SurveyInput = {
  courseId?: InputMaybe<Scalars['ID']>;
  defaultLessonNumber?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  questions: Array<SurveyQuestionInput>;
  title: Scalars['String'];
};

/** Parent is a SurveyQuestion instance. */
export type SurveyQuestionForStudentType = {
  __typename?: 'SurveyQuestionForStudentType';
  id: Scalars['ID'];
  number: Scalars['Int'];
  options: Array<Scalars['String']>;
  questionType: Scalars['String'];
  required: Scalars['Boolean'];
  text: Scalars['String'];
};

export type SurveyQuestionInput = {
  id?: InputMaybe<Scalars['ID']>;
  options?: InputMaybe<Array<Scalars['String']>>;
  questionType: Scalars['String'];
  required: Scalars['Boolean'];
  text: Scalars['String'];
};

/** Parent is the dict built by services.results._aggregate. */
export type SurveyQuestionResultType = {
  __typename?: 'SurveyQuestionResultType';
  answersCount: Scalars['Int'];
  average?: Maybe<Scalars['Float']>;
  distribution: Array<SurveyDistributionBucketType>;
  question: SurveyQuestionType;
};

/** Parent is a SurveyQuestion instance. */
export type SurveyQuestionType = {
  __typename?: 'SurveyQuestionType';
  id: Scalars['ID'];
  number: Scalars['Int'];
  options: Array<Scalars['String']>;
  questionType: Scalars['String'];
  required: Scalars['Boolean'];
  text: Scalars['String'];
};

/** Parent is {'student': Student, 'response': SurveyResponse|None}. */
export type SurveyRespondentStatusType = {
  __typename?: 'SurveyRespondentStatusType';
  email?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  responded: Scalars['Boolean'];
  responseId?: Maybe<Scalars['ID']>;
  studentId: Scalars['ID'];
  submittedAt?: Maybe<Scalars['DateTime']>;
};

/** Parent is {'response': SurveyResponse, 'answers': [SurveyAnswer]}. */
export type SurveyResponseDetailType = {
  __typename?: 'SurveyResponseDetailType';
  answers: Array<SurveyAnswerViewType>;
  fullName: Scalars['String'];
  responseId: Scalars['ID'];
  studentId: Scalars['ID'];
  submittedAt: Scalars['DateTime'];
};

/**
 * Parent is a Survey instance (course select_related, questions
 * prefetched by the queries).
 */
export type SurveyType = {
  __typename?: 'SurveyType';
  assignmentsCount: Scalars['Int'];
  courseId?: Maybe<Scalars['ID']>;
  courseName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  defaultLessonNumber?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  hasResponses: Scalars['Boolean'];
  id: Scalars['ID'];
  isArchived: Scalars['Boolean'];
  questions: Array<SurveyQuestionType>;
  questionsCount: Scalars['Int'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

/** Sync accounts + every cloud recording in Zoom for a date range. */
export type SyncAllZoomRecordingsMutation = {
  __typename?: 'SyncAllZoomRecordingsMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * On-demand «обновить сообщения»: enqueue a Slack backfill PLUS a Gmail
 * backfill of the latest mail (metadata-first, so it's cheap). Without
 * group_id it syncs every ENABLED workspace of an ACTIVE group (one that
 * still has future lessons) plus legacy channel links; with group_id it
 * syncs that group's workspace regardless of activity — the group-card
 * button keeps working for finished groups. Async via Celery — the button
 * returns immediately; new messages appear once the worker finishes.
 */
export type SyncCommunicationsNowMutation = {
  __typename?: 'SyncCommunicationsNowMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  queued?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * On-demand 'refresh mail' button: enqueue a Gmail backfill of the latest
 * ~100 messages per mailbox. Runs async via Celery so the request returns
 * immediately; the new mail appears once the worker finishes.
 */
export type SyncGmailNowMutation = {
  __typename?: 'SyncGmailNowMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  queued?: Maybe<Scalars['Boolean']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Create (if needed) and refill the group's SendGrid contact list.
 *
 * Idempotent — contacts are upserted by email, so re-running re-syncs rather
 * than duplicating. SendGrid processes the upload asynchronously, so the
 * contact count updates a few seconds later.
 */
export type SyncGroupSendgridList = {
  __typename?: 'SyncGroupSendgridList';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  list?: Maybe<SendgridGroupListType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SyncZoomAccountsMutation = {
  __typename?: 'SyncZoomAccountsMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SyncZoomRecordingsMutation = {
  __typename?: 'SyncZoomRecordingsMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Refresh the Zoom account usage summary (storage quota + counts). */
export type SyncZoomUsageMutation = {
  __typename?: 'SyncZoomUsageMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * The single entity a task is about (spec 0014).
 *
 * Discriminated on `kind`, so an invalid combination is unrepresentable:
 * applying a subject always rewrites ALL four subject FKs, which is what keeps
 * "teacher XOR student/group/agreement" true without a cross-field check.
 */
export type TaskSubjectInput = {
  /** kind="student" only — the roster row (договор) the task is filed against. */
  agreementId?: InputMaybe<Scalars['ID']>;
  /** kind="student" only — the group the student was picked from (context shown on the card). */
  groupId?: InputMaybe<Scalars['ID']>;
  /** PK of the subject. Required unless kind is "none". */
  id?: InputMaybe<Scalars['ID']>;
  /** One of "student" | "group" | "teacher" | "none". "none" is a personal to-do with no subject. */
  kind: Scalars['String'];
};

/** Minimal {id, name} of a course a teacher is qualified to teach. */
export type TeacherCourseRef = {
  __typename?: 'TeacherCourseRef';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type TeacherFilterType = Node & {
  __typename?: 'TeacherFilterType';
  accessToLms: Scalars['Boolean'];
  applications?: Maybe<ApplicationConnection>;
  availability?: Maybe<Scalars['String']>;
  courses?: Maybe<Array<Maybe<Scalars['String']>>>;
  coursesCanTeach?: Maybe<Array<TeacherCourseRef>>;
  deleteAvailable?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  employmentTypes?: Maybe<Array<Maybe<EmploymentType>>>;
  expenses: Array<ExpenseType>;
  fullName?: Maybe<Scalars['String']>;
  groupsCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  individualentrepreneur?: Maybe<IndividualEntrepreneurType>;
  internalNote: Scalars['String'];
  interview?: Maybe<Scalars['String']>;
  interviewRecording: Scalars['String'];
  interviewTitle?: Maybe<Scalars['String']>;
  isDismissed?: Maybe<Scalars['Boolean']>;
  legalentity?: Maybe<LegalEntityType>;
  mainTeachers: MainTeacherWebTypeConnection;
  naturalperson?: Maybe<NaturalPersonType>;
  photo?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  selfemployed?: Maybe<SelfEmployedType>;
  siteDisplay: Scalars['Boolean'];
  studentComments?: Maybe<Array<TeacherStudentCommentType>>;
  studentRating?: Maybe<Scalars['Float']>;
  studentRatingCount: Scalars['Int'];
  teacher: TeacherWebTypeConnection;
  user: CustomUserType;
};


export type TeacherFilterTypeApplicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TeacherFilterTypeMainTeachersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type TeacherFilterTypeTeacherArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type TeacherFilterTypeConnection = {
  __typename?: 'TeacherFilterTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TeacherFilterTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `TeacherFilterType` and its cursor. */
export type TeacherFilterTypeEdge = {
  __typename?: 'TeacherFilterTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<TeacherType>;
};

export type TeacherLessonAttachmentType = Node & {
  __typename?: 'TeacherLessonAttachmentType';
  file: Scalars['String'];
  id: Scalars['ID'];
  lesson?: Maybe<GroupLessonType>;
  title: Scalars['String'];
};

export type TeacherLessonAttachmentTypeConnection = {
  __typename?: 'TeacherLessonAttachmentTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TeacherLessonAttachmentTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TeacherLessonAttachmentType` and its cursor. */
export type TeacherLessonAttachmentTypeEdge = {
  __typename?: 'TeacherLessonAttachmentTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<TeacherLessonAttachmentType>;
};

export type TeacherLessonAttachmentsType = Node & {
  __typename?: 'TeacherLessonAttachmentsType';
  courseLesson?: Maybe<CourseLessonType>;
  file: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type TeacherLessonAttachmentsTypeConnection = {
  __typename?: 'TeacherLessonAttachmentsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TeacherLessonAttachmentsTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TeacherLessonAttachmentsType` and its cursor. */
export type TeacherLessonAttachmentsTypeEdge = {
  __typename?: 'TeacherLessonAttachmentsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<TeacherLessonAttachmentsType>;
};

/**
 * One named student comment about the teacher, from a survey
 * `teacher_comment` answer (spec 0011 extension). ERP-staff only.
 */
export type TeacherStudentCommentType = {
  __typename?: 'TeacherStudentCommentType';
  comment: Scalars['String'];
  courseName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  groupName?: Maybe<Scalars['String']>;
  studentName: Scalars['String'];
};

export type TeacherType = Node & {
  __typename?: 'TeacherType';
  accessToLms: Scalars['Boolean'];
  applications?: Maybe<ApplicationConnection>;
  availability?: Maybe<Scalars['String']>;
  courses?: Maybe<Array<Maybe<Scalars['String']>>>;
  coursesCanTeach?: Maybe<Array<TeacherCourseRef>>;
  deleteAvailable?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  employmentTypes?: Maybe<Array<Maybe<EmploymentType>>>;
  expenses: Array<ExpenseType>;
  fullName?: Maybe<Scalars['String']>;
  groupsCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  internalNote: Scalars['String'];
  interview?: Maybe<Scalars['String']>;
  interviewRecording: Scalars['String'];
  interviewTitle?: Maybe<Scalars['String']>;
  isDismissed?: Maybe<Scalars['Boolean']>;
  mainTeachers: MainTeacherWebTypeConnection;
  photo?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
  siteDisplay: Scalars['Boolean'];
  studentComments?: Maybe<Array<TeacherStudentCommentType>>;
  studentRating?: Maybe<Scalars['Float']>;
  studentRatingCount: Scalars['Int'];
  teacher: TeacherWebTypeConnection;
  user: CustomUserType;
};


export type TeacherTypeApplicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type TeacherTypeMainTeachersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type TeacherTypeTeacherArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type TeacherWebType = Node & {
  __typename?: 'TeacherWebType';
  course?: Maybe<CourseFilterType>;
  description: Scalars['String'];
  id: Scalars['ID'];
  teachersPreview: TeacherFilterTypeConnection;
  title: Scalars['String'];
};


export type TeacherWebTypeTeachersPreviewArgs = {
  after?: InputMaybe<Scalars['String']>;
  availability?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  course?: InputMaybe<Scalars['Decimal']>;
  first?: InputMaybe<Scalars['Int']>;
  hasDescription?: InputMaybe<Scalars['Boolean']>;
  hasInterview?: InputMaybe<Scalars['Boolean']>;
  hasPhoto?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  minRating?: InputMaybe<Scalars['Decimal']>;
  offset?: InputMaybe<Scalars['Int']>;
  siteDisplay?: InputMaybe<Scalars['Boolean']>;
};

export type TeacherWebTypeConnection = {
  __typename?: 'TeacherWebTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TeacherWebTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TeacherWebType` and its cursor. */
export type TeacherWebTypeEdge = {
  __typename?: 'TeacherWebTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<TeacherWebType>;
};

export type TeacherWithTypeInput = {
  accessToLms?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  siteDisplay?: InputMaybe<Scalars['Boolean']>;
};

export type TeachersPageInfoType = {
  __typename?: 'TeachersPageInfoType';
  description: Scalars['String'];
  id: Scalars['ID'];
  seoDescription: Scalars['String'];
  seoImage: Scalars['String'];
  seoKeywords: Scalars['String'];
  seoTitle: Scalars['String'];
  title: Scalars['String'];
};

/**
 * Safe one-click agreement termination — see docs/groups/groups_upgrade.md §B3.
 *
 * Replaces the chained `updateStudentWithAgreement` workaround that
 * re-sent the student's PII just to flip `terminated=True`. This mutation
 * touches only the agreement and writes an audit log entry; contributions
 * and deferred payments are deliberately left alone.
 */
export type TerminateAgreementMutation = {
  __typename?: 'TerminateAgreementMutation';
  agreement?: Maybe<AgreementType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum TerminatedReasonEnum {
  NonPayment = 'NON_PAYMENT',
  Other = 'OTHER',
  StudentRequest = 'STUDENT_REQUEST',
  Transfer = 'TRANSFER'
}

export type ThesesType = {
  __typename?: 'ThesesType';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  successStory?: Maybe<SuccessStoriesType>;
  title?: Maybe<Scalars['String']>;
};

export enum TimelineEventTypeEnum {
  InvoiceIssued = 'INVOICE_ISSUED',
  InvoiceLinked = 'INVOICE_LINKED',
  Moved = 'MOVED',
  Note = 'NOTE',
  Paid = 'PAID',
  Signed = 'SIGNED',
  TaskCreated = 'TASK_CREATED',
  TaskDone = 'TASK_DONE',
  Terminated = 'TERMINATED'
}

/**
 * Group-scoped Fakturownia sync — docs/groups/group_dashboard.md §G10.
 *
 * Same Celery task as `triggerFakturowniaSync`, but the dedup lock is
 * scoped per `(group_id, period)` so a busy operator can fire syncs
 * for several groups without the global trigger getting in the way.
 * The payer-email UNION (agreement.buyer_email + student.email) is
 * recorded in the audit log and the returned `message`; narrowing the
 * actual Fakturownia API call by that list is intentionally deferred —
 * the mirror only ever grows, and the new canonical `groupId` filter
 * (§G7) will surface the new rows on the group's FinancesTab as soon
 * as the sync completes.
 */
export type TriggerFakturowniaGroupSyncMutation = {
  __typename?: 'TriggerFakturowniaGroupSyncMutation';
  /** Count of unique payer emails on the group's agreements + students. Recorded for audit; the API query itself is not narrowed yet. */
  emailsTargeted?: Maybe<Scalars['Int']>;
  enqueued?: Maybe<Scalars['Boolean']>;
  lastRun?: Maybe<FakturowniaSyncRunType>;
  message?: Maybe<Scalars['String']>;
};

/**
 * Fire-and-forget: enqueue a Fakturownia sync via Celery.
 *
 * The frontend pattern is: call this mutation → poll
 * `fakturownia_sync_status` until `is_running` flips back to false →
 * read `last_run.stats` to render "synced N invoices". The returned
 * `last_run` is the state *before* the new task starts so the UI can
 * show "synced 14:23 (… enqueueing new run …)" instantly.
 */
export type TriggerFakturowniaSyncMutation = {
  __typename?: 'TriggerFakturowniaSyncMutation';
  enqueued?: Maybe<Scalars['Boolean']>;
  /** Latest run *before* this trigger fired. Poll `fakturownia_sync_status` afterwards to see the new run. */
  lastRun?: Maybe<FakturowniaSyncRunType>;
  message?: Maybe<Scalars['String']>;
};

/**
 * Enqueue a full PandaDoc re-sync (list + details, with student folder
 * backfill). Powers the dashboard 'refresh everything' button — the Celery
 * task self-chains until the whole details backlog is drained.
 */
export type TriggerPandadocSyncMutation = {
  __typename?: 'TriggerPandadocSyncMutation';
  enqueued?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  syncStatus?: Maybe<PandaDocSyncStatusType>;
};

/**
 * Manual Zoom sync scoped to one group — docs/groups/group_dashboard.md
 * §G9. Re-runs `sync_recordings` for the window and the matcher against
 * the group's lessons. 60-sec dedup lock per group so a frantic operator
 * doesn't queue ten copies.
 */
export type TriggerZoomGroupProcessMutation = {
  __typename?: 'TriggerZoomGroupProcessMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  enqueued?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  queuedCount?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Manually restore a student's LMS access. */
export type UnblockStudentLmsAccessMutation = {
  __typename?: 'UnblockStudentLmsAccessMutation';
  accessBlock?: Maybe<StudentAccessBlockType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UnionGroupConnection = {
  __typename?: 'UnionGroupConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UnionGroupEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `UnionGroup` and its cursor. */
export type UnionGroupEdge = {
  __typename?: 'UnionGroupEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<UnionGroupType>;
};

export type UnionGroupType = GroupType | MethodistGroupType | StudentGroupType;

export type UnionLessonType = GroupLessonForLmsType | MethodistLessonType | StudentLessonType;

/**
 * Detach the Payment from a Contribution. The Payment stays alive as
 * an orphan (visible in the "вне графика" block); the Contribution
 * flips back to `complete=False, remainder=amount_foreign`.
 */
export type UnlinkContributionMutation = {
  __typename?: 'UnlinkContributionMutation';
  contribution?: Maybe<ContributionType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  payment?: Maybe<PaymentType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UnlinkLessonRecordingMutation = {
  __typename?: 'UnlinkLessonRecordingMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UnlinkLessonWhiteboardMutation = {
  __typename?: 'UnlinkLessonWhiteboardMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  whiteboard?: Maybe<WhiteboardType>;
};

/** Detach a manually-linked PandaDoc document from its agreement. */
export type UnlinkPandadocDocumentMutation = {
  __typename?: 'UnlinkPandadocDocumentMutation';
  document?: Maybe<PandaDocDocumentType>;
  errors?: Maybe<Scalars['JSONString']>;
};

/** Detach a PandaDoc document from its teacher. */
export type UnlinkPandadocTeacherMutation = {
  __typename?: 'UnlinkPandadocTeacherMutation';
  document?: Maybe<PandaDocDocumentType>;
  errors?: Maybe<Scalars['JSONString']>;
};

/**
 * The inverse view — answers «did I miss anyone?», which the operator
 * needs more than the per-file errors.
 */
export type UnmatchedStudentType = {
  __typename?: 'UnmatchedStudentType';
  fullName?: Maybe<Scalars['String']>;
  missingLanguages: Array<Scalars['String']>;
  student: DiplomaStudentType;
};

export type UpdateApplicationInputType = {
  applicationId: Scalars['ID'];
  comment?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['ID']>;
  currency: Currencies;
  date: Scalars['Date'];
  group: Scalars['ID'];
  isTerminated: Scalars['Boolean'];
  lastLessonDate?: InputMaybe<Scalars['Date']>;
  lessonsCount: Scalars['Int'];
  riaPrice?: InputMaybe<Scalars['Float']>;
  servicePrice: Scalars['Float'];
  teacherType: EmploymentTypes;
  title: Scalars['String'];
};

export type UpdateAttendanceMutation = {
  __typename?: 'UpdateAttendanceMutation';
  attendance?: Maybe<AttendanceType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateCareerMember = {
  __typename?: 'UpdateCareerMember';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  member?: Maybe<CareerMemberType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateCompanyInput = {
  comment: Scalars['String'];
  email: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  responsiblePerson: Scalars['String'];
};

export type UpdateCompanyMutation = {
  __typename?: 'UpdateCompanyMutation';
  company?: Maybe<CompanyType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateCourseMutation = {
  __typename?: 'UpdateCourseMutation';
  course?: Maybe<CourseType>;
};

export type UpdateExpenseInput = {
  amount?: InputMaybe<Scalars['Float']>;
  categorySlug?: InputMaybe<Scalars['String']>;
  counterpartyName?: InputMaybe<Scalars['String']>;
  counterpartyTaxNo?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  documentUrl?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  legalEntityId?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  paidAt?: InputMaybe<Scalars['Date']>;
  recurrence?: InputMaybe<Scalars['String']>;
  recurrenceDay?: InputMaybe<Scalars['Int']>;
  recurrenceUntil?: InputMaybe<Scalars['Date']>;
  /** Link a received Fakturownia invoice — prefills and locks amount/currency/date/counterparty from it, sets source='fakturownia'. */
  relatedFakturowniaInvoiceId?: InputMaybe<Scalars['ID']>;
  relatedGroupId?: InputMaybe<Scalars['ID']>;
  relatedTeacherId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
};

export type UpdateGroupInput = {
  course_id: Scalars['Int'];
  currency: Scalars['String'];
  daysOfClass: Array<DayOfClassInput>;
  modules: Array<InputMaybe<UpdateModuleInput>>;
  name: Scalars['String'];
  price: Scalars['Float'];
  startDate: Scalars['Date'];
};

export type UpdateGroupMutation = {
  __typename?: 'UpdateGroupMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  group?: Maybe<GroupType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateJournalsMutation = {
  __typename?: 'UpdateJournalsMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateLessonInput = {
  additional?: InputMaybe<Scalars['Boolean']>;
  application_id?: InputMaybe<Scalars['ID']>;
  lesson_id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  teacher_id?: InputMaybe<Scalars['Int']>;
};

export type UpdateMaterialInput = {
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  kind?: InputMaybe<MaterialKindEnum>;
  lessonId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateMaterialMutation = {
  __typename?: 'UpdateMaterialMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  material?: Maybe<MaterialType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateModuleInput = {
  lessons: Array<InputMaybe<UpdateLessonInput>>;
  module_id: Scalars['Int'];
};

export type UpdatePaymentCorrectionInput = {
  amount?: InputMaybe<Scalars['Float']>;
  date?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};

export type UpdatePaymentCorrectionMutation = {
  __typename?: 'UpdatePaymentCorrectionMutation';
  correction?: Maybe<PaymentCorrectionType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdatePaymentInput = {
  amountAgreement?: InputMaybe<Scalars['Float']>;
  date?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
};

/**
 * Patch a Payment's amount and/or date.
 *
 * Re-derives `amount_byn` / `amount_foreign` via `PaymentBase.save()` —
 * that's how the existing forms-based path keeps the chargeback / debt
 * tables consistent.
 */
export type UpdatePaymentMutation = {
  __typename?: 'UpdatePaymentMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  payment?: Maybe<PaymentType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdatePlannedPaymentInput = {
  amount?: InputMaybe<Scalars['Float']>;
  categorySlug?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  legalEntityId?: InputMaybe<Scalars['ID']>;
  recurrence?: InputMaybe<Scalars['String']>;
  recurrenceDay?: InputMaybe<Scalars['Int']>;
  recurrenceUntil?: InputMaybe<Scalars['Date']>;
  relatedGroupId?: InputMaybe<Scalars['ID']>;
  relatedTeacherId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateStaffTaskInput = {
  agreementId?: InputMaybe<Scalars['ID']>;
  assigneeId?: InputMaybe<Scalars['ID']>;
  clearTargets?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  groupId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  priority?: InputMaybe<Scalars['String']>;
  studentId?: InputMaybe<Scalars['ID']>;
  subject?: InputMaybe<TaskSubjectInput>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateStaffTaskMutation = {
  __typename?: 'UpdateStaffTaskMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  task?: Maybe<StaffTaskType>;
};

export type UpdateStudentInput = {
  accountsPayable?: InputMaybe<AccountsPayableInput>;
  agreement: AgreementInput;
  chargeback?: InputMaybe<ChargebackInput>;
  company?: InputMaybe<SetCompanyInput>;
  contributions?: InputMaybe<Array<InputMaybe<ContributionInput>>>;
  student: StudentInput;
  studentLessons?: InputMaybe<AgreementLessonsInput>;
  usedPayables?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateStudentNoteInput = {
  body?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  pinned?: InputMaybe<Scalars['Boolean']>;
  sentiment?: InputMaybe<Scalars['String']>;
};

export type UpdateStudentNoteMutation = {
  __typename?: 'UpdateStudentNoteMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  note?: Maybe<StudentNoteType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateSurveyAssignmentMutation = {
  __typename?: 'UpdateSurveyAssignmentMutation';
  assignment?: Maybe<SurveyAssignmentType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateSurveyMutation = {
  __typename?: 'UpdateSurveyMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  survey?: Maybe<SurveyType>;
};

/** Move a task between statuses; stamps/clears `completed_at` on done. */
export type UpdateTaskStatusMutation = {
  __typename?: 'UpdateTaskStatusMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  task?: Maybe<StaffTaskType>;
};

export type UpdateTeacherApplication = {
  __typename?: 'UpdateTeacherApplication';
  application?: Maybe<ApplicationType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateTeacherWithTypeMutation = {
  __typename?: 'UpdateTeacherWithTypeMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
  teacher?: Maybe<TeacherType>;
};

/**
 * ERP: upload a lesson video (multipart, server-side write to the private
 * bucket — the same path as attachments, diplomas and the Django-admin file
 * widget, so no bucket CORS is required).
 */
export type UploadCareerLessonVideo = {
  __typename?: 'UploadCareerLessonVideo';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lesson?: Maybe<CareerLessonType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UploadLessonVideo = {
  __typename?: 'UploadLessonVideo';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Attach or replace one student's diploma in one language. */
export type UploadStudentDiplomaMutation = {
  __typename?: 'UploadStudentDiplomaMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  diploma?: Maybe<DiplomaType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Pastes an image onto a board (spec 0010 rev.3): the bytes go to the
 * private bucket, the scene keeps only the fileId reference.
 */
export type UploadWhiteboardFileMutation = {
  __typename?: 'UploadWhiteboardFileMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  file?: Maybe<WhiteboardFileType>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpsertCareerLesson = {
  __typename?: 'UpsertCareerLesson';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  lesson?: Maybe<CareerLessonType>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Teacher creates or edits the lesson's homework assignment (backed by
 * materials.Material kind=HOMEWORK; ≤1 per lesson via this path).
 */
export type UpsertHomeworkAssignmentMutation = {
  __typename?: 'UpsertHomeworkAssignmentMutation';
  assignment?: Maybe<HomeworkAssignmentType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpsertVacancy = {
  __typename?: 'UpsertVacancy';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
  vacancy?: Maybe<VacancyType>;
};

/**
 * Тип пользователя (ТЗ 0021, стадия 4 — база больше не `graphql_auth.schema.UserNode`).
 *
 * Четыре поля пакета (`pk`, `archived`, `verified`, `secondary_email`) и его
 * `get_queryset` перенесены сюда ВЕРБАТИМНО и объявлены ПЕРВЫМИ: graphene 2
 * складывает поля обходом reversed-MRO, и в текущем SDL они идут именно перед
 * проектными `activeRole`/`methodistGroupsCount`/… — порядок менять нельзя.
 */
export type UserNode = Node & {
  __typename?: 'UserNode';
  activeRole?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  dateJoined: Scalars['DateTime'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  /** Określa czy użytkownika należy uważać za aktywnego. Odznacz zamiast usuwać konto. */
  isActive: Scalars['Boolean'];
  /** Określa czy użytkownik może zalogować się do panelu administracyjnego. */
  isStaff: Scalars['Boolean'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  lmsAccessBlock?: Maybe<LmsAccessBlockType>;
  methodistGroupsCount?: Maybe<Scalars['Int']>;
  middleName?: Maybe<Scalars['String']>;
  pendingSurveysCount?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['Int']>;
  roles: Array<Scalars['String']>;
  secondaryEmail?: Maybe<Scalars['String']>;
  student?: Maybe<StudentType>;
  teacher?: Maybe<TeacherFilterType>;
  /** Wymagana. 150 lub mniej znaków. Jedynie litery, cyfry i @/./+/-/_. */
  username: Scalars['String'];
  verified?: Maybe<Scalars['Boolean']>;
};

export type UserNodeConnection = {
  __typename?: 'UserNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `UserNode` and its cursor. */
export type UserNodeEdge = {
  __typename?: 'UserNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<UserNode>;
};

export type UserSettingsDeleteMutation = {
  __typename?: 'UserSettingsDeleteMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UserSettingsRolesAddMutation = {
  __typename?: 'UserSettingsRolesAddMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
  user?: Maybe<CustomUserType>;
};

export type UserSettingsUpdateMutation = {
  __typename?: 'UserSettingsUpdateMutation';
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  success?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserNode>;
};

export type UsersSettingsConnection = {
  __typename?: 'UsersSettingsConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UsersSettingsEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `UsersSettings` and its cursor. */
export type UsersSettingsEdge = {
  __typename?: 'UsersSettingsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<UserNode>;
};

export type VacancyInput = {
  applyUrl: Scalars['String'];
  companyName?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  directionIds?: InputMaybe<Array<Scalars['ID']>>;
  employmentType?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['Date']>;
  location?: InputMaybe<Scalars['String']>;
  salaryCurrency?: InputMaybe<Scalars['String']>;
  salaryMax?: InputMaybe<Scalars['Int']>;
  salaryMin?: InputMaybe<Scalars['Int']>;
  seniority?: InputMaybe<Scalars['String']>;
  skillIds?: InputMaybe<Array<Scalars['ID']>>;
  title: Scalars['String'];
  workMode?: InputMaybe<Scalars['String']>;
};

/**
 * A curated job opening. `my_interaction` is set only on the LMS feed
 * (the calling member's SAVED/APPLIED state); it's None on the ERP side.
 * Direction/skill refs are flat light lists.
 */
export type VacancyType = {
  __typename?: 'VacancyType';
  appliedCount?: Maybe<Scalars['Int']>;
  applyUrl: Scalars['String'];
  companyName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  directionIds: Array<Scalars['ID']>;
  directionTitles: Array<Scalars['String']>;
  employmentType: Scalars['String'];
  expiresAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  location: Scalars['String'];
  myInteraction?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  salaryCurrency: Scalars['String'];
  salaryMax?: Maybe<Scalars['Int']>;
  salaryMin?: Maybe<Scalars['Int']>;
  seniority: Scalars['String'];
  skillIds: Array<Scalars['ID']>;
  skillNames: Array<Scalars['String']>;
  status: Scalars['String'];
  title: Scalars['String'];
  workMode: Scalars['String'];
};

export type VerifiedStudent = {
  __typename?: 'VerifiedStudent';
  code: Scalars['String'];
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<Scalars['String']>;
  student?: Maybe<StudentType>;
  user?: Maybe<CustomUserType>;
};

export type VerifiedTeacher = {
  __typename?: 'VerifiedTeacher';
  code: Scalars['String'];
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  message?: Maybe<Scalars['String']>;
  teacher?: Maybe<TeacherType>;
  user?: Maybe<CustomUserType>;
};

/** SDL: {payload: GenericScalar, success, errors}. */
export type VerifyToken = {
  __typename?: 'VerifyToken';
  errors?: Maybe<Scalars['ExpectedErrorType']>;
  payload?: Maybe<Scalars['GenericScalar']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type VideoTrailerType = {
  __typename?: 'VideoTrailerType';
  course?: Maybe<CourseFilterType>;
  description: Scalars['String'];
  id: Scalars['ID'];
  url: Scalars['String'];
};

export type WeeksBudget = {
  __typename?: 'WeeksBudget';
  BYN?: Maybe<Scalars['CustomFloat']>;
  EUR?: Maybe<Scalars['CustomFloat']>;
  PLN?: Maybe<Scalars['CustomFloat']>;
  RUB?: Maybe<Scalars['CustomFloat']>;
  USD?: Maybe<Scalars['CustomFloat']>;
  week?: Maybe<Scalars['Int']>;
};

export type WeeksBudgetInfo = {
  __typename?: 'WeeksBudgetInfo';
  budget?: Maybe<Array<Maybe<WeeksBudget>>>;
  plan?: Maybe<Array<Maybe<WeeksBudget>>>;
};

/**
 * One image of a board, living on the private bucket rather than inside
 * the scene JSON. `url` is a short-TTL presigned link the client fetches and
 * feeds back to excalidraw via addFiles.
 */
export type WhiteboardFileType = {
  __typename?: 'WhiteboardFileType';
  fileId: Scalars['String'];
  mimeType?: Maybe<Scalars['String']>;
  url: Scalars['String'];
};

/**
 * A linked lesson, as shown in the continue-picker. Parent is a
 * GroupLesson instance.
 */
export type WhiteboardLessonRefType = {
  __typename?: 'WhiteboardLessonRefType';
  lessonDate?: Maybe<Scalars['Date']>;
  lessonId: Scalars['ID'];
  lessonName?: Maybe<Scalars['String']>;
  lessonNumber?: Maybe<Scalars['Int']>;
};

/**
 * The school-wide component library (spec 0010 rev.2). `itemsJson` is
 * the LibraryItems ARRAY serialized as a string — same size-guard-before-
 * parse rationale as WhiteboardType.sceneJson.
 */
export type WhiteboardLibraryType = {
  __typename?: 'WhiteboardLibraryType';
  itemsJson: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  version: Scalars['Int'];
};

/** Light shape for lists (continue picker) — no scene payload. */
export type WhiteboardMetaType = {
  __typename?: 'WhiteboardMetaType';
  id: Scalars['ID'];
  lessons: Array<WhiteboardLessonRefType>;
  name: Scalars['String'];
  sceneVersion: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

/** Full shape — the serialized scene plus its S3-hosted images. */
export type WhiteboardType = {
  __typename?: 'WhiteboardType';
  createdAt: Scalars['DateTime'];
  files: Array<WhiteboardFileType>;
  id: Scalars['ID'];
  lessons: Array<WhiteboardLessonRefType>;
  name: Scalars['String'];
  sceneJson: Scalars['String'];
  sceneVersion: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type WorkExperienceType = {
  __typename?: 'WorkExperienceType';
  company: Scalars['String'];
  description: Scalars['String'];
  endMonth?: Maybe<Scalars['Int']>;
  endYear?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isCurrent: Scalars['Boolean'];
  position: Scalars['String'];
  startMonth?: Maybe<Scalars['Int']>;
  startYear?: Maybe<Scalars['Int']>;
};

/**
 * Zero an UNPAID contribution's amount on a transfer-out agreement.
 *
 * `Contribution.save()` re-derives `remainder = amount_foreign` for any
 * unpaid row, so "set remainder=0" is impossible — the legitimate way to
 * drop a contribution to zero is to set its AMOUNT to 0. This is strictly
 * gated:
 *
 * * the agreement must be `terminated` AND `transfer_out` — i.e. wound down
 *   via `ChangeAgreementGroup`, which clones the schedule onto the NEW group,
 *   so the obligation is re-attributed there, not erased; and
 * * the contribution must NOT have a linked Payment — real received money is
 *   never destroyed here. To move already-received cash out of the old group,
 *   use a Chargeback / AccountsPayable carry-out (capped at `paid_amount`),
 *   not this mutation.
 *
 * Every call is audited. The old terminated contract is already excluded from
 * debtors / finance / the calendar by the `terminated_date` cutoff; zeroing
 * additionally makes the old agreement read literally zero, which is what the
 * "обнулить старую группу" workflow asks for.
 */
export type ZeroOutContributionMutation = {
  __typename?: 'ZeroOutContributionMutation';
  contribution?: Maybe<ContributionType>;
  customErrors?: Maybe<Array<Maybe<CustomErrorType>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ZoomAccountConnection = {
  __typename?: 'ZoomAccountConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ZoomAccountEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ZoomAccount` and its cursor. */
export type ZoomAccountEdge = {
  __typename?: 'ZoomAccountEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ZoomAccountType>;
};

export type ZoomAccountType = Node & {
  __typename?: 'ZoomAccountType';
  createdAt: Scalars['DateTime'];
  displayName: Scalars['String'];
  email: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  notes: Scalars['String'];
  syncedAt?: Maybe<Scalars['DateTime']>;
  zoomUserId: Scalars['String'];
};

export type ZoomAccountUsageType = Node & {
  __typename?: 'ZoomAccountUsageType';
  filesCount: Scalars['Int'];
  /** The ID of the object */
  id: Scalars['ID'];
  planRecordingType: Scalars['String'];
  planStorageFreeBytes?: Maybe<Scalars['Float']>;
  planStorageTotalBytes?: Maybe<Scalars['Float']>;
  planStorageUsedBytes?: Maybe<Scalars['Float']>;
  planUsageAvailable: Scalars['Boolean'];
  recordingsCount: Scalars['Int'];
  recordingsSizeBytes?: Maybe<Scalars['Float']>;
  storageUsedPercent?: Maybe<Scalars['Float']>;
  syncedAt: Scalars['DateTime'];
  usersCount: Scalars['Int'];
};

export type ZoomAuditLogConnection = {
  __typename?: 'ZoomAuditLogConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ZoomAuditLogEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ZoomAuditLog` and its cursor. */
export type ZoomAuditLogEdge = {
  __typename?: 'ZoomAuditLogEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ZoomAuditLogType>;
};

export type ZoomAuditLogType = Node & {
  __typename?: 'ZoomAuditLogType';
  action: Scalars['String'];
  createdAt: Scalars['DateTime'];
  details: Scalars['JSONString'];
  /** The ID of the object */
  id: Scalars['ID'];
  targetId: Scalars['Int'];
  targetKind: Scalars['String'];
  user?: Maybe<CustomUserType>;
};

export type ZoomDashboardPipelineCounts = {
  __typename?: 'ZoomDashboardPipelineCounts';
  aiCompleted?: Maybe<Scalars['Int']>;
  aiProcessing?: Maybe<Scalars['Int']>;
  downloading?: Maybe<Scalars['Int']>;
  failed?: Maybe<Scalars['Int']>;
  published?: Maybe<Scalars['Int']>;
  uploaded?: Maybe<Scalars['Int']>;
};

export type ZoomDashboardType = {
  __typename?: 'ZoomDashboardType';
  dateFrom?: Maybe<Scalars['Date']>;
  dateTo?: Maybe<Scalars['Date']>;
  lessonsMatched?: Maybe<Scalars['Int']>;
  lessonsMissing?: Maybe<Scalars['Int']>;
  lessonsSkipped?: Maybe<Scalars['Int']>;
  lessonsTotal?: Maybe<Scalars['Int']>;
  pipeline?: Maybe<ZoomDashboardPipelineCounts>;
  recordingsOrphan?: Maybe<Scalars['Int']>;
  recordingsTotal?: Maybe<Scalars['Int']>;
};

export type ZoomLessonConnection = {
  __typename?: 'ZoomLessonConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ZoomLessonEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ZoomLesson` and its cursor. */
export type ZoomLessonEdge = {
  __typename?: 'ZoomLessonEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<GroupLessonForLmsType>;
};

export type ZoomProcessingLogConnection = {
  __typename?: 'ZoomProcessingLogConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ZoomProcessingLogEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ZoomProcessingLog` and its cursor. */
export type ZoomProcessingLogEdge = {
  __typename?: 'ZoomProcessingLogEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ZoomProcessingLogType>;
};

/** An enumeration. */
export enum ZoomProcessingLogLevel {
  /** Błąd */
  Error = 'ERROR',
  /** Info */
  Info = 'INFO',
  /** Warning */
  Warning = 'WARNING'
}

/** An enumeration. */
export enum ZoomProcessingLogStep {
  /** AI completed */
  AiCompleted = 'AI_COMPLETED',
  /** AI started */
  AiStarted = 'AI_STARTED',
  /** AI waiting (lock busy) */
  AiWaiting = 'AI_WAITING',
  /** Download audio */
  DownloadAudio = 'DOWNLOAD_AUDIO',
  /** Download chat */
  DownloadChat = 'DOWNLOAD_CHAT',
  /** Download transcript */
  DownloadTranscript = 'DOWNLOAD_TRANSCRIPT',
  /** Download video */
  DownloadVideo = 'DOWNLOAD_VIDEO',
  /** Błąd */
  Error = 'ERROR',
  /** Matched */
  Matched = 'MATCHED',
  /** Published */
  Published = 'PUBLISHED',
  /** Status change */
  StatusChange = 'STATUS_CHANGE'
}

export type ZoomProcessingLogType = Node & {
  __typename?: 'ZoomProcessingLogType';
  createdAt: Scalars['DateTime'];
  details: Scalars['JSONString'];
  /** The ID of the object */
  id: Scalars['ID'];
  lesson: GroupLessonType;
  lessonRecording?: Maybe<LessonRecordingType>;
  level: ZoomProcessingLogLevel;
  message: Scalars['String'];
  step: ZoomProcessingLogStep;
};

export type ZoomProcessingLogTypeConnection = {
  __typename?: 'ZoomProcessingLogTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ZoomProcessingLogTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ZoomProcessingLogType` and its cursor. */
export type ZoomProcessingLogTypeEdge = {
  __typename?: 'ZoomProcessingLogTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ZoomProcessingLogType>;
};

export type ZoomRecordingConnection = {
  __typename?: 'ZoomRecordingConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ZoomRecordingEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `ZoomRecording` and its cursor. */
export type ZoomRecordingEdge = {
  __typename?: 'ZoomRecordingEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ZoomRecordingType>;
};

export enum ZoomRecordingStatusEnum {
  Failed = 'FAILED',
  Orphan = 'ORPHAN',
  Processing = 'PROCESSING',
  Ready = 'READY',
  TooShort = 'TOO_SHORT'
}

export type ZoomRecordingType = Node & {
  __typename?: 'ZoomRecordingType';
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedFromZoom: Scalars['Boolean'];
  durationMinutes: Scalars['Int'];
  failureReason?: Maybe<Scalars['String']>;
  files: Scalars['JSONString'];
  /** The ID of the object */
  id: Scalars['ID'];
  isMatched?: Maybe<Scalars['Boolean']>;
  isOrphan?: Maybe<Scalars['Boolean']>;
  isTooShort?: Maybe<Scalars['Boolean']>;
  lessonRecordings?: Maybe<Array<Maybe<LessonRecordingType>>>;
  pk?: Maybe<Scalars['Int']>;
  startTime: Scalars['DateTime'];
  status?: Maybe<ZoomRecordingStatusEnum>;
  syncedAt: Scalars['DateTime'];
  topic: Scalars['String'];
  totalSizeBytes?: Maybe<Scalars['Float']>;
  zoomAccount: ZoomAccountType;
  zoomMeetingId?: Maybe<Scalars['String']>;
  zoomMeetingUuid: Scalars['String'];
};

export type RegisterUserMutationVariables = Exact<{
  firstName: Scalars['String'];
  phone: Scalars['String'];
  email: Scalars['String'];
  recaptchaToken: Scalars['String'];
}>;


export type RegisterUserMutation = { __typename?: 'Mutation', lmsStudentSignUp?: { __typename?: 'StudentSignUpLMSMutation', success?: boolean | null, errors?: any | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null, student?: { __typename?: 'StudentType', user?: { __typename?: 'CustomUserType', firstName: string, email: string, phone?: string | null } | null } | null } | null };

export type CareerProfileFieldsFragment = { __typename?: 'CareerProfileType', id: string, firstName: string, lastName: string, email: string, phone: string, photoUrl?: string | null, city: string, country: string, relocationReady: boolean, workMode: string, workPermit: string, availableFrom?: any | null, seniority: string, desiredPosition: string, desiredSalary: string, githubUrl: string, linkedinUrl: string, portfolioUrl: string, customSkills: Array<string>, isSearchable: boolean, contactsVisible: boolean, completeness: number, skills: Array<{ __typename?: 'StudentSkillType', skillId: string, name: string, category: string, level: number, years?: number | null }>, projects: Array<{ __typename?: 'PortfolioProjectType', id: string, title: string, description: string, role: string, repoUrl: string, demoUrl: string, technologyIds: Array<string>, technologyNames: Array<string> }>, experience: Array<{ __typename?: 'WorkExperienceType', id: string, company: string, position: string, description: string, startYear?: number | null, startMonth?: number | null, endYear?: number | null, endMonth?: number | null, isCurrent: boolean }>, education: Array<{ __typename?: 'EducationType', id: string, institution: string, degree: string, specialization: string, startYear?: number | null, startMonth?: number | null, endYear?: number | null, endMonth?: number | null }>, languages: Array<{ __typename?: 'LanguageSkillType', id: string, language: string, level: string }>, certificates: Array<{ __typename?: 'CertificateType', id: string, title: string, issuer: string, issuedAt?: any | null, url: string, fileUrl?: string | null }>, locales: Array<{ __typename?: 'CvLocaleType', language: string, jobTitle: string, about: string }> };

export type UserFieldsFragment = { __typename?: 'UserNode', id: string, activeRole?: string | null, username: string, firstName: string, middleName?: string | null, lastName: string, email: string, roles: Array<string>, phone?: string | null, methodistGroupsCount?: number | null, pendingSurveysCount?: number | null, lmsAccessBlock?: { __typename?: 'LmsAccessBlockType', isBlocked: boolean, reason?: string | null, overdueAmount?: number | null } | null, student?: { __typename?: 'StudentType', groupsCount?: number | null } | null, teacher?: { __typename?: 'TeacherFilterType', photo?: string | null, groupsCount?: number | null } | null };

export type SendAuthCodeMutationVariables = Exact<{
  email: Scalars['String'];
  scope: Scalars['String'];
}>;


export type SendAuthCodeMutation = { __typename?: 'Mutation', sendLmsAuthEmail?: { __typename?: 'SendAuthenticationCode', success?: boolean | null, createdAt?: any | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null } | null };

export type LoginMutationVariables = Exact<{
  authenticationCode: Scalars['String'];
  email: Scalars['String'];
  scope: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', customLogin?: { __typename?: 'CustomObtainJSONWebToken', success?: boolean | null, token?: string | null, refreshToken?: string | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null, user?: { __typename?: 'UserNode', id: string, activeRole?: string | null, username: string, firstName: string, middleName?: string | null, lastName: string, email: string, roles: Array<string>, phone?: string | null, methodistGroupsCount?: number | null, pendingSurveysCount?: number | null, lmsAccessBlock?: { __typename?: 'LmsAccessBlockType', isBlocked: boolean, reason?: string | null, overdueAmount?: number | null } | null, student?: { __typename?: 'StudentType', groupsCount?: number | null } | null, teacher?: { __typename?: 'TeacherFilterType', photo?: string | null, groupsCount?: number | null } | null } | null } | null };

export type RefreshTokenMutationVariables = Exact<{
  refresh_token: Scalars['String'];
  scope: Scalars['String'];
  activeRole?: InputMaybe<LmsRoles>;
}>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken?: { __typename?: 'CustomRefreshToken', token?: string | null, refreshToken?: string | null, payload?: any | null, errors?: any | null } | null };

export type DemoLoginMutationVariables = Exact<{
  email: Scalars['String'];
  scope: Scalars['String'];
}>;


export type DemoLoginMutation = { __typename?: 'Mutation', demoCustomLogin?: { __typename?: 'CustomObtainJSONWebToken', token?: string | null, refreshToken?: string | null, errors?: any | null } | null };

export type MarkCareerLessonDoneMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  artifactUrl?: InputMaybe<Scalars['String']>;
}>;


export type MarkCareerLessonDoneMutation = { __typename?: 'Mutation', completeCareerLesson?: { __typename?: 'CompleteCareerLesson', success?: boolean | null, lessonsCompleted?: number | null, lessonsTotal?: number | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, message?: string | null, code?: string | null } | null> | null } | null };

export type TouchCareerLessonMutationVariables = Exact<{
  lessonId: Scalars['ID'];
}>;


export type TouchCareerLessonMutation = { __typename?: 'Mutation', markCareerLessonOpened?: { __typename?: 'MarkCareerLessonOpened', success?: boolean | null, openCount?: number | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, message?: string | null, code?: string | null } | null> | null } | null };

export type StoreCareerLessonNotesMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  notes: Scalars['String'];
}>;


export type StoreCareerLessonNotesMutation = { __typename?: 'Mutation', saveCareerLessonNotes?: { __typename?: 'SaveCareerLessonNotes', success?: boolean | null, notes?: string | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, message?: string | null, code?: string | null } | null> | null } | null };

export type ToggleCareerLessonBookmarkMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  isBookmarked: Scalars['Boolean'];
}>;


export type ToggleCareerLessonBookmarkMutation = { __typename?: 'Mutation', setCareerLessonBookmark?: { __typename?: 'SetCareerLessonBookmark', success?: boolean | null, isBookmarked?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, message?: string | null, code?: string | null } | null> | null } | null };

export type GradeCareerQuizMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  answers: Array<CareerQuizAnswerInput> | CareerQuizAnswerInput;
}>;


export type GradeCareerQuizMutation = { __typename?: 'Mutation', submitCareerQuiz?: { __typename?: 'SubmitCareerQuiz', success?: boolean | null, score?: number | null, maxScore?: number | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, message?: string | null, code?: string | null } | null> | null, results?: Array<{ __typename?: 'CareerQuizResultType', questionId: string, correct: boolean, correctIndexes: Array<number> }> | null } | null };

export type SubmitVacancyInteractionMutationVariables = Exact<{
  vacancyId: Scalars['ID'];
  kind: Scalars['String'];
}>;


export type SubmitVacancyInteractionMutation = { __typename?: 'Mutation', markVacancyInteraction?: { __typename?: 'MarkVacancyInteraction', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, message?: string | null, code?: string | null } | null> | null, vacancy?: { __typename?: 'VacancyType', id: string, myInteraction?: string | null } | null } | null };

export type SaveCareerProfileFormMutationVariables = Exact<{
  input: CareerProfileInput;
  photo?: InputMaybe<Scalars['Upload']>;
  clearPhoto?: InputMaybe<Scalars['Boolean']>;
}>;


export type SaveCareerProfileFormMutation = { __typename?: 'Mutation', saveCareerProfile?: { __typename?: 'SaveCareerProfile', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, message?: string | null, code?: string | null } | null> | null, profile?: { __typename?: 'CareerProfileType', id: string, firstName: string, lastName: string, email: string, phone: string, photoUrl?: string | null, city: string, country: string, relocationReady: boolean, workMode: string, workPermit: string, availableFrom?: any | null, seniority: string, desiredPosition: string, desiredSalary: string, githubUrl: string, linkedinUrl: string, portfolioUrl: string, customSkills: Array<string>, isSearchable: boolean, contactsVisible: boolean, completeness: number, skills: Array<{ __typename?: 'StudentSkillType', skillId: string, name: string, category: string, level: number, years?: number | null }>, projects: Array<{ __typename?: 'PortfolioProjectType', id: string, title: string, description: string, role: string, repoUrl: string, demoUrl: string, technologyIds: Array<string>, technologyNames: Array<string> }>, experience: Array<{ __typename?: 'WorkExperienceType', id: string, company: string, position: string, description: string, startYear?: number | null, startMonth?: number | null, endYear?: number | null, endMonth?: number | null, isCurrent: boolean }>, education: Array<{ __typename?: 'EducationType', id: string, institution: string, degree: string, specialization: string, startYear?: number | null, startMonth?: number | null, endYear?: number | null, endMonth?: number | null }>, languages: Array<{ __typename?: 'LanguageSkillType', id: string, language: string, level: string }>, certificates: Array<{ __typename?: 'CertificateType', id: string, title: string, issuer: string, issuedAt?: any | null, url: string, fileUrl?: string | null }>, locales: Array<{ __typename?: 'CvLocaleType', language: string, jobTitle: string, about: string }> } | null } | null };

export type SaveCvLocaleMutationVariables = Exact<{
  language: Scalars['String'];
  jobTitle?: InputMaybe<Scalars['String']>;
  about?: InputMaybe<Scalars['String']>;
}>;


export type SaveCvLocaleMutation = { __typename?: 'Mutation', saveCvText?: { __typename?: 'SaveCvText', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, message?: string | null, code?: string | null } | null> | null, profile?: { __typename?: 'CareerProfileType', id: string, completeness: number } | null } | null };

export type SetProfileSearchableMutationVariables = Exact<{
  isSearchable: Scalars['Boolean'];
  contactsVisible?: InputMaybe<Scalars['Boolean']>;
}>;


export type SetProfileSearchableMutation = { __typename?: 'Mutation', setProfileSearchable?: { __typename?: 'SetProfileSearchable', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, message?: string | null, code?: string | null } | null> | null, profile?: { __typename?: 'CareerProfileType', id: string, isSearchable: boolean, contactsVisible: boolean } | null } | null };

export type SubmitLessonHomeworkMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  githubUrl?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['Upload']>;
}>;


export type SubmitLessonHomeworkMutation = { __typename?: 'Mutation', submitHomework?: { __typename?: 'SubmitHomeworkMutation', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null, submission?: { __typename?: 'MyHomeworkSubmissionType', id: string, githubUrl?: string | null, fileName?: string | null, status: string, attempt: number, submittedAt: any, hwMark?: string | null, teacherComment?: string | null } | null } | null };

export type UpsertLessonHomeworkAssignmentMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  title: Scalars['String'];
  text: Scalars['String'];
  dueDate?: InputMaybe<Scalars['Date']>;
}>;


export type UpsertLessonHomeworkAssignmentMutation = { __typename?: 'Mutation', upsertHomeworkAssignment?: { __typename?: 'UpsertHomeworkAssignmentMutation', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null, assignment?: { __typename?: 'HomeworkAssignmentType', id: string, lessonId: string, title: string, text: string, dueDate?: any | null, updatedAt: any } | null } | null };

export type GradeHomeworkSubmissionMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  studentId: Scalars['ID'];
  hwMark: Scalars['String'];
  comment?: InputMaybe<Scalars['String']>;
  attempt?: InputMaybe<Scalars['Int']>;
}>;


export type GradeHomeworkSubmissionMutation = { __typename?: 'Mutation', gradeHomework?: { __typename?: 'GradeHomeworkMutation', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null, row?: { __typename?: 'HomeworkRosterRowType', studentId: string, hwMark?: string | null, submission?: { __typename?: 'HomeworkSubmissionType', id: string, status: string, teacherComment?: string | null, gradedByName?: string | null } | null } | null } | null };

export type RerunSubmissionAiReviewMutationVariables = Exact<{
  submissionId: Scalars['ID'];
}>;


export type RerunSubmissionAiReviewMutation = { __typename?: 'Mutation', rerunHomeworkAiReview?: { __typename?: 'RerunHomeworkAiReviewMutation', success?: boolean | null, aiReviewStatus?: string | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null } | null };

export type FinishLessonMutationVariables = Exact<{
  groupLessonId: Scalars['Int'];
  comment: Scalars['String'];
  attendances: Array<LmsAttendanceType> | LmsAttendanceType;
}>;


export type FinishLessonMutation = { __typename?: 'Mutation', finishLmsLesson?: { __typename?: 'FinishLmsLessonMutation', success?: boolean | null, errors?: any | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null } | null };

export type UploadLessonVideoMutationVariables = Exact<{
  lessonId: Scalars['Int'];
  videoUrl: Scalars['String'];
}>;


export type UploadLessonVideoMutation = { __typename?: 'Mutation', uploadLessonVideo?: { __typename?: 'UploadLessonVideo', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null } | null };

export type CancelUploadVideoMutationVariables = Exact<{
  lessonId: Scalars['Int'];
}>;


export type CancelUploadVideoMutation = { __typename?: 'Mutation', cancelVideoUpload?: { __typename?: 'CancelVideoUpload', customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, code?: string | null, message?: string | null } | null> | null } | null };

export type AddStudentsMarksMutationVariables = Exact<{
  lessonId: Scalars['Int'];
  taskType: LessonTaskTypeEnum;
  studentsMarks: Array<InputMaybe<LessonMarkInput>> | InputMaybe<LessonMarkInput>;
  date: Scalars['Date'];
}>;


export type AddStudentsMarksMutation = { __typename?: 'Mutation', setStudentsMarks?: { __typename?: 'SetStudentsMarksMutation', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, code?: string | null, message?: string | null } | null> | null } | null };

export type SendSurveyResponseMutationVariables = Exact<{
  assignmentId: Scalars['ID'];
  answers: Array<SurveyAnswerInput> | SurveyAnswerInput;
}>;


export type SendSurveyResponseMutation = { __typename?: 'Mutation', submitSurveyResponse?: { __typename?: 'SubmitSurveyResponseMutation', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null } | null };

export type CreateWhiteboardForLessonMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
}>;


export type CreateWhiteboardForLessonMutation = { __typename?: 'Mutation', createLessonWhiteboard?: { __typename?: 'CreateLessonWhiteboardMutation', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null, whiteboard?: { __typename?: 'WhiteboardType', id: string, name: string, sceneJson: string, sceneVersion: number } | null } | null };

export type LinkWhiteboardToLessonMutationVariables = Exact<{
  lessonId: Scalars['ID'];
  whiteboardId: Scalars['ID'];
}>;


export type LinkWhiteboardToLessonMutation = { __typename?: 'Mutation', linkLessonWhiteboard?: { __typename?: 'LinkLessonWhiteboardMutation', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null, whiteboard?: { __typename?: 'WhiteboardType', id: string, name: string, sceneJson: string, sceneVersion: number } | null } | null };

export type SaveBoardSceneMutationVariables = Exact<{
  whiteboardId: Scalars['ID'];
  sceneJson: Scalars['String'];
  expectedVersion: Scalars['Int'];
}>;


export type SaveBoardSceneMutation = { __typename?: 'Mutation', saveWhiteboardScene?: { __typename?: 'SaveWhiteboardSceneMutation', success?: boolean | null, sceneVersion?: number | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null, whiteboard?: { __typename?: 'WhiteboardType', id: string, sceneVersion: number } | null } | null };

export type RenameBoardMutationVariables = Exact<{
  whiteboardId: Scalars['ID'];
  name: Scalars['String'];
}>;


export type RenameBoardMutation = { __typename?: 'Mutation', renameWhiteboard?: { __typename?: 'RenameWhiteboardMutation', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null, whiteboard?: { __typename?: 'WhiteboardType', id: string, name: string } | null } | null };

export type UnlinkWhiteboardFromLessonMutationVariables = Exact<{
  lessonId: Scalars['ID'];
}>;


export type UnlinkWhiteboardFromLessonMutation = { __typename?: 'Mutation', unlinkLessonWhiteboard?: { __typename?: 'UnlinkLessonWhiteboardMutation', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null } | null };

export type UploadBoardImageMutationVariables = Exact<{
  whiteboardId: Scalars['ID'];
  fileId: Scalars['String'];
  mimeType?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
}>;


export type UploadBoardImageMutation = { __typename?: 'Mutation', uploadWhiteboardFile?: { __typename?: 'UploadWhiteboardFileMutation', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null, file?: { __typename?: 'WhiteboardFileType', fileId: string, mimeType?: string | null, url: string } | null } | null };

export type SaveSchoolLibraryMutationVariables = Exact<{
  itemsJson: Scalars['String'];
  expectedVersion: Scalars['Int'];
}>;


export type SaveSchoolLibraryMutation = { __typename?: 'Mutation', saveWhiteboardLibrary?: { __typename?: 'SaveWhiteboardLibraryMutation', success?: boolean | null, version?: number | null, customErrors?: Array<{ __typename?: 'CustomErrorType', code?: string | null, field?: string | null, message?: string | null } | null> | null } | null };

export type JoinLessonNowMutationVariables = Exact<{
  groupLessonId: Scalars['Int'];
}>;


export type JoinLessonNowMutation = { __typename?: 'Mutation', lmsJoinLesson?: { __typename?: 'LmsJoinLesson', success?: boolean | null, redirectUrl?: string | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, code?: string | null, message?: string | null } | null> | null } | null };

export type PutTodayLessonLinkMutationVariables = Exact<{
  groupId: Scalars['Int'];
  joinUrl: Scalars['String'];
}>;


export type PutTodayLessonLinkMutation = { __typename?: 'Mutation', lmsSetTodayLessonLink?: { __typename?: 'LmsSetTodayLessonLink', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, code?: string | null, message?: string | null } | null> | null } | null };

export type DropTodayLessonLinkMutationVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type DropTodayLessonLinkMutation = { __typename?: 'Mutation', lmsClearTodayLessonLink?: { __typename?: 'LmsClearTodayLessonLink', success?: boolean | null, customErrors?: Array<{ __typename?: 'CustomErrorType', field?: string | null, code?: string | null, message?: string | null } | null> | null } | null };

export type StudentGroupAttendanceQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type StudentGroupAttendanceQuery = { __typename?: 'Query', myAttendance: Array<{ __typename?: 'MyLessonAttendanceType', lessonId: string, lessonName: string, lessonNumber: number, date?: any | null, attendance?: boolean | null }> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'UserNode', id: string, activeRole?: string | null, username: string, firstName: string, middleName?: string | null, lastName: string, email: string, roles: Array<string>, phone?: string | null, methodistGroupsCount?: number | null, pendingSurveysCount?: number | null, lmsAccessBlock?: { __typename?: 'LmsAccessBlockType', isBlocked: boolean, reason?: string | null, overdueAmount?: number | null } | null, student?: { __typename?: 'StudentType', groupsCount?: number | null } | null, teacher?: { __typename?: 'TeacherFilterType', photo?: string | null, groupsCount?: number | null } | null } | null };

export type MyCareerCenterInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCareerCenterInfoQuery = { __typename?: 'Query', myCareerCenter?: { __typename?: 'CareerCenterType', memberId: string, status: string, directionTitle?: string | null, enrolledAt: any, lessonsCompleted: number, lessonsTotal: number } | null };

export type CareerLessonsListQueryVariables = Exact<{ [key: string]: never; }>;


export type CareerLessonsListQuery = { __typename?: 'Query', careerLessons: Array<{ __typename?: 'CareerLessonType', id: string, order: number, title: string, summary: string, durationMin?: number | null, completionKind: string, isUnlocked: boolean, isCompleted: boolean, completedAt?: any | null, isOpened: boolean, isBookmarked: boolean }> };

export type CareerLessonDetailQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CareerLessonDetailQuery = { __typename?: 'Query', careerLesson?: { __typename?: 'CareerLessonType', id: string, order: number, title: string, summary: string, durationMin?: number | null, completionKind: string, artifactHint: string, isUnlocked: boolean, isCompleted: boolean, completedAt?: any | null, isOpened: boolean, openedAt?: any | null, openCount: number, myNotes: string, isBookmarked: boolean, content?: string | null, videoUrl?: string | null, attachments: Array<{ __typename?: 'CareerLessonAttachmentType', id: string, originalName: string, contentType: string, sizeBytes: number, url?: string | null }>, quizQuestions: Array<{ __typename?: 'CareerQuizQuestionType', id: string, order: number, text: string, options: Array<string>, correctIndexes: Array<number> }> } | null };

export type MyCareerVacanciesQueryVariables = Exact<{
  directionId?: InputMaybe<Scalars['ID']>;
  skillId?: InputMaybe<Scalars['ID']>;
  workMode?: InputMaybe<Scalars['String']>;
  seniority?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  savedOnly?: InputMaybe<Scalars['Boolean']>;
}>;


export type MyCareerVacanciesQuery = { __typename?: 'Query', careerVacancies: Array<{ __typename?: 'VacancyType', id: string, title: string, companyName: string, applyUrl: string, location: string, workMode: string, seniority: string, employmentType: string, salaryMin?: number | null, salaryMax?: number | null, salaryCurrency: string, description: string, publishedAt?: any | null, expiresAt?: any | null, directionIds: Array<string>, directionTitles: Array<string>, skillNames: Array<string>, myInteraction?: string | null }> };

export type MyCareerProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type MyCareerProfileQuery = { __typename?: 'Query', myCareerProfile?: { __typename?: 'CareerProfileType', id: string, firstName: string, lastName: string, email: string, phone: string, photoUrl?: string | null, city: string, country: string, relocationReady: boolean, workMode: string, workPermit: string, availableFrom?: any | null, seniority: string, desiredPosition: string, desiredSalary: string, githubUrl: string, linkedinUrl: string, portfolioUrl: string, customSkills: Array<string>, isSearchable: boolean, contactsVisible: boolean, completeness: number, skills: Array<{ __typename?: 'StudentSkillType', skillId: string, name: string, category: string, level: number, years?: number | null }>, projects: Array<{ __typename?: 'PortfolioProjectType', id: string, title: string, description: string, role: string, repoUrl: string, demoUrl: string, technologyIds: Array<string>, technologyNames: Array<string> }>, experience: Array<{ __typename?: 'WorkExperienceType', id: string, company: string, position: string, description: string, startYear?: number | null, startMonth?: number | null, endYear?: number | null, endMonth?: number | null, isCurrent: boolean }>, education: Array<{ __typename?: 'EducationType', id: string, institution: string, degree: string, specialization: string, startYear?: number | null, startMonth?: number | null, endYear?: number | null, endMonth?: number | null }>, languages: Array<{ __typename?: 'LanguageSkillType', id: string, language: string, level: string }>, certificates: Array<{ __typename?: 'CertificateType', id: string, title: string, issuer: string, issuedAt?: any | null, url: string, fileUrl?: string | null }>, locales: Array<{ __typename?: 'CvLocaleType', language: string, jobTitle: string, about: string }> } | null };

export type CareerSkillsSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
}>;


export type CareerSkillsSearchQuery = { __typename?: 'Query', careerSkills: Array<{ __typename?: 'SkillType', id: string, name: string, category: string }> };

export type AllCoursesQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
  finished?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  courseId?: InputMaybe<Scalars['ID']>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  lessonDate?: InputMaybe<Scalars['Date']>;
}>;


export type AllCoursesQuery = { __typename?: 'Query', allGroupsForLms?: { __typename?: 'UnionGroupConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'UnionGroupEdge', cursor: string, node?: { __typename?: 'GroupType', id: string, passedLessonsCount?: number | null, lessonsCount?: number | null, studentsCount?: number | null, name: string, statusFinished?: boolean | null, datetimeNextLesson?: any | null, course: { __typename?: 'CourseFilterType', id: string, courseIcon?: string | null, educationForm?: string | null, name: string } } | { __typename?: 'MethodistGroupType', id: string, passedLessonsCount?: number | null, lessonsCount?: number | null, studentsCount?: number | null, name: string, statusFinished?: boolean | null, datetimeNextLesson?: any | null, course: { __typename?: 'CourseFilterType', id: string, courseIcon?: string | null, educationForm?: string | null, name: string } } | { __typename?: 'StudentGroupType', id: string, passedLessonsCount?: number | null, lessonsCount?: number | null, studentsCount?: number | null, name: string, statusFinished?: boolean | null, datetimeNextLesson?: any | null, course: { __typename?: 'CourseFilterType', id: string, courseIcon?: string | null, educationForm?: string | null, name: string } } | null } | null> } | null };

export type MethodistGroupOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type MethodistGroupOptionsQuery = { __typename?: 'Query', allGroupsForLms?: { __typename?: 'UnionGroupConnection', edges: Array<{ __typename?: 'UnionGroupEdge', node?: { __typename?: 'GroupType' } | { __typename?: 'MethodistGroupType', id: string, name: string, course: { __typename?: 'CourseFilterType', id: string, name: string } } | { __typename?: 'StudentGroupType' } | null } | null> } | null };

export type GroupForLmsQueryVariables = Exact<{
  groupId?: InputMaybe<Scalars['ID']>;
}>;


export type GroupForLmsQuery = { __typename?: 'Query', groupForLms?: { __typename?: 'GroupType', id: string, statusFinished?: boolean | null, isFree: boolean, passedLessonsCount?: number | null, lessonsCount?: number | null, studentsCount?: number | null, name: string, course: { __typename?: 'CourseFilterType', id: string, courseIcon?: string | null, name: string }, lessons?: Array<{ __typename?: 'GroupLessonType', id: string, name: string, date: any, index?: number | null, needToFinish?: boolean | null }> | null } | { __typename?: 'MethodistGroupType', id: string, statusFinished?: boolean | null, isFree: boolean, passedLessonsCount?: number | null, lessonsCount?: number | null, studentsCount?: number | null, name: string, course: { __typename?: 'CourseFilterType', id: string, courseIcon?: string | null, name: string }, lessons?: Array<{ __typename?: 'GroupLessonType', id: string, name: string, date: any, index?: number | null }> | null } | { __typename?: 'StudentGroupType', id: string, statusFinished?: boolean | null, isFree: boolean, passedLessonsCount?: number | null, lessonsCount?: number | null, studentsCount?: number | null, name: string, course: { __typename?: 'CourseFilterType', id: string, courseIcon?: string | null, name: string }, lessons?: Array<{ __typename?: 'GroupLessonType', id: string, name: string, date: any, index?: number | null }> | null } | null };

export type StudentDiplomasQueryVariables = Exact<{ [key: string]: never; }>;


export type StudentDiplomasQuery = { __typename?: 'Query', myDiplomas: Array<{ __typename?: 'MyDiplomaType', id: string, language: DiplomaLanguageEnum, groupName?: string | null, courseName?: string | null, originalName?: string | null, sizeBytes?: number | null, issuedAt?: any | null }> };

export type StudentDiplomaDownloadUrlQueryVariables = Exact<{
  diplomaId: Scalars['ID'];
}>;


export type StudentDiplomaDownloadUrlQuery = { __typename?: 'Query', myDiplomaDownloadUrl?: { __typename?: 'DiplomaDownloadUrlType', url: string, expiresAt: any } | null };

export type MyLessonHomeworkQueryVariables = Exact<{
  lessonId: Scalars['ID'];
}>;


export type MyLessonHomeworkQuery = { __typename?: 'Query', myLessonHomework?: { __typename?: 'HomeworkAssignmentForStudentType', id: string, lessonId: string, hasTeacherAssignment: boolean, title?: string | null, text?: string | null, dueDate?: any | null, canSubmit: boolean, mySubmission?: { __typename?: 'MyHomeworkSubmissionType', id: string, githubUrl?: string | null, fileName?: string | null, status: string, attempt: number, submittedAt: any, hwMark?: string | null, teacherComment?: string | null } | null } | null };

export type LmsLessonHomeworkQueryVariables = Exact<{
  lessonId: Scalars['ID'];
}>;


export type LmsLessonHomeworkQuery = { __typename?: 'Query', lessonHomework?: { __typename?: 'HomeworkAssignmentType', id: string, lessonId: string, title: string, text: string, dueDate?: any | null, updatedAt: any } | null };

export type LmsHomeworkRosterQueryVariables = Exact<{
  lessonId: Scalars['ID'];
}>;


export type LmsHomeworkRosterQuery = { __typename?: 'Query', homeworkAiEnabled: boolean, homeworkRoster: Array<{ __typename?: 'HomeworkRosterRowType', studentId: string, studentName: string, hwMark?: string | null, submission?: { __typename?: 'HomeworkSubmissionType', id: string, githubUrl?: string | null, fileName?: string | null, fileSizeBytes?: number | null, status: string, attempt: number, submittedAt: any, teacherComment?: string | null, gradedAt?: any | null, gradedByName?: string | null, aiReview?: { __typename?: 'HomeworkAiReviewType', status: string, aiScore?: number | null, aiSummary?: string | null, aiJustification?: string | null, suspiciousContent: boolean, suspicionNotes?: string | null, errorMessage?: string | null, analyzedAt?: any | null, truncatedBasis?: boolean | null, filesUsedCount?: number | null, assignmentSource?: string | null } | null } | null }> };

export type LmsHomeworkSubmissionDownloadUrlQueryVariables = Exact<{
  submissionId: Scalars['ID'];
}>;


export type LmsHomeworkSubmissionDownloadUrlQuery = { __typename?: 'Query', homeworkSubmissionDownloadUrl?: string | null };

export type StudentInvoicesQueryVariables = Exact<{ [key: string]: never; }>;


export type StudentInvoicesQuery = { __typename?: 'Query', myInvoices?: Array<{ __typename?: 'StudentInvoiceType', fakturowniaId?: string | null, number?: string | null, status?: string | null, issueDate?: any | null, paymentTo?: any | null, currency?: string | null, priceGross?: number | null, paid?: number | null, outstanding?: number | null, isOverdue?: boolean | null, daysOverdue?: number | null, viewUrl?: string | null, paymentUrl?: string | null } | null> | null };

export type LessonForLmsQueryVariables = Exact<{
  groupLessonId?: InputMaybe<Scalars['ID']>;
}>;


export type LessonForLmsQuery = { __typename?: 'Query', lessonForLms?: { __typename?: 'GroupLessonForLMSType', id: string, name: string, date: any, index?: number | null, lmsDescription?: string | null, startTime: any, endTime: any, finished: boolean, needToFinish?: boolean | null, comment?: string | null, video?: string | null, taskTypes: Array<string>, hasTeacherAttachment?: boolean | null, whiteboardId?: string | null, homeworkAssignmentId?: string | null, homeworkAvailable?: boolean | null, hasJoinLink?: boolean | null, linkOverrideActive?: boolean | null } | { __typename?: 'MethodistLessonType', id: string, name: string, date: any, index?: number | null, lmsDescription?: string | null, startTime: any, endTime: any, finished: boolean, comment?: string | null, video?: string | null, hasTeacherAttachment?: boolean | null, hasStudentAttachment?: boolean | null, whiteboardId?: string | null, homeworkAssignmentId?: string | null, homeworkAvailable?: boolean | null, hasJoinLink?: boolean | null, linkOverrideActive?: boolean | null } | { __typename?: 'StudentLessonType', id: string, name: string, date: any, index?: number | null, lmsDescription?: string | null, startTime: any, endTime: any, finished: boolean, comment?: string | null, video?: string | null, hasStudentMarks?: boolean | null, hasStudentAttachment?: boolean | null, whiteboardId?: string | null, homeworkAssignmentId?: string | null, homeworkAvailable?: boolean | null, hasJoinLink?: boolean | null, linkOverrideActive?: boolean | null } | null };

export type GroupLessonAttendanceForLmsQueryVariables = Exact<{
  groupLessonId?: InputMaybe<Scalars['ID']>;
}>;


export type GroupLessonAttendanceForLmsQuery = { __typename?: 'Query', groupLessonAttendanceForLms?: Array<{ __typename?: 'LessonAttendancesType', id: string, attendance?: boolean | null, student: { __typename?: 'StudentType', id: string, user?: { __typename?: 'CustomUserType', id: string, firstName: string, lastName: string } | null } } | null> | null };

export type GroupLessonAttachmentForLmsQueryVariables = Exact<{
  groupLessonId?: InputMaybe<Scalars['ID']>;
  attachmentRole?: InputMaybe<Scalars['String']>;
}>;


export type GroupLessonAttachmentForLmsQuery = { __typename?: 'Query', groupLessonAttachmentForLms?: Array<{ __typename?: 'LessonAttachmentsForLMSType', id: string, title: string, file: string } | null> | null };

export type GroupLessonAttachmentQueryVariables = Exact<{
  attachmentId?: InputMaybe<Scalars['ID']>;
  attachmentRole?: InputMaybe<Scalars['String']>;
}>;


export type GroupLessonAttachmentQuery = { __typename?: 'Query', groupLessonAttachment?: { __typename?: 'LessonAttachmentsType', id?: string | null, title?: string | null, file?: string | null } | null };

export type StudentsMarksQueryVariables = Exact<{
  lessonsId: Scalars['ID'];
  lessonIdForMarks: Scalars['String'];
  taskType: Scalars['String'];
}>;


export type StudentsMarksQuery = { __typename?: 'Query', studentsMarks?: { __typename?: 'StudentConnection', edges: Array<{ __typename?: 'StudentEdge', node?: { __typename?: 'StudentType', id: string, user?: { __typename?: 'CustomUserType', id: string, firstName: string, lastName: string, student?: { __typename?: 'StudentType', id: string } | null } | null, marks: { __typename?: 'StudentsMarkTypeConnection', edges: Array<{ __typename?: 'StudentsMarkTypeEdge', node?: { __typename?: 'StudentsMarkType', id: string, date: any, mark?: number | null, hwMark?: StudentsMarkHwMark | null } | null } | null> } } | null } | null> } | null };

export type StudentMarksQueryVariables = Exact<{
  lessonsId: Scalars['ID'];
}>;


export type StudentMarksQuery = { __typename?: 'Query', studentMarks?: { __typename?: 'StudentsMarkConnection', edges: Array<{ __typename?: 'StudentsMarkEdge', node?: { __typename?: 'StudentsMarkType', mark?: number | null, hwMark?: StudentsMarkHwMark | null, date: any, taskType?: StudentsMarkTaskType | null } | null } | null> } | null };

export type StudentPendingSurveysQueryVariables = Exact<{ [key: string]: never; }>;


export type StudentPendingSurveysQuery = { __typename?: 'Query', mySurveys: Array<{ __typename?: 'PendingSurveyType', assignmentId: string, title: string, description: string, groupName: string, lessonName: string, lessonNumber: number, teacherName?: string | null, questions: Array<{ __typename?: 'SurveyQuestionForStudentType', id: string, number: number, text: string, questionType: string, required: boolean, options: Array<string> }> }> };

export type GetLessonWhiteboardQueryVariables = Exact<{
  lessonId: Scalars['ID'];
}>;


export type GetLessonWhiteboardQuery = { __typename?: 'Query', lessonWhiteboard?: { __typename?: 'WhiteboardType', id: string, name: string, sceneJson: string, sceneVersion: number, createdAt: any, updatedAt: any, lessons: Array<{ __typename?: 'WhiteboardLessonRefType', lessonId: string, lessonName?: string | null, lessonNumber?: number | null, lessonDate?: any | null }>, files: Array<{ __typename?: 'WhiteboardFileType', fileId: string, mimeType?: string | null, url: string }> } | null };

export type GetWhiteboardLibraryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWhiteboardLibraryQuery = { __typename?: 'Query', whiteboardLibrary?: { __typename?: 'WhiteboardLibraryType', itemsJson: string, version: number } | null };

export type GetGroupWhiteboardsQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type GetGroupWhiteboardsQuery = { __typename?: 'Query', groupWhiteboards: Array<{ __typename?: 'WhiteboardMetaType', id: string, name: string, sceneVersion: number, updatedAt: any, lessons: Array<{ __typename?: 'WhiteboardLessonRefType', lessonId: string, lessonName?: string | null, lessonNumber?: number | null, lessonDate?: any | null }> }> };

export type LessonJoinHintsQueryVariables = Exact<{
  groupLessonId: Scalars['Int'];
}>;


export type LessonJoinHintsQuery = { __typename?: 'Query', lmsLessonJoinClicks?: Array<{ __typename?: 'LmsLessonJoinClickType', studentId: number, studentName: string, clickedAt: any } | null> | null };

export const CareerProfileFieldsFragmentDoc = gql`
    fragment CareerProfileFields on CareerProfileType {
  id
  firstName
  lastName
  email
  phone
  photoUrl
  city
  country
  relocationReady
  workMode
  workPermit
  availableFrom
  seniority
  desiredPosition
  desiredSalary
  githubUrl
  linkedinUrl
  portfolioUrl
  customSkills
  isSearchable
  contactsVisible
  completeness
  skills {
    skillId
    name
    category
    level
    years
  }
  projects {
    id
    title
    description
    role
    repoUrl
    demoUrl
    technologyIds
    technologyNames
  }
  experience {
    id
    company
    position
    description
    startYear
    startMonth
    endYear
    endMonth
    isCurrent
  }
  education {
    id
    institution
    degree
    specialization
    startYear
    startMonth
    endYear
    endMonth
  }
  languages {
    id
    language
    level
  }
  certificates {
    id
    title
    issuer
    issuedAt
    url
    fileUrl
  }
  locales {
    language
    jobTitle
    about
  }
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on UserNode {
  id
  activeRole
  username
  firstName
  middleName
  lastName
  email
  roles
  phone
  methodistGroupsCount
  pendingSurveysCount
  lmsAccessBlock {
    isBlocked
    reason
    overdueAmount
  }
  student {
    groupsCount
  }
  teacher {
    photo
    groupsCount
  }
}
    `;
export const RegisterUserDocument = gql`
    mutation RegisterUser($firstName: String!, $phone: String!, $email: String!, $recaptchaToken: String!) {
  lmsStudentSignUp(
    studentInput: {firstName: $firstName, phone: $phone, email: $email, recaptchaToken: $recaptchaToken}
  ) {
    success
    errors
    customErrors {
      code
      field
      message
    }
    student {
      user {
        firstName
        email
        phone
      }
    }
  }
}
    `;
export type RegisterUserMutationFn = Apollo.MutationFunction<RegisterUserMutation, RegisterUserMutationVariables>;

/**
 * __useRegisterUserMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserMutation, { data, loading, error }] = useRegisterUserMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      phone: // value for 'phone'
 *      email: // value for 'email'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function useRegisterUserMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserMutation, RegisterUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserMutation, RegisterUserMutationVariables>(RegisterUserDocument, options);
      }
export type RegisterUserMutationHookResult = ReturnType<typeof useRegisterUserMutation>;
export type RegisterUserMutationResult = Apollo.MutationResult<RegisterUserMutation>;
export type RegisterUserMutationOptions = Apollo.BaseMutationOptions<RegisterUserMutation, RegisterUserMutationVariables>;
export const SendAuthCodeDocument = gql`
    mutation sendAuthCode($email: String!, $scope: String!) {
  sendLmsAuthEmail(authenticationInput: {email: $email, scope: $scope}) {
    success
    createdAt
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type SendAuthCodeMutationFn = Apollo.MutationFunction<SendAuthCodeMutation, SendAuthCodeMutationVariables>;

/**
 * __useSendAuthCodeMutation__
 *
 * To run a mutation, you first call `useSendAuthCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendAuthCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendAuthCodeMutation, { data, loading, error }] = useSendAuthCodeMutation({
 *   variables: {
 *      email: // value for 'email'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useSendAuthCodeMutation(baseOptions?: Apollo.MutationHookOptions<SendAuthCodeMutation, SendAuthCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendAuthCodeMutation, SendAuthCodeMutationVariables>(SendAuthCodeDocument, options);
      }
export type SendAuthCodeMutationHookResult = ReturnType<typeof useSendAuthCodeMutation>;
export type SendAuthCodeMutationResult = Apollo.MutationResult<SendAuthCodeMutation>;
export type SendAuthCodeMutationOptions = Apollo.BaseMutationOptions<SendAuthCodeMutation, SendAuthCodeMutationVariables>;
export const LoginDocument = gql`
    mutation login($authenticationCode: String!, $email: String!, $scope: String!) {
  customLogin(
    authenticationCode: $authenticationCode
    email: $email
    scope: $scope
  ) {
    success
    token
    refreshToken
    customErrors {
      code
      field
      message
    }
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      authenticationCode: // value for 'authenticationCode'
 *      email: // value for 'email'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation refreshToken($refresh_token: String!, $scope: String!, $activeRole: LmsRoles) {
  refreshToken(
    refreshToken: $refresh_token
    scope: $scope
    activeRole: $activeRole
  ) {
    token
    refreshToken
    payload
    errors
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      refresh_token: // value for 'refresh_token'
 *      scope: // value for 'scope'
 *      activeRole: // value for 'activeRole'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const DemoLoginDocument = gql`
    mutation demoLogin($email: String!, $scope: String!) {
  demoCustomLogin(email: $email, scope: $scope) {
    token
    refreshToken
    errors
  }
}
    `;
export type DemoLoginMutationFn = Apollo.MutationFunction<DemoLoginMutation, DemoLoginMutationVariables>;

/**
 * __useDemoLoginMutation__
 *
 * To run a mutation, you first call `useDemoLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDemoLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [demoLoginMutation, { data, loading, error }] = useDemoLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useDemoLoginMutation(baseOptions?: Apollo.MutationHookOptions<DemoLoginMutation, DemoLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DemoLoginMutation, DemoLoginMutationVariables>(DemoLoginDocument, options);
      }
export type DemoLoginMutationHookResult = ReturnType<typeof useDemoLoginMutation>;
export type DemoLoginMutationResult = Apollo.MutationResult<DemoLoginMutation>;
export type DemoLoginMutationOptions = Apollo.BaseMutationOptions<DemoLoginMutation, DemoLoginMutationVariables>;
export const MarkCareerLessonDoneDocument = gql`
    mutation MarkCareerLessonDone($lessonId: ID!, $artifactUrl: String) {
  completeCareerLesson(lessonId: $lessonId, artifactUrl: $artifactUrl) {
    success
    customErrors {
      field
      message
      code
    }
    lessonsCompleted
    lessonsTotal
  }
}
    `;
export type MarkCareerLessonDoneMutationFn = Apollo.MutationFunction<MarkCareerLessonDoneMutation, MarkCareerLessonDoneMutationVariables>;

/**
 * __useMarkCareerLessonDoneMutation__
 *
 * To run a mutation, you first call `useMarkCareerLessonDoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCareerLessonDoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCareerLessonDoneMutation, { data, loading, error }] = useMarkCareerLessonDoneMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      artifactUrl: // value for 'artifactUrl'
 *   },
 * });
 */
export function useMarkCareerLessonDoneMutation(baseOptions?: Apollo.MutationHookOptions<MarkCareerLessonDoneMutation, MarkCareerLessonDoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkCareerLessonDoneMutation, MarkCareerLessonDoneMutationVariables>(MarkCareerLessonDoneDocument, options);
      }
export type MarkCareerLessonDoneMutationHookResult = ReturnType<typeof useMarkCareerLessonDoneMutation>;
export type MarkCareerLessonDoneMutationResult = Apollo.MutationResult<MarkCareerLessonDoneMutation>;
export type MarkCareerLessonDoneMutationOptions = Apollo.BaseMutationOptions<MarkCareerLessonDoneMutation, MarkCareerLessonDoneMutationVariables>;
export const TouchCareerLessonDocument = gql`
    mutation TouchCareerLesson($lessonId: ID!) {
  markCareerLessonOpened(lessonId: $lessonId) {
    success
    customErrors {
      field
      message
      code
    }
    openCount
  }
}
    `;
export type TouchCareerLessonMutationFn = Apollo.MutationFunction<TouchCareerLessonMutation, TouchCareerLessonMutationVariables>;

/**
 * __useTouchCareerLessonMutation__
 *
 * To run a mutation, you first call `useTouchCareerLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTouchCareerLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [touchCareerLessonMutation, { data, loading, error }] = useTouchCareerLessonMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useTouchCareerLessonMutation(baseOptions?: Apollo.MutationHookOptions<TouchCareerLessonMutation, TouchCareerLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TouchCareerLessonMutation, TouchCareerLessonMutationVariables>(TouchCareerLessonDocument, options);
      }
export type TouchCareerLessonMutationHookResult = ReturnType<typeof useTouchCareerLessonMutation>;
export type TouchCareerLessonMutationResult = Apollo.MutationResult<TouchCareerLessonMutation>;
export type TouchCareerLessonMutationOptions = Apollo.BaseMutationOptions<TouchCareerLessonMutation, TouchCareerLessonMutationVariables>;
export const StoreCareerLessonNotesDocument = gql`
    mutation StoreCareerLessonNotes($lessonId: ID!, $notes: String!) {
  saveCareerLessonNotes(lessonId: $lessonId, notes: $notes) {
    success
    customErrors {
      field
      message
      code
    }
    notes
  }
}
    `;
export type StoreCareerLessonNotesMutationFn = Apollo.MutationFunction<StoreCareerLessonNotesMutation, StoreCareerLessonNotesMutationVariables>;

/**
 * __useStoreCareerLessonNotesMutation__
 *
 * To run a mutation, you first call `useStoreCareerLessonNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreCareerLessonNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeCareerLessonNotesMutation, { data, loading, error }] = useStoreCareerLessonNotesMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useStoreCareerLessonNotesMutation(baseOptions?: Apollo.MutationHookOptions<StoreCareerLessonNotesMutation, StoreCareerLessonNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoreCareerLessonNotesMutation, StoreCareerLessonNotesMutationVariables>(StoreCareerLessonNotesDocument, options);
      }
export type StoreCareerLessonNotesMutationHookResult = ReturnType<typeof useStoreCareerLessonNotesMutation>;
export type StoreCareerLessonNotesMutationResult = Apollo.MutationResult<StoreCareerLessonNotesMutation>;
export type StoreCareerLessonNotesMutationOptions = Apollo.BaseMutationOptions<StoreCareerLessonNotesMutation, StoreCareerLessonNotesMutationVariables>;
export const ToggleCareerLessonBookmarkDocument = gql`
    mutation ToggleCareerLessonBookmark($lessonId: ID!, $isBookmarked: Boolean!) {
  setCareerLessonBookmark(lessonId: $lessonId, isBookmarked: $isBookmarked) {
    success
    customErrors {
      field
      message
      code
    }
    isBookmarked
  }
}
    `;
export type ToggleCareerLessonBookmarkMutationFn = Apollo.MutationFunction<ToggleCareerLessonBookmarkMutation, ToggleCareerLessonBookmarkMutationVariables>;

/**
 * __useToggleCareerLessonBookmarkMutation__
 *
 * To run a mutation, you first call `useToggleCareerLessonBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCareerLessonBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCareerLessonBookmarkMutation, { data, loading, error }] = useToggleCareerLessonBookmarkMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      isBookmarked: // value for 'isBookmarked'
 *   },
 * });
 */
export function useToggleCareerLessonBookmarkMutation(baseOptions?: Apollo.MutationHookOptions<ToggleCareerLessonBookmarkMutation, ToggleCareerLessonBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleCareerLessonBookmarkMutation, ToggleCareerLessonBookmarkMutationVariables>(ToggleCareerLessonBookmarkDocument, options);
      }
export type ToggleCareerLessonBookmarkMutationHookResult = ReturnType<typeof useToggleCareerLessonBookmarkMutation>;
export type ToggleCareerLessonBookmarkMutationResult = Apollo.MutationResult<ToggleCareerLessonBookmarkMutation>;
export type ToggleCareerLessonBookmarkMutationOptions = Apollo.BaseMutationOptions<ToggleCareerLessonBookmarkMutation, ToggleCareerLessonBookmarkMutationVariables>;
export const GradeCareerQuizDocument = gql`
    mutation GradeCareerQuiz($lessonId: ID!, $answers: [CareerQuizAnswerInput!]!) {
  submitCareerQuiz(lessonId: $lessonId, answers: $answers) {
    success
    customErrors {
      field
      message
      code
    }
    score
    maxScore
    results {
      questionId
      correct
      correctIndexes
    }
  }
}
    `;
export type GradeCareerQuizMutationFn = Apollo.MutationFunction<GradeCareerQuizMutation, GradeCareerQuizMutationVariables>;

/**
 * __useGradeCareerQuizMutation__
 *
 * To run a mutation, you first call `useGradeCareerQuizMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGradeCareerQuizMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gradeCareerQuizMutation, { data, loading, error }] = useGradeCareerQuizMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useGradeCareerQuizMutation(baseOptions?: Apollo.MutationHookOptions<GradeCareerQuizMutation, GradeCareerQuizMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GradeCareerQuizMutation, GradeCareerQuizMutationVariables>(GradeCareerQuizDocument, options);
      }
export type GradeCareerQuizMutationHookResult = ReturnType<typeof useGradeCareerQuizMutation>;
export type GradeCareerQuizMutationResult = Apollo.MutationResult<GradeCareerQuizMutation>;
export type GradeCareerQuizMutationOptions = Apollo.BaseMutationOptions<GradeCareerQuizMutation, GradeCareerQuizMutationVariables>;
export const SubmitVacancyInteractionDocument = gql`
    mutation SubmitVacancyInteraction($vacancyId: ID!, $kind: String!) {
  markVacancyInteraction(vacancyId: $vacancyId, kind: $kind) {
    success
    customErrors {
      field
      message
      code
    }
    vacancy {
      id
      myInteraction
    }
  }
}
    `;
export type SubmitVacancyInteractionMutationFn = Apollo.MutationFunction<SubmitVacancyInteractionMutation, SubmitVacancyInteractionMutationVariables>;

/**
 * __useSubmitVacancyInteractionMutation__
 *
 * To run a mutation, you first call `useSubmitVacancyInteractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitVacancyInteractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitVacancyInteractionMutation, { data, loading, error }] = useSubmitVacancyInteractionMutation({
 *   variables: {
 *      vacancyId: // value for 'vacancyId'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useSubmitVacancyInteractionMutation(baseOptions?: Apollo.MutationHookOptions<SubmitVacancyInteractionMutation, SubmitVacancyInteractionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitVacancyInteractionMutation, SubmitVacancyInteractionMutationVariables>(SubmitVacancyInteractionDocument, options);
      }
export type SubmitVacancyInteractionMutationHookResult = ReturnType<typeof useSubmitVacancyInteractionMutation>;
export type SubmitVacancyInteractionMutationResult = Apollo.MutationResult<SubmitVacancyInteractionMutation>;
export type SubmitVacancyInteractionMutationOptions = Apollo.BaseMutationOptions<SubmitVacancyInteractionMutation, SubmitVacancyInteractionMutationVariables>;
export const SaveCareerProfileFormDocument = gql`
    mutation SaveCareerProfileForm($input: CareerProfileInput!, $photo: Upload, $clearPhoto: Boolean) {
  saveCareerProfile(input: $input, photo: $photo, clearPhoto: $clearPhoto) {
    success
    customErrors {
      field
      message
      code
    }
    profile {
      ...CareerProfileFields
    }
  }
}
    ${CareerProfileFieldsFragmentDoc}`;
export type SaveCareerProfileFormMutationFn = Apollo.MutationFunction<SaveCareerProfileFormMutation, SaveCareerProfileFormMutationVariables>;

/**
 * __useSaveCareerProfileFormMutation__
 *
 * To run a mutation, you first call `useSaveCareerProfileFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCareerProfileFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCareerProfileFormMutation, { data, loading, error }] = useSaveCareerProfileFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *      photo: // value for 'photo'
 *      clearPhoto: // value for 'clearPhoto'
 *   },
 * });
 */
export function useSaveCareerProfileFormMutation(baseOptions?: Apollo.MutationHookOptions<SaveCareerProfileFormMutation, SaveCareerProfileFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCareerProfileFormMutation, SaveCareerProfileFormMutationVariables>(SaveCareerProfileFormDocument, options);
      }
export type SaveCareerProfileFormMutationHookResult = ReturnType<typeof useSaveCareerProfileFormMutation>;
export type SaveCareerProfileFormMutationResult = Apollo.MutationResult<SaveCareerProfileFormMutation>;
export type SaveCareerProfileFormMutationOptions = Apollo.BaseMutationOptions<SaveCareerProfileFormMutation, SaveCareerProfileFormMutationVariables>;
export const SaveCvLocaleDocument = gql`
    mutation SaveCvLocale($language: String!, $jobTitle: String, $about: String) {
  saveCvText(language: $language, jobTitle: $jobTitle, about: $about) {
    success
    customErrors {
      field
      message
      code
    }
    profile {
      id
      completeness
    }
  }
}
    `;
export type SaveCvLocaleMutationFn = Apollo.MutationFunction<SaveCvLocaleMutation, SaveCvLocaleMutationVariables>;

/**
 * __useSaveCvLocaleMutation__
 *
 * To run a mutation, you first call `useSaveCvLocaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCvLocaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCvLocaleMutation, { data, loading, error }] = useSaveCvLocaleMutation({
 *   variables: {
 *      language: // value for 'language'
 *      jobTitle: // value for 'jobTitle'
 *      about: // value for 'about'
 *   },
 * });
 */
export function useSaveCvLocaleMutation(baseOptions?: Apollo.MutationHookOptions<SaveCvLocaleMutation, SaveCvLocaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCvLocaleMutation, SaveCvLocaleMutationVariables>(SaveCvLocaleDocument, options);
      }
export type SaveCvLocaleMutationHookResult = ReturnType<typeof useSaveCvLocaleMutation>;
export type SaveCvLocaleMutationResult = Apollo.MutationResult<SaveCvLocaleMutation>;
export type SaveCvLocaleMutationOptions = Apollo.BaseMutationOptions<SaveCvLocaleMutation, SaveCvLocaleMutationVariables>;
export const SetProfileSearchableDocument = gql`
    mutation SetProfileSearchable($isSearchable: Boolean!, $contactsVisible: Boolean) {
  setProfileSearchable(
    isSearchable: $isSearchable
    contactsVisible: $contactsVisible
  ) {
    success
    customErrors {
      field
      message
      code
    }
    profile {
      id
      isSearchable
      contactsVisible
    }
  }
}
    `;
export type SetProfileSearchableMutationFn = Apollo.MutationFunction<SetProfileSearchableMutation, SetProfileSearchableMutationVariables>;

/**
 * __useSetProfileSearchableMutation__
 *
 * To run a mutation, you first call `useSetProfileSearchableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProfileSearchableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProfileSearchableMutation, { data, loading, error }] = useSetProfileSearchableMutation({
 *   variables: {
 *      isSearchable: // value for 'isSearchable'
 *      contactsVisible: // value for 'contactsVisible'
 *   },
 * });
 */
export function useSetProfileSearchableMutation(baseOptions?: Apollo.MutationHookOptions<SetProfileSearchableMutation, SetProfileSearchableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProfileSearchableMutation, SetProfileSearchableMutationVariables>(SetProfileSearchableDocument, options);
      }
export type SetProfileSearchableMutationHookResult = ReturnType<typeof useSetProfileSearchableMutation>;
export type SetProfileSearchableMutationResult = Apollo.MutationResult<SetProfileSearchableMutation>;
export type SetProfileSearchableMutationOptions = Apollo.BaseMutationOptions<SetProfileSearchableMutation, SetProfileSearchableMutationVariables>;
export const SubmitLessonHomeworkDocument = gql`
    mutation SubmitLessonHomework($lessonId: ID!, $githubUrl: String, $file: Upload) {
  submitHomework(lessonId: $lessonId, githubUrl: $githubUrl, file: $file) {
    success
    customErrors {
      code
      field
      message
    }
    submission {
      id
      githubUrl
      fileName
      status
      attempt
      submittedAt
      hwMark
      teacherComment
    }
  }
}
    `;
export type SubmitLessonHomeworkMutationFn = Apollo.MutationFunction<SubmitLessonHomeworkMutation, SubmitLessonHomeworkMutationVariables>;

/**
 * __useSubmitLessonHomeworkMutation__
 *
 * To run a mutation, you first call `useSubmitLessonHomeworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitLessonHomeworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitLessonHomeworkMutation, { data, loading, error }] = useSubmitLessonHomeworkMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      githubUrl: // value for 'githubUrl'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useSubmitLessonHomeworkMutation(baseOptions?: Apollo.MutationHookOptions<SubmitLessonHomeworkMutation, SubmitLessonHomeworkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitLessonHomeworkMutation, SubmitLessonHomeworkMutationVariables>(SubmitLessonHomeworkDocument, options);
      }
export type SubmitLessonHomeworkMutationHookResult = ReturnType<typeof useSubmitLessonHomeworkMutation>;
export type SubmitLessonHomeworkMutationResult = Apollo.MutationResult<SubmitLessonHomeworkMutation>;
export type SubmitLessonHomeworkMutationOptions = Apollo.BaseMutationOptions<SubmitLessonHomeworkMutation, SubmitLessonHomeworkMutationVariables>;
export const UpsertLessonHomeworkAssignmentDocument = gql`
    mutation UpsertLessonHomeworkAssignment($lessonId: ID!, $title: String!, $text: String!, $dueDate: Date) {
  upsertHomeworkAssignment(
    lessonId: $lessonId
    title: $title
    text: $text
    dueDate: $dueDate
  ) {
    success
    customErrors {
      code
      field
      message
    }
    assignment {
      id
      lessonId
      title
      text
      dueDate
      updatedAt
    }
  }
}
    `;
export type UpsertLessonHomeworkAssignmentMutationFn = Apollo.MutationFunction<UpsertLessonHomeworkAssignmentMutation, UpsertLessonHomeworkAssignmentMutationVariables>;

/**
 * __useUpsertLessonHomeworkAssignmentMutation__
 *
 * To run a mutation, you first call `useUpsertLessonHomeworkAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLessonHomeworkAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertLessonHomeworkAssignmentMutation, { data, loading, error }] = useUpsertLessonHomeworkAssignmentMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      title: // value for 'title'
 *      text: // value for 'text'
 *      dueDate: // value for 'dueDate'
 *   },
 * });
 */
export function useUpsertLessonHomeworkAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<UpsertLessonHomeworkAssignmentMutation, UpsertLessonHomeworkAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertLessonHomeworkAssignmentMutation, UpsertLessonHomeworkAssignmentMutationVariables>(UpsertLessonHomeworkAssignmentDocument, options);
      }
export type UpsertLessonHomeworkAssignmentMutationHookResult = ReturnType<typeof useUpsertLessonHomeworkAssignmentMutation>;
export type UpsertLessonHomeworkAssignmentMutationResult = Apollo.MutationResult<UpsertLessonHomeworkAssignmentMutation>;
export type UpsertLessonHomeworkAssignmentMutationOptions = Apollo.BaseMutationOptions<UpsertLessonHomeworkAssignmentMutation, UpsertLessonHomeworkAssignmentMutationVariables>;
export const GradeHomeworkSubmissionDocument = gql`
    mutation GradeHomeworkSubmission($lessonId: ID!, $studentId: ID!, $hwMark: String!, $comment: String, $attempt: Int) {
  gradeHomework(
    lessonId: $lessonId
    studentId: $studentId
    hwMark: $hwMark
    comment: $comment
    attempt: $attempt
  ) {
    success
    customErrors {
      code
      field
      message
    }
    row {
      studentId
      hwMark
      submission {
        id
        status
        teacherComment
        gradedByName
      }
    }
  }
}
    `;
export type GradeHomeworkSubmissionMutationFn = Apollo.MutationFunction<GradeHomeworkSubmissionMutation, GradeHomeworkSubmissionMutationVariables>;

/**
 * __useGradeHomeworkSubmissionMutation__
 *
 * To run a mutation, you first call `useGradeHomeworkSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGradeHomeworkSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gradeHomeworkSubmissionMutation, { data, loading, error }] = useGradeHomeworkSubmissionMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      studentId: // value for 'studentId'
 *      hwMark: // value for 'hwMark'
 *      comment: // value for 'comment'
 *      attempt: // value for 'attempt'
 *   },
 * });
 */
export function useGradeHomeworkSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<GradeHomeworkSubmissionMutation, GradeHomeworkSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GradeHomeworkSubmissionMutation, GradeHomeworkSubmissionMutationVariables>(GradeHomeworkSubmissionDocument, options);
      }
export type GradeHomeworkSubmissionMutationHookResult = ReturnType<typeof useGradeHomeworkSubmissionMutation>;
export type GradeHomeworkSubmissionMutationResult = Apollo.MutationResult<GradeHomeworkSubmissionMutation>;
export type GradeHomeworkSubmissionMutationOptions = Apollo.BaseMutationOptions<GradeHomeworkSubmissionMutation, GradeHomeworkSubmissionMutationVariables>;
export const RerunSubmissionAiReviewDocument = gql`
    mutation RerunSubmissionAiReview($submissionId: ID!) {
  rerunHomeworkAiReview(submissionId: $submissionId) {
    success
    customErrors {
      code
      field
      message
    }
    aiReviewStatus
  }
}
    `;
export type RerunSubmissionAiReviewMutationFn = Apollo.MutationFunction<RerunSubmissionAiReviewMutation, RerunSubmissionAiReviewMutationVariables>;

/**
 * __useRerunSubmissionAiReviewMutation__
 *
 * To run a mutation, you first call `useRerunSubmissionAiReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRerunSubmissionAiReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rerunSubmissionAiReviewMutation, { data, loading, error }] = useRerunSubmissionAiReviewMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useRerunSubmissionAiReviewMutation(baseOptions?: Apollo.MutationHookOptions<RerunSubmissionAiReviewMutation, RerunSubmissionAiReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RerunSubmissionAiReviewMutation, RerunSubmissionAiReviewMutationVariables>(RerunSubmissionAiReviewDocument, options);
      }
export type RerunSubmissionAiReviewMutationHookResult = ReturnType<typeof useRerunSubmissionAiReviewMutation>;
export type RerunSubmissionAiReviewMutationResult = Apollo.MutationResult<RerunSubmissionAiReviewMutation>;
export type RerunSubmissionAiReviewMutationOptions = Apollo.BaseMutationOptions<RerunSubmissionAiReviewMutation, RerunSubmissionAiReviewMutationVariables>;
export const FinishLessonDocument = gql`
    mutation finishLesson($groupLessonId: Int!, $comment: String!, $attendances: [LmsAttendanceType!]!) {
  finishLmsLesson(
    groupLessonId: $groupLessonId
    comment: $comment
    attendances: $attendances
  ) {
    success
    errors
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type FinishLessonMutationFn = Apollo.MutationFunction<FinishLessonMutation, FinishLessonMutationVariables>;

/**
 * __useFinishLessonMutation__
 *
 * To run a mutation, you first call `useFinishLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishLessonMutation, { data, loading, error }] = useFinishLessonMutation({
 *   variables: {
 *      groupLessonId: // value for 'groupLessonId'
 *      comment: // value for 'comment'
 *      attendances: // value for 'attendances'
 *   },
 * });
 */
export function useFinishLessonMutation(baseOptions?: Apollo.MutationHookOptions<FinishLessonMutation, FinishLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishLessonMutation, FinishLessonMutationVariables>(FinishLessonDocument, options);
      }
export type FinishLessonMutationHookResult = ReturnType<typeof useFinishLessonMutation>;
export type FinishLessonMutationResult = Apollo.MutationResult<FinishLessonMutation>;
export type FinishLessonMutationOptions = Apollo.BaseMutationOptions<FinishLessonMutation, FinishLessonMutationVariables>;
export const UploadLessonVideoDocument = gql`
    mutation uploadLessonVideo($lessonId: Int!, $videoUrl: String!) {
  uploadLessonVideo(lessonId: $lessonId, videoUrl: $videoUrl) {
    success
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type UploadLessonVideoMutationFn = Apollo.MutationFunction<UploadLessonVideoMutation, UploadLessonVideoMutationVariables>;

/**
 * __useUploadLessonVideoMutation__
 *
 * To run a mutation, you first call `useUploadLessonVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadLessonVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadLessonVideoMutation, { data, loading, error }] = useUploadLessonVideoMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      videoUrl: // value for 'videoUrl'
 *   },
 * });
 */
export function useUploadLessonVideoMutation(baseOptions?: Apollo.MutationHookOptions<UploadLessonVideoMutation, UploadLessonVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadLessonVideoMutation, UploadLessonVideoMutationVariables>(UploadLessonVideoDocument, options);
      }
export type UploadLessonVideoMutationHookResult = ReturnType<typeof useUploadLessonVideoMutation>;
export type UploadLessonVideoMutationResult = Apollo.MutationResult<UploadLessonVideoMutation>;
export type UploadLessonVideoMutationOptions = Apollo.BaseMutationOptions<UploadLessonVideoMutation, UploadLessonVideoMutationVariables>;
export const CancelUploadVideoDocument = gql`
    mutation cancelUploadVideo($lessonId: Int!) {
  cancelVideoUpload(lessonId: $lessonId) {
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type CancelUploadVideoMutationFn = Apollo.MutationFunction<CancelUploadVideoMutation, CancelUploadVideoMutationVariables>;

/**
 * __useCancelUploadVideoMutation__
 *
 * To run a mutation, you first call `useCancelUploadVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelUploadVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelUploadVideoMutation, { data, loading, error }] = useCancelUploadVideoMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useCancelUploadVideoMutation(baseOptions?: Apollo.MutationHookOptions<CancelUploadVideoMutation, CancelUploadVideoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelUploadVideoMutation, CancelUploadVideoMutationVariables>(CancelUploadVideoDocument, options);
      }
export type CancelUploadVideoMutationHookResult = ReturnType<typeof useCancelUploadVideoMutation>;
export type CancelUploadVideoMutationResult = Apollo.MutationResult<CancelUploadVideoMutation>;
export type CancelUploadVideoMutationOptions = Apollo.BaseMutationOptions<CancelUploadVideoMutation, CancelUploadVideoMutationVariables>;
export const AddStudentsMarksDocument = gql`
    mutation addStudentsMarks($lessonId: Int!, $taskType: LessonTaskTypeEnum!, $studentsMarks: [LessonMarkInput]!, $date: Date!) {
  setStudentsMarks(
    lessonId: $lessonId
    taskType: $taskType
    studentsMarks: $studentsMarks
    date: $date
  ) {
    success
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type AddStudentsMarksMutationFn = Apollo.MutationFunction<AddStudentsMarksMutation, AddStudentsMarksMutationVariables>;

/**
 * __useAddStudentsMarksMutation__
 *
 * To run a mutation, you first call `useAddStudentsMarksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStudentsMarksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStudentsMarksMutation, { data, loading, error }] = useAddStudentsMarksMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      taskType: // value for 'taskType'
 *      studentsMarks: // value for 'studentsMarks'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useAddStudentsMarksMutation(baseOptions?: Apollo.MutationHookOptions<AddStudentsMarksMutation, AddStudentsMarksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStudentsMarksMutation, AddStudentsMarksMutationVariables>(AddStudentsMarksDocument, options);
      }
export type AddStudentsMarksMutationHookResult = ReturnType<typeof useAddStudentsMarksMutation>;
export type AddStudentsMarksMutationResult = Apollo.MutationResult<AddStudentsMarksMutation>;
export type AddStudentsMarksMutationOptions = Apollo.BaseMutationOptions<AddStudentsMarksMutation, AddStudentsMarksMutationVariables>;
export const SendSurveyResponseDocument = gql`
    mutation SendSurveyResponse($assignmentId: ID!, $answers: [SurveyAnswerInput!]!) {
  submitSurveyResponse(assignmentId: $assignmentId, answers: $answers) {
    success
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type SendSurveyResponseMutationFn = Apollo.MutationFunction<SendSurveyResponseMutation, SendSurveyResponseMutationVariables>;

/**
 * __useSendSurveyResponseMutation__
 *
 * To run a mutation, you first call `useSendSurveyResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSurveyResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSurveyResponseMutation, { data, loading, error }] = useSendSurveyResponseMutation({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useSendSurveyResponseMutation(baseOptions?: Apollo.MutationHookOptions<SendSurveyResponseMutation, SendSurveyResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSurveyResponseMutation, SendSurveyResponseMutationVariables>(SendSurveyResponseDocument, options);
      }
export type SendSurveyResponseMutationHookResult = ReturnType<typeof useSendSurveyResponseMutation>;
export type SendSurveyResponseMutationResult = Apollo.MutationResult<SendSurveyResponseMutation>;
export type SendSurveyResponseMutationOptions = Apollo.BaseMutationOptions<SendSurveyResponseMutation, SendSurveyResponseMutationVariables>;
export const CreateWhiteboardForLessonDocument = gql`
    mutation CreateWhiteboardForLesson($lessonId: ID!, $name: String) {
  createLessonWhiteboard(lessonId: $lessonId, name: $name) {
    success
    customErrors {
      code
      field
      message
    }
    whiteboard {
      id
      name
      sceneJson
      sceneVersion
    }
  }
}
    `;
export type CreateWhiteboardForLessonMutationFn = Apollo.MutationFunction<CreateWhiteboardForLessonMutation, CreateWhiteboardForLessonMutationVariables>;

/**
 * __useCreateWhiteboardForLessonMutation__
 *
 * To run a mutation, you first call `useCreateWhiteboardForLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWhiteboardForLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWhiteboardForLessonMutation, { data, loading, error }] = useCreateWhiteboardForLessonMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateWhiteboardForLessonMutation(baseOptions?: Apollo.MutationHookOptions<CreateWhiteboardForLessonMutation, CreateWhiteboardForLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWhiteboardForLessonMutation, CreateWhiteboardForLessonMutationVariables>(CreateWhiteboardForLessonDocument, options);
      }
export type CreateWhiteboardForLessonMutationHookResult = ReturnType<typeof useCreateWhiteboardForLessonMutation>;
export type CreateWhiteboardForLessonMutationResult = Apollo.MutationResult<CreateWhiteboardForLessonMutation>;
export type CreateWhiteboardForLessonMutationOptions = Apollo.BaseMutationOptions<CreateWhiteboardForLessonMutation, CreateWhiteboardForLessonMutationVariables>;
export const LinkWhiteboardToLessonDocument = gql`
    mutation LinkWhiteboardToLesson($lessonId: ID!, $whiteboardId: ID!) {
  linkLessonWhiteboard(lessonId: $lessonId, whiteboardId: $whiteboardId) {
    success
    customErrors {
      code
      field
      message
    }
    whiteboard {
      id
      name
      sceneJson
      sceneVersion
    }
  }
}
    `;
export type LinkWhiteboardToLessonMutationFn = Apollo.MutationFunction<LinkWhiteboardToLessonMutation, LinkWhiteboardToLessonMutationVariables>;

/**
 * __useLinkWhiteboardToLessonMutation__
 *
 * To run a mutation, you first call `useLinkWhiteboardToLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkWhiteboardToLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkWhiteboardToLessonMutation, { data, loading, error }] = useLinkWhiteboardToLessonMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *      whiteboardId: // value for 'whiteboardId'
 *   },
 * });
 */
export function useLinkWhiteboardToLessonMutation(baseOptions?: Apollo.MutationHookOptions<LinkWhiteboardToLessonMutation, LinkWhiteboardToLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkWhiteboardToLessonMutation, LinkWhiteboardToLessonMutationVariables>(LinkWhiteboardToLessonDocument, options);
      }
export type LinkWhiteboardToLessonMutationHookResult = ReturnType<typeof useLinkWhiteboardToLessonMutation>;
export type LinkWhiteboardToLessonMutationResult = Apollo.MutationResult<LinkWhiteboardToLessonMutation>;
export type LinkWhiteboardToLessonMutationOptions = Apollo.BaseMutationOptions<LinkWhiteboardToLessonMutation, LinkWhiteboardToLessonMutationVariables>;
export const SaveBoardSceneDocument = gql`
    mutation SaveBoardScene($whiteboardId: ID!, $sceneJson: String!, $expectedVersion: Int!) {
  saveWhiteboardScene(
    whiteboardId: $whiteboardId
    sceneJson: $sceneJson
    expectedVersion: $expectedVersion
  ) {
    success
    customErrors {
      code
      field
      message
    }
    sceneVersion
    whiteboard {
      id
      sceneVersion
    }
  }
}
    `;
export type SaveBoardSceneMutationFn = Apollo.MutationFunction<SaveBoardSceneMutation, SaveBoardSceneMutationVariables>;

/**
 * __useSaveBoardSceneMutation__
 *
 * To run a mutation, you first call `useSaveBoardSceneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBoardSceneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBoardSceneMutation, { data, loading, error }] = useSaveBoardSceneMutation({
 *   variables: {
 *      whiteboardId: // value for 'whiteboardId'
 *      sceneJson: // value for 'sceneJson'
 *      expectedVersion: // value for 'expectedVersion'
 *   },
 * });
 */
export function useSaveBoardSceneMutation(baseOptions?: Apollo.MutationHookOptions<SaveBoardSceneMutation, SaveBoardSceneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBoardSceneMutation, SaveBoardSceneMutationVariables>(SaveBoardSceneDocument, options);
      }
export type SaveBoardSceneMutationHookResult = ReturnType<typeof useSaveBoardSceneMutation>;
export type SaveBoardSceneMutationResult = Apollo.MutationResult<SaveBoardSceneMutation>;
export type SaveBoardSceneMutationOptions = Apollo.BaseMutationOptions<SaveBoardSceneMutation, SaveBoardSceneMutationVariables>;
export const RenameBoardDocument = gql`
    mutation RenameBoard($whiteboardId: ID!, $name: String!) {
  renameWhiteboard(whiteboardId: $whiteboardId, name: $name) {
    success
    customErrors {
      code
      field
      message
    }
    whiteboard {
      id
      name
    }
  }
}
    `;
export type RenameBoardMutationFn = Apollo.MutationFunction<RenameBoardMutation, RenameBoardMutationVariables>;

/**
 * __useRenameBoardMutation__
 *
 * To run a mutation, you first call `useRenameBoardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameBoardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameBoardMutation, { data, loading, error }] = useRenameBoardMutation({
 *   variables: {
 *      whiteboardId: // value for 'whiteboardId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameBoardMutation(baseOptions?: Apollo.MutationHookOptions<RenameBoardMutation, RenameBoardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameBoardMutation, RenameBoardMutationVariables>(RenameBoardDocument, options);
      }
export type RenameBoardMutationHookResult = ReturnType<typeof useRenameBoardMutation>;
export type RenameBoardMutationResult = Apollo.MutationResult<RenameBoardMutation>;
export type RenameBoardMutationOptions = Apollo.BaseMutationOptions<RenameBoardMutation, RenameBoardMutationVariables>;
export const UnlinkWhiteboardFromLessonDocument = gql`
    mutation UnlinkWhiteboardFromLesson($lessonId: ID!) {
  unlinkLessonWhiteboard(lessonId: $lessonId) {
    success
    customErrors {
      code
      field
      message
    }
  }
}
    `;
export type UnlinkWhiteboardFromLessonMutationFn = Apollo.MutationFunction<UnlinkWhiteboardFromLessonMutation, UnlinkWhiteboardFromLessonMutationVariables>;

/**
 * __useUnlinkWhiteboardFromLessonMutation__
 *
 * To run a mutation, you first call `useUnlinkWhiteboardFromLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkWhiteboardFromLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkWhiteboardFromLessonMutation, { data, loading, error }] = useUnlinkWhiteboardFromLessonMutation({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useUnlinkWhiteboardFromLessonMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkWhiteboardFromLessonMutation, UnlinkWhiteboardFromLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkWhiteboardFromLessonMutation, UnlinkWhiteboardFromLessonMutationVariables>(UnlinkWhiteboardFromLessonDocument, options);
      }
export type UnlinkWhiteboardFromLessonMutationHookResult = ReturnType<typeof useUnlinkWhiteboardFromLessonMutation>;
export type UnlinkWhiteboardFromLessonMutationResult = Apollo.MutationResult<UnlinkWhiteboardFromLessonMutation>;
export type UnlinkWhiteboardFromLessonMutationOptions = Apollo.BaseMutationOptions<UnlinkWhiteboardFromLessonMutation, UnlinkWhiteboardFromLessonMutationVariables>;
export const UploadBoardImageDocument = gql`
    mutation UploadBoardImage($whiteboardId: ID!, $fileId: String!, $mimeType: String, $file: Upload!) {
  uploadWhiteboardFile(
    whiteboardId: $whiteboardId
    fileId: $fileId
    mimeType: $mimeType
    file: $file
  ) {
    success
    customErrors {
      code
      field
      message
    }
    file {
      fileId
      mimeType
      url
    }
  }
}
    `;
export type UploadBoardImageMutationFn = Apollo.MutationFunction<UploadBoardImageMutation, UploadBoardImageMutationVariables>;

/**
 * __useUploadBoardImageMutation__
 *
 * To run a mutation, you first call `useUploadBoardImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadBoardImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadBoardImageMutation, { data, loading, error }] = useUploadBoardImageMutation({
 *   variables: {
 *      whiteboardId: // value for 'whiteboardId'
 *      fileId: // value for 'fileId'
 *      mimeType: // value for 'mimeType'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadBoardImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadBoardImageMutation, UploadBoardImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadBoardImageMutation, UploadBoardImageMutationVariables>(UploadBoardImageDocument, options);
      }
export type UploadBoardImageMutationHookResult = ReturnType<typeof useUploadBoardImageMutation>;
export type UploadBoardImageMutationResult = Apollo.MutationResult<UploadBoardImageMutation>;
export type UploadBoardImageMutationOptions = Apollo.BaseMutationOptions<UploadBoardImageMutation, UploadBoardImageMutationVariables>;
export const SaveSchoolLibraryDocument = gql`
    mutation SaveSchoolLibrary($itemsJson: String!, $expectedVersion: Int!) {
  saveWhiteboardLibrary(itemsJson: $itemsJson, expectedVersion: $expectedVersion) {
    success
    customErrors {
      code
      field
      message
    }
    version
  }
}
    `;
export type SaveSchoolLibraryMutationFn = Apollo.MutationFunction<SaveSchoolLibraryMutation, SaveSchoolLibraryMutationVariables>;

/**
 * __useSaveSchoolLibraryMutation__
 *
 * To run a mutation, you first call `useSaveSchoolLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSchoolLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSchoolLibraryMutation, { data, loading, error }] = useSaveSchoolLibraryMutation({
 *   variables: {
 *      itemsJson: // value for 'itemsJson'
 *      expectedVersion: // value for 'expectedVersion'
 *   },
 * });
 */
export function useSaveSchoolLibraryMutation(baseOptions?: Apollo.MutationHookOptions<SaveSchoolLibraryMutation, SaveSchoolLibraryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSchoolLibraryMutation, SaveSchoolLibraryMutationVariables>(SaveSchoolLibraryDocument, options);
      }
export type SaveSchoolLibraryMutationHookResult = ReturnType<typeof useSaveSchoolLibraryMutation>;
export type SaveSchoolLibraryMutationResult = Apollo.MutationResult<SaveSchoolLibraryMutation>;
export type SaveSchoolLibraryMutationOptions = Apollo.BaseMutationOptions<SaveSchoolLibraryMutation, SaveSchoolLibraryMutationVariables>;
export const JoinLessonNowDocument = gql`
    mutation JoinLessonNow($groupLessonId: Int!) {
  lmsJoinLesson(groupLessonId: $groupLessonId) {
    success
    redirectUrl
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type JoinLessonNowMutationFn = Apollo.MutationFunction<JoinLessonNowMutation, JoinLessonNowMutationVariables>;

/**
 * __useJoinLessonNowMutation__
 *
 * To run a mutation, you first call `useJoinLessonNowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinLessonNowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinLessonNowMutation, { data, loading, error }] = useJoinLessonNowMutation({
 *   variables: {
 *      groupLessonId: // value for 'groupLessonId'
 *   },
 * });
 */
export function useJoinLessonNowMutation(baseOptions?: Apollo.MutationHookOptions<JoinLessonNowMutation, JoinLessonNowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JoinLessonNowMutation, JoinLessonNowMutationVariables>(JoinLessonNowDocument, options);
      }
export type JoinLessonNowMutationHookResult = ReturnType<typeof useJoinLessonNowMutation>;
export type JoinLessonNowMutationResult = Apollo.MutationResult<JoinLessonNowMutation>;
export type JoinLessonNowMutationOptions = Apollo.BaseMutationOptions<JoinLessonNowMutation, JoinLessonNowMutationVariables>;
export const PutTodayLessonLinkDocument = gql`
    mutation PutTodayLessonLink($groupId: Int!, $joinUrl: String!) {
  lmsSetTodayLessonLink(groupId: $groupId, joinUrl: $joinUrl) {
    success
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type PutTodayLessonLinkMutationFn = Apollo.MutationFunction<PutTodayLessonLinkMutation, PutTodayLessonLinkMutationVariables>;

/**
 * __usePutTodayLessonLinkMutation__
 *
 * To run a mutation, you first call `usePutTodayLessonLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePutTodayLessonLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [putTodayLessonLinkMutation, { data, loading, error }] = usePutTodayLessonLinkMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      joinUrl: // value for 'joinUrl'
 *   },
 * });
 */
export function usePutTodayLessonLinkMutation(baseOptions?: Apollo.MutationHookOptions<PutTodayLessonLinkMutation, PutTodayLessonLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PutTodayLessonLinkMutation, PutTodayLessonLinkMutationVariables>(PutTodayLessonLinkDocument, options);
      }
export type PutTodayLessonLinkMutationHookResult = ReturnType<typeof usePutTodayLessonLinkMutation>;
export type PutTodayLessonLinkMutationResult = Apollo.MutationResult<PutTodayLessonLinkMutation>;
export type PutTodayLessonLinkMutationOptions = Apollo.BaseMutationOptions<PutTodayLessonLinkMutation, PutTodayLessonLinkMutationVariables>;
export const DropTodayLessonLinkDocument = gql`
    mutation DropTodayLessonLink($groupId: Int!) {
  lmsClearTodayLessonLink(groupId: $groupId) {
    success
    customErrors {
      field
      code
      message
    }
  }
}
    `;
export type DropTodayLessonLinkMutationFn = Apollo.MutationFunction<DropTodayLessonLinkMutation, DropTodayLessonLinkMutationVariables>;

/**
 * __useDropTodayLessonLinkMutation__
 *
 * To run a mutation, you first call `useDropTodayLessonLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDropTodayLessonLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dropTodayLessonLinkMutation, { data, loading, error }] = useDropTodayLessonLinkMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useDropTodayLessonLinkMutation(baseOptions?: Apollo.MutationHookOptions<DropTodayLessonLinkMutation, DropTodayLessonLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DropTodayLessonLinkMutation, DropTodayLessonLinkMutationVariables>(DropTodayLessonLinkDocument, options);
      }
export type DropTodayLessonLinkMutationHookResult = ReturnType<typeof useDropTodayLessonLinkMutation>;
export type DropTodayLessonLinkMutationResult = Apollo.MutationResult<DropTodayLessonLinkMutation>;
export type DropTodayLessonLinkMutationOptions = Apollo.BaseMutationOptions<DropTodayLessonLinkMutation, DropTodayLessonLinkMutationVariables>;
export const StudentGroupAttendanceDocument = gql`
    query StudentGroupAttendance($groupId: ID!) {
  myAttendance(groupId: $groupId) {
    lessonId
    lessonName
    lessonNumber
    date
    attendance
  }
}
    `;

/**
 * __useStudentGroupAttendanceQuery__
 *
 * To run a query within a React component, call `useStudentGroupAttendanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentGroupAttendanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentGroupAttendanceQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useStudentGroupAttendanceQuery(baseOptions: Apollo.QueryHookOptions<StudentGroupAttendanceQuery, StudentGroupAttendanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentGroupAttendanceQuery, StudentGroupAttendanceQueryVariables>(StudentGroupAttendanceDocument, options);
      }
export function useStudentGroupAttendanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentGroupAttendanceQuery, StudentGroupAttendanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentGroupAttendanceQuery, StudentGroupAttendanceQueryVariables>(StudentGroupAttendanceDocument, options);
        }
export type StudentGroupAttendanceQueryHookResult = ReturnType<typeof useStudentGroupAttendanceQuery>;
export type StudentGroupAttendanceLazyQueryHookResult = ReturnType<typeof useStudentGroupAttendanceLazyQuery>;
export type StudentGroupAttendanceQueryResult = Apollo.QueryResult<StudentGroupAttendanceQuery, StudentGroupAttendanceQueryVariables>;
export const MeDocument = gql`
    query me {
  me {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const MyCareerCenterInfoDocument = gql`
    query MyCareerCenterInfo {
  myCareerCenter {
    memberId
    status
    directionTitle
    enrolledAt
    lessonsCompleted
    lessonsTotal
  }
}
    `;

/**
 * __useMyCareerCenterInfoQuery__
 *
 * To run a query within a React component, call `useMyCareerCenterInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCareerCenterInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCareerCenterInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyCareerCenterInfoQuery(baseOptions?: Apollo.QueryHookOptions<MyCareerCenterInfoQuery, MyCareerCenterInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCareerCenterInfoQuery, MyCareerCenterInfoQueryVariables>(MyCareerCenterInfoDocument, options);
      }
export function useMyCareerCenterInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCareerCenterInfoQuery, MyCareerCenterInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCareerCenterInfoQuery, MyCareerCenterInfoQueryVariables>(MyCareerCenterInfoDocument, options);
        }
export type MyCareerCenterInfoQueryHookResult = ReturnType<typeof useMyCareerCenterInfoQuery>;
export type MyCareerCenterInfoLazyQueryHookResult = ReturnType<typeof useMyCareerCenterInfoLazyQuery>;
export type MyCareerCenterInfoQueryResult = Apollo.QueryResult<MyCareerCenterInfoQuery, MyCareerCenterInfoQueryVariables>;
export const CareerLessonsListDocument = gql`
    query CareerLessonsList {
  careerLessons {
    id
    order
    title
    summary
    durationMin
    completionKind
    isUnlocked
    isCompleted
    completedAt
    isOpened
    isBookmarked
  }
}
    `;

/**
 * __useCareerLessonsListQuery__
 *
 * To run a query within a React component, call `useCareerLessonsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCareerLessonsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCareerLessonsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useCareerLessonsListQuery(baseOptions?: Apollo.QueryHookOptions<CareerLessonsListQuery, CareerLessonsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CareerLessonsListQuery, CareerLessonsListQueryVariables>(CareerLessonsListDocument, options);
      }
export function useCareerLessonsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CareerLessonsListQuery, CareerLessonsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CareerLessonsListQuery, CareerLessonsListQueryVariables>(CareerLessonsListDocument, options);
        }
export type CareerLessonsListQueryHookResult = ReturnType<typeof useCareerLessonsListQuery>;
export type CareerLessonsListLazyQueryHookResult = ReturnType<typeof useCareerLessonsListLazyQuery>;
export type CareerLessonsListQueryResult = Apollo.QueryResult<CareerLessonsListQuery, CareerLessonsListQueryVariables>;
export const CareerLessonDetailDocument = gql`
    query CareerLessonDetail($id: ID!) {
  careerLesson(id: $id) {
    id
    order
    title
    summary
    durationMin
    completionKind
    artifactHint
    isUnlocked
    isCompleted
    completedAt
    isOpened
    openedAt
    openCount
    myNotes
    isBookmarked
    content
    videoUrl
    attachments {
      id
      originalName
      contentType
      sizeBytes
      url
    }
    quizQuestions {
      id
      order
      text
      options
      correctIndexes
    }
  }
}
    `;

/**
 * __useCareerLessonDetailQuery__
 *
 * To run a query within a React component, call `useCareerLessonDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCareerLessonDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCareerLessonDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCareerLessonDetailQuery(baseOptions: Apollo.QueryHookOptions<CareerLessonDetailQuery, CareerLessonDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CareerLessonDetailQuery, CareerLessonDetailQueryVariables>(CareerLessonDetailDocument, options);
      }
export function useCareerLessonDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CareerLessonDetailQuery, CareerLessonDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CareerLessonDetailQuery, CareerLessonDetailQueryVariables>(CareerLessonDetailDocument, options);
        }
export type CareerLessonDetailQueryHookResult = ReturnType<typeof useCareerLessonDetailQuery>;
export type CareerLessonDetailLazyQueryHookResult = ReturnType<typeof useCareerLessonDetailLazyQuery>;
export type CareerLessonDetailQueryResult = Apollo.QueryResult<CareerLessonDetailQuery, CareerLessonDetailQueryVariables>;
export const MyCareerVacanciesDocument = gql`
    query MyCareerVacancies($directionId: ID, $skillId: ID, $workMode: String, $seniority: String, $search: String, $savedOnly: Boolean) {
  careerVacancies(
    directionId: $directionId
    skillId: $skillId
    workMode: $workMode
    seniority: $seniority
    search: $search
    savedOnly: $savedOnly
  ) {
    id
    title
    companyName
    applyUrl
    location
    workMode
    seniority
    employmentType
    salaryMin
    salaryMax
    salaryCurrency
    description
    publishedAt
    expiresAt
    directionIds
    directionTitles
    skillNames
    myInteraction
  }
}
    `;

/**
 * __useMyCareerVacanciesQuery__
 *
 * To run a query within a React component, call `useMyCareerVacanciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCareerVacanciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCareerVacanciesQuery({
 *   variables: {
 *      directionId: // value for 'directionId'
 *      skillId: // value for 'skillId'
 *      workMode: // value for 'workMode'
 *      seniority: // value for 'seniority'
 *      search: // value for 'search'
 *      savedOnly: // value for 'savedOnly'
 *   },
 * });
 */
export function useMyCareerVacanciesQuery(baseOptions?: Apollo.QueryHookOptions<MyCareerVacanciesQuery, MyCareerVacanciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCareerVacanciesQuery, MyCareerVacanciesQueryVariables>(MyCareerVacanciesDocument, options);
      }
export function useMyCareerVacanciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCareerVacanciesQuery, MyCareerVacanciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCareerVacanciesQuery, MyCareerVacanciesQueryVariables>(MyCareerVacanciesDocument, options);
        }
export type MyCareerVacanciesQueryHookResult = ReturnType<typeof useMyCareerVacanciesQuery>;
export type MyCareerVacanciesLazyQueryHookResult = ReturnType<typeof useMyCareerVacanciesLazyQuery>;
export type MyCareerVacanciesQueryResult = Apollo.QueryResult<MyCareerVacanciesQuery, MyCareerVacanciesQueryVariables>;
export const MyCareerProfileDocument = gql`
    query MyCareerProfile {
  myCareerProfile {
    ...CareerProfileFields
  }
}
    ${CareerProfileFieldsFragmentDoc}`;

/**
 * __useMyCareerProfileQuery__
 *
 * To run a query within a React component, call `useMyCareerProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyCareerProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyCareerProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyCareerProfileQuery(baseOptions?: Apollo.QueryHookOptions<MyCareerProfileQuery, MyCareerProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyCareerProfileQuery, MyCareerProfileQueryVariables>(MyCareerProfileDocument, options);
      }
export function useMyCareerProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyCareerProfileQuery, MyCareerProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyCareerProfileQuery, MyCareerProfileQueryVariables>(MyCareerProfileDocument, options);
        }
export type MyCareerProfileQueryHookResult = ReturnType<typeof useMyCareerProfileQuery>;
export type MyCareerProfileLazyQueryHookResult = ReturnType<typeof useMyCareerProfileLazyQuery>;
export type MyCareerProfileQueryResult = Apollo.QueryResult<MyCareerProfileQuery, MyCareerProfileQueryVariables>;
export const CareerSkillsSearchDocument = gql`
    query CareerSkillsSearch($search: String, $category: String) {
  careerSkills(search: $search, category: $category) {
    id
    name
    category
  }
}
    `;

/**
 * __useCareerSkillsSearchQuery__
 *
 * To run a query within a React component, call `useCareerSkillsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCareerSkillsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCareerSkillsSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useCareerSkillsSearchQuery(baseOptions?: Apollo.QueryHookOptions<CareerSkillsSearchQuery, CareerSkillsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CareerSkillsSearchQuery, CareerSkillsSearchQueryVariables>(CareerSkillsSearchDocument, options);
      }
export function useCareerSkillsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CareerSkillsSearchQuery, CareerSkillsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CareerSkillsSearchQuery, CareerSkillsSearchQueryVariables>(CareerSkillsSearchDocument, options);
        }
export type CareerSkillsSearchQueryHookResult = ReturnType<typeof useCareerSkillsSearchQuery>;
export type CareerSkillsSearchLazyQueryHookResult = ReturnType<typeof useCareerSkillsSearchLazyQuery>;
export type CareerSkillsSearchQueryResult = Apollo.QueryResult<CareerSkillsSearchQuery, CareerSkillsSearchQueryVariables>;
export const AllCoursesDocument = gql`
    query AllCourses($active: Boolean, $finished: Boolean, $first: Int, $after: String, $last: Int, $search: String, $courseId: ID, $groupIds: [ID], $lessonDate: Date) {
  allGroupsForLms(
    active: $active
    finished: $finished
    first: $first
    after: $after
    last: $last
    search: $search
    courseId: $courseId
    groupIds: $groupIds
    lessonDate: $lessonDate
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      cursor
      node {
        ... on GroupType {
          id
          course {
            id
            courseIcon
            educationForm
            name
          }
          passedLessonsCount
          lessonsCount
          studentsCount
          name
          statusFinished
          datetimeNextLesson
        }
        ... on StudentGroupType {
          id
          course {
            id
            courseIcon
            educationForm
            name
          }
          passedLessonsCount
          lessonsCount
          studentsCount
          name
          statusFinished
          datetimeNextLesson
        }
        ... on MethodistGroupType {
          id
          course {
            id
            courseIcon
            educationForm
            name
          }
          passedLessonsCount
          lessonsCount
          studentsCount
          name
          statusFinished
          datetimeNextLesson
        }
      }
    }
  }
}
    `;

/**
 * __useAllCoursesQuery__
 *
 * To run a query within a React component, call `useAllCoursesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCoursesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCoursesQuery({
 *   variables: {
 *      active: // value for 'active'
 *      finished: // value for 'finished'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      search: // value for 'search'
 *      courseId: // value for 'courseId'
 *      groupIds: // value for 'groupIds'
 *      lessonDate: // value for 'lessonDate'
 *   },
 * });
 */
export function useAllCoursesQuery(baseOptions?: Apollo.QueryHookOptions<AllCoursesQuery, AllCoursesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCoursesQuery, AllCoursesQueryVariables>(AllCoursesDocument, options);
      }
export function useAllCoursesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCoursesQuery, AllCoursesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCoursesQuery, AllCoursesQueryVariables>(AllCoursesDocument, options);
        }
export type AllCoursesQueryHookResult = ReturnType<typeof useAllCoursesQuery>;
export type AllCoursesLazyQueryHookResult = ReturnType<typeof useAllCoursesLazyQuery>;
export type AllCoursesQueryResult = Apollo.QueryResult<AllCoursesQuery, AllCoursesQueryVariables>;
export const MethodistGroupOptionsDocument = gql`
    query MethodistGroupOptions {
  allGroupsForLms(first: 500) {
    edges {
      node {
        ... on MethodistGroupType {
          id
          name
          course {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMethodistGroupOptionsQuery__
 *
 * To run a query within a React component, call `useMethodistGroupOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMethodistGroupOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMethodistGroupOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMethodistGroupOptionsQuery(baseOptions?: Apollo.QueryHookOptions<MethodistGroupOptionsQuery, MethodistGroupOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MethodistGroupOptionsQuery, MethodistGroupOptionsQueryVariables>(MethodistGroupOptionsDocument, options);
      }
export function useMethodistGroupOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MethodistGroupOptionsQuery, MethodistGroupOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MethodistGroupOptionsQuery, MethodistGroupOptionsQueryVariables>(MethodistGroupOptionsDocument, options);
        }
export type MethodistGroupOptionsQueryHookResult = ReturnType<typeof useMethodistGroupOptionsQuery>;
export type MethodistGroupOptionsLazyQueryHookResult = ReturnType<typeof useMethodistGroupOptionsLazyQuery>;
export type MethodistGroupOptionsQueryResult = Apollo.QueryResult<MethodistGroupOptionsQuery, MethodistGroupOptionsQueryVariables>;
export const GroupForLmsDocument = gql`
    query groupForLms($groupId: ID) {
  groupForLms(groupId: $groupId) {
    ... on GroupType {
      id
      course {
        id
        courseIcon
        name
      }
      statusFinished
      isFree
      lessons {
        id
        name
        date
        index
        needToFinish
      }
      passedLessonsCount
      lessonsCount
      studentsCount
      name
    }
    ... on StudentGroupType {
      id
      course {
        id
        courseIcon
        name
      }
      statusFinished
      isFree
      lessons {
        id
        name
        date
        index
      }
      passedLessonsCount
      lessonsCount
      studentsCount
      name
    }
    ... on MethodistGroupType {
      id
      course {
        id
        courseIcon
        name
      }
      statusFinished
      isFree
      lessons {
        id
        name
        date
        index
      }
      passedLessonsCount
      lessonsCount
      studentsCount
      name
    }
  }
}
    `;

/**
 * __useGroupForLmsQuery__
 *
 * To run a query within a React component, call `useGroupForLmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupForLmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupForLmsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGroupForLmsQuery(baseOptions?: Apollo.QueryHookOptions<GroupForLmsQuery, GroupForLmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupForLmsQuery, GroupForLmsQueryVariables>(GroupForLmsDocument, options);
      }
export function useGroupForLmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupForLmsQuery, GroupForLmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupForLmsQuery, GroupForLmsQueryVariables>(GroupForLmsDocument, options);
        }
export type GroupForLmsQueryHookResult = ReturnType<typeof useGroupForLmsQuery>;
export type GroupForLmsLazyQueryHookResult = ReturnType<typeof useGroupForLmsLazyQuery>;
export type GroupForLmsQueryResult = Apollo.QueryResult<GroupForLmsQuery, GroupForLmsQueryVariables>;
export const StudentDiplomasDocument = gql`
    query StudentDiplomas {
  myDiplomas {
    id
    language
    groupName
    courseName
    originalName
    sizeBytes
    issuedAt
  }
}
    `;

/**
 * __useStudentDiplomasQuery__
 *
 * To run a query within a React component, call `useStudentDiplomasQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentDiplomasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentDiplomasQuery({
 *   variables: {
 *   },
 * });
 */
export function useStudentDiplomasQuery(baseOptions?: Apollo.QueryHookOptions<StudentDiplomasQuery, StudentDiplomasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentDiplomasQuery, StudentDiplomasQueryVariables>(StudentDiplomasDocument, options);
      }
export function useStudentDiplomasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentDiplomasQuery, StudentDiplomasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentDiplomasQuery, StudentDiplomasQueryVariables>(StudentDiplomasDocument, options);
        }
export type StudentDiplomasQueryHookResult = ReturnType<typeof useStudentDiplomasQuery>;
export type StudentDiplomasLazyQueryHookResult = ReturnType<typeof useStudentDiplomasLazyQuery>;
export type StudentDiplomasQueryResult = Apollo.QueryResult<StudentDiplomasQuery, StudentDiplomasQueryVariables>;
export const StudentDiplomaDownloadUrlDocument = gql`
    query StudentDiplomaDownloadUrl($diplomaId: ID!) {
  myDiplomaDownloadUrl(diplomaId: $diplomaId) {
    url
    expiresAt
  }
}
    `;

/**
 * __useStudentDiplomaDownloadUrlQuery__
 *
 * To run a query within a React component, call `useStudentDiplomaDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentDiplomaDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentDiplomaDownloadUrlQuery({
 *   variables: {
 *      diplomaId: // value for 'diplomaId'
 *   },
 * });
 */
export function useStudentDiplomaDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<StudentDiplomaDownloadUrlQuery, StudentDiplomaDownloadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentDiplomaDownloadUrlQuery, StudentDiplomaDownloadUrlQueryVariables>(StudentDiplomaDownloadUrlDocument, options);
      }
export function useStudentDiplomaDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentDiplomaDownloadUrlQuery, StudentDiplomaDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentDiplomaDownloadUrlQuery, StudentDiplomaDownloadUrlQueryVariables>(StudentDiplomaDownloadUrlDocument, options);
        }
export type StudentDiplomaDownloadUrlQueryHookResult = ReturnType<typeof useStudentDiplomaDownloadUrlQuery>;
export type StudentDiplomaDownloadUrlLazyQueryHookResult = ReturnType<typeof useStudentDiplomaDownloadUrlLazyQuery>;
export type StudentDiplomaDownloadUrlQueryResult = Apollo.QueryResult<StudentDiplomaDownloadUrlQuery, StudentDiplomaDownloadUrlQueryVariables>;
export const MyLessonHomeworkDocument = gql`
    query MyLessonHomework($lessonId: ID!) {
  myLessonHomework(lessonId: $lessonId) {
    id
    lessonId
    hasTeacherAssignment
    title
    text
    dueDate
    canSubmit
    mySubmission {
      id
      githubUrl
      fileName
      status
      attempt
      submittedAt
      hwMark
      teacherComment
    }
  }
}
    `;

/**
 * __useMyLessonHomeworkQuery__
 *
 * To run a query within a React component, call `useMyLessonHomeworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyLessonHomeworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyLessonHomeworkQuery({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useMyLessonHomeworkQuery(baseOptions: Apollo.QueryHookOptions<MyLessonHomeworkQuery, MyLessonHomeworkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyLessonHomeworkQuery, MyLessonHomeworkQueryVariables>(MyLessonHomeworkDocument, options);
      }
export function useMyLessonHomeworkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyLessonHomeworkQuery, MyLessonHomeworkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyLessonHomeworkQuery, MyLessonHomeworkQueryVariables>(MyLessonHomeworkDocument, options);
        }
export type MyLessonHomeworkQueryHookResult = ReturnType<typeof useMyLessonHomeworkQuery>;
export type MyLessonHomeworkLazyQueryHookResult = ReturnType<typeof useMyLessonHomeworkLazyQuery>;
export type MyLessonHomeworkQueryResult = Apollo.QueryResult<MyLessonHomeworkQuery, MyLessonHomeworkQueryVariables>;
export const LmsLessonHomeworkDocument = gql`
    query LmsLessonHomework($lessonId: ID!) {
  lessonHomework(lessonId: $lessonId) {
    id
    lessonId
    title
    text
    dueDate
    updatedAt
  }
}
    `;

/**
 * __useLmsLessonHomeworkQuery__
 *
 * To run a query within a React component, call `useLmsLessonHomeworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useLmsLessonHomeworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLmsLessonHomeworkQuery({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useLmsLessonHomeworkQuery(baseOptions: Apollo.QueryHookOptions<LmsLessonHomeworkQuery, LmsLessonHomeworkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LmsLessonHomeworkQuery, LmsLessonHomeworkQueryVariables>(LmsLessonHomeworkDocument, options);
      }
export function useLmsLessonHomeworkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LmsLessonHomeworkQuery, LmsLessonHomeworkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LmsLessonHomeworkQuery, LmsLessonHomeworkQueryVariables>(LmsLessonHomeworkDocument, options);
        }
export type LmsLessonHomeworkQueryHookResult = ReturnType<typeof useLmsLessonHomeworkQuery>;
export type LmsLessonHomeworkLazyQueryHookResult = ReturnType<typeof useLmsLessonHomeworkLazyQuery>;
export type LmsLessonHomeworkQueryResult = Apollo.QueryResult<LmsLessonHomeworkQuery, LmsLessonHomeworkQueryVariables>;
export const LmsHomeworkRosterDocument = gql`
    query LmsHomeworkRoster($lessonId: ID!) {
  homeworkAiEnabled
  homeworkRoster(lessonId: $lessonId) {
    studentId
    studentName
    hwMark
    submission {
      id
      githubUrl
      fileName
      fileSizeBytes
      status
      attempt
      submittedAt
      teacherComment
      gradedAt
      gradedByName
      aiReview {
        status
        aiScore
        aiSummary
        aiJustification
        suspiciousContent
        suspicionNotes
        errorMessage
        analyzedAt
        truncatedBasis
        filesUsedCount
        assignmentSource
      }
    }
  }
}
    `;

/**
 * __useLmsHomeworkRosterQuery__
 *
 * To run a query within a React component, call `useLmsHomeworkRosterQuery` and pass it any options that fit your needs.
 * When your component renders, `useLmsHomeworkRosterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLmsHomeworkRosterQuery({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useLmsHomeworkRosterQuery(baseOptions: Apollo.QueryHookOptions<LmsHomeworkRosterQuery, LmsHomeworkRosterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LmsHomeworkRosterQuery, LmsHomeworkRosterQueryVariables>(LmsHomeworkRosterDocument, options);
      }
export function useLmsHomeworkRosterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LmsHomeworkRosterQuery, LmsHomeworkRosterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LmsHomeworkRosterQuery, LmsHomeworkRosterQueryVariables>(LmsHomeworkRosterDocument, options);
        }
export type LmsHomeworkRosterQueryHookResult = ReturnType<typeof useLmsHomeworkRosterQuery>;
export type LmsHomeworkRosterLazyQueryHookResult = ReturnType<typeof useLmsHomeworkRosterLazyQuery>;
export type LmsHomeworkRosterQueryResult = Apollo.QueryResult<LmsHomeworkRosterQuery, LmsHomeworkRosterQueryVariables>;
export const LmsHomeworkSubmissionDownloadUrlDocument = gql`
    query LmsHomeworkSubmissionDownloadUrl($submissionId: ID!) {
  homeworkSubmissionDownloadUrl(submissionId: $submissionId)
}
    `;

/**
 * __useLmsHomeworkSubmissionDownloadUrlQuery__
 *
 * To run a query within a React component, call `useLmsHomeworkSubmissionDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useLmsHomeworkSubmissionDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLmsHomeworkSubmissionDownloadUrlQuery({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *   },
 * });
 */
export function useLmsHomeworkSubmissionDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<LmsHomeworkSubmissionDownloadUrlQuery, LmsHomeworkSubmissionDownloadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LmsHomeworkSubmissionDownloadUrlQuery, LmsHomeworkSubmissionDownloadUrlQueryVariables>(LmsHomeworkSubmissionDownloadUrlDocument, options);
      }
export function useLmsHomeworkSubmissionDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LmsHomeworkSubmissionDownloadUrlQuery, LmsHomeworkSubmissionDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LmsHomeworkSubmissionDownloadUrlQuery, LmsHomeworkSubmissionDownloadUrlQueryVariables>(LmsHomeworkSubmissionDownloadUrlDocument, options);
        }
export type LmsHomeworkSubmissionDownloadUrlQueryHookResult = ReturnType<typeof useLmsHomeworkSubmissionDownloadUrlQuery>;
export type LmsHomeworkSubmissionDownloadUrlLazyQueryHookResult = ReturnType<typeof useLmsHomeworkSubmissionDownloadUrlLazyQuery>;
export type LmsHomeworkSubmissionDownloadUrlQueryResult = Apollo.QueryResult<LmsHomeworkSubmissionDownloadUrlQuery, LmsHomeworkSubmissionDownloadUrlQueryVariables>;
export const StudentInvoicesDocument = gql`
    query StudentInvoices {
  myInvoices {
    fakturowniaId
    number
    status
    issueDate
    paymentTo
    currency
    priceGross
    paid
    outstanding
    isOverdue
    daysOverdue
    viewUrl
    paymentUrl
  }
}
    `;

/**
 * __useStudentInvoicesQuery__
 *
 * To run a query within a React component, call `useStudentInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentInvoicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useStudentInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<StudentInvoicesQuery, StudentInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentInvoicesQuery, StudentInvoicesQueryVariables>(StudentInvoicesDocument, options);
      }
export function useStudentInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentInvoicesQuery, StudentInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentInvoicesQuery, StudentInvoicesQueryVariables>(StudentInvoicesDocument, options);
        }
export type StudentInvoicesQueryHookResult = ReturnType<typeof useStudentInvoicesQuery>;
export type StudentInvoicesLazyQueryHookResult = ReturnType<typeof useStudentInvoicesLazyQuery>;
export type StudentInvoicesQueryResult = Apollo.QueryResult<StudentInvoicesQuery, StudentInvoicesQueryVariables>;
export const LessonForLmsDocument = gql`
    query lessonForLms($groupLessonId: ID) {
  lessonForLms(groupLessonId: $groupLessonId) {
    ... on GroupLessonForLMSType {
      id
      name
      date
      index
      lmsDescription
      startTime
      endTime
      finished
      needToFinish
      comment
      video
      taskTypes
      hasTeacherAttachment
      whiteboardId
      homeworkAssignmentId
      homeworkAvailable
      hasJoinLink
      linkOverrideActive
    }
    ... on StudentLessonType {
      id
      name
      date
      index
      lmsDescription
      startTime
      endTime
      finished
      comment
      video
      hasStudentMarks
      hasStudentAttachment
      whiteboardId
      homeworkAssignmentId
      homeworkAvailable
      hasJoinLink
      linkOverrideActive
    }
    ... on MethodistLessonType {
      id
      name
      date
      index
      lmsDescription
      startTime
      endTime
      finished
      comment
      video
      hasTeacherAttachment
      hasStudentAttachment
      whiteboardId
      homeworkAssignmentId
      homeworkAvailable
      hasJoinLink
      linkOverrideActive
    }
  }
}
    `;

/**
 * __useLessonForLmsQuery__
 *
 * To run a query within a React component, call `useLessonForLmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLessonForLmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLessonForLmsQuery({
 *   variables: {
 *      groupLessonId: // value for 'groupLessonId'
 *   },
 * });
 */
export function useLessonForLmsQuery(baseOptions?: Apollo.QueryHookOptions<LessonForLmsQuery, LessonForLmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LessonForLmsQuery, LessonForLmsQueryVariables>(LessonForLmsDocument, options);
      }
export function useLessonForLmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LessonForLmsQuery, LessonForLmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LessonForLmsQuery, LessonForLmsQueryVariables>(LessonForLmsDocument, options);
        }
export type LessonForLmsQueryHookResult = ReturnType<typeof useLessonForLmsQuery>;
export type LessonForLmsLazyQueryHookResult = ReturnType<typeof useLessonForLmsLazyQuery>;
export type LessonForLmsQueryResult = Apollo.QueryResult<LessonForLmsQuery, LessonForLmsQueryVariables>;
export const GroupLessonAttendanceForLmsDocument = gql`
    query groupLessonAttendanceForLms($groupLessonId: ID) {
  groupLessonAttendanceForLms(groupLessonId: $groupLessonId) {
    id
    attendance
    student {
      id
      user {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGroupLessonAttendanceForLmsQuery__
 *
 * To run a query within a React component, call `useGroupLessonAttendanceForLmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupLessonAttendanceForLmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupLessonAttendanceForLmsQuery({
 *   variables: {
 *      groupLessonId: // value for 'groupLessonId'
 *   },
 * });
 */
export function useGroupLessonAttendanceForLmsQuery(baseOptions?: Apollo.QueryHookOptions<GroupLessonAttendanceForLmsQuery, GroupLessonAttendanceForLmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupLessonAttendanceForLmsQuery, GroupLessonAttendanceForLmsQueryVariables>(GroupLessonAttendanceForLmsDocument, options);
      }
export function useGroupLessonAttendanceForLmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupLessonAttendanceForLmsQuery, GroupLessonAttendanceForLmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupLessonAttendanceForLmsQuery, GroupLessonAttendanceForLmsQueryVariables>(GroupLessonAttendanceForLmsDocument, options);
        }
export type GroupLessonAttendanceForLmsQueryHookResult = ReturnType<typeof useGroupLessonAttendanceForLmsQuery>;
export type GroupLessonAttendanceForLmsLazyQueryHookResult = ReturnType<typeof useGroupLessonAttendanceForLmsLazyQuery>;
export type GroupLessonAttendanceForLmsQueryResult = Apollo.QueryResult<GroupLessonAttendanceForLmsQuery, GroupLessonAttendanceForLmsQueryVariables>;
export const GroupLessonAttachmentForLmsDocument = gql`
    query groupLessonAttachmentForLms($groupLessonId: ID, $attachmentRole: String) {
  groupLessonAttachmentForLms(
    groupLessonId: $groupLessonId
    attachmentRole: $attachmentRole
  ) {
    id
    title
    file
  }
}
    `;

/**
 * __useGroupLessonAttachmentForLmsQuery__
 *
 * To run a query within a React component, call `useGroupLessonAttachmentForLmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupLessonAttachmentForLmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupLessonAttachmentForLmsQuery({
 *   variables: {
 *      groupLessonId: // value for 'groupLessonId'
 *      attachmentRole: // value for 'attachmentRole'
 *   },
 * });
 */
export function useGroupLessonAttachmentForLmsQuery(baseOptions?: Apollo.QueryHookOptions<GroupLessonAttachmentForLmsQuery, GroupLessonAttachmentForLmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupLessonAttachmentForLmsQuery, GroupLessonAttachmentForLmsQueryVariables>(GroupLessonAttachmentForLmsDocument, options);
      }
export function useGroupLessonAttachmentForLmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupLessonAttachmentForLmsQuery, GroupLessonAttachmentForLmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupLessonAttachmentForLmsQuery, GroupLessonAttachmentForLmsQueryVariables>(GroupLessonAttachmentForLmsDocument, options);
        }
export type GroupLessonAttachmentForLmsQueryHookResult = ReturnType<typeof useGroupLessonAttachmentForLmsQuery>;
export type GroupLessonAttachmentForLmsLazyQueryHookResult = ReturnType<typeof useGroupLessonAttachmentForLmsLazyQuery>;
export type GroupLessonAttachmentForLmsQueryResult = Apollo.QueryResult<GroupLessonAttachmentForLmsQuery, GroupLessonAttachmentForLmsQueryVariables>;
export const GroupLessonAttachmentDocument = gql`
    query groupLessonAttachment($attachmentId: ID, $attachmentRole: String) {
  groupLessonAttachment(
    attachmentId: $attachmentId
    attachmentRole: $attachmentRole
  ) {
    id
    title
    file
  }
}
    `;

/**
 * __useGroupLessonAttachmentQuery__
 *
 * To run a query within a React component, call `useGroupLessonAttachmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupLessonAttachmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupLessonAttachmentQuery({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *      attachmentRole: // value for 'attachmentRole'
 *   },
 * });
 */
export function useGroupLessonAttachmentQuery(baseOptions?: Apollo.QueryHookOptions<GroupLessonAttachmentQuery, GroupLessonAttachmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupLessonAttachmentQuery, GroupLessonAttachmentQueryVariables>(GroupLessonAttachmentDocument, options);
      }
export function useGroupLessonAttachmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupLessonAttachmentQuery, GroupLessonAttachmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupLessonAttachmentQuery, GroupLessonAttachmentQueryVariables>(GroupLessonAttachmentDocument, options);
        }
export type GroupLessonAttachmentQueryHookResult = ReturnType<typeof useGroupLessonAttachmentQuery>;
export type GroupLessonAttachmentLazyQueryHookResult = ReturnType<typeof useGroupLessonAttachmentLazyQuery>;
export type GroupLessonAttachmentQueryResult = Apollo.QueryResult<GroupLessonAttachmentQuery, GroupLessonAttachmentQueryVariables>;
export const StudentsMarksDocument = gql`
    query studentsMarks($lessonsId: ID!, $lessonIdForMarks: String!, $taskType: String!) {
  studentsMarks(lessonsId: $lessonsId) {
    edges {
      node {
        id
        user {
          id
          firstName
          lastName
          student {
            id
          }
        }
        marks(taskType: $taskType, lessonId: $lessonIdForMarks) {
          edges {
            node {
              id
              date
              mark
              hwMark
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useStudentsMarksQuery__
 *
 * To run a query within a React component, call `useStudentsMarksQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentsMarksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentsMarksQuery({
 *   variables: {
 *      lessonsId: // value for 'lessonsId'
 *      lessonIdForMarks: // value for 'lessonIdForMarks'
 *      taskType: // value for 'taskType'
 *   },
 * });
 */
export function useStudentsMarksQuery(baseOptions: Apollo.QueryHookOptions<StudentsMarksQuery, StudentsMarksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentsMarksQuery, StudentsMarksQueryVariables>(StudentsMarksDocument, options);
      }
export function useStudentsMarksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentsMarksQuery, StudentsMarksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentsMarksQuery, StudentsMarksQueryVariables>(StudentsMarksDocument, options);
        }
export type StudentsMarksQueryHookResult = ReturnType<typeof useStudentsMarksQuery>;
export type StudentsMarksLazyQueryHookResult = ReturnType<typeof useStudentsMarksLazyQuery>;
export type StudentsMarksQueryResult = Apollo.QueryResult<StudentsMarksQuery, StudentsMarksQueryVariables>;
export const StudentMarksDocument = gql`
    query studentMarks($lessonsId: ID!) {
  studentMarks(lessonsId: $lessonsId) {
    edges {
      node {
        mark
        hwMark
        date
        taskType
      }
    }
  }
}
    `;

/**
 * __useStudentMarksQuery__
 *
 * To run a query within a React component, call `useStudentMarksQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentMarksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentMarksQuery({
 *   variables: {
 *      lessonsId: // value for 'lessonsId'
 *   },
 * });
 */
export function useStudentMarksQuery(baseOptions: Apollo.QueryHookOptions<StudentMarksQuery, StudentMarksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentMarksQuery, StudentMarksQueryVariables>(StudentMarksDocument, options);
      }
export function useStudentMarksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentMarksQuery, StudentMarksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentMarksQuery, StudentMarksQueryVariables>(StudentMarksDocument, options);
        }
export type StudentMarksQueryHookResult = ReturnType<typeof useStudentMarksQuery>;
export type StudentMarksLazyQueryHookResult = ReturnType<typeof useStudentMarksLazyQuery>;
export type StudentMarksQueryResult = Apollo.QueryResult<StudentMarksQuery, StudentMarksQueryVariables>;
export const StudentPendingSurveysDocument = gql`
    query StudentPendingSurveys {
  mySurveys {
    assignmentId
    title
    description
    groupName
    lessonName
    lessonNumber
    teacherName
    questions {
      id
      number
      text
      questionType
      required
      options
    }
  }
}
    `;

/**
 * __useStudentPendingSurveysQuery__
 *
 * To run a query within a React component, call `useStudentPendingSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentPendingSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentPendingSurveysQuery({
 *   variables: {
 *   },
 * });
 */
export function useStudentPendingSurveysQuery(baseOptions?: Apollo.QueryHookOptions<StudentPendingSurveysQuery, StudentPendingSurveysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentPendingSurveysQuery, StudentPendingSurveysQueryVariables>(StudentPendingSurveysDocument, options);
      }
export function useStudentPendingSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentPendingSurveysQuery, StudentPendingSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentPendingSurveysQuery, StudentPendingSurveysQueryVariables>(StudentPendingSurveysDocument, options);
        }
export type StudentPendingSurveysQueryHookResult = ReturnType<typeof useStudentPendingSurveysQuery>;
export type StudentPendingSurveysLazyQueryHookResult = ReturnType<typeof useStudentPendingSurveysLazyQuery>;
export type StudentPendingSurveysQueryResult = Apollo.QueryResult<StudentPendingSurveysQuery, StudentPendingSurveysQueryVariables>;
export const GetLessonWhiteboardDocument = gql`
    query GetLessonWhiteboard($lessonId: ID!) {
  lessonWhiteboard(lessonId: $lessonId) {
    id
    name
    sceneJson
    sceneVersion
    createdAt
    updatedAt
    lessons {
      lessonId
      lessonName
      lessonNumber
      lessonDate
    }
    files {
      fileId
      mimeType
      url
    }
  }
}
    `;

/**
 * __useGetLessonWhiteboardQuery__
 *
 * To run a query within a React component, call `useGetLessonWhiteboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLessonWhiteboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLessonWhiteboardQuery({
 *   variables: {
 *      lessonId: // value for 'lessonId'
 *   },
 * });
 */
export function useGetLessonWhiteboardQuery(baseOptions: Apollo.QueryHookOptions<GetLessonWhiteboardQuery, GetLessonWhiteboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLessonWhiteboardQuery, GetLessonWhiteboardQueryVariables>(GetLessonWhiteboardDocument, options);
      }
export function useGetLessonWhiteboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLessonWhiteboardQuery, GetLessonWhiteboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLessonWhiteboardQuery, GetLessonWhiteboardQueryVariables>(GetLessonWhiteboardDocument, options);
        }
export type GetLessonWhiteboardQueryHookResult = ReturnType<typeof useGetLessonWhiteboardQuery>;
export type GetLessonWhiteboardLazyQueryHookResult = ReturnType<typeof useGetLessonWhiteboardLazyQuery>;
export type GetLessonWhiteboardQueryResult = Apollo.QueryResult<GetLessonWhiteboardQuery, GetLessonWhiteboardQueryVariables>;
export const GetWhiteboardLibraryDocument = gql`
    query GetWhiteboardLibrary {
  whiteboardLibrary {
    itemsJson
    version
  }
}
    `;

/**
 * __useGetWhiteboardLibraryQuery__
 *
 * To run a query within a React component, call `useGetWhiteboardLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWhiteboardLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWhiteboardLibraryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWhiteboardLibraryQuery(baseOptions?: Apollo.QueryHookOptions<GetWhiteboardLibraryQuery, GetWhiteboardLibraryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWhiteboardLibraryQuery, GetWhiteboardLibraryQueryVariables>(GetWhiteboardLibraryDocument, options);
      }
export function useGetWhiteboardLibraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWhiteboardLibraryQuery, GetWhiteboardLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWhiteboardLibraryQuery, GetWhiteboardLibraryQueryVariables>(GetWhiteboardLibraryDocument, options);
        }
export type GetWhiteboardLibraryQueryHookResult = ReturnType<typeof useGetWhiteboardLibraryQuery>;
export type GetWhiteboardLibraryLazyQueryHookResult = ReturnType<typeof useGetWhiteboardLibraryLazyQuery>;
export type GetWhiteboardLibraryQueryResult = Apollo.QueryResult<GetWhiteboardLibraryQuery, GetWhiteboardLibraryQueryVariables>;
export const GetGroupWhiteboardsDocument = gql`
    query GetGroupWhiteboards($groupId: ID!) {
  groupWhiteboards(groupId: $groupId) {
    id
    name
    sceneVersion
    updatedAt
    lessons {
      lessonId
      lessonName
      lessonNumber
      lessonDate
    }
  }
}
    `;

/**
 * __useGetGroupWhiteboardsQuery__
 *
 * To run a query within a React component, call `useGetGroupWhiteboardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupWhiteboardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupWhiteboardsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetGroupWhiteboardsQuery(baseOptions: Apollo.QueryHookOptions<GetGroupWhiteboardsQuery, GetGroupWhiteboardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupWhiteboardsQuery, GetGroupWhiteboardsQueryVariables>(GetGroupWhiteboardsDocument, options);
      }
export function useGetGroupWhiteboardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupWhiteboardsQuery, GetGroupWhiteboardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupWhiteboardsQuery, GetGroupWhiteboardsQueryVariables>(GetGroupWhiteboardsDocument, options);
        }
export type GetGroupWhiteboardsQueryHookResult = ReturnType<typeof useGetGroupWhiteboardsQuery>;
export type GetGroupWhiteboardsLazyQueryHookResult = ReturnType<typeof useGetGroupWhiteboardsLazyQuery>;
export type GetGroupWhiteboardsQueryResult = Apollo.QueryResult<GetGroupWhiteboardsQuery, GetGroupWhiteboardsQueryVariables>;
export const LessonJoinHintsDocument = gql`
    query LessonJoinHints($groupLessonId: Int!) {
  lmsLessonJoinClicks(groupLessonId: $groupLessonId) {
    studentId
    studentName
    clickedAt
  }
}
    `;

/**
 * __useLessonJoinHintsQuery__
 *
 * To run a query within a React component, call `useLessonJoinHintsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLessonJoinHintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLessonJoinHintsQuery({
 *   variables: {
 *      groupLessonId: // value for 'groupLessonId'
 *   },
 * });
 */
export function useLessonJoinHintsQuery(baseOptions: Apollo.QueryHookOptions<LessonJoinHintsQuery, LessonJoinHintsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LessonJoinHintsQuery, LessonJoinHintsQueryVariables>(LessonJoinHintsDocument, options);
      }
export function useLessonJoinHintsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LessonJoinHintsQuery, LessonJoinHintsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LessonJoinHintsQuery, LessonJoinHintsQueryVariables>(LessonJoinHintsDocument, options);
        }
export type LessonJoinHintsQueryHookResult = ReturnType<typeof useLessonJoinHintsQuery>;
export type LessonJoinHintsLazyQueryHookResult = ReturnType<typeof useLessonJoinHintsLazyQuery>;
export type LessonJoinHintsQueryResult = Apollo.QueryResult<LessonJoinHintsQuery, LessonJoinHintsQueryVariables>;